
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("foVrt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bXh4X = parcelRequire("bXh4X");


var $67wrw = parcelRequire("67wrw");


var $cDpdq = parcelRequire("cDpdq");


var $j2p1x = parcelRequire("j2p1x");


var $eSr5w = parcelRequire("eSr5w");


var $9wGTI = parcelRequire("9wGTI");


var $7QM6o = parcelRequire("7QM6o");


var $bQm3c = parcelRequire("bQm3c");


var $02cx8 = parcelRequire("02cx8");


var $lmEhP = parcelRequire("lmEhP");


var $hfIjM = parcelRequire("hfIjM");

const $820a39291628bd44$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $820a39291628bd44$var$defaultOptions = {
    appearance: 'full-page',
    onFeedbackClicked: ()=>{},
    onReviewStateEntered: ()=>{},
    onExperienceComplete: ()=>{},
    aiGlobalOptIn: {
        status: 'disabled',
        triggerOptInFlow: ()=>{}
    }
};
const $820a39291628bd44$export$ac968d961305af39 = (options)=>{
    const optionsToUse = options || $820a39291628bd44$var$defaultOptions;
    const createEditorPluginAIOptions = (0, $cozmU.useMemo)(()=>optionsToUse.appearance === 'page-comment' ? (0, $j2p1x.createPageCommentEditorPluginAIOptions) : (0, $j2p1x.createPageEditorPluginAIOptions), [
        optionsToUse.appearance
    ]);
    const optionsToUseRef = (0, $cozmU.useRef)(optionsToUse);
    optionsToUseRef.current = optionsToUse;
    const { cloudId: cloudId, userId: userId, isRovoEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = isRovoLLMEnabled;
    // Memoize session data to avoid recreating the object on every render
    const sessionData = (0, $cozmU.useMemo)(()=>userId && cloudId ? {
            userId: userId,
            cloudId: cloudId
        } : undefined, [
        userId,
        cloudId
    ]);
    // Use the dedicated hook for auto-apply state management
    const autoApplyState = (0, $eSr5w.useAutoApplyState)((0, $9wGTI.fg)('enable_auto_apply_toggling') ? sessionData : undefined);
    const isInDocumentStreamingAllowed = (0, $9wGTI.fg)('enable_auto_apply_toggling') ? autoApplyState?.enabled ?? false : false;
    const refresh = autoApplyState?.refresh;
    // Listen for changes from other parts of the app
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('enable_auto_apply_toggling') || !refresh) return;
        const handleAutoApplyChange = ()=>{
            // Refresh the state from backend/localStorage when toggle changes
            refresh();
        };
        window.addEventListener('autoApplyChanged', handleAutoApplyChange);
        return ()=>window.removeEventListener('autoApplyChanged', handleAutoApplyChange);
    }, [
        refresh
    ]);
    // Use a ref to avoid recreating the options object on every state update
    const isInDocumentStreamingAllowedRef = (0, $cozmU.useRef)(isInDocumentStreamingAllowed);
    isInDocumentStreamingAllowedRef.current = isInDocumentStreamingAllowed;
    const productConfig = (0, $cozmU.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const linkPicker = (0, $cDpdq.useLinkPickerEditorProps)(undefined, productConfig);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId);
    const linkingProp = (0, $lmEhP.useLinkingFeatures)($820a39291628bd44$var$CARD_OPTIONS);
    const PromptEditor = (0, $cozmU.useMemo)(()=>(0, $67wrw.createPromptEditor)({
            linkPicker: linkPicker,
            enableLinks: true,
            linking: linkingProp.linking,
            mentionProvider: mentionProvider,
            featureFlags: {}
        }), [
        linkingProp.linking,
        linkPicker,
        mentionProvider
    ]);
    const editorRovoButtonActions = (0, $02cx8.useEditorRovoButtonActions)();
    const isAISmartButtonEnabled = (0, $cozmU.useMemo)(()=>optionsToUse.appearance !== 'page-comment' && optionsToUse.aiGlobalOptIn.status === 'enabled', [
        optionsToUse.appearance,
        optionsToUse.aiGlobalOptIn.status
    ]);
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const aiSmartButtonOptions = (0, $cozmU.useMemo)(()=>isAISmartButtonEnabled ? {
            actions: {
                ...editorRovoButtonActions,
                setNudges: setNudges
            }
        } : undefined, [
        isAISmartButtonEnabled,
        editorRovoButtonActions,
        setNudges
    ]);
    return (0, $cozmU.useMemo)(()=>{
        return createEditorPluginAIOptions({
            aiGlobalOptIn: optionsToUseRef.current.aiGlobalOptIn,
            experienceMode: optionsToUse.experienceMode,
            streamingTelepointerIdentity: optionsToUse.streamingTelepointerIdentity,
            /**
			 * Hide AI button in primary toolbar when AI proactive is enabled or
			 * 	when appearance is full-page and AI smart button is enabled
			 */ hidePrimaryToolbarButton: optionsToUse.appearance === 'full-page' && optionsToUse.aiGlobalOptIn.status === 'enabled',
            generativeAIApiUrl: `${window.location.origin}/gateway/api/editor-ai/v1/generative/ai`,
            handleFeedbackSubmission: async (feedbackMetadata)=>{
                try {
                    // TODO: EDF-831: Fix and ensure types match with handleFeedbackSubmission
                    optionsToUseRef.current.onFeedbackClicked?.(feedbackMetadata);
                    return {
                        status: 'submitted'
                    };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (error) {
                    return {
                        status: 'failed'
                    };
                }
            },
            onAnnotationsRemoved: optionsToUseRef.current.onAnnotationsRemoved,
            onExperienceEvent: {
                // Thumbs up and down are being deprecated and are no longer used.
                THUMBS_UP: ()=>{},
                THUMBS_DOWN: ()=>{},
                REVIEW_STATE_ENTERED: ()=>{
                    optionsToUseRef.current.onReviewStateEntered?.();
                },
                EXPERIENCE_COMPLETE: ()=>{
                    optionsToUseRef.current.onExperienceComplete?.();
                }
            },
            onDocChangeByAgent: (_agent)=>{
            // TODO Integrate with confluence
            },
            onAIProviderChanged: (source, aiProvider)=>{
                if (optionsToUseRef.current.onAIProviderChanged) optionsToUseRef.current.onAIProviderChanged(source, aiProvider);
            },
            getUserPreferences: ()=>{
                if (!(0, $9wGTI.fg)('enable_auto_apply_toggling')) return {};
                return {
                    isInDocumentStreamingAllowed: isInDocumentStreamingAllowedRef.current
                };
            },
            getChannelVariables: optionsToUseRef.current.getChannelVariables,
            getHasRealTimeCollab: ()=>optionsToUseRef.current.getHasRealTimeCollab?.() ?? false,
            product: 'CONFLUENCE',
            objectId: optionsToUseRef.current.contentId,
            PromptEditor: PromptEditor,
            AIButtonWrapper: options?.AIButtonWrapper,
            providers: options?.providers,
            /**
			 * Need to audit logs only for confluence page as of now.
			 */ auditLogSettings: optionsToUse.appearance !== 'page-comment' && optionsToUse.contentId ? {
                enabled: true,
                eventData: {
                    type: 'page',
                    pageId: optionsToUse.contentId
                }
            } : {
                enabled: false
            },
            ...isAISmartButtonEnabled && {
                aiSmartButtonOptions: aiSmartButtonOptions
            },
            ...optionsToUse.usePlatformPrompt && {
                onSubmit: ()=>{}
            },
            isInDocumentStreamingEnabled: true,
            isRovoEnabled: isRovoEnabled,
            // Provide creation context for experience-based agent routing.
            // Only set for full-page editor appearances (pages/blogs), not page comments.
            ...optionsToUse.appearance !== 'page-comment' && {
                creationContextParams: {
                    experience: 'inline_edit',
                    contentTypes: [
                        optionsToUse.contentType ?? 'page'
                    ]
                }
            }
        });
    }, [
        createEditorPluginAIOptions,
        optionsToUse.appearance,
        optionsToUse.experienceMode,
        optionsToUse.streamingTelepointerIdentity,
        optionsToUse.contentId,
        optionsToUse.contentType,
        PromptEditor,
        options?.AIButtonWrapper,
        options?.providers,
        isAISmartButtonEnabled,
        aiSmartButtonOptions,
        optionsToUse.aiGlobalOptIn.status,
        optionsToUse.usePlatformPrompt,
        isRovoEnabled
    ]);
};
module.exports["useEditorPluginAIOptions"] = $820a39291628bd44$export$ac968d961305af39;

});

parcelRegister("j2p1x", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $93WrI = parcelRequire("93WrI");

var $2urSQ = parcelRequire("2urSQ");

var $7ZL6d = parcelRequire("7ZL6d");


var $ggncV = parcelRequire("ggncV");

var $p6OqS = parcelRequire("p6OqS");

var $6Jphz = parcelRequire("6Jphz");

var $dQeg1 = parcelRequire("dQeg1");

var $4WfQc = parcelRequire("4WfQc");

var $2xJ2w = parcelRequire("2xJ2w");

var $3CdTA = parcelRequire("3CdTA");

var $74BSk = parcelRequire("74BSk");


var $7Jde4 = parcelRequire("7Jde4");


var $iDrrr = parcelRequire("iDrrr");


var $4TgUg = parcelRequire("4TgUg");


var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");







parcelRequire("cozmU");


var $dVbiN = parcelRequire("dVbiN");

const $308391080aec9cff$export$ced89349fedce38 = ({ size: size = 'medium' } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
        label: "",
        spacing: "spacious",
        size: size
    });



var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $88f2ac45e0b8ca2a$export$683185be8e4be56f = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).BRAINSTORM,
        title: (0, $93WrI.aiConfigItemMessages).brainstormTitle,
        description: (0, $93WrI.aiConfigItemMessages).brainstormDescription,
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $308391080aec9cff$export$ced89349fedce38), {}),
        promptLabel: (0, $93WrI.aiConfigItemMessages).brainstormPromptLabel,
        promptHint: (0, $93WrI.aiConfigItemMessages).brainstormPromptHint,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        agentId: 'editor_agent',
        intentSchemaId: 'brainstorm_intent_schema.json',
        featureId: 'brainstorm',
        alwaysNoDocAndSelection: true,
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $88f2ac45e0b8ca2a$export$dddd8d441293ae3 = (options)=>({
        config: $88f2ac45e0b8ca2a$export$683185be8e4be56f(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 0
            },
            selection: {
                enabled: false
            }
        }
    });



var $dFWys = parcelRequire("dFWys");




parcelRequire("cozmU");





var $3fO5l = parcelRequire("3fO5l");







const $6c2fd50787c1318b$var$intentSchemaId = 'convert_to_bullet_points.json';
const $6c2fd50787c1318b$export$c791aa34bcfdf607 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CONVERT_TO_BULLETED_LIST,
        title: (0, $93WrI.aiConfigItemMessages).convertToBulletListTitle,
        description: (0, $93WrI.aiConfigItemMessages).convertToBulletListDescription,
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $6c2fd50787c1318b$var$intentSchemaId,
        actions: {
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $6c2fd50787c1318b$export$37c986c539d0ca07 = (options)=>({
        config: $6c2fd50787c1318b$export$c791aa34bcfdf607(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });





parcelRequire("cozmU");





var $1bzO2 = parcelRequire("1bzO2");







const $e180adc23351de79$var$intentSchemaId = 'convert_to_table.json';
const $e180adc23351de79$export$a7ada90d2d2877a7 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CONVERT_TO_TABLE,
        title: (0, $93WrI.aiConfigItemMessages).convertToTableTitle,
        description: (0, $93WrI.aiConfigItemMessages).convertToTableDescription,
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $e180adc23351de79$var$intentSchemaId,
        actions: {
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $e180adc23351de79$export$d67616d0b45ccf63 = (options)=>({
        config: $e180adc23351de79$export$a7ada90d2d2877a7(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });



var $iO5TS = parcelRequire("iO5TS");




parcelRequire("cozmU");









var $cXtTj = parcelRequire("cXtTj");

const $5b3f9a38f8fe8658$export$cd87ff8f4335648e = ()=>{
    const getExperimentValue = (0, $cXtTj.default).getExperimentValue;
    const variation = getExperimentValue('platform_editor_ai-prompts-placeholder', 'cohort', 'not-enrolled');
    if (variation !== 'control' && variation !== 'not-enrolled') {
        const label = getExperimentValue('platform_editor_ai-prompts-placeholder', 'label', '');
        const description = getExperimentValue('platform_editor_ai-prompts-placeholder', 'description', '');
        const intent = getExperimentValue('platform_editor_ai-prompts-placeholder', 'intent', '');
        const listOrder = getExperimentValue('platform_editor_ai-prompts-placeholder', 'list_order', 0);
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        // The follow are optional backwards compatible properties which can be configured in the experiment
        const showOnEmpty = getExperimentValue('platform_editor_ai-prompts-placeholder', 'show_on_empty_page', true);
        const statusType = getExperimentValue('platform_editor_ai-prompts-placeholder', 'prompt_status_type', '');
        if (label && description && intent && analyticsExperienceName) return {
            label: {
                id: label,
                description: label,
                defaultMessage: label
            },
            description: {
                id: description,
                description: description,
                defaultMessage: description
            },
            intent: intent,
            listOrder: listOrder,
            analyticsExperienceName: analyticsExperienceName,
            showOnEmpty: showOnEmpty,
            statusType: statusType
        };
    }
};


const $475ac549a376725c$export$6cd03141a939166d = ()=>{
    const configurations = (0, $5b3f9a38f8fe8658$export$cd87ff8f4335648e)();
    if (configurations) {
        const statusLozengeType = configurations.statusType.toLowerCase() === 'new' || configurations.statusType.toLowerCase() === 'beta' ? configurations.statusType.toLowerCase() : undefined;
        return {
            ...configurations,
            configItem: {
                key: (0, $2MofN.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER,
                title: configurations.label,
                description: configurations.description,
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $308391080aec9cff$export$ced89349fedce38), {}),
                statusLozengeType: statusLozengeType,
                intentSchemaId: configurations.intent,
                actions: {
                    empty: [
                        (0, $33Ze6.createInsertAtCurrentPosition)({
                            appearance: 'secondary'
                        }),
                        (0, $33Ze6.createInsertAtTop)({
                            appearance: 'primary'
                        })
                    ],
                    selection: [
                        (0, $33Ze6.createInsertBelow)({
                            appearance: 'secondary'
                        }),
                        (0, $33Ze6.createReplace)({
                            appearance: 'primary'
                        })
                    ]
                },
                getBackendModel: ()=>{
                    return 'assistance-service';
                }
            }
        };
    }
};
const $475ac549a376725c$export$d991dc90761ce2a0 = ()=>{
    const res = $475ac549a376725c$export$6cd03141a939166d();
    if (res) {
        const { configItem: configItem, ...others } = res;
        return {
            configItemWithOptions: {
                config: configItem,
                triggers: {
                    empty: {
                        enabled: true,
                        docMinSize: 1
                    },
                    selection: {
                        enabled: true
                    }
                }
            },
            ...others
        };
    }
};





parcelRequire("cozmU");







parcelRequire("cozmU");


var $2hwiA = parcelRequire("2hwiA");

const $3509da16250bd576$export$6eebfc33bd4f687b = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hwiA))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });








const $ec29599520f1fdd8$export$acf0f0fea45f23f0 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).FIND_ACTION_ITEMS,
        title: (0, $93WrI.aiConfigItemMessages).findActionItemsTitle,
        description: (0, $93WrI.aiConfigItemMessages).findActionItemsDescription,
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3509da16250bd576$export$6eebfc33bd4f687b), {}),
        intentSchemaId: 'action_items_intent_schema.json',
        featureId: 'find_action_items',
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary',
                    factoryOptions: options
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $ec29599520f1fdd8$export$8edb35f92492e5cd = (options)=>({
        config: $ec29599520f1fdd8$export$acf0f0fea45f23f0(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });






var $flbIU = parcelRequire("flbIU");




const $3b09d49da4bcd338$export$28052871323f977f = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
        // This is to avoid StateMachine `guard` check
        title: {
            id: 'free-generate-aifc-title',
            defaultMessage: 'Free Generate AIFC'
        },
        description: (0, $flbIU.default).aiUniversalLongCallToAction,
        promptHint: (0, $93WrI.aiConfigItemMessages).freeGeneratePromptHint,
        adfPrompt: true,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        intentSchemaId: 'custom_free_generate_intent_schema.json',
        actions: {},
        getBackendModel: ()=>'aifc-bridge'
    });



var $7vVCw = parcelRequire("7vVCw");


var $lQkyl = parcelRequire("lQkyl");


var $ddlQ3 = parcelRequire("ddlQ3");


var $iTW08 = parcelRequire("iTW08");


var $hXIpv = parcelRequire("hXIpv");


var $llvMC = parcelRequire("llvMC");


var $9pamm = parcelRequire("9pamm");


var $2aMCF = parcelRequire("2aMCF");


var $gcCwL = parcelRequire("gcCwL");

const $16f3b32138480c8a$export$fa98ce94fc01fa17 = {
    brainstormConfigItem: (0, $88f2ac45e0b8ca2a$export$683185be8e4be56f)(),
    freeGenerateAifcConfigItem: (0, $3b09d49da4bcd338$export$28052871323f977f)(),
    addPolishConfigItem: ()=>(0, $iTW08.addPolish)()
};
function $16f3b32138480c8a$var$getDynamicSurfaceConfigItems(opts) {
    const dynamicSurfaceConfigItems = [
        // Only brainstorm, suggest title and find action items are enabled for empty
        {
            config: (0, $iO5TS.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $iO5TS.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToEducational)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $ddlQ3.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $lQkyl.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $iTW08.addPolishWithOptions)(opts),
        // Convert to table and bullet list are already on enabled for selection
        (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
        (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
        (0, $ec29599520f1fdd8$export$8edb35f92492e5cd)(opts),
        (0, $hXIpv.suggestTitleForConfluenceTitleToolbarWithOptions)(opts),
        {
            config: (0, $llvMC.summarizeWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $9pamm.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    // Fix this const name after team 25 with platform_editor_ai_aifc_streaming being cleaned up
    const dynamicSurfaceConfigItemsTeam25 = [
        {
            config: (0, $iO5TS.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $iTW08.addPolishWithOptions)(opts),
        {
            config: (0, $iO5TS.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $ddlQ3.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $lQkyl.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $9pamm.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    return opts.isInDocumentStreamingEnabled ? dynamicSurfaceConfigItemsTeam25 : dynamicSurfaceConfigItems;
}
const $16f3b32138480c8a$export$25814a113f71ded2 = (props)=>{
    const { editorView: editorView, configItem: configItem } = props;
    const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
        state: editorView.state,
        configItem: configItem,
        lastTriggeredFrom: 'triggerConfigItem',
        aiGlobalOptIn: {
            status: 'enabled',
            triggerOptInFlow: ()=>{}
        }
    });
    openAIModalCommand(editorView.state, editorView.dispatch);
};
function $16f3b32138480c8a$export$15d114523124a386(options) {
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $dFWys.changeToneToProfessionalWithOptions)(opts),
            (0, $llvMC.summarizeWritingWithOptions)(opts),
            (0, $iO5TS.improveWritingWithOptions)(opts),
            (0, $iO5TS.fixSpellingAndGrammarWithOptions)(opts),
            (0, $ddlQ3.makeShorterWithOptions)(opts),
            (0, $lQkyl.makeLongerWithOptions)(opts),
            (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
            (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
            (0, $hXIpv.suggestTitleWithOptions)(opts),
            (0, $dFWys.changeToneToEmpatheticWithOptions)(opts),
            (0, $dFWys.changeToneToCasualWithOptions)(opts),
            (0, $dFWys.changeToneToEducationalWithOptions)(opts),
            ...(0, $9pamm.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $475ac549a376725c$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming');
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $7vVCw.freeGenerate)(),
        configItemWithOptions: getConfigItems({
            product: product,
            isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
        }),
        disableAISelectionToolbar: true,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $gcCwL._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        /**
     * Below options are added to use rovo agent behind the scenes for free generate.
     *
     * Need to load rovo agents, so getChannelVariables and isRovoEnabled is set.
     * showRovoAgentsInCommandPalette will disable showing Rovo agents section.
     * useFreeGenerateEditorAgent will swap standard free generate prompt with
     * 	rovo agent enabled free generate after agents are loaded.
     * If loading agents fails, then fallback to standard free generate.
     */ getChannelVariables: options.getChannelVariables,
        getHasRealTimeCollab: options.getHasRealTimeCollab,
        isRovoEnabled: options.isRovoEnabled ?? true,
        showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? false,
        useFreeGenerateEditorAgent: options.useFreeGenerateEditorAgent ?? true,
        onSubmit: options.onSubmit,
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
        enableQuickPrompt: options.enableQuickPrompt ?? false
    };
}
const $16f3b32138480c8a$export$b2747cd26144b27d = (options)=>{
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $dFWys.changeToneToProfessionalWithOptions)(opts),
            (0, $llvMC.summarizeWritingWithOptions)(opts),
            (0, $iO5TS.improveWritingWithOptions)(opts),
            (0, $iO5TS.fixSpellingAndGrammarWithOptions)(opts),
            (0, $ddlQ3.makeShorterWithOptions)(opts),
            (0, $lQkyl.makeLongerWithOptions)(opts),
            (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
            (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
            (0, $ec29599520f1fdd8$export$8edb35f92492e5cd)(opts),
            (0, $hXIpv.suggestTitleWithOptions)(opts),
            (0, $dFWys.changeToneToEmpatheticWithOptions)(opts),
            (0, $dFWys.changeToneToCasualWithOptions)(opts),
            (0, $dFWys.changeToneToEducationalWithOptions)(opts),
            (0, $iTW08.addPolishWithOptions)(opts),
            ...(0, $9pamm.translationConfigItemWithOptions)(opts)
        ];
        const newListOrder = [
            (0, $iO5TS.fixSpellingAndGrammarWithOptions)(opts),
            (0, $dFWys.changeToneToProfessionalWithOptions)(opts),
            (0, $ddlQ3.makeShorterWithOptions)(opts),
            (0, $llvMC.summarizeWritingWithOptions)(opts),
            (0, $iO5TS.improveWritingWithOptions)(opts),
            (0, $lQkyl.makeLongerWithOptions)(opts),
            (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
            (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
            (0, $ec29599520f1fdd8$export$8edb35f92492e5cd)(opts),
            (0, $hXIpv.suggestTitleWithOptions)(opts),
            (0, $dFWys.changeToneToEmpatheticWithOptions)(opts),
            (0, $dFWys.changeToneToCasualWithOptions)(opts),
            (0, $dFWys.changeToneToEducationalWithOptions)(opts),
            (0, $iTW08.addPolishWithOptions)(opts),
            ...(0, $9pamm.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $475ac549a376725c$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData && !opts.isInDocumentStreamingEnabled) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return opts.isInDocumentStreamingEnabled ? newListOrder : list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming');
    const configItemOptions = {
        product: product,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $7vVCw.freeGenerate)(configItemOptions),
        configItemWithOptions: getConfigItems(configItemOptions),
        getSelectionToolbarDropdowns () {
            const selectionToolbarOptions = [
                {
                    id: 'change-tone',
                    label: (0, $7ZL6d.aiMessages).confluenceChangeToneSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneProfessionalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToProfessional)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneEmpatheticToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToEmpathetic)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneCasualToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToCasual)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneNeutralToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToNeutral)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneEducationalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToEducational)(configItemOptions)
                        }
                    ]
                },
                {
                    id: 'rewrite',
                    label: (0, $7ZL6d.aiMessages).confluenceRewriteSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $93WrI.aiConfigItemMessages).improveWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iO5TS.improveWriting)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).fixSpellingGrammarSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iO5TS.fixSpellingAndGrammar)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).summarizeWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $llvMC.summarizeWriting)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).makeShorterSelectionToolbarDropdownItemTitle,
                            configItem: (0, $ddlQ3.makeShorter)(configItemOptions)
                        }
                    ]
                }
            ];
            const translationConfigItemsMap = (0, $9pamm.createTranslationConfigItems)(configItemOptions);
            const translateOptions = (0, $2aMCF.getSortedSupportedTranslationLanguages)().map((language)=>{
                const label = (0, $2urSQ.aiLanguageMessages)[language];
                return {
                    label: label,
                    configItem: translationConfigItemsMap[language]
                };
            });
            selectionToolbarOptions.push({
                id: 'translate',
                label: (0, $7ZL6d.aiMessages).confluenceTranslateSelectionToolbarDropdownMenuTitle,
                options: translateOptions
            });
            return selectionToolbarOptions;
        },
        disableAISelectionToolbar: false,
        experienceMode: options.experienceMode,
        streamingTelepointerIdentity: options.streamingTelepointerIdentity,
        hidePrimaryToolbarButton: isInDocumentStreamingEnabled ? false : options.hidePrimaryToolbarButton,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $gcCwL._getFetchCustomHeaders),
        getChannelVariables: options.getChannelVariables,
        getHasRealTimeCollab: options.getHasRealTimeCollab,
        onDocChangeByAgent: options.onDocChangeByAgent,
        onAIProviderChanged: options.onAIProviderChanged,
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        disableInterrogation: options.disableInterrogation ?? false,
        aiUsageDisclaimer: options.aiUsageDisclaimer,
        isRovoEnabled: options.isRovoEnabled ?? true,
        /**
     * Below options are added because;
     * - Show rovo agents in command palette.
     */ showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? true,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        aiSmartButtonOptions: options.aiSmartButtonOptions,
        heroConfigItem: isInDocumentStreamingEnabled ? (0, $iO5TS.improveWritingWithOptions)(configItemOptions) : undefined,
        ...options.aiGlobalOptIn.status === 'enabled' && (0, $iDrrr.fg)('ai-smart-button-team-25') && {
            dynamicSurfaceConfigItems: $16f3b32138480c8a$var$getDynamicSurfaceConfigItems(configItemOptions)
        },
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        onSubmit: options.onSubmit,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
        enableQuickPrompt: options.enableQuickPrompt ?? true,
        creationContextParams: options.creationContextParams
    };
};
const $16f3b32138480c8a$export$679d027153aa30cf = (editorApi)=>{
    const onActionClick = (configItem)=>{
        return ()=>{
            editorApi.aiExperience?.actions.openAIModal({
                invokedFrom: 'objectSidebar',
                configItem: configItem
            });
        };
    };
    const configItemOptions = {
        product: 'CONFLUENCE',
        isInDocumentStreamingEnabled: (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming')
    };
    const changeToneActionItems = [
        {
            title: (0, $7ZL6d.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($p6OqS))),
            onClick: onActionClick((0, $dFWys.changeToneToProfessional)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).moreCasualToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Jphz))),
            onClick: onActionClick((0, $dFWys.changeToneToCasual)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4WfQc))),
            onClick: onActionClick((0, $dFWys.changeToneToEmpathetic)(configItemOptions))
        }
    ];
    const adjustLengthActionItems = [
        {
            title: (0, $7ZL6d.aiMessages).makeShorterToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3CdTA))),
            onClick: onActionClick((0, $ddlQ3.makeShorter)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).makeLongerToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2xJ2w))),
            onClick: onActionClick((0, $lQkyl.makeLonger)(configItemOptions))
        }
    ];
    const objectSideBarButtons = [
        {
            title: (0, $7ZL6d.aiMessages).spellingAndGrammarToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($74BSk))),
            onClick: onActionClick((0, $iO5TS.fixSpellingAndGrammar)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).changeToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQeg1))),
            subItems: changeToneActionItems
        },
        {
            title: (0, $7ZL6d.aiMessages).adjustLengthToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ggncV))),
            subItems: adjustLengthActionItems
        },
        {
            title: (0, $93WrI.aiConfigItemMessages).improveFormattingTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))),
            onClick: onActionClick((0, $iTW08.addPolish)(configItemOptions))
        }
    ];
    return objectSideBarButtons;
};
module.exports["UNSTABLE_configItems"] = $16f3b32138480c8a$export$fa98ce94fc01fa17;
module.exports["UNSTABLE_DO_NOT_USE_ONLY_FOR_CONFLUENCE_triggerConfigItem"] = $16f3b32138480c8a$export$25814a113f71ded2;
module.exports["createPageCommentEditorPluginAIOptions"] = $16f3b32138480c8a$export$15d114523124a386;
module.exports["createPageEditorPluginAIOptions"] = $16f3b32138480c8a$export$b2747cd26144b27d;
module.exports["getEditorActionsForObjectSidebar"] = $16f3b32138480c8a$export$679d027153aa30cf;

});

parcelRegister("5JZoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $8Rpmh = parcelRequire("8Rpmh");







const $e85d9b72d1bb97d7$export$e9c2274564cfd3df = (diffType)=>(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) || diffType === 'smart' && (0, $iDrrr.fg)('platform_editor_ai_smart_diff');
const $e85d9b72d1bb97d7$export$abfb7344ac6f0d49 = ()=>(0, $iDrrr.fg)('platform_editor_ai_smart_diff') ? 'smart' : 'inline';


const $c8506ce9a0d29c95$export$ce4c822284447bb4 = {
    diff: 'diff',
    anchor: 'anchor',
    contributorTag: 'contributor-tag'
};
const $c8506ce9a0d29c95$export$9a5be357131ea835 = '--ak-editor-diff-additional-margin';
const $c8506ce9a0d29c95$export$92a3db689480415b = `calc(${"var(--ds-space-400, 32px)"} + var(${$c8506ce9a0d29c95$export$9a5be357131ea835}, 0px))`;
const $c8506ce9a0d29c95$export$830d4c4bf8b7876b = `scroll-margin-top: ${$c8506ce9a0d29c95$export$92a3db689480415b};`;
const $c8506ce9a0d29c95$export$fa63aa0289bee17d = {
    from: 'from',
    to: 'to',
    left: 'left',
    docMargin: 'doc-margin',
    /** The decorated block itself, which its contributor tag positions against. */ tag: 'tag'
};
const $c8506ce9a0d29c95$export$821fbb25e40fbb48 = {
    inline: `${$c8506ce9a0d29c95$export$ce4c822284447bb4.diff}-inline`,
    block: `${$c8506ce9a0d29c95$export$ce4c822284447bb4.diff}-block`,
    widget: `${$c8506ce9a0d29c95$export$ce4c822284447bb4.diff}-widget`
};
const $c8506ce9a0d29c95$export$bc2e1517d52e2060 = `${$c8506ce9a0d29c95$export$ce4c822284447bb4.anchor}-${$c8506ce9a0d29c95$export$fa63aa0289bee17d.docMargin}`;
const $c8506ce9a0d29c95$export$c580b39c28f817bd = ({ diffId: diffId, anchorType: anchorType })=>{
    return `${$c8506ce9a0d29c95$export$ce4c822284447bb4.anchor}-${diffId}${anchorType ? `-${anchorType}` : ''}`;
};
const $c8506ce9a0d29c95$export$e95973fb6fa1595f = ({ decorationKeyPrefix: decorationKeyPrefix, isActive: isActive, diffId: diffId, diffType: diffType })=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return `${decorationKeyPrefix}-${diffId}-${isActive ? 'active' : 'inactive'}`;
    return isActive !== undefined ? `${decorationKeyPrefix}-${isActive ? 'active' : 'inactive'}` : decorationKeyPrefix;
};
const $c8506ce9a0d29c95$export$b63856cff30de075 = ({ attributionKey: attributionKey, colorScheme: colorScheme, decorationType: decorationType, diffId: diffId, isActive: isActive, isInserted: isInserted, nodeName: nodeName, side: side, diffType: diffType })=>({
        decorationFamily: $c8506ce9a0d29c95$export$ce4c822284447bb4.diff,
        decorationType: decorationType,
        diffId: diffId,
        key: $c8506ce9a0d29c95$export$e95973fb6fa1595f({
            decorationKeyPrefix: $c8506ce9a0d29c95$export$821fbb25e40fbb48[decorationType],
            diffId: diffId,
            isActive: isActive,
            diffType: diffType
        }),
        ...attributionKey ? {
            attributionKey: attributionKey
        } : {},
        // Active state is only needed by contributor tags, so keep it alongside an attribution key.
        ...attributionKey && isActive !== undefined ? {
            isActive: isActive
        } : {},
        ...isInserted !== undefined ? {
            isInserted: isInserted
        } : {},
        ...colorScheme ? {
            colorScheme: colorScheme
        } : {},
        ...nodeName ? {
            nodeName: nodeName
        } : {},
        ...side !== undefined ? {
            side: side
        } : {}
    });
function $c8506ce9a0d29c95$export$bfa07d0d50bcdd89({ anchorType: anchorType, diffId: diffId, side: side }) {
    if (anchorType === $c8506ce9a0d29c95$export$fa63aa0289bee17d.docMargin) return {
        decorationFamily: $c8506ce9a0d29c95$export$ce4c822284447bb4.anchor,
        anchorType: anchorType,
        key: $c8506ce9a0d29c95$export$bc2e1517d52e2060,
        ...side !== undefined ? {
            side: side
        } : {}
    };
    if (!diffId) throw new Error(`diffId is required for anchor type "${anchorType}"`);
    return {
        decorationFamily: $c8506ce9a0d29c95$export$ce4c822284447bb4.anchor,
        anchorType: anchorType,
        diffId: diffId,
        key: $c8506ce9a0d29c95$export$c580b39c28f817bd({
            diffId: diffId,
            anchorType: anchorType
        }),
        ...side !== undefined ? {
            side: side
        } : {}
    };
}
const $c8506ce9a0d29c95$export$46440ba1409edb32 = (diffId)=>({
        decorationFamily: $c8506ce9a0d29c95$export$ce4c822284447bb4.contributorTag,
        diffId: diffId,
        // Stable across recalculations, so ProseMirror keeps the host element the tag is portalled into.
        key: `${$c8506ce9a0d29c95$export$ce4c822284447bb4.contributorTag}-${diffId}`
    });
const $c8506ce9a0d29c95$export$f24673b80d65051c = (spec)=>Boolean(spec && typeof spec === 'object' && 'decorationFamily' in spec && spec.decorationFamily === $c8506ce9a0d29c95$export$ce4c822284447bb4.diff);
const $c8506ce9a0d29c95$export$daed4283846b64e6 = (spec)=>Boolean(spec && typeof spec === 'object' && 'decorationFamily' in spec && spec.decorationFamily === $c8506ce9a0d29c95$export$ce4c822284447bb4.anchor);
const $c8506ce9a0d29c95$export$c9bc510aa0f85e34 = (decoration)=>$c8506ce9a0d29c95$export$f24673b80d65051c(decoration.spec);
const $c8506ce9a0d29c95$export$f6b1e5edab6db0b1 = (decorations)=>decorations.find(undefined, undefined, $c8506ce9a0d29c95$export$f24673b80d65051c).filter($c8506ce9a0d29c95$export$c9bc510aa0f85e34).map(({ spec: spec })=>{
        return {
            ...spec.colorScheme ? {
                colorScheme: spec.colorScheme
            } : {},
            id: spec.diffId,
            ...spec.isInserted !== undefined ? {
                isInserted: spec.isInserted
            } : {},
            type: spec.decorationType
        };
    });



var $8QOo3 = parcelRequire("8QOo3");


var $5Qi6J = parcelRequire("5Qi6J");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $5aU9U = parcelRequire("5aU9U");


var $8nvEM = parcelRequire("8nvEM");



var $kSwu1 = parcelRequire("kSwu1");

const $ac7272e76071c6ac$export$eb50c889b583cc1d = (0, $kSwu1.defineMessages)({
    changedBy: {
        id: "editor-plugin-show-diff.ContributorTag.changedBy",
        defaultMessage: "Changed by {name}"
    },
    changedByAgent: {
        id: "editor-plugin-show-diff.ContributorTag.changedByAgent",
        defaultMessage: "Changed by {name}, an AI agent"
    },
    changedByConnected: {
        id: "editor-plugin-show-diff.ContributorTag.changedByConnected",
        defaultMessage: "Changed by {agentName} with {userName}"
    },
    externalAgentName: {
        id: "editor-plugin-show-diff.ContributorTag.externalAgentName",
        defaultMessage: "External agent"
    }
});


const $81beb338efe450ad$var$getContributorName = (contributor, formatMessage)=>{
    const name = contributor.name?.trim();
    if (name) return name;
    // `agentKind` defaults to `'external'` per the plugin type contract; an unidentified external
    // agent falls back to a generic label rather than rendering a nameless tag.
    if (contributor.kind === 'agent' && (contributor.agentKind ?? 'external') === 'external') return formatMessage((0, $ac7272e76071c6ac$export$eb50c889b583cc1d).externalAgentName);
    return '';
};
/**
 * Whether the label has to spell out that the contributor is an agent. A sighted user reads that off
 * the `aria-hidden` avatar, so the label is the only other carrier.
 *
 * Excluded: a connected pair, which says it via `changedByConnected`, and an unnamed external agent,
 * whose name `getContributorName` has already resolved to "External agent".
 */ const $81beb338efe450ad$var$isUnaccompaniedNamedAgent = (model)=>!model.connectedContributor && model.contributor.kind === 'agent' && Boolean(model.contributor.name?.trim());
const $81beb338efe450ad$export$365f1be1e901f461 = (model, formatMessage)=>{
    const isPrimaryAgent = model.contributor.kind === 'agent';
    const primaryName = $81beb338efe450ad$var$getContributorName(model.contributor, formatMessage);
    const secondaryName = model.connectedContributor ? $81beb338efe450ad$var$getContributorName(model.connectedContributor, formatMessage) : '';
    const agentName = isPrimaryAgent ? primaryName : secondaryName;
    const userName = isPrimaryAgent ? secondaryName : primaryName;
    return {
        fullLabel: model.connectedContributor ? formatMessage((0, $ac7272e76071c6ac$export$eb50c889b583cc1d).changedByConnected, {
            agentName: agentName,
            userName: userName
        }) : formatMessage($81beb338efe450ad$var$isUnaccompaniedNamedAgent(model) ? (0, $ac7272e76071c6ac$export$eb50c889b583cc1d).changedByAgent : (0, $ac7272e76071c6ac$export$eb50c889b583cc1d).changedBy, {
            name: primaryName
        }),
        // A connected pair only ever shows the agent; the pair is spelled out in `fullLabel`, because
        // the tag is capped at `MAX_TAG_WIDTH` and two names rarely fit inside it.
        visibleName: model.connectedContributor ? agentName || primaryName : primaryName
    };
};





const $c01acd5f54beb5e5$export$e499ecb0b83675e6 = (0, $kSwu1.defineMessages)({
    activeChange: {
        id: "editor-plugin-show-diff.DiffNavigation.activeChange",
        defaultMessage: "Change {index} of {total}"
    },
    activeChangeWithContributor: {
        id: "editor-plugin-show-diff.DiffNavigation.activeChangeWithContributor",
        defaultMessage: "Change {index} of {total}. {contributor}"
    }
});


/**
 * The tag that captions the given decoration, if any. `linkedDiffIds` is checked as well as
 * `diffId`, because a replacement's two decorations share one tag and navigation can land on either.
 */ const $06c65279ee11c673$var$findTagFor = (decoration, contributorTags)=>{
    if (!contributorTags?.length || !(0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration)) return undefined;
    const { diffId: diffId } = decoration.spec;
    return contributorTags.find((tag)=>tag.diffId === diffId || tag.linkedDiffIds?.includes(diffId));
};
const $06c65279ee11c673$export$be37737225e29297 = ({ activeIndex: activeIndex, contributorTags: contributorTags, decorations: decorations, intl: intl })=>{
    const activeDecoration = decorations[activeIndex];
    if (!activeDecoration) return undefined;
    const position = {
        index: activeIndex + 1,
        total: decorations.length
    };
    const tag = $06c65279ee11c673$var$findTagFor(activeDecoration, contributorTags);
    return tag ? intl.formatMessage((0, $c01acd5f54beb5e5$export$e499ecb0b83675e6).activeChangeWithContributor, {
        ...position,
        contributor: (0, $81beb338efe450ad$export$365f1be1e901f461)(tag, intl.formatMessage).fullLabel
    }) : intl.formatMessage((0, $c01acd5f54beb5e5$export$e499ecb0b83675e6).activeChange, position);
};



var $3u5lg = parcelRequire("3u5lg");


var $dOBRD = parcelRequire("dOBRD");


var $dFI5z = parcelRequire("dFI5z");


var $gE3l8 = parcelRequire("gE3l8");


var $6SJ6d = parcelRequire("6SJ6d");


var $eOaGc = parcelRequire("eOaGc");











var $anBbz = parcelRequire("anBbz");


var $bjg0G = parcelRequire("bjg0G");








/**
 * Resolves the doc-level block node (table/expand/layout) for `from`, along with
 * the position right before it (`beforePos`). Falls back to `$from.nodeAfter`
 * when there is no depth-1 ancestor (e.g. `from` sits just before the block).
 */ const $b6432cc061a6f6cb$var$resolveDocLevelNode = (doc, from)=>{
    const $from = doc.resolve(from);
    const node = $from.node(1) ?? $from.nodeAfter;
    if (!node) return undefined;
    // Content start of the block. For the depth-1 case this is `$from.start(1)`;
    // for the `nodeAfter` fallback, `from` is the position just before the block
    // node, so its content starts at `from + 1`.
    const nodeStart = $from.node(1) ? $from.start(1) : from + 1;
    return {
        node: node,
        nodeStart: nodeStart,
        // Position of the block node itself (one before its content start).
        beforePos: nodeStart - 1
    };
};
/**
 * Handles edge cases for block nodes whose inline content can exceed the doc
 * margin (tables, layouts, expands). Returns the position whose DOM should be
 * measured to size the left anchor, or `undefined` when the diff is not inside
 * such a node.
 */ const $b6432cc061a6f6cb$var$edgeCases = (doc, from)=>{
    const resolved = $b6432cc061a6f6cb$var$resolveDocLevelNode(doc, from);
    if (!resolved) return undefined;
    const { node: node, nodeStart: nodeStart, beforePos: beforePos } = resolved;
    if (node.type.name === 'layoutSection' && (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) // Columns extend past the node-view wrapper via negative margins (12px or 20px).
    // Measure their container so the indicator stays outside the diff outline, including
    // breakout layouts and after responsive resizing, without changing the column geometry.
    return {
        beforePos: beforePos,
        measurePos: beforePos,
        measureSelector: '[data-layout-section]'
    };
    /**
	 * All resizable nodes will need dynamic calculations of the block indicator left anchor
	 */ if (node.marks.some((mark)=>mark.type.name === 'breakout')) /**
		 * Layouts and Expands have extra padding around the container
		 */ return {
        beforePos: beforePos,
        measurePos: beforePos
    };
    switch(node.type.name){
        /**
		 * For resizable blocks, inline content can exceed the doc margin.
		 * The widget is placed before the block; the anchor is sized against the
		 * block's DOM so it doesn't get clipped when the block is resized :')
		 */ case 'table':
            // A table with no rows has nothing to measure.
            if (!node.firstChild) return undefined;
            // Measure the first row (`nodeStart` is just inside the table, i.e. the
            // position of the first row): its width matches the table's.
            return {
                beforePos: beforePos,
                measurePos: nodeStart
            };
        case 'layoutSection':
        case 'expand':
            // Measure the block itself (the widget is rendered outside the block).
            return {
                beforePos: beforePos,
                leftOffset: 12
            };
        default:
            return undefined;
    }
};
const $b6432cc061a6f6cb$export$e9accf2864a96b18 = ()=>{
    return (0, $8nvEM.Decoration).widget(0, ()=>{
        const span = document.createElement('span');
        span.style.setProperty('anchor-name', `--${(0, $c8506ce9a0d29c95$export$bc2e1517d52e2060)}`);
        return span;
    }, // set the side to -999 so that it is always rendered before any other anchors
    (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).docMargin,
        side: -999
    }));
};
const $b6432cc061a6f6cb$export$bb60b01773a85c0d = ({ doc: doc, from: from, diffId: diffId })=>{
    const edgeCase = $b6432cc061a6f6cb$var$edgeCases(doc, from);
    if (edgeCase === undefined) return undefined;
    // Render the widget right before the doc-level node so it lives outside the
    // resizable block container.
    const { beforePos: beforePos } = edgeCase;
    const leftAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
    });
    let leftResizeObserver;
    return (0, $8nvEM.Decoration).widget(beforePos, (view, getPos)=>{
        // Outer span stays in the flow but takes up no space.
        const wrapper = document.createElement('div');
        wrapper.style.setProperty('position', 'relative');
        wrapper.style.setProperty('width', '100%');
        // Inner span is absolutely positioned in the doc margin; it carries the
        // `anchor-name` the IndicatorBar aligns its left edge against.
        const anchor = document.createElement('div');
        anchor.style.setProperty('anchor-name', `--${leftAnchorKey}`);
        anchor.style.setProperty('position', 'absolute');
        anchor.style.setProperty('left', `calc(50% - ${edgeCase?.leftOffset || 0}px)`);
        anchor.style.setProperty('transform', 'translateX(-50%)');
        wrapper.appendChild(anchor);
        const measureWidth = ()=>{
            if (getPos() === undefined || edgeCase.measurePos === undefined) return;
            const nodeDOM = view.nodeDOM(edgeCase.measurePos);
            const dom = edgeCase.measureSelector && nodeDOM instanceof HTMLElement ? nodeDOM.querySelector(edgeCase.measureSelector) ?? nodeDOM : nodeDOM;
            if (dom instanceof HTMLElement) {
                // The left anchor only needs the container width so the
                // IndicatorBar can align against the block's horizontal extent.
                anchor.style.setProperty('width', `${dom.offsetWidth}px`);
                // Observe the measured element for size changes (e.g. page
                // resize) so the indicator stays aligned. CCI-17981
                if (!leftResizeObserver) {
                    leftResizeObserver = new ResizeObserver(()=>{
                        if (getPos() !== undefined) anchor.style.setProperty('width', `${dom.offsetWidth}px`);
                    });
                    leftResizeObserver.observe(dom);
                }
            }
        };
        // The block DOM may not be settled synchronously (e.g. after a
        // transaction), so defer the measurement like the gap cursor does.
        requestAnimationFrame(measureWidth);
        return wrapper;
    }, {
        ...(0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
            diffId: diffId,
            anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left,
            side: -999
        }),
        destroy: ()=>leftResizeObserver?.disconnect()
    });
};
const $b6432cc061a6f6cb$export$34d0779dfc2e9aea = ({ doc: doc, from: from, to: to, diffId: diffId })=>{
    const leftAnchor = $b6432cc061a6f6cb$export$bb60b01773a85c0d({
        doc: doc,
        from: from,
        diffId: diffId
    });
    const maybeLeftAnchor = leftAnchor ? [
        leftAnchor
    ] : [];
    /**
	 * A single anchor widget spans the full height of the block node, mimicking
	 * the gap cursor placement logic (see `place-gap-cursor.ts`): an element
	 * whose height is measured from the block's DOM so its box covers the block.
	 *
	 * Because the anchor rect covers the whole block, the `IndicatorBar` can
	 * resolve `top`, `bottom` and `left` against this one anchor (keyed by
	 * `diffId` with no `anchorType`) instead of separate `from`/`to` anchors.
	 */ const blockAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId
    });
    /**
	 * If `from` lands inside a table cell/header or a table row, the widget must
	 * still be rendered *outside* the table (widgets placed inside a table are
	 * clipped/mis-laid-out), but we want the anchor to be sized against the
	 * actual cell/row DOM. So we split into two positions:
	 * - `widgetPos`: where the widget DOM is rendered (outside the table).
	 * - `measurePos`: the closest cell/row whose DOM we measure for the height.
	 */ const $from = doc.resolve(from);
    const parentTable = (0, $bjg0G.findParentNodeClosestToPos)($from, (ancestor)=>ancestor.type.name === 'table');
    const parentCellOrRow = (0, $bjg0G.findParentNodeClosestToPos)($from, (ancestor)=>[
            'tableCell',
            'tableHeader',
            'tableRow'
        ].includes(ancestor.type.name));
    const parentLayout = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? (0, $bjg0G.findParentNodeClosestToPos)($from, (ancestor)=>ancestor.type.name === 'layoutSection') : undefined;
    // Layouts flatten direct widget children with display: contents. Such a wrapper has no
    // bounding box or positioning context, so measuring its top produces an offset from the
    // viewport origin and displaces the indicator into content below the editor. Keep the
    // wrapper outside the layout, just as we do for tables, but still measure the target node.
    const widgetPos = parentTable?.pos ?? parentLayout?.pos ?? from;
    // Measure the actual cell/row DOM when inside one; otherwise measure the
    // widget's own position.
    const measurePos = parentCellOrRow ? parentCellOrRow.pos : from;
    let blockResizeObserver;
    const blockWidget = (0, $8nvEM.Decoration).widget(widgetPos, (view, getPos)=>{
        // Outer span stays in the flow but takes up no space.
        const wrapper = document.createElement('span');
        wrapper.style.setProperty('position', 'relative');
        // Inner span is absolutely positioned and sized to the block height;
        // it carries the `anchor-name` the IndicatorBar aligns against.
        const anchor = document.createElement('span');
        anchor.style.setProperty('position', 'absolute');
        anchor.style.setProperty('anchor-name', `--${blockAnchorKey}`);
        wrapper.appendChild(anchor);
        const measureBlock = ()=>{
            if (getPos() === undefined) return;
            const dom = view.nodeDOM(measurePos);
            if (dom instanceof HTMLElement) {
                anchor.style.setProperty('height', `${dom.offsetHeight}px`);
                // The wrapper renders outside the table, so there is a vertical
                // gap between it and the cell/row we're anchoring to. Measure
                // that delta and offset the (absolutely positioned) anchor by it
                // so its box lines up with the cell/row.
                const wrapperTop = wrapper.getBoundingClientRect().top;
                const domTop = dom.getBoundingClientRect().top;
                const verticalOffset = domTop - wrapperTop;
                anchor.style.setProperty('top', `${verticalOffset}px`);
                // The offset already accounts for the cell/row's position, so the
                // margin-top must not be double-applied.
                anchor.style.setProperty('margin-top', '0px');
                // Observe the measured element for size changes (e.g. page
                // resize) so the indicator stays aligned. CCI-17981
                if (!blockResizeObserver) {
                    blockResizeObserver = new ResizeObserver(()=>{
                        if (getPos() !== undefined) measureBlock();
                    });
                    blockResizeObserver.observe(dom);
                }
            }
        };
        // The block DOM may not be settled synchronously (e.g. after a
        // transaction), so defer the measurement like the gap cursor does.
        requestAnimationFrame(measureBlock);
        return wrapper;
    }, {
        ...(0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
            diffId: diffId,
            // Reuse the `from` anchor type slot; the generated key intentionally
            // omits the anchor type so the single element backs top/bottom/left.
            anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from,
            side: -1
        }),
        destroy: ()=>blockResizeObserver?.disconnect()
    });
    return [
        blockWidget,
        ...maybeLeftAnchor
    ];
};
const $b6432cc061a6f6cb$export$e97e6c8c8b705874 = (doc, pos, direction)=>{
    const $pos = doc.resolve(pos);
    if ($pos.parent.type.name !== 'tableRow') return pos;
    const cell = direction === 1 ? $pos.nodeAfter : $pos.nodeBefore;
    if (!cell || cell.type.name !== 'tableHeader' && cell.type.name !== 'tableCell') return pos;
    // +2 past the cell and its first child boundary = inside the cell's content;
    // for the backward case, step back the same amount from the cell's end.
    return direction === 1 ? pos + 2 : pos - 2;
};
const $b6432cc061a6f6cb$export$9c6819d26dfec631 = (anchorKey)=>{
    const span = document.createElement('span');
    span.style.setProperty('anchor-name', `--${anchorKey}`);
    return span;
};
const $b6432cc061a6f6cb$var$createAnchorSpanWidget = ({ pos: pos, diffId: diffId, anchorType: anchorType, side: side })=>(0, $8nvEM.Decoration).widget(pos, ()=>$b6432cc061a6f6cb$export$9c6819d26dfec631((0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
            diffId: diffId,
            anchorType: anchorType
        })), (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        diffId: diffId,
        anchorType: anchorType,
        side: side
    }));
const $b6432cc061a6f6cb$export$dc213f6c0d801266 = ({ doc: doc, from: from, to: to, diffId: diffId })=>{
    const leftAnchor = $b6432cc061a6f6cb$export$bb60b01773a85c0d({
        doc: doc,
        from: from,
        diffId: diffId
    });
    const maybeLeftAnchor = leftAnchor ? [
        leftAnchor
    ] : [];
    // Keep the start/end anchors out of the table row's grid (see helper above).
    const fromPos = $b6432cc061a6f6cb$export$e97e6c8c8b705874(doc, from, 1);
    const toPos = $b6432cc061a6f6cb$export$e97e6c8c8b705874(doc, to, -1);
    /**
	 * Two widgets mark the start and end of the inline range so the
	 * IndicatorBar can determine top/bottom even if
	 * the inline decoration is broken up by marks / between blocks.
	 */ // Gated purely so the `createAnchorSpanWidget` rewrite can be rolled back independently of the
    // contributor-tag anchors it was extracted for: both branches build the same two widgets at the
    // same positions. Drop the fallback with the gate.
    if ((0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history')) return [
        $b6432cc061a6f6cb$var$createAnchorSpanWidget({
            pos: fromPos,
            diffId: diffId,
            anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from,
            side: 1
        }),
        $b6432cc061a6f6cb$var$createAnchorSpanWidget({
            pos: toPos,
            diffId: diffId,
            anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).to,
            side: -1
        }),
        ...maybeLeftAnchor
    ];
    const fromAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from
    });
    const fromWidget = (0, $8nvEM.Decoration).widget(fromPos, ()=>{
        const span = document.createElement('span');
        span.style.setProperty('anchor-name', `--${fromAnchorKey}`);
        return span;
    }, (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from,
        side: 1
    }));
    const toAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).to
    });
    const toWidget = (0, $8nvEM.Decoration).widget(toPos, ()=>{
        const span = document.createElement('span');
        span.style.setProperty('anchor-name', `--${toAnchorKey}`);
        return span;
    }, (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).to,
        side: -1
    }));
    return [
        fromWidget,
        toWidget,
        ...maybeLeftAnchor
    ];
};



var $8Dx7s = parcelRequire("8Dx7s");








var $4o0zT = parcelRequire("4o0zT");











const $476d00a9ed5be1b0$export$9645c6cfb2371e19 = ()=>(0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? {
        textDecorationLine: 'line-through'
    } : {
        textDecoration: 'line-through'
    };


const $e28b33baecacf396$export$fd697ce9882275f1 = '--show-diff-deleted-highlight-bg';
const $e28b33baecacf396$export$8e1375a56e74a28c = '--show-diff-deleted-highlight-border';
// token() is a build-time transform needing static literals, so pre-compute every colour's
// tokens here and index by name at runtime.
const $e28b33baecacf396$var$bgSubtlestMap = {
    green: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    teal: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    blue: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    purple: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    red: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    orange: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    yellow: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    magenta: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    gray: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    lime: "var(--ds-background-accent-lime-subtlest, #EFFFD6)"
};
const $e28b33baecacf396$var$bgSubtlestHoveredMap = {
    green: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    teal: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    blue: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    purple: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    red: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    orange: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    yellow: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    magenta: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    gray: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    lime: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)"
};
const $e28b33baecacf396$var$bgSubtlestPressedMap = {
    green: "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    teal: "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    blue: "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    purple: "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    red: "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    orange: "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    yellow: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    magenta: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    gray: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    lime: "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)"
};
const $e28b33baecacf396$var$bgSubtlerMap = {
    green: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    teal: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    blue: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    purple: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    red: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    orange: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    yellow: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    magenta: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    gray: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    lime: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
};
const $e28b33baecacf396$var$bgSubtlerPressedMap = {
    green: "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    teal: "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    blue: "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    purple: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    red: "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    orange: "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    yellow: "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    magenta: "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    gray: "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    lime: "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)"
};
const $e28b33baecacf396$var$bgBolderMap = {
    green: "var(--ds-background-accent-green-bolder, #1F845A)",
    teal: "var(--ds-background-accent-teal-bolder, #227D9B)",
    blue: "var(--ds-background-accent-blue-bolder, #1868DB)",
    purple: "var(--ds-background-accent-purple-bolder, #964AC0)",
    red: "var(--ds-background-accent-red-bolder, #C9372C)",
    orange: "var(--ds-background-accent-orange-bolder, #BD5B00)",
    yellow: "var(--ds-background-accent-yellow-bolder, #946F00)",
    magenta: "var(--ds-background-accent-magenta-bolder, #AE4787)",
    gray: "var(--ds-background-accent-gray-bolder, #6B6E76)",
    lime: "var(--ds-background-accent-lime-bolder, #5B7F24)"
};
const $e28b33baecacf396$var$borderAccentMap = {
    green: "var(--ds-border-accent-green, #22A06B)",
    teal: "var(--ds-border-accent-teal, #2898BD)",
    blue: "var(--ds-border-accent-blue, #357DE8)",
    purple: "var(--ds-border-accent-purple, #AF59E1)",
    red: "var(--ds-border-accent-red, #E2483D)",
    orange: "var(--ds-border-accent-orange, #E06C00)",
    yellow: "var(--ds-border-accent-yellow, #B38600)",
    magenta: "var(--ds-border-accent-magenta, #CD519D)",
    gray: "var(--ds-border-accent-gray, #7D818A)",
    lime: "var(--ds-border-accent-lime, #6A9A23)"
};
const $e28b33baecacf396$var$textAccentMap = {
    green: "var(--ds-text-accent-green, #216E4E)",
    teal: "var(--ds-text-accent-teal, #206A83)",
    blue: "var(--ds-text-accent-blue, #1558BC)",
    purple: "var(--ds-text-accent-purple, #803FA5)",
    red: "var(--ds-text-accent-red, #AE2E24)",
    orange: "var(--ds-text-accent-orange, #9E4C00)",
    yellow: "var(--ds-text-accent-yellow, #7F5F01)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    gray: "var(--ds-text-accent-gray, #505258)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)"
};
function $e28b33baecacf396$var$bgSubtlest(color) {
    return $e28b33baecacf396$var$bgSubtlestMap[color];
}
function $e28b33baecacf396$var$bgSubtlestPressed(color) {
    return $e28b33baecacf396$var$bgSubtlestPressedMap[color];
}
function $e28b33baecacf396$var$bgSubtler(color) {
    return $e28b33baecacf396$var$bgSubtlerMap[color];
}
function $e28b33baecacf396$var$bgBolder(color) {
    return $e28b33baecacf396$var$bgBolderMap[color];
}
function $e28b33baecacf396$var$bgSubtlerPressed(color) {
    return $e28b33baecacf396$var$bgSubtlerPressedMap[color];
}
function $e28b33baecacf396$var$borderAccent(color) {
    return $e28b33baecacf396$var$borderAccentMap[color];
}
function $e28b33baecacf396$var$textAccent(color) {
    return $e28b33baecacf396$var$textAccentMap[color];
}
function $e28b33baecacf396$export$7d0a3d1deacd835a(color) {
    return {
        background: $e28b33baecacf396$var$bgBolder(color),
        text: "var(--ds-text-inverse, #FFFFFF)"
    };
}
function $e28b33baecacf396$export$c010c3eb7bcbc04e(color) {
    return $e28b33baecacf396$var$borderAccent(color);
}
/** Ring colour for an active (scroll-target) deleted block outline. */ function $e28b33baecacf396$var$deletedBlockOutlineActiveRing(colors) {
    return colors.deletedBlockOutlineActiveEmphasis === 'border' ? $e28b33baecacf396$var$borderAccent(colors.deleteActiveColor) : $e28b33baecacf396$var$bgSubtlerPressed(colors.deleteActiveColor);
}
/** Outline colour for deleted table-cell overlays. */ function $e28b33baecacf396$var$deletedCellOutline(colors) {
    return colors.deletedCellBorderProminence === 'subtle' ? "var(--ds-border-disabled, #0515240F)" : $e28b33baecacf396$var$borderAccent(colors.deletedCellColor);
}
// --- Inserted content styles ---
function $e28b33baecacf396$var$insertedInlineBorderColor(colors) {
    return colors.insertedInlineBorderTone === 'backgroundHovered' ? $e28b33baecacf396$var$bgSubtlestHoveredMap[colors.insertColor] : $e28b33baecacf396$var$borderAccent(colors.insertColor);
}
function $e28b33baecacf396$export$82262e1f5a4bc0d4(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        background: $e28b33baecacf396$var$bgSubtlest(colors.insertColor),
        textDecoration: 'underline',
        textDecorationStyle: colors.insertUnderlineStyle,
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: $e28b33baecacf396$var$borderAccent(colors.insertColor)
    });
}
function $e28b33baecacf396$export$7a02da73a51c5872(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        textDecoration: 'underline',
        textDecorationStyle: colors.insertUnderlineStyle,
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: $e28b33baecacf396$var$borderAccent(colors.insertColor)
    });
}
function $e28b33baecacf396$export$5fab5218b7eea3ef(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        background: $e28b33baecacf396$var$bgSubtlest(colors.insertColor),
        borderBottom: `2px solid ${$e28b33baecacf396$var$insertedInlineBorderColor(colors)}`,
        padding: `1px 0 2px`
    });
}
function $e28b33baecacf396$export$bb378cc1b1ef4fa2(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        borderBottom: `2px solid ${$e28b33baecacf396$var$insertedInlineBorderColor(colors)}`,
        padding: `1px 0 2px`
    });
}
function $e28b33baecacf396$export$a33e264c283926(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        background: $e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor),
        borderBottom: `2px solid ${$e28b33baecacf396$var$borderAccent(colors.insertColor)}`,
        padding: `1px 0 2px`
    });
}
function $e28b33baecacf396$export$ff53ea63d183e034(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        background: $e28b33baecacf396$var$bgSubtlest(colors.insertColor),
        padding: `1px 0 2px`
    });
}
function $e28b33baecacf396$export$6560b65b269507f7(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        background: $e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor),
        padding: `1px 0 2px`
    });
}
function $e28b33baecacf396$export$4a10e3f9ee1f1332(_colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        padding: `1px 0 2px`
    });
}
function $e28b33baecacf396$export$bfc49da2006f92f0(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        background: $e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor),
        textDecoration: 'underline',
        textDecorationStyle: colors.insertUnderlineStyle,
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: $e28b33baecacf396$var$textAccent(colors.insertActiveColor)
    });
}
// --- Deleted inline content styles ---
/** Base deleted-inline-style object, shared by several exports. */ function $e28b33baecacf396$var$deletedInlineStyleBase(colors) {
    return {
        textDecorationColor: $e28b33baecacf396$var$borderAccent(colors.deleteTextColor ?? colors.deleteColor),
        textDecoration: 'line-through',
        position: 'relative',
        opacity: 1
    };
}
/** Active deleted-inline-style object, extending the base. */ function $e28b33baecacf396$var$deletedInlineStyleActiveBase(colors) {
    return {
        ...$e28b33baecacf396$var$deletedInlineStyleBase(colors),
        textDecorationThickness: '2px',
        backgroundColor: $e28b33baecacf396$var$bgSubtlestPressed(colors.deleteActiveColor)
    };
}
function $e28b33baecacf396$export$a253cd53c2e78280(colors, isActive) {
    return isActive ? (0, $8Dx7s.convertToInlineCss)($e28b33baecacf396$var$deletedInlineStyleActiveBase(colors)) : (0, $8Dx7s.convertToInlineCss)($e28b33baecacf396$var$deletedInlineStyleBase(colors));
}
function $e28b33baecacf396$export$83928b85b59c5edf(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: '50%',
        width: '100%',
        display: 'inline-block',
        borderTop: `1px solid ${$e28b33baecacf396$var$borderAccent(colors.deleteColor)}`,
        pointerEvents: 'none',
        zIndex: 1
    });
}
function $e28b33baecacf396$export$1b7d90755db7b218(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: '50%',
        width: '100%',
        display: 'inline-block',
        borderTop: `2px solid ${$e28b33baecacf396$var$borderAccent(colors.deleteColor)}`,
        pointerEvents: 'none',
        zIndex: 1
    });
}
function $e28b33baecacf396$export$2d4dff1bdf91b259(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: '50%',
        width: '100%',
        display: 'inline-block',
        borderTop: `1px solid ${$e28b33baecacf396$var$textAccent(colors.deleteTextColor ?? colors.deleteColor)}`,
        pointerEvents: 'none',
        zIndex: 1
    });
}
function $e28b33baecacf396$export$a00bcdfbbac54e80(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        marginTop: "var(--ds-space-150, 12px)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-025, 2px)",
        boxShadow: `0 0 0 1px ${$e28b33baecacf396$var$borderAccent(colors.deleteColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$3ed900f26521c9f5(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        marginTop: "var(--ds-space-150, 12px)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-025, 2px)",
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$borderAccent(colors.deleteActiveColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$3b7e7b503a47214f(colors) {
    if (colors.deletedQuoteNodeShape === 'borderLeft') return (0, $8Dx7s.convertToInlineCss)({
        borderLeft: `2px solid ${$e28b33baecacf396$var$borderAccent(colors.deleteColor)}`
    });
    return (0, $8Dx7s.convertToInlineCss)({
        marginTop: "var(--ds-space-150, 12px)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-025, 2px)",
        boxShadow: `0 0 0 1px ${$e28b33baecacf396$var$borderAccent(colors.deleteColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$407fbec4f1e98cef(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        marginTop: "var(--ds-space-150, 12px)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-025, 2px)",
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$bgSubtlerPressed(colors.deleteActiveColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$75e56dcd4b81b8e0(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 1px ${$e28b33baecacf396$var$borderAccent(colors.deleteColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$5750ffe19fbf9171(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$deletedBlockOutlineActiveRing(colors)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$c693fb2a96429890(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 1px ${$e28b33baecacf396$var$borderAccent(colors.deleteColor)}`,
        borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
    });
}
function $e28b33baecacf396$export$274be73202bc436b(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$deletedBlockOutlineActiveRing(colors)}`,
        borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
    });
}
function $e28b33baecacf396$export$2d291cc49390f12b(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$bgSubtlest(colors.deleteColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$1a8b15734e611191(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$bgSubtlest(colors.deleteColor)}`,
        borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
    });
}
function $e28b33baecacf396$export$f7d79f6b121d95c8(colors) {
    // Each branch emits exactly the CSS the pre-factory shim did for its scheme.
    return colors.deletedRowTreatment === 'textTint' ? (0, $8Dx7s.convertToInlineCss)({
        color: $e28b33baecacf396$var$textAccent(colors.deleteTextColor ?? colors.deleteColor),
        ...(0, $476d00a9ed5be1b0$export$9645c6cfb2371e19)(),
        opacity: 0.6,
        display: 'table-row'
    }) : (0, $8Dx7s.convertToInlineCss)({
        textDecorationColor: $e28b33baecacf396$var$borderAccent(colors.deleteColor),
        textDecoration: 'line-through',
        opacity: 0.6,
        display: 'table-row'
    });
}
function $e28b33baecacf396$export$4e1af505db4a78ba(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        borderLeft: `2px solid ${$e28b33baecacf396$var$borderAccent(colors.insertColor)}`
    });
}
function $e28b33baecacf396$export$479a1d7f8dbe8b9c(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        borderLeft: `4px solid ${$e28b33baecacf396$var$bgSubtlest(colors.insertColor)}`
    });
}
function $e28b33baecacf396$export$39a663a4486e081(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        borderLeft: `4px solid ${$e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor)}`
    });
}
function $e28b33baecacf396$export$d9f4032290f3d9c3(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        backgroundColor: $e28b33baecacf396$var$borderAccent(colors.insertColor)
    });
}
function $e28b33baecacf396$export$b1e61689af8f5034(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        backgroundColor: $e28b33baecacf396$var$bgSubtlest(colors.insertColor),
        border: 'none',
        height: '4px',
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$2c0869c8e71ee09e(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        backgroundColor: $e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor),
        border: 'none',
        height: '4px',
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$7c9daea341f0c892(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 1px ${$e28b33baecacf396$var$borderAccent(colors.insertColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$da8b11b4aa693b34(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$bgSubtlest(colors.insertColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$90580fdb7ed1bb88(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor)}`,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
}
function $e28b33baecacf396$export$fcd058bfb978a8cc(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 1px ${$e28b33baecacf396$var$borderAccent(colors.insertColor)}`,
        borderRadius: "var(--ds-radius-medium, 6px)"
    });
}
function $e28b33baecacf396$export$a2453fdbf1e29a79(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$bgSubtlest(colors.insertColor)}`,
        borderRadius: "var(--ds-radius-medium, 6px)"
    });
}
function $e28b33baecacf396$export$40374aa1a728de2b(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        boxShadow: `0 0 0 4px ${$e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor)}`,
        borderRadius: "var(--ds-radius-medium, 6px)"
    });
}
function $e28b33baecacf396$export$c951a6a1ddd9727d(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        '--diff-decoration-marker-color': $e28b33baecacf396$var$borderAccent(colors.insertColor),
        '--diff-decoration-marker-ring-width': '1px'
    });
}
function $e28b33baecacf396$export$221709ac53cf77cf(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        '--diff-decoration-marker-color': $e28b33baecacf396$var$bgSubtlest(colors.insertColor),
        '--diff-decoration-marker-ring-width': '4px'
    });
}
function $e28b33baecacf396$export$bec1f78bdc255588(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        '--diff-decoration-marker-color': $e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor),
        '--diff-decoration-marker-ring-width': '4px'
    });
}
function $e28b33baecacf396$export$ac40da789fb904f1(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        ...$e28b33baecacf396$var$deletedInlineStyleBase(colors),
        '--diff-decoration-marker-color': $e28b33baecacf396$var$borderAccent(colors.deleteColor),
        '--diff-decoration-marker-ring-width': '1px'
    });
}
function $e28b33baecacf396$export$c2599555dda168f0(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        opacity: 0.8,
        '--diff-decoration-marker-color': $e28b33baecacf396$var$borderAccent(colors.deleteColor),
        '--diff-decoration-marker-ring-width': '1px'
    });
}
/** Whether the emphasised state is stated in the bottom border rather than a deeper highlight. */ function $e28b33baecacf396$var$usesUnderlineEmphasis(colors) {
    return colors.deletedInlineActiveEmphasis === 'underline';
}
function $e28b33baecacf396$export$cf33a4212f50e620(colors, isActive = false) {
    // Resting 'onEmphasis' paints nothing; the highlight arrives when the hover variables are set. The
    // active state takes the literal branch below, so hover cannot disturb it.
    if (colors.deletedInlineHighlight === 'onEmphasis' && !isActive) return (0, $8Dx7s.convertToInlineCss)({
        backgroundColor: `var(${$e28b33baecacf396$export$fd697ce9882275f1}, transparent)`,
        // Reserved while transparent, so the highlight arriving does not shift the text.
        borderBottom: `2px solid var(${$e28b33baecacf396$export$8e1375a56e74a28c}, transparent)`,
        padding: `1px 0 2px`
    });
    // Under 'underline' emphasis the highlight stays on its resting tint — the same one hover paints —
    // so only the border carries the emphasis.
    const isUnderlineEmphasis = isActive && $e28b33baecacf396$var$usesUnderlineEmphasis(colors);
    const backgroundColor = isActive && !isUnderlineEmphasis && colors.deletedInlineBorderTone === 'background' ? $e28b33baecacf396$var$bgSubtlerPressed(colors.deleteActiveColor) : $e28b33baecacf396$var$bgSubtlest(colors.deleteColor);
    const borderColor = isUnderlineEmphasis ? $e28b33baecacf396$var$borderAccent(colors.deleteActiveColor) : colors.deletedInlineBorderTone === 'background' ? backgroundColor : $e28b33baecacf396$var$borderAccent(colors.deleteColor);
    return (0, $8Dx7s.convertToInlineCss)({
        backgroundColor: backgroundColor,
        borderBottom: `2px solid ${borderColor}`,
        padding: `1px 0 2px`
    });
}
/**
 * Glyph opacity for the 'glyphTint' treatment. 'onEmphasis' schemes are opaque in every state: with
 * no highlight behind the glyph at rest, the accent text token has to carry the contrast on its own.
 */ function $e28b33baecacf396$var$deletedGlyphOpacity(colors, state) {
    if (colors.deletedInlineHighlight === 'onEmphasis') return 1;
    if (state === 'active') return colors.deleteTextColor ? 0.83 : 1;
    return colors.deleteTextColor || state === 'new' ? 0.83 : 0.6;
}
function $e28b33baecacf396$export$9a4d6f34023ac088(colors, state) {
    if (state === 'active') return (0, $8Dx7s.convertToInlineCss)({
        color: colors.deleteTextColor ? $e28b33baecacf396$var$textAccent(colors.deleteTextColor) : "var(--ds-text, #292A2E)",
        ...(0, $476d00a9ed5be1b0$export$9645c6cfb2371e19)(),
        textDecorationColor: $e28b33baecacf396$var$textAccent(colors.deleteTextColor ?? colors.deleteColor),
        position: 'relative',
        opacity: $e28b33baecacf396$var$deletedGlyphOpacity(colors, state)
    });
    return (0, $8Dx7s.convertToInlineCss)({
        color: $e28b33baecacf396$var$textAccent(colors.deleteTextColor ?? colors.deleteColor),
        ...(0, $476d00a9ed5be1b0$export$9645c6cfb2371e19)(),
        position: 'relative',
        opacity: $e28b33baecacf396$var$deletedGlyphOpacity(colors, state)
    });
}
function $e28b33baecacf396$export$4a3c54b59557bb6f(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        ...$e28b33baecacf396$var$deletedInlineStyleBase(colors),
        '--diff-decoration-marker-color': $e28b33baecacf396$var$bgSubtlest(colors.deleteColor),
        '--diff-decoration-marker-ring-width': '4px'
    });
}
function $e28b33baecacf396$export$b9725b2ff6d3fc81(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        ...$e28b33baecacf396$var$deletedInlineStyleActiveBase(colors),
        '--diff-decoration-marker-color': $e28b33baecacf396$var$bgSubtlerPressed(colors.deleteActiveColor),
        '--diff-decoration-marker-ring-width': '4px'
    });
}
function $e28b33baecacf396$export$59d4030fb8ee6502(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: `rgba(from ${$e28b33baecacf396$var$bgSubtlest(colors.insertColor)} r g b / ${colors.insertedCellOpacity})`,
        zIndex: colors.addedCellOverlayZIndex,
        outline: `1px solid ${$e28b33baecacf396$var$borderAccent(colors.insertColor)}`,
        pointerEvents: 'none'
    });
}
function $e28b33baecacf396$export$ad8079eeea0b3320(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: `rgba(from ${$e28b33baecacf396$var$bgSubtlest(colors.insertColor)} r g b / ${colors.insertedCellOpacity})`,
        zIndex: 2,
        outline: `1px solid ${$e28b33baecacf396$var$borderAccent(colors.insertColor)}`,
        pointerEvents: 'none',
        ...colors.roundedAddedCellOverlayInheritsBorder ? {
            border: 'inherit'
        } : {},
        borderRadius: 'inherit'
    });
}
function $e28b33baecacf396$export$c6c02df0b7af04e7(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: `rgba(from ${$e28b33baecacf396$var$bgSubtlest(colors.insertColor)} r g b / ${colors.insertedCellOpacity})`,
        zIndex: 1,
        outline: `1px solid ${$e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor)}`,
        pointerEvents: 'none'
    });
}
function $e28b33baecacf396$export$79e32cdc2c1a623c(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: `rgba(from ${$e28b33baecacf396$var$bgSubtlest(colors.deletedCellColor)} r g b / ${colors.deletedCellOpacity})`,
        zIndex: 1,
        outline: `1px solid ${$e28b33baecacf396$var$deletedCellOutline(colors)}`,
        pointerEvents: 'none'
    });
}
function $e28b33baecacf396$export$4e3e05920801547c(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: `rgba(from ${$e28b33baecacf396$var$bgSubtlest(colors.deletedCellColor)} r g b / ${colors.deletedCellOpacity})`,
        zIndex: 2,
        outline: `1px solid ${$e28b33baecacf396$var$deletedCellOutline(colors)}`,
        pointerEvents: 'none',
        border: 'inherit',
        borderRadius: 'inherit'
    });
}
function $e28b33baecacf396$export$638cdf51a14ce957(colors, isActive, hideAddedDiffsUnderline) {
    if (colors.insertedInlineTreatment === 'underline') return isActive ? $e28b33baecacf396$export$bfc49da2006f92f0(colors) : $e28b33baecacf396$export$82262e1f5a4bc0d4(colors);
    if (isActive) return hideAddedDiffsUnderline ? $e28b33baecacf396$export$6560b65b269507f7(colors) : $e28b33baecacf396$export$a33e264c283926(colors);
    return hideAddedDiffsUnderline ? $e28b33baecacf396$export$ff53ea63d183e034(colors) : $e28b33baecacf396$export$5fab5218b7eea3ef(colors);
}
function $e28b33baecacf396$export$f892bb9756d31514(colors, isActive, hideAddedDiffsUnderline) {
    return {
        background: isActive ? $e28b33baecacf396$var$bgSubtlerPressed(colors.insertActiveColor) : $e28b33baecacf396$var$bgSubtlest(colors.insertColor),
        border: hideAddedDiffsUnderline ? 'transparent' : $e28b33baecacf396$var$borderAccent(colors.insertColor)
    };
}
function $e28b33baecacf396$export$19b310b9417bfd22(colors) {
    // Nothing to wipe in where the resting state paints no highlight.
    if (colors.deletedInlineHighlight === 'onEmphasis') return {
        background: 'transparent',
        border: 'transparent'
    };
    return {
        background: $e28b33baecacf396$var$bgSubtlest(colors.deleteColor),
        border: $e28b33baecacf396$var$borderAccent(colors.deleteColor)
    };
}
function $e28b33baecacf396$export$2c459d08c73567bb(colors) {
    return $e28b33baecacf396$var$bgSubtlest(colors.deleteColor);
}
function $e28b33baecacf396$export$cd5de2dd5b015a7e(colors) {
    return $e28b33baecacf396$var$usesUnderlineEmphasis(colors) ? $e28b33baecacf396$var$borderAccent(colors.deleteActiveColor) : $e28b33baecacf396$export$2c459d08c73567bb(colors);
}
function $e28b33baecacf396$export$86cc6705ce45ea54(colors, state) {
    return colors.deletedInlineTreatment === 'strikethrough' ? $e28b33baecacf396$export$a253cd53c2e78280(colors, state === 'active') : $e28b33baecacf396$export$9a4d6f34023ac088(colors, state);
}
function $e28b33baecacf396$export$66146d9b3a76038c(colors, isActive) {
    if (colors.deletedNodeEmphasis !== 'stateful') return $e28b33baecacf396$export$2d4dff1bdf91b259(colors);
    return isActive ? $e28b33baecacf396$export$1b7d90755db7b218(colors) : $e28b33baecacf396$export$83928b85b59c5edf(colors);
}
// --- Deleted-content "REMOVED" lozenge ---
/** Structural CSS shared by both lozenge states — everything except the tint and the label colour. */ const $e28b33baecacf396$var$deletedLozengeBase = {
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
/**
 * Label colour for both lozenge states. `inverse` is a fixed tone that reads on any tint, which is
 * why the resting lozenge could get away with a hardcoded gray background; a scheme that tints the
 * lozenge itself needs `accent` instead.
 */ function $e28b33baecacf396$var$deletedLozengeTextColor(colors) {
    return colors.deletedLozengeTextTone === 'accent' ? $e28b33baecacf396$var$textAccent(colors.deletedLozengeColor) : "var(--ds-text-warning-inverse, #292A2E)";
}
function $e28b33baecacf396$export$488e769d08c6469(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        ...$e28b33baecacf396$var$deletedLozengeBase,
        color: $e28b33baecacf396$var$deletedLozengeTextColor(colors),
        backgroundColor: $e28b33baecacf396$var$bgSubtler(colors.deletedLozengeColor)
    });
}
function $e28b33baecacf396$export$6674adb58bd99cd8(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        ...$e28b33baecacf396$var$deletedLozengeBase,
        color: $e28b33baecacf396$var$deletedLozengeTextColor(colors),
        backgroundColor: $e28b33baecacf396$var$bgSubtlerPressed(colors.deleteActiveColor)
    });
}
function $e28b33baecacf396$export$da6c5a56c4c92f0d(colors, shape, isActive) {
    const isStateful = colors.insertedNodeEmphasis === 'stateful';
    switch(shape){
        case 'quote':
            if (!isStateful) return $e28b33baecacf396$export$4e1af505db4a78ba(colors);
            return isActive ? $e28b33baecacf396$export$39a663a4486e081(colors) : $e28b33baecacf396$export$479a1d7f8dbe8b9c(colors);
        case 'rule':
            if (!isStateful) return $e28b33baecacf396$export$d9f4032290f3d9c3(colors);
            return isActive ? $e28b33baecacf396$export$2c0869c8e71ee09e(colors) : $e28b33baecacf396$export$b1e61689af8f5034(colors);
        case 'cardBlock':
            if (!isStateful) return $e28b33baecacf396$export$fcd058bfb978a8cc(colors);
            return isActive ? $e28b33baecacf396$export$40374aa1a728de2b(colors) : $e28b33baecacf396$export$a2453fdbf1e29a79(colors);
        case 'marker':
            if (!isStateful) return $e28b33baecacf396$export$c951a6a1ddd9727d(colors);
            return isActive ? $e28b33baecacf396$export$bec1f78bdc255588(colors) : $e28b33baecacf396$export$221709ac53cf77cf(colors);
        case 'node':
        default:
            if (!isStateful) return $e28b33baecacf396$export$7c9daea341f0c892(colors);
            return isActive ? $e28b33baecacf396$export$90580fdb7ed1bb88(colors) : $e28b33baecacf396$export$da8b11b4aa693b34(colors);
    }
}
function $e28b33baecacf396$export$be2d45f1d38443ad(colors, category, isActive) {
    const isStrikethrough = colors.deletedInlineTreatment === 'strikethrough';
    const statefulMarker = ()=>isActive ? $e28b33baecacf396$export$b9725b2ff6d3fc81(colors) : $e28b33baecacf396$export$4a3c54b59557bb6f(colors);
    switch(category){
        case 'quote':
            // Both emphases share one builder here — `deletedQuoteNodeShape` already carries the
            // only variance (a ring versus a left border).
            return $e28b33baecacf396$export$3b7e7b503a47214f(colors);
        case 'container':
            return isStrikethrough ? $e28b33baecacf396$export$a253cd53c2e78280(colors, false) : $e28b33baecacf396$export$c2599555dda168f0(colors);
        case 'listItem':
            return colors.deletedNodeEmphasis === 'stateful' ? statefulMarker() : $e28b33baecacf396$export$c2599555dda168f0(colors);
        case 'marker':
            return colors.deletedNodeEmphasis === 'stateful' ? statefulMarker() : $e28b33baecacf396$export$9a4d6f34023ac088(colors, 'new');
        case 'generic':
        default:
            return isStrikethrough ? $e28b33baecacf396$export$a253cd53c2e78280(colors, false) : $e28b33baecacf396$export$9a4d6f34023ac088(colors, 'new');
    }
}
function $e28b33baecacf396$export$630ee3b3f22241a2(colors, isActive) {
    if (!isActive) return $e28b33baecacf396$export$a00bcdfbbac54e80(colors);
    return colors.deletedQuoteNodeActiveTone === 'backgroundPressed' ? $e28b33baecacf396$export$407fbec4f1e98cef(colors) : $e28b33baecacf396$export$3ed900f26521c9f5(colors);
}
function $e28b33baecacf396$export$a081ec2056a7f2bf(colors, { isActive: isActive, isRounded: isRounded }) {
    if (isActive) return isRounded ? $e28b33baecacf396$export$274be73202bc436b(colors) : $e28b33baecacf396$export$5750ffe19fbf9171(colors);
    if (colors.deletedNodeEmphasis === 'stateful') return isRounded ? $e28b33baecacf396$export$1a8b15734e611191(colors) : $e28b33baecacf396$export$2d291cc49390f12b(colors);
    return isRounded ? $e28b33baecacf396$export$c693fb2a96429890(colors) : $e28b33baecacf396$export$75e56dcd4b81b8e0(colors);
}
function $e28b33baecacf396$export$d0c526b03c2e5381(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        '--show-diff-atomic-inline-changed-border-color': $e28b33baecacf396$var$borderAccent(colors.insertColor)
    });
}
function $e28b33baecacf396$export$e85c271228836846(colors) {
    return (0, $8Dx7s.convertToInlineCss)({
        '--diff-delete-color': $e28b33baecacf396$var$borderAccent(colors.deleteColor),
        '--diff-delete-color-new': $e28b33baecacf396$var$bgSubtlest(colors.deleteColor),
        '--diff-delete-color-active': $e28b33baecacf396$var$bgSubtlerPressed(colors.deleteActiveColor),
        '--diff-delete-media-ring-color': $e28b33baecacf396$var$borderAccent(colors.deletedMediaRingColor),
        '--diff-delete-embed-strike-line': colors.strikesDeletedEmbedCard ? 'line-through' : 'none',
        ...colors.deletedNodeEmphasis === 'stateful' ? {
            '--diff-delete-opacity': '1',
            '--diff-delete-ring-width': 'var(--diff-decoration-marker-ring-width, 1px)',
            '--diff-delete-text-decoration-color': $e28b33baecacf396$var$borderAccent(colors.deleteColor)
        } : {}
    });
}



var $kNwwQ = parcelRequire("kNwwQ");

const $2b1f4eac4487ddd9$export$953f103c2e7e2bb = {
    insertColor: 'green',
    insertUnderlineStyle: 'solid',
    insertActiveColor: 'green',
    deleteColor: 'red',
    deleteActiveColor: 'red',
    deletedCellColor: 'gray',
    deletedCellOpacity: 0.5,
    deletedLozengeColor: 'gray',
    deletedLozengeTextTone: 'inverse',
    deletedMediaRingColor: 'red',
    deletedRowTreatment: 'strikeColor',
    insertedCellOpacity: 0.5,
    deletedQuoteNodeShape: 'ring',
    deletedCellBorderProminence: 'subtle',
    deletedBlockOutlineActiveEmphasis: 'background',
    addedCellOverlayZIndex: 1,
    roundedAddedCellOverlayInheritsBorder: true,
    insertedInlineTreatment: 'underline',
    deletedInlineTreatment: 'strikethrough',
    deletedInlineHighlight: 'always',
    insertedNodeEmphasis: 'stateful',
    deletedNodeEmphasis: 'stateful',
    deletedQuoteNodeActiveTone: 'backgroundPressed',
    strikesDeletedEmbedCard: true
};
const $2b1f4eac4487ddd9$export$656b90dc764786c5 = {
    insertColor: 'purple',
    insertUnderlineStyle: 'dotted',
    insertActiveColor: 'purple',
    deleteColor: 'gray',
    deleteActiveColor: 'red',
    deletedCellColor: 'gray',
    deletedCellOpacity: 0.5,
    deletedLozengeColor: 'gray',
    deletedLozengeTextTone: 'inverse',
    // Red, not `deleteColor`'s gray: a11y-fixes rings deleted media red in both schemes.
    deletedMediaRingColor: 'red',
    deletedRowTreatment: 'textTint',
    insertedCellOpacity: 0.2,
    deletedQuoteNodeShape: 'borderLeft',
    deletedCellBorderProminence: 'accent',
    deletedBlockOutlineActiveEmphasis: 'border',
    addedCellOverlayZIndex: 2,
    roundedAddedCellOverlayInheritsBorder: false,
    insertedInlineTreatment: 'borderBottom',
    deletedInlineTreatment: 'glyphTint',
    deletedInlineHighlight: 'always',
    insertedNodeEmphasis: 'static',
    deletedNodeEmphasis: 'static',
    deletedQuoteNodeActiveTone: 'borderAccent',
    strikesDeletedEmbedCard: false
};
const $2b1f4eac4487ddd9$var$createAttributionScheme = (color)=>{
    return {
        ...$2b1f4eac4487ddd9$export$656b90dc764786c5,
        insertColor: color,
        insertedInlineBorderTone: 'backgroundHovered',
        insertActiveColor: color,
        deleteColor: color,
        deletedInlineBorderTone: 'background',
        // Like the public schemes, the highlight holds its resting tint when active.
        deletedInlineActiveEmphasis: 'underline',
        // The contributor's own hue, so deleted text reads as theirs without a highlight behind it.
        deleteTextColor: color,
        deletedInlineHighlight: 'onEmphasis',
        deleteActiveColor: color,
        deletedCellColor: color
    };
};
const $2b1f4eac4487ddd9$var$attributionColorSchemes = Object.fromEntries((0, $kNwwQ.PARTICIPANT_COLOR_SCHEMES).map((color)=>[
        color,
        $2b1f4eac4487ddd9$var$createAttributionScheme(color)
    ]));
const $2b1f4eac4487ddd9$export$ff5fc39b2e819c33 = {
    ...$2b1f4eac4487ddd9$var$attributionColorSchemes,
    traditional: $2b1f4eac4487ddd9$export$953f103c2e7e2bb,
    standard: $2b1f4eac4487ddd9$export$656b90dc764786c5
};
const $2b1f4eac4487ddd9$export$fd28930f0c124891 = (colorScheme)=>colorScheme === 'standard' || colorScheme === 'traditional' ? colorScheme : undefined;










var $cbY7C = parcelRequire("cbY7C");


var $h1Peg = parcelRequire("h1Peg");







var $7Y8M5 = parcelRequire("7Y8M5");

const $73303cab152d5784$export$c3d9ff0aa91ceebb = 'diff-contributor-tag';
const $73303cab152d5784$export$cb6b1bf295e03557 = 'diff-contributor-tag-name';
const $73303cab152d5784$export$3644f075e95de861 = '200px';
const $73303cab152d5784$export$7b5a98f29fec636e = (0, $7Y8M5.akEditorSmallZIndex) + 1;
const $73303cab152d5784$export$f15e6853e58de422 = 'ak-editor-diff-contributor-tag';
const $73303cab152d5784$export$71576bf369e984b0 = 'data-revealed';
const $73303cab152d5784$export$7b0a066327bc02d9 = 1200;
const $73303cab152d5784$export$5aa7c23e2d307b4 = {
    boxSizing: 'border-box',
    maxWidth: '240px',
    backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
    // A `popover` is given one by the UA stylesheet.
    border: 'none',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    overflowWrap: 'break-word',
    paddingBlock: "var(--ds-space-050, 4px)",
    paddingInline: "var(--ds-space-075, 6px)",
    whiteSpace: 'normal',
    // A tooltip is never a hit target — it hangs over the document's own content.
    pointerEvents: 'none'
};
// Positioned against the host widget its decoration renders on the change's first character:
// `bottom: 100%` lifts the tag onto the line above, `inset-inline-start` starts it on that
// character.
const $73303cab152d5784$var$constraintStyle = (0, $8Dx7s.convertToInlineCss)({
    // `flex`, not `block`: a block box lays the tag on a line box whose strut is the *paragraph's*
    // line-height (~24px) against the tag's ~20px, so `bottom: 100%` pins that leftover strut to the
    // change and the tag floats above it. A flex container has no line box.
    display: 'flex',
    position: 'absolute',
    bottom: '100%',
    insetInlineStart: 0,
    // On the root, since that is the absolutely positioned box; the tag below fills it.
    maxWidth: $73303cab152d5784$export$3644f075e95de861,
    minWidth: 0,
    // This box's bottom edge is the join with the highlight, and the tag paints *above* that
    // highlight — so anything spilling past this edge would read as the tag laid on top of the change
    // rather than attached to it. The reveal's `translateY` is exactly that spill: it starts the tag
    // 4px low, and clipping the part that hangs over the highlight turns the rise into an unfurl out
    // of the join. `clip`, not `hidden`: `hidden` would make this a scroll container, and focusing the
    // tag mid-reveal would scroll it 4px out of alignment for good.
    //
    // The tooltip is unaffected — it is a `popover`, so it paints in the top layer, which no
    // ancestor's clip reaches.
    overflow: 'clip',
    zIndex: $73303cab152d5784$export$7b5a98f29fec636e,
    // It renders inside the document and it is not content: dragging a selection across the change
    // must not select it.
    userSelect: 'none'
});
// `backgroundColor` comes from the model, and is set by the controller. `opacity`, `pointer-events`
// and the transition between their two states are in `contributorTagStyles` — see
// `CONTRIBUTOR_TAG_CLASS`.
const $73303cab152d5784$var$tagStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    // Never wider than `MAX_TAG_WIDTH` on the root; overflow is ellipsised on the name below.
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    paddingInline: "var(--ds-space-050, 4px)",
    paddingBlock: "var(--ds-space-025, 2px)",
    // Top corners only: the bottom edge butts onto the change, and a rounded corner there would let
    // the page background through at the join.
    borderTopLeftRadius: "var(--ds-radius-small, 4px)",
    borderTopRightRadius: "var(--ds-radius-small, 4px)",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    // Deliberately no bottom border: the change already carries the accent as its own underline, and
    // a second rule directly above it reads as two objects rather than one label on one change.
    //
    // Deliberately no `elevation.shadow.overlay`: its `0 8px 12px` offset casts downwards onto the
    // change, which reads as a gap between the tag and the content it captions.
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    whiteSpace: 'nowrap',
    boxSizing: 'border-box'
});
const $73303cab152d5784$var$avatarsStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0
});
const $73303cab152d5784$var$nameStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'block',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
/** `@atlaskit/visually-hidden`, inlined. */ const $73303cab152d5784$var$srLabelStyle = (0, $8Dx7s.convertToInlineCss)({
    width: '1px',
    height: '1px',
    padding: 0,
    position: 'absolute',
    border: 0,
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    userSelect: 'none',
    whiteSpace: 'nowrap'
});
/**
 * Ids for the hidden label that the tag's `aria-labelledby` points at. Namespaced and random because
 * the tag renders inside the document and shares the host page's id space — the same reason
 * `VanillaTooltip` does it this way. The counter is a fallback for non-secure contexts, where
 * `crypto.randomUUID` is unavailable.
 */ const $73303cab152d5784$var$generateLabelId = (()=>{
    let count = 0;
    return ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `${$73303cab152d5784$export$f15e6853e58de422}-label-${crypto.randomUUID()}` : `${$73303cab152d5784$export$f15e6853e58de422}-label-${count += 1}`;
})();
const $73303cab152d5784$var$createSpan = (doc, style, attributes = {})=>{
    const span = doc.createElement('span');
    span.setAttribute('style', style);
    for (const [name, value] of Object.entries(attributes))span.setAttribute(name, value);
    return span;
};
const $73303cab152d5784$export$c10c5ca7fcd98750 = (doc, anchorName)=>{
    const labelId = $73303cab152d5784$var$generateLabelId();
    const root = $73303cab152d5784$var$createSpan(doc, $73303cab152d5784$var$constraintStyle);
    if (anchorName) {
        // Anchored to the block's own box, so the tag clears whatever margin its node type has — the
        // same `anchor()` insets the `IndicatorBar` uses. A browser without anchor positioning rejects
        // these values and keeps the `bottom: 100%` fallback above.
        root.style.setProperty('bottom', `anchor(--${anchorName} top)`);
        root.style.setProperty('inset-inline-start', `anchor(--${anchorName} left)`);
    }
    const tag = $73303cab152d5784$var$createSpan(doc, $73303cab152d5784$var$tagStyle, {
        class: $73303cab152d5784$export$f15e6853e58de422,
        'data-testid': $73303cab152d5784$export$c3d9ff0aa91ceebb,
        // Named by the hidden label rather than `aria-label`, which would be a second copy of the same
        // sentence. `role="note"` takes its name from the author, not its contents, so without this
        // the tag is a focus stop with no accessible name.
        'aria-labelledby': labelId,
        role: 'note',
        // Focusable so keyboard and screen-reader users can reach the tag and its tooltip. Its focus
        // ring is drawn inward — see `contributorTagStyles` in editor-core.
        tabindex: '0'
    });
    const avatars = $73303cab152d5784$var$createSpan(doc, $73303cab152d5784$var$avatarsStyle);
    // `aria-hidden`: the hidden label restates this name in a full sentence, so leaving it in the
    // tree announced the contributor twice ("Priya Changed by Priya").
    const name = $73303cab152d5784$var$createSpan(doc, $73303cab152d5784$var$nameStyle, {
        'aria-hidden': 'true',
        'data-testid': $73303cab152d5784$export$cb6b1bf295e03557
    });
    const srLabel = $73303cab152d5784$var$createSpan(doc, $73303cab152d5784$var$srLabelStyle, {
        id: labelId
    });
    tag.append(avatars, name, srLabel);
    root.appendChild(tag);
    return {
        avatars: avatars,
        name: name,
        root: root,
        srLabel: srLabel,
        tag: tag
    };
};






var $ekCm6 = parcelRequire("ekCm6");


var $izukn = parcelRequire("izukn");




/**
 * The icons a contributor tag can draw, as inline SVG.
 *
 * Neither `@atlaskit/icon`, `@atlaskit/icon-lab` nor `@atlaskit/logo` exposes a raw-SVG entry
 * point, so the markup is copied here rather than kept as a React island for these glyphs. Keep in
 * sync with the sources named on each constant.
 *
 * The Rovo hex is the `brand` appearance, whose `--rovo-*-color` variables resolve to `initial` in
 * both themes — the fallbacks below are the rendered colours, so no theme observer is needed.
 */ /** `@atlaskit/icon/core/person`, at the 16px the avatar renders it. */ const $ef6d5f90686210a0$var$PERSON_ICON_SVG = `<svg width="16" height="16" fill="none" viewBox="0 0 16 16" role="presentation" style="display:block"><path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/></svg>`;
/** `@atlaskit/icon-lab/core/ai-bot`, at 12px so it fits inside the 16px hexagon. */ const $ef6d5f90686210a0$var$AI_BOT_ICON_SVG = `<svg width="12" height="12" fill="none" viewBox="0 0 16 16" role="presentation" style="display:block"><path fill="currentcolor" d="M13 5.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zm-6.5 2v3H5v-3zm4.5 0v3H9.5v-3zm3.5 1H16V10h-1.5v3a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-3H0V8.5h1.5v-3a2 2 0 0 1 2-2h3.75v-2H4V0h4a.75.75 0 0 1 .75.75V3.5h3.75a2 2 0 0 1 2 2z"/></svg>`;
/**
 * The glyph from `@atlaskit/icon/core/ai-agent`, at 12px so it fits inside the 16px hexagon.
 * The icon package only exposes this as a React component; this tag is otherwise imperative DOM,
 * so keep the generated glyph here rather than introducing a React render boundary.
 */ const $ef6d5f90686210a0$var$AI_AGENT_ICON_SVG = `<svg width="12" height="12" fill="none" viewBox="0 0 16 16" role="presentation" style="display:block"><path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/></svg>`;
/** `RovoHexIcon` from `@atlaskit/logo/rovo-hex/icon`, at the 16px `xxsmall` renders. */ const $ef6d5f90686210a0$var$ROVO_HEX_ICON_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" role="presentation" style="display:block"><path fill="#1868db" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/><path fill="#6a9a23" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/><path fill="#af59e1" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/><path fill="#fca700" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/></svg>`;
/** ClaudeLogo from ai-mate/studio-browse-kit, inset to fit the agent hexagon. */ const $ef6d5f90686210a0$var$CLAUDE_ICON_SVG = `<svg width="12" height="12" viewBox="8 8 32 32" role="presentation" style="display:block"><path fill="#FFFFFF" d="M14.2785 29.274L20.5732 25.7445L20.6785 25.4369L20.5732 25.2669H20.2653L19.2122 25.2021L15.6152 25.105L12.4962 24.9755L9.47443 24.8136L8.71291 24.6517L8 23.7126L8.07291 23.2431L8.71291 22.8141L9.62835 22.895L11.6537 23.0326L14.6916 23.2431L16.8952 23.3726L20.16 23.7126H20.6785L20.7514 23.5022L20.5732 23.3726L20.4354 23.2431L17.2922 21.1141L13.8896 18.8636L12.1073 17.5684L11.1433 16.9127L10.6572 16.2975L10.4466 14.9537L11.3215 13.9904L12.4962 14.0713L12.7959 14.1523L13.9868 15.067L16.5306 17.0342L19.8522 19.4789L20.3382 19.8836L20.5327 19.746L20.557 19.6489L20.3382 19.2846L18.5316 16.0223L16.6035 12.7033L15.7448 11.3271L15.518 10.5014C15.437 10.1614 15.3803 9.87807 15.3803 9.52998L16.3767 8.17809L16.9276 8L18.2562 8.17809L18.8152 8.6638L19.6415 10.55L20.9782 13.5209L23.0522 17.5603L23.6597 18.7584L23.9838 19.8674L24.1053 20.2074H24.3159V20.0132L24.4861 17.7384L24.802 14.9456L25.1099 11.3514L25.2152 10.3395L25.7175 9.12522L26.7139 8.46952L27.4916 8.84189L28.1316 9.75664L28.0425 10.3476L27.6618 12.8166L26.9165 16.6861L26.4304 19.2765H26.7139L27.038 18.9527L28.3504 17.2122L30.5539 14.4599L31.5261 13.3671L32.6603 12.1609L33.3894 11.5861H34.7666L35.7792 13.0918L35.3256 14.6461L33.9079 16.4432L32.7332 17.9651L31.0481 20.2317L29.9949 22.045L30.0922 22.1907L30.3433 22.1665L34.1509 21.3569L36.2086 20.9846L38.6633 20.5636L39.7732 21.0817L39.8947 21.6079L39.4572 22.6845L36.8324 23.3322L33.7539 23.9474L29.1686 25.0321L29.1119 25.0726L29.1767 25.1536L31.2425 25.3478L32.1256 25.3964H34.2886L38.3149 25.6959L39.3681 26.3921L40 27.2421L39.8947 27.8897L38.2744 28.7154L36.0871 28.1973L30.9833 26.9831L29.2334 26.5459H28.9904V26.6916L30.4486 28.1164L33.122 30.5287L36.4678 33.6372L36.638 34.4063L36.2086 35.0134L35.7549 34.9486L32.8142 32.7387L31.68 31.743L29.1119 29.5816H28.9418V29.8082L29.5332 30.6744L32.6603 35.3696L32.8223 36.8105L32.5954 37.28L31.7853 37.5634L30.8942 37.4015L29.0633 34.8353L27.1757 31.9454L25.6527 29.3549L25.4663 29.4602L24.5671 39.1338L24.1458 39.6276L23.1737 40L22.3635 39.3848L21.9342 38.3891L22.3635 36.422L22.882 33.8558L23.3033 31.8158L23.6841 29.2821L23.9109 28.4402L23.8947 28.3835L23.7084 28.4078L21.7965 31.0306L18.8881 34.9567L16.5873 37.4177L16.0365 37.6362L15.0805 37.1424L15.1696 36.2601L15.7043 35.4748L18.8881 31.4273L20.8081 28.9178L22.0476 27.4688L22.0395 27.2583H21.9666L13.5089 32.7468L12.002 32.9411L11.3539 32.3339L11.4349 31.3382L11.7428 31.0144L14.2866 29.2659L14.2785 29.274Z"/></svg>`;
const $ef6d5f90686210a0$var$markup = {
    aiAgent: $ef6d5f90686210a0$var$AI_AGENT_ICON_SVG,
    aiBot: $ef6d5f90686210a0$var$AI_BOT_ICON_SVG,
    claude: $ef6d5f90686210a0$var$CLAUDE_ICON_SVG,
    person: $ef6d5f90686210a0$var$PERSON_ICON_SVG,
    rovoHex: $ef6d5f90686210a0$var$ROVO_HEX_ICON_SVG
};
/**
 * Parsing the markup is the same work for every tag, so each icon is parsed once into a template
 * and cloned per use — appending a `DocumentFragment` moves its children out of it, so a shared
 * fragment would leave every icon after the first empty.
 */ const $ef6d5f90686210a0$var$templates = {};
const $ef6d5f90686210a0$export$40449554e53b0054 = (icon, doc)=>{
    let template = $ef6d5f90686210a0$var$templates[icon];
    if (!template) {
        template = doc.createElement('template');
        template.innerHTML = $ef6d5f90686210a0$var$markup[icon];
        $ef6d5f90686210a0$var$templates[icon] = template;
    }
    return template.content.cloneNode(true);
};


/** Agent kinds with a custom contributor-tag icon. */ const $76ceb2a7022cc933$var$AGENT_KIND_ICONS = {
    claude: 'claude',
    rovo: 'rovoHex'
};
/** The size `@atlaskit/avatar`'s `xxsmall` rendered at. */ const $76ceb2a7022cc933$var$AVATAR_SIZE = (0, $ekCm6.AVATAR_SIZES).xxsmall;
/** `xxsmall` also carried a `space.025` margin — the same 2px — which is where the ring is painted. */ const $76ceb2a7022cc933$var$AVATAR_RING_WIDTH = (0, $izukn.BORDER_WIDTH);
const $76ceb2a7022cc933$var$AVATAR_BOX_SIZE = $76ceb2a7022cc933$var$AVATAR_SIZE + $76ceb2a7022cc933$var$AVATAR_RING_WIDTH * 2;
/** Reused from `@atlaskit/avatar`'s `avatar-content`, so the two shapes cannot drift. */ const $76ceb2a7022cc933$var$HEXAGON_CLIP_PATH = 'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)';
const $76ceb2a7022cc933$var$boxStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxSizing: 'border-box',
    width: `${$76ceb2a7022cc933$var$AVATAR_BOX_SIZE}px`,
    height: `${$76ceb2a7022cc933$var$AVATAR_BOX_SIZE}px`
});
const $76ceb2a7022cc933$var$shapeStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    width: `${$76ceb2a7022cc933$var$AVATAR_SIZE}px`,
    height: `${$76ceb2a7022cc933$var$AVATAR_SIZE}px`,
    overflow: 'hidden'
});
const $76ceb2a7022cc933$var$imageStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover'
});
/** The `@atlaskit/avatar` image fallback: a subtle glyph on a tinted box. */ const $76ceb2a7022cc933$var$personFallbackStyle = (0, $8Dx7s.convertToInlineCss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    color: "var(--ds-icon-subtle, #505258)"
});
const $76ceb2a7022cc933$export$14a87e8c9cc753cb = ({ contributor: contributor, doc: doc, ringColor: ringColor, stackIndex: stackIndex })=>{
    const isAgent = contributor.kind === 'agent';
    const element = doc.createElement('span');
    element.setAttribute('style', $76ceb2a7022cc933$var$boxStyle);
    // Decorative: the tag names its contributors in the visually hidden label its screen-reader
    // announcement comes from.
    element.setAttribute('aria-hidden', 'true');
    if (stackIndex !== undefined) element.style.setProperty('z-index', String(stackIndex));
    const shape = doc.createElement('span');
    shape.setAttribute('style', $76ceb2a7022cc933$var$shapeStyle);
    element.appendChild(shape);
    if (isAgent) {
        element.style.setProperty('clip-path', $76ceb2a7022cc933$var$HEXAGON_CLIP_PATH);
        shape.style.setProperty('clip-path', $76ceb2a7022cc933$var$HEXAGON_CLIP_PATH);
    } else shape.style.setProperty('border-radius', "var(--ds-radius-full, 9999px)");
    let image;
    let unbindImageError;
    const showFallback = ()=>{
        unbindImageError?.();
        unbindImageError = undefined;
        image?.remove();
        image = undefined;
        if (!isAgent) {
            const fallback = doc.createElement('span');
            fallback.setAttribute('style', $76ceb2a7022cc933$var$personFallbackStyle);
            fallback.appendChild((0, $ef6d5f90686210a0$export$40449554e53b0054)('person', doc));
            shape.appendChild(fallback);
            return;
        }
        shape.appendChild((0, $ef6d5f90686210a0$export$40449554e53b0054)($76ceb2a7022cc933$var$AGENT_KIND_ICONS[contributor.agentKind ?? 'external'] ?? 'aiAgent', doc));
    };
    if (contributor.avatarUrl) {
        image = doc.createElement('img');
        image.alt = '';
        image.decoding = 'async';
        image.draggable = false;
        image.loading = 'lazy';
        image.setAttribute('style', $76ceb2a7022cc933$var$imageStyle);
        unbindImageError = (0, $cbY7C.bind)(image, {
            type: 'error',
            listener: showFallback
        });
        shape.appendChild(image);
        image.src = contributor.avatarUrl;
    } else showFallback();
    const setRingColor = (nextRingColor)=>{
        if (isAgent) {
            element.style.setProperty('background', nextRingColor);
            // Shows through wherever the artwork is transparent, as the avatar background did.
            shape.style.setProperty('background', nextRingColor);
            return;
        }
        shape.style.setProperty('box-shadow', `0 0 0 ${$76ceb2a7022cc933$var$AVATAR_RING_WIDTH}px ${nextRingColor}`);
        shape.style.setProperty('background', nextRingColor);
    };
    setRingColor(ringColor);
    return {
        destroy: ()=>{
            unbindImageError?.();
            unbindImageError = undefined;
            element.remove();
        },
        element: element,
        setRingColor: setRingColor
    };
};



/**
 * Resolves the tag's accent from the same scheme value the highlight was drawn from, so the colour
 * the two carry can never drift — only the tone does, which is `getAccentTokens`'s to pick.
 */ const $ce68ad859e395fd5$var$getTagAccent = ({ colorScheme: colorScheme, isActive: isActive, isInserted: isInserted })=>{
    const colors = (0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme ?? 'standard'];
    const accent = isInserted ? isActive ? colors.insertActiveColor : colors.insertColor : isActive ? colors.deleteActiveColor : colors.deleteColor;
    return (0, $e28b33baecacf396$export$7d0a3d1deacd835a)(accent);
};
/**
 * Keyboard focus, as a member of `revealSources` alongside the elements the pointer can be over. It
 * has no element of its own to key on — the tag is already in the set under its own hover.
 */ const $ce68ad859e395fd5$var$FOCUS_SOURCE = Symbol('contributor-tag-focus');
/** Moves the tag between the two ends of the fade `contributorTagStyles` declares. */ const $ce68ad859e395fd5$var$setRevealed = (tag, isVisible)=>{
    tag.toggleAttribute((0, $73303cab152d5784$export$71576bf369e984b0), isVisible);
};
/**
 * Whether the browser is showing this focus, which is the same question its focus ring answers — see
 * the `:focus-visible` rule in `contributorTagStyles`.
 *
 * Clicking the tag focuses it, so a tag held up by focus alone stayed on screen after the pointer had
 * left, until something else took focus (EDITOR-9046). Measured in Chromium: a click leaves this
 * `false` and `Tab` leaves it `true`, so the keyboard focus stop is unaffected.
 */ const $ce68ad859e395fd5$var$isFocusVisible = (tag)=>tag.matches(':focus-visible');
/**
 * Whether flipping the tag's state will actually run a transition on it.
 *
 * Asked of the element rather than of `matchMedia`, because reduced motion and a missing stylesheet
 * both compute to a zero duration — and a transition that never starts fires no `transitionend`, so
 * a tag waiting for one would sit on screen until the backstop timeout.
 *
 * Read only when a tag is being taken down: it resolves style.
 */ const $ce68ad859e395fd5$var$willTransition = (tag)=>window.getComputedStyle(tag).transitionDuration.split(',').some((duration)=>parseFloat(duration) > 0);
/**
 * Fades a tag that is still on screen out, and releases it once the fade has finished.
 *
 * No controller owns the element by the time this runs — it is released up front so a republished
 * model's tag can fade in over the top — so everything the removal needs is captured here.
 */ const $ce68ad859e395fd5$var$fadeTagOut = (tag, release)=>{
    $ce68ad859e395fd5$var$setRevealed(tag, false);
    // Nothing to wait for: reduced motion, or no stylesheet to fade it with.
    if (!$ce68ad859e395fd5$var$willTransition(tag)) {
        release();
        return;
    }
    let unbind;
    let isFinished = false;
    const finish = ()=>{
        // Whichever of the two signals arrives first wins; the other must not release twice.
        if (isFinished) return;
        isFinished = true;
        unbind?.();
        unbind = undefined;
        clearTimeout(fallbackId);
        release();
    };
    unbind = (0, $cbY7C.bind)(tag, {
        type: 'transitionend',
        // `transitionend` bubbles, and opacity is not the only property that could ever carry one.
        listener: (event)=>{
            if (event.target === tag && event.propertyName === 'opacity') finish();
        }
    });
    const fallbackId = setTimeout(finish, (0, $73303cab152d5784$export$7b0a066327bc02d9));
};
/** The contributors a tag draws, keyed so a republished model can be recognised as the same pair. */ const $ce68ad859e395fd5$var$identityOf = (model)=>[
        model?.contributor,
        model?.connectedContributor
    ].map((contributor)=>contributor ? `${contributor.kind}:${contributor.agentKind ?? ''}:${contributor.name}:${contributor.avatarUrl ?? ''}` : '').join('|');
class $ce68ad859e395fd5$export$6201a9c6b8711f66 {
    mount(host) {
        this.host = host;
        const { sharedState: sharedState } = this.options.api?.showDiff ?? {};
        this.unsubscribe = sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            this.applyModel(this.findModel(nextSharedState?.contributorTags));
        });
        this.applyModel(this.findModel(sharedState?.currentState()?.contributorTags));
    }
    destroy() {
        this.isDestroyed = true;
        this.unsubscribe?.();
        this.unsubscribe = undefined;
        this.teardownTag();
        this.host = undefined;
    }
    findModel(tags) {
        return tags?.find((tag)=>tag.diffId === this.options.diffId);
    }
    applyModel(next) {
        if (this.isDestroyed || next === this.model) return;
        const previous = this.model;
        this.model = next;
        const { host: host } = this;
        if (!next || !host) {
            this.teardownTag();
            return;
        }
        if (!this.dom) {
            this.dom = (0, $73303cab152d5784$export$c10c5ca7fcd98750)(host.ownerDocument, this.options.anchorName);
            this.bindTag(this.dom);
            host.appendChild(this.dom.root);
        }
        if (!previous || $ce68ad859e395fd5$var$identityOf(previous) !== $ce68ad859e395fd5$var$identityOf(next)) this.renderAvatars(next);
        this.renderLabels(next);
        this.applyAccent(next);
        this.syncHighlightBindings(next);
        this.applyVisibility();
        this.syncTooltip();
    }
    /**
   * Takes the tag's DOM down, keeping the subscription so a republished model redraws it.
   *
   * A tag that is still on screen is released here and fades out on its own, so a republished
   * model's tag fades in over the top of the outgoing one — see `fadeTagOut`.
   */ teardownTag() {
        // Unbound synchronously, ahead of any fade: a tag on its way out must not be revealed again by
        // the pointer, and these listeners are what hold this controller.
        this.unbindHighlightState();
        this.boundSelector = undefined;
        this.unbindTag?.();
        this.unbindTag = undefined;
        // Destroyed rather than carried through the fade: it is a popover in the top layer.
        this.tooltip?.destroy();
        this.tooltip = undefined;
        this.tooltipContent = undefined;
        const { dom: dom, isVisible: isVisible } = this;
        // Destroying an avatar removes its element, so the avatars go with whoever removes the tag —
        // destroyed here and it would fade out empty.
        const { avatars: avatars } = this;
        this.avatars = [];
        this.dom = undefined;
        this.isVisible = false;
        // The set belongs to the listeners just unbound: a stale member would draw the tag as visible
        // with the pointer nowhere near it.
        this.revealSources.clear();
        if (!dom) return;
        const release = ()=>{
            avatars.forEach((avatar)=>avatar.destroy());
            dom.root.remove();
        };
        // Nothing on screen to fade. `isConnected` covers ProseMirror destroying the widget: a fade on
        // a detached element never starts.
        if (!isVisible || !dom.tag.isConnected) {
            release();
            return;
        }
        $ce68ad859e395fd5$var$fadeTagOut(dom.tag, release);
    }
    bindTag({ tag: tag }) {
        // `mouseover`/`mouseout` rather than the enter/leave pair, because they are what fire as the
        // pointer moves between the tag's own children. Both are keyed on the tag, so those moves add
        // and remove the same member and the set never empties.
        this.unbindTag = (0, $cbY7C.bindAll)(tag, [
            {
                type: 'mouseover',
                listener: this.trackRevealSource(tag, true)
            },
            {
                type: 'mouseout',
                listener: this.trackRevealSource(tag, false)
            },
            // Only a focus the browser is showing holds the tag up — see `isFocusVisible`.
            {
                type: 'focus',
                listener: ()=>this.setRevealSource($ce68ad859e395fd5$var$FOCUS_SOURCE, $ce68ad859e395fd5$var$isFocusVisible(tag))
            },
            {
                type: 'blur',
                listener: this.trackRevealSource($ce68ad859e395fd5$var$FOCUS_SOURCE, false)
            }
        ]);
    }
    /** One listener shape for every reveal source, so all of them land in the same set. */ trackRevealSource(source, isRevealing) {
        return ()=>this.setRevealSource(source, isRevealing);
    }
    setRevealSource(source, isRevealing) {
        if (isRevealing) this.revealSources.add(source);
        else this.revealSources.delete(source);
        this.applyVisibility();
    }
    renderAvatars(model) {
        const { avatars: container } = this.dom ?? {};
        if (!container) return;
        this.avatars.forEach((avatar)=>avatar.destroy());
        this.avatars = [];
        const doc = container.ownerDocument;
        const { background: background } = this.accentOf(model);
        const isPrimaryAgent = model.contributor.kind === 'agent';
        // Resolved by `kind` so a reverse `connectedTo` (an attributed user pointing at its agent)
        // renders identically.
        const user = isPrimaryAgent ? model.connectedContributor : model.contributor;
        const agent = isPrimaryAgent ? model.contributor : model.connectedContributor;
        // Hand-rolled avatar stack: `@atlaskit/avatar-group` cannot render below 24px and the tag uses
        // 16px avatars.
        const stack = model.connectedContributor ? [
            ...user ? [
                {
                    contributor: user,
                    stackIndex: 1
                }
            ] : [],
            ...agent ? [
                {
                    contributor: agent,
                    stackIndex: 0
                }
            ] : []
        ] : [
            {
                contributor: model.contributor
            }
        ];
        stack.forEach(({ contributor: contributor, stackIndex: stackIndex }, index)=>{
            const avatar = (0, $76ceb2a7022cc933$export$14a87e8c9cc753cb)({
                contributor: contributor,
                doc: doc,
                ringColor: background,
                stackIndex: stackIndex
            });
            if (index < stack.length - 1) // Overlaps the leading avatar of a connected pair onto the one it sits in front of.
            avatar.element.style.setProperty('margin-inline-end', "var(--ds-space-negative-050, -4px)");
            container.appendChild(avatar.element);
            this.avatars.push(avatar);
        });
    }
    renderLabels(model) {
        if (!this.dom) return;
        const { fullLabel: fullLabel, visibleName: visibleName } = (0, $81beb338efe450ad$export$365f1be1e901f461)(model, this.options.getIntl().formatMessage);
        this.dom.name.textContent = visibleName;
        this.fullLabel = fullLabel;
        this.dom.srLabel.textContent = fullLabel;
    }
    accentOf(model) {
        return $ce68ad859e395fd5$var$getTagAccent({
            colorScheme: model.colorScheme,
            isActive: Boolean(model.isActive),
            isInserted: model.isInserted ?? true
        });
    }
    applyAccent(model) {
        if (!this.dom) return;
        const accent = this.accentOf(model);
        this.dom.tag.style.setProperty('background-color', accent.background);
        this.dom.name.style.setProperty('color', accent.text);
        this.avatars.forEach((avatar)=>avatar.setRingColor(accent.background));
    }
    /**
   * Visibility — the one thing the model does not carry on its own, because hover is not in it.
   *
   * One idempotent attribute write, with nothing to guard: whether the flip is a real one, whether
   * the tag is attached yet, and whether motion is wanted at all are all the stylesheet's to answer.
   */ applyVisibility() {
        if (!this.dom) return;
        const isVisible = Boolean(this.model?.isActive) || this.revealSources.size > 0;
        this.isVisible = isVisible;
        $ce68ad859e395fd5$var$setRevealed(this.dom.tag, isVisible);
        this.applyHighlightHover();
    }
    /**
   * Brings the deleted highlight up alongside the tag, for the schemes that paint none at rest —
   * see `DELETED_HIGHLIGHT_BG_VAR`. Keyed on `revealSources` rather than on the tag's own
   * visibility: an active change paints its highlight from its decoration style, which this must
   * not be able to override.
   */ applyHighlightHover() {
        const isHovered = this.revealSources.size > 0;
        const colors = (0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[this.model?.colorScheme ?? 'standard'];
        this.highlightElements.forEach((highlight)=>{
            if (isHovered) {
                highlight.style.setProperty((0, $e28b33baecacf396$export$fd697ce9882275f1), (0, $e28b33baecacf396$export$2c459d08c73567bb)(colors));
                highlight.style.setProperty((0, $e28b33baecacf396$export$8e1375a56e74a28c), (0, $e28b33baecacf396$export$cd5de2dd5b015a7e)(colors));
            } else {
                highlight.style.removeProperty((0, $e28b33baecacf396$export$fd697ce9882275f1));
                highlight.style.removeProperty((0, $e28b33baecacf396$export$8e1375a56e74a28c));
            }
        });
    }
    /**
   * The full label is always the tooltip, whether or not the name it draws is clipped: a name longer
   * than `MAX_TAG_WIDTH` is ellipsised, and a connected pair spells out a contributor the tag does
   * not show at any width.
   *
   * `VanillaTooltip` has no "set new content" call, so it is rebuilt when the label changes — the
   * shape of `syncVanillaDisabledTooltip` in `mentionNodeView`.
   */ syncTooltip() {
        const content = this.dom ? this.fullLabel : undefined;
        if (content === this.tooltipContent) return;
        this.tooltip?.destroy();
        this.tooltip = undefined;
        this.tooltipContent = content;
        if (!content || !this.dom) return;
        this.tooltip = new (0, $h1Peg.VanillaTooltip)(this.dom.tag, content, // Generated id.
        undefined, // No class: the look is inline, because a hoisted tooltip is outside the `.ProseMirror`
        // scope `VANILLA_TOOLTIP_DEFAULT_CLASS` is keyed on — see `CONTRIBUTOR_TAG_TOOLTIP_STYLES`.
        '', // Default delay, no `onShow`, and the default `top` placement.
        undefined, (0, $73303cab152d5784$export$5aa7c23e2d307b4), undefined, undefined, this.resolveTooltipContainer());
        // `VanillaTooltip` sets `aria-describedby` on its trigger, which would announce the label a
        // second time — the hidden child already announces it, and names the tag with it.
        this.dom.tag.removeAttribute('aria-describedby');
        // Out of the tag but still in the document, so its text would otherwise be a third copy of the
        // same sentence. It stays visible for sighted users, who need the part of the name the tag
        // clipped.
        this.tooltip.element.setAttribute('aria-hidden', 'true');
    }
    /**
   * Where the tooltip is appended, rather than inside the tag.
   *
   * Popper and the browser only agree on a top-layer popover's origin when nothing above it is
   * transformed, and the tag hangs under the editor's own transformed nodes — inside a wide image
   * that is `.rich-media-item`, whose `translateX(-50%)` threw the tooltip off screen
   * (EDITOR-8971). The content area is the nearest ancestor with none of that above it, and keeps
   * the tooltip inside the editor it belongs to; the document body covers an appearance that has
   * no content area.
   */ resolveTooltipContainer() {
        const editorRoot = this.options.getEditorRoot();
        return editorRoot?.closest('.ak-editor-content-area') ?? editorRoot?.ownerDocument.body;
    }
    /**
   * Observes the highlight this tag describes, for what CSS here cannot see: its hover state. The
   * highlight is a ProseMirror decoration in a different DOM subtree, so listeners are bound
   * imperatively via `data-diff-id`.
   *
   * Deliberately not routed through plugin state: a transaction per pointer move would re-run the
   * memoised decoration calculation.
   */ syncHighlightBindings(model) {
        const { diffId: diffId } = this.options;
        const selector = [
            diffId,
            ...model.linkedDiffIds ?? []
        ].map((id)=>`[data-diff-id="${id}"]`).join(', ');
        if (selector === this.boundSelector) return;
        this.boundSelector = selector;
        this.unbindHighlightState();
        // ProseMirror draws the tag's host in the same pass as the highlights it binds to, so those may
        // not be in the document yet. A microtask lands once that pass has finished.
        const pendingBind = ++this.bindToken;
        queueMicrotask(()=>{
            if (!this.isDestroyed && pendingBind === this.bindToken) this.bindHighlightState(selector);
        });
    }
    bindHighlightState(selector) {
        // Scoped to this editor's content root, so a tag can only ever bind to the decorations its own
        // plugin instance rendered — another editor on the page, or one nested inside this one, cannot
        // reveal this tag.
        const highlights = this.options.getEditorRoot()?.querySelectorAll(selector);
        if (!highlights?.length) return;
        // `bindAll` takes a single target, and a change can render more than one highlight. Each is its
        // own member of `revealSources`, so the pointer can cross between them without the set
        // emptying.
        this.highlightElements = Array.from(highlights);
        this.unbindHighlights = this.highlightElements.map((highlight)=>(0, $cbY7C.bindAll)(highlight, [
                {
                    type: 'mouseenter',
                    listener: this.trackRevealSource(highlight, true)
                },
                {
                    type: 'mouseleave',
                    listener: this.trackRevealSource(highlight, false)
                }
            ]));
        // The pointer may already be over a highlight by the time this binds, a draw pass after it
        // entered.
        this.applyHighlightHover();
    }
    unbindHighlightState() {
        this.unbindHighlights.forEach((unbind)=>unbind());
        this.unbindHighlights = [];
        // Cleared before the elements are released: ProseMirror reuses decoration DOM, so a hover left
        // written on one would paint a highlight nothing is holding up.
        this.highlightElements.forEach((highlight)=>{
            highlight.style.removeProperty((0, $e28b33baecacf396$export$fd697ce9882275f1));
            highlight.style.removeProperty((0, $e28b33baecacf396$export$8e1375a56e74a28c));
        });
        this.highlightElements = [];
    }
    constructor(options){
        this.options = options;
        this.avatars = [];
        /** Guards a deferred bind that a later model change has already superseded. */ this.bindToken = 0;
        this.boundSelector = void 0;
        this.dom = void 0;
        this.fullLabel = '';
        /** The bound highlights themselves, so hover can write the deleted highlight onto them. */ this.highlightElements = [];
        this.host = void 0;
        this.isDestroyed = false;
        /** Last visibility written, so a teardown knows whether there is anything on screen to fade. */ this.isVisible = false;
        this.model = void 0;
        /**
     * Everything currently asking for the tag to be up, other than the model: each hovered highlight,
     * the tag itself while the pointer is on it, and `FOCUS_SOURCE` while it holds focus.
     *
     * One set rather than independent booleans, which is what let the exit's trailing delay go: a
     * pointer crossing from the highlight onto the tag removes one member and adds another in the same
     * dispatch, so no style is resolved in between and the browser never starts the exit. Booleans
     * could not see each other, so the crossing wrote the tag out and straight back in.
     */ this.revealSources = new Set();
        this.tooltip = void 0;
        this.tooltipContent = void 0;
        this.unbindHighlights = [];
        this.unbindTag = void 0;
        this.unsubscribe = void 0;
    }
}



var $9DmEw = parcelRequire("9DmEw");



const $6dde019bf889ed99$export$a09fe66595d82658 = 'data-contributor-tag-host';
const $6dde019bf889ed99$export$91669580aae6a96e = ()=>(0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history');
const $6dde019bf889ed99$export$418b248d936c5129 = ({ anchorName: anchorName, diffId: diffId, host: host, mountContext: mountContext })=>{
    if (!mountContext) return undefined;
    const controller = new (0, $ce68ad859e395fd5$export$6201a9c6b8711f66)({
        ...mountContext,
        anchorName: anchorName,
        diffId: diffId
    });
    controller.mount(host);
    /**
   * Kept alive when ProseMirror only rebuilt the widget desc around this same host: a document
   * change remaps the decoration and fires `destroy`, but an element `toDOM` is reused verbatim
   * and runs no mount callback, so tearing down here left an active change with no tag
   * (EDITOR-8971).
   *
   * Deferred, because the host is still attached while that update is in flight. A host outside a
   * live editor root is a real removal — including the view being destroyed, which drops the root.
   */ return {
        destroy: ()=>queueMicrotask(()=>{
                if (!host.isConnected || !mountContext.getEditorRoot()?.contains(host)) controller.destroy();
            })
    };
};
const $6dde019bf889ed99$export$ee8ab98941ac5744 = (mount)=>{
    mount?.destroy();
};
/**
 * A zero-size inline host for one contributor tag. `position: relative` makes it the containing
 * block of the absolutely positioned tag, so the tag sits on the change with no measurement.
 *
 * An anchored tag takes a static host instead: an anchor is only acceptable when it sits inside the
 * tag's containing block, and the block node is not inside this host. Measured in Chrome 153 — a
 * relative host makes the `anchor()` insets resolve to `auto`.
 */ const $6dde019bf889ed99$var$buildContributorTagHost = (diffId, anchorName)=>{
    const host = document.createElement('span');
    host.setAttribute($6dde019bf889ed99$export$a09fe66595d82658, diffId);
    if (!anchorName) host.style.setProperty('position', 'relative');
    return host;
};
/** Without anchor positioning the tag keeps its host-relative placement. */ const $6dde019bf889ed99$var$supportsAnchorPositioning = ()=>typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('bottom', 'anchor(--a top)');
const $6dde019bf889ed99$export$ab9117595eb8066d = (diffId, mountContext)=>{
    if (!$6dde019bf889ed99$export$91669580aae6a96e()) return undefined;
    const host = $6dde019bf889ed99$var$buildContributorTagHost(diffId);
    return {
        host: host,
        mount: $6dde019bf889ed99$export$418b248d936c5129({
            diffId: diffId,
            host: host,
            mountContext: mountContext
        })
    };
};
/**
 * The first *visible* character of the content that `[from, to)` highlights.
 *
 * `from` is not sufficient, for two reasons. A range can begin at the tail of one paragraph and only
 * cover text in a later block, and ProseMirror clips `Decoration.inline` to the content it can paint
 * — so a host left at `from` would sit lines away from the highlight. And a range routinely starts on
 * whitespace, because the changeset joins neighbouring edits across the space between them: a tag
 * hosted there captions the gap in front of the change rather than the change (EDITOR-8855).
 *
 * Whitespace is skipped across blocks, so a range whose first block contributes nothing but spaces
 * anchors on the next block that has something to show. The fallback to the first paintable position
 * covers a range holding no text at all — an atomic block such as media or a rule; a range of
 * nothing but whitespace never reaches here, because a change with no visible content carries no tag
 * (see `hasVisibleContent`).
 */ const $6dde019bf889ed99$var$resolveTagAnchorPos = (doc, from, to)=>{
    let edge;
    let visibleEdge;
    doc.nodesBetween(from, to, (node, nodePos)=>{
        if (visibleEdge !== undefined) return false;
        if (!node.isTextblock) return true;
        // The slice of this block the range actually covers; empty means nothing paintable.
        const blockStart = nodePos + 1;
        const contentFrom = Math.max(blockStart, from);
        const contentTo = Math.min(blockStart + node.content.size, to);
        if (contentTo > contentFrom && edge === undefined) edge = contentFrom;
        // A `null` is a non-text inline node (mention, emoji, date, …). Those are visible, so they
        // anchor the tag exactly as a letter does.
        const chars = (0, $9DmEw.buildCharsByOffset)(node);
        for(let offset = contentFrom - blockStart; offset < contentTo - blockStart; offset++){
            const char = chars[offset];
            if (char === null || !(0, $9DmEw.isWhitespaceChar)(char)) {
                visibleEdge = blockStart + offset;
                break;
            }
        }
        // Textblocks have no block children to descend into.
        return false;
    });
    return visibleEdge ?? edge ?? from;
};
/**
 * The position just before the code block enclosing `pos`, or `undefined` when nothing does.
 *
 * `.code-block-content-wrapper` hides its block-axis overflow, so a host left inside the code has
 * its tag clipped away. Hosting it before the block puts the tag on the block's top-left corner,
 * where a whole-code-block change is tagged too (EDITOR-8766).
 */ const $6dde019bf889ed99$var$resolveCodeBlockStart = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    for(let depth = $pos.depth; depth > 0; depth--){
        if ($pos.node(depth).type.name === 'codeBlock') return $pos.before(depth);
    }
    return undefined;
};
const $6dde019bf889ed99$export$3281cc96f6ed36d3 = ({ anchorAtRangeStart: anchorAtRangeStart = false, anchorName: anchorName, doc: doc, from: from, to: to, diffId: diffId, mountContext: mountContext })=>{
    if (!$6dde019bf889ed99$export$91669580aae6a96e()) return undefined;
    const tagAnchorName = anchorName && $6dde019bf889ed99$var$supportsAnchorPositioning() ? anchorName : undefined;
    // Reassigned when ProseMirror redraws this decoration, which it may do more than once for the
    // same `Decoration` instance.
    let mount;
    const anchorPos = anchorAtRangeStart ? from : $6dde019bf889ed99$var$resolveTagAnchorPos(doc, from, to);
    // A change inside a code block is hoisted out of it; anything else keeps its own anchor.
    const codeBlockPos = $6dde019bf889ed99$var$resolveCodeBlockStart(doc, anchorPos);
    return (0, $8nvEM.Decoration).widget(// Keep the host out of the table row's grid (EDITOR-8442).
    (0, $b6432cc061a6f6cb$export$e97e6c8c8b705874)(doc, codeBlockPos ?? anchorPos, 1), ()=>{
        const host = $6dde019bf889ed99$var$buildContributorTagHost(diffId, tagAnchorName);
        mount = $6dde019bf889ed99$export$418b248d936c5129({
            anchorName: tagAnchorName,
            diffId: diffId,
            host: host,
            mountContext: mountContext
        });
        return host;
    }, {
        ...(0, $c8506ce9a0d29c95$export$46440ba1409edb32)(diffId),
        side: 1,
        // The tag is chrome: it inherits no surrounding mark, and its own events are not the
        // document's to handle.
        marks: [],
        ignoreSelection: true,
        stopEvent: ()=>true,
        destroy: ()=>{
            $6dde019bf889ed99$export$ee8ab98941ac5744(mount);
            mount = undefined;
        }
    });
};



/**
 * Pre-refactor code preserved for the OFF cohort of
 * `platform_editor_show_diff_color_scheme_refactor`.
 *
 * This keeps the `getBlockNodeStyle` and cell-overlay style selection that lived in
 * `createBlockChangedDecoration.ts` before the `colorSchemeRegistry` + `factory.ts` migration.
 * Standard deleted styles are resolved at runtime only so the ADF-safety gate can select the
 * equivalent longhand; with that gate off, their CSS remains unchanged. Delete this file at
 * cleanup, together with `colorSchemes/standard.ts`, `colorSchemes/traditional.ts` (EDITOR-8281).
 */ 







const $b4335631fdf63f73$export$8382eabaf43593de = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $b4335631fdf63f73$export$bab085854a7b47c = (0, $8Dx7s.convertToInlineCss)({
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $b4335631fdf63f73$export$97e4289fb0e21ca7 = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-purple, #803FA5)"
});
const $b4335631fdf63f73$export$6cbccbf53a6b2a8 = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$21401c524509064e = (0, $8Dx7s.convertToInlineCss)({
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$6edd58aab948260b = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$91e319dbe79d8dba = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$1f17ddddf9c73b1f = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$4f4aedbfd2e6dac3 = (0, $8Dx7s.convertToInlineCss)({
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$377dbc0d0546178d = ()=>(0, $8Dx7s.convertToInlineCss)({
        color: "var(--ds-text-accent-gray, #505258)",
        ...(0, $476d00a9ed5be1b0$export$9645c6cfb2371e19)(),
        position: 'relative',
        opacity: 0.6
    });
const $b4335631fdf63f73$export$fbd0e685b6d20e1a = ()=>(0, $8Dx7s.convertToInlineCss)({
        color: "var(--ds-text, #292A2E)",
        ...(0, $476d00a9ed5be1b0$export$9645c6cfb2371e19)(),
        textDecorationColor: "var(--ds-text-accent-gray, #505258)",
        position: 'relative',
        opacity: 1
    });
const $b4335631fdf63f73$export$4d3c1a132d48c86d = ()=>(0, $8Dx7s.convertToInlineCss)({
        color: "var(--ds-text-accent-gray, #505258)",
        ...(0, $476d00a9ed5be1b0$export$9645c6cfb2371e19)(),
        position: 'relative',
        opacity: 0.83
    });
const $b4335631fdf63f73$export$19cf8e2cf40a1110 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    borderBottom: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$f9aac5ed53f3d424 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-text-accent-gray, #505258)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $b4335631fdf63f73$export$4be2f4158e5479e9 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`
});
const $b4335631fdf63f73$export$a26de8170ba89016 = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$b1c2428901df334f = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$2b892754935ecdf0 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$f2cea9f09f40fb64 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$95d973a7458c1194 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $b4335631fdf63f73$export$1e0b247f41c702d9 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $b4335631fdf63f73$export$3b88c73646ebc317 = ()=>(0, $8Dx7s.convertToInlineCss)({
        color: "var(--ds-text-accent-gray, #505258)",
        ...(0, $476d00a9ed5be1b0$export$9645c6cfb2371e19)(),
        opacity: 0.6,
        display: 'table-row'
    });
const $b4335631fdf63f73$export$61432713bede9dea = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`
});
const $b4335631fdf63f73$export$69c3a1c4f451af4e = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $b4335631fdf63f73$export$6ba987e1eae93022 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$7643378707ce1e7 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $b4335631fdf63f73$export$5675345213f1a131 = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-purple, #AF59E1)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $b4335631fdf63f73$export$56ba023604266b1a = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-gray, #7D818A)",
    '--diff-decoration-marker-ring-width': '1px',
    opacity: 0.8
});
const $b4335631fdf63f73$export$d311b2309a26b4fb = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} r g b / 0.2)`,
    zIndex: 2,
    outline: `1px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    pointerEvents: 'none'
});
const $b4335631fdf63f73$export$9bb29312b2a8bd50 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} r g b / 0.2)`,
    zIndex: 2,
    outline: `1px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    pointerEvents: 'none',
    borderRadius: 'inherit'
});
const $b4335631fdf63f73$export$7000268b4d4c5e1 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-gray, #7D818A)"}`,
    pointerEvents: 'none'
});
const $b4335631fdf63f73$export$19ee1020da83364c = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 2,
    outline: `1px solid ${"var(--ds-border-accent-gray, #7D818A)"}`,
    pointerEvents: 'none',
    border: 'inherit',
    borderRadius: 'inherit'
});





const $e7971598d3f97abe$export$5f26b1217ef25d6b = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-green, #22A06B)"
});
const $e7971598d3f97abe$export$a9b71bdebdda9dc4 = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-green, #216E4E)"
});
const $e7971598d3f97abe$var$deletedTraditionalInlineStyleBase = {
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 1
};
const $e7971598d3f97abe$var$deletedTraditionalInlineStyleActiveBase = {
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleBase,
    textDecorationThickness: '2px',
    backgroundColor: "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)"
};
function $e7971598d3f97abe$export$f37b168a762b249f(isActive) {
    return isActive ? (0, $8Dx7s.convertToInlineCss)($e7971598d3f97abe$var$deletedTraditionalInlineStyleActiveBase) : (0, $8Dx7s.convertToInlineCss)($e7971598d3f97abe$var$deletedTraditionalInlineStyleBase);
}
const $e7971598d3f97abe$export$d7c13cc5c70ee199 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $e7971598d3f97abe$export$e384205f8cc82cfe = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `2px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $e7971598d3f97abe$export$781ad9e3e3929b91 = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$cd5411bbe62ac5f5 = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$2881f0731c48e52 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$bb158c719faea3c7 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$4d45bc5137e495cf = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $e7971598d3f97abe$export$9c9f71734a3c1e70 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $e7971598d3f97abe$export$94cf9011b730dea = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$bd7e21e639c80e8d = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $e7971598d3f97abe$export$62207903895cae1 = (0, $8Dx7s.convertToInlineCss)({
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
const $e7971598d3f97abe$export$2baa37676a9f2541 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-green, #22A06B)"}`
});
const $e7971598d3f97abe$export$94c7715dcf202eb7 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `4px solid ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`
});
const $e7971598d3f97abe$export$f0d2b829bf102560 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `4px solid ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`
});
const $e7971598d3f97abe$export$83df991322f77466 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-green, #22A06B)"
});
const $e7971598d3f97abe$export$987d21925631f1e0 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    border: 'none',
    height: '4px',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$27f4e50fea498762 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    border: 'none',
    height: '4px',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$d4e3bc1287ea5f02 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$2e643fe7923d8094 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$a60bf2c814acef8e = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$4352b2b7d464e82a = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $e7971598d3f97abe$export$b5d15ab6b9f40699 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $e7971598d3f97abe$export$cf5a738872f070ca = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $e7971598d3f97abe$export$90be779ecd934b0a = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-green, #22A06B)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $e7971598d3f97abe$export$25ad6f21613cdcf1 = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$4752b9cd0a02e8d3 = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$e3ce52bf0fe385a = (0, $8Dx7s.convertToInlineCss)({
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleBase,
    '--diff-decoration-marker-color': "var(--ds-border-accent-red, #E2483D)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $e7971598d3f97abe$export$1c68397531783614 = (0, $8Dx7s.convertToInlineCss)({
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleBase,
    '--diff-decoration-marker-color': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$2e6c07fb91e6b5f7 = (0, $8Dx7s.convertToInlineCss)({
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleActiveBase,
    '--diff-decoration-marker-color': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$d2957495f69575c = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-green, #22A06B)"}`,
    pointerEvents: 'none'
});
const $e7971598d3f97abe$export$7ff4479842f2d7ec = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} r g b / 0.5)`,
    zIndex: 2,
    outline: `1px solid ${"var(--ds-border-accent-green, #22A06B)"}`,
    pointerEvents: 'none',
    border: 'inherit',
    borderRadius: 'inherit'
});
const $e7971598d3f97abe$export$4447a7c482f80938 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    pointerEvents: 'none'
});
const $e7971598d3f97abe$export$ea323b9930a7947d = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-disabled, #0515240F)"}`,
    pointerEvents: 'none'
});
const $e7971598d3f97abe$export$ff7c70906e6c1d66 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 2,
    outline: `1px solid ${"var(--ds-border-disabled, #0515240F)"}`,
    pointerEvents: 'none',
    border: 'inherit',
    borderRadius: 'inherit'
});


const $fa0a813c4bfb9385$export$586f80a88d2bf3e5 = ({ colorScheme: colorScheme, isRoundedTable: isRoundedTable, useAddedStyle: useAddedStyle })=>{
    const isTraditional = colorScheme === 'traditional';
    const addedCellStyle = isTraditional ? isRoundedTable ? (0, $e7971598d3f97abe$export$7ff4479842f2d7ec) : (0, $e7971598d3f97abe$export$d2957495f69575c) : isRoundedTable ? (0, $b4335631fdf63f73$export$9bb29312b2a8bd50) : (0, $b4335631fdf63f73$export$d311b2309a26b4fb);
    const deletedCellStyle = isTraditional ? isRoundedTable ? (0, $e7971598d3f97abe$export$ff7c70906e6c1d66) : (0, $e7971598d3f97abe$export$ea323b9930a7947d) : isRoundedTable ? (0, $b4335631fdf63f73$export$19ee1020da83364c) : (0, $b4335631fdf63f73$export$7000268b4d4c5e1);
    return useAddedStyle ? addedCellStyle : deletedCellStyle;
};
const $fa0a813c4bfb9385$export$2f7042c1d2371481 = ({ nodeName: nodeName, colorScheme: colorScheme, isInserted: isInserted = true, isActive: isActive = false, diffType: diffType })=>{
    const isTraditional = colorScheme === 'traditional';
    if ([
        'mediaSingle',
        'mediaGroup',
        'table',
        'tableRow',
        'paragraph',
        'heading',
        'hardBreak',
        'decisionList',
        'taskList',
        'bulletList',
        'orderedList',
        'layoutSection'
    ].includes(nodeName)) // Layout nodes do not need special styling
    return undefined;
    // Media nodes inside mediaSingle should not get position:relative
    // as it shifts the image outside its parent container (e.g. panel)
    if (nodeName === 'media') {
        if (!isInserted && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$56ba023604266b1a);
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
    }
    if ([
        'tableCell',
        'tableHeader'
    ].includes(nodeName)) {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) // This is used for positioning the cell overlay widget decorations
        return (0, $8Dx7s.convertToInlineCss)({
            position: 'relative'
        });
        // When gate is off, it should return undefined as above
        return undefined;
    }
    if (nodeName === 'panel') {
        if (!isInserted && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$56ba023604266b1a);
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
    }
    if ([
        'extension',
        'embedCard',
        'listItem'
    ].includes(nodeName)) {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional && isActive ? (0, $e7971598d3f97abe$export$4752b9cd0a02e8d3) : isTraditional ? (0, $e7971598d3f97abe$export$25ad6f21613cdcf1) : (0, $b4335631fdf63f73$export$5675345213f1a131);
            else {
                if (nodeName === 'listItem') return isTraditional && isActive ? (0, $e7971598d3f97abe$export$2e6c07fb91e6b5f7) : isTraditional ? (0, $e7971598d3f97abe$export$1c68397531783614) : (0, $b4335631fdf63f73$export$56ba023604266b1a);
                return isTraditional && isActive ? (0, $e7971598d3f97abe$export$2e6c07fb91e6b5f7) : isTraditional ? (0, $e7971598d3f97abe$export$1c68397531783614) : (0, $b4335631fdf63f73$export$4d3c1a132d48c86d)();
            }
        }
        return isTraditional && isActive ? (0, $e7971598d3f97abe$export$4752b9cd0a02e8d3) : isTraditional ? (0, $e7971598d3f97abe$export$25ad6f21613cdcf1) : (0, $b4335631fdf63f73$export$5675345213f1a131);
    }
    if (nodeName === 'blockquote') {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$f0d2b829bf102560) : (0, $e7971598d3f97abe$export$94c7715dcf202eb7) : (0, $b4335631fdf63f73$export$61432713bede9dea);
            else return isTraditional ? (0, $e7971598d3f97abe$export$781ad9e3e3929b91) : (0, $b4335631fdf63f73$export$4be2f4158e5479e9);
        }
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$f0d2b829bf102560) : (0, $e7971598d3f97abe$export$94c7715dcf202eb7) : (0, $b4335631fdf63f73$export$61432713bede9dea);
    }
    if (nodeName === 'rule') {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$27f4e50fea498762) : (0, $e7971598d3f97abe$export$987d21925631f1e0) : (0, $b4335631fdf63f73$export$69c3a1c4f451af4e);
            else return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$4d3c1a132d48c86d)();
        }
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$27f4e50fea498762) : (0, $e7971598d3f97abe$export$987d21925631f1e0) : (0, $b4335631fdf63f73$export$69c3a1c4f451af4e);
    }
    if (nodeName === 'blockCard') {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$cf5a738872f070ca) : (0, $e7971598d3f97abe$export$b5d15ab6b9f40699) : (0, $b4335631fdf63f73$export$7643378707ce1e7);
            else return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$4d3c1a132d48c86d)();
        }
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$cf5a738872f070ca) : (0, $e7971598d3f97abe$export$b5d15ab6b9f40699) : (0, $b4335631fdf63f73$export$7643378707ce1e7);
    }
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
        else return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$4d3c1a132d48c86d)();
    }
    return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
};


const $272524b39064824e$var$displayNoneStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'none'
});
const $272524b39064824e$var$DEFAULT_COLOR_SCHEME = 'standard';
/** Nodes that carry no decoration styling of their own — layout, lists, text blocks, media groups. */ const $272524b39064824e$var$UNSTYLED_NODES = [
    'mediaSingle',
    'mediaGroup',
    'table',
    // Handle table separately to avoid border issues
    'tableRow',
    'paragraph',
    // Paragraph and heading nodes do not need special styling
    'heading',
    'hardBreak',
    'decisionList',
    'taskList',
    'bulletList',
    'orderedList',
    'layoutSection'
];
const $272524b39064824e$var$CELL_NODES = [
    'tableCell',
    'tableHeader'
];
/**
 * Block nodes that host a contributor tag of their own — those whose whole box reads as one change.
 * Lists and tables are excluded: they decorate per item and per cell, with no one-tag-per-block
 * design yet. `blockCard` covers the datasource variant, which is the same node type.
 */ const $272524b39064824e$var$TAGGABLE_BLOCK_NODES = new Set([
    'blockCard',
    'blockquote',
    'bodiedExtension',
    'codeBlock',
    'embedCard',
    'expand',
    'extension',
    'media',
    'multiBodiedExtension',
    'panel',
    'rule'
]);
/** Panels, rules and media can also sit in a table cell, which is out of scope for block tags. */ const $272524b39064824e$var$isInsideTable = (doc, pos)=>(0, $bjg0G.findParentNodeClosestToPos)(doc.resolve(pos), (node)=>node.type.name === 'table') !== undefined;
/** Whether this block can host a contributor tag of its own. */ const $272524b39064824e$var$canTagBlock = ({ diffType: diffType, doc: doc, from: from, name: name })=>doc !== undefined && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && $272524b39064824e$var$TAGGABLE_BLOCK_NODES.has(name) && !$272524b39064824e$var$isInsideTable(doc, from);
/** Positioning context for the cell overlay widget decorations. */ const $272524b39064824e$var$cellPositionStyle = (0, $8Dx7s.convertToInlineCss)({
    position: 'relative'
});
const $272524b39064824e$var$getInsertedBlockNodeShape = (nodeName)=>{
    switch(nodeName){
        case 'blockquote':
            return 'quote';
        case 'rule':
            return 'rule';
        case 'blockCard':
            return 'cardBlock';
        case 'extension':
        case 'embedCard':
        case 'listItem':
            return 'marker';
        default:
            return 'node';
    }
};
const $272524b39064824e$var$getDeletedBlockNodeCategory = (nodeName)=>{
    switch(nodeName){
        case 'blockquote':
            return 'quote';
        // Media nodes inside mediaSingle should not get position:relative
        // as it shifts the image outside its parent container (e.g. panel)
        case 'media':
        case 'panel':
            return 'container';
        case 'listItem':
            return 'listItem';
        case 'extension':
        case 'embedCard':
            return 'marker';
        default:
            return 'generic';
    }
};
const $272524b39064824e$var$getNodeClass = (name)=>{
    switch(name){
        case 'extension':
            return 'show-diff-changed-decoration-node';
        default:
            return undefined;
    }
};
const $272524b39064824e$var$getBlockNodeStyleNext = ({ nodeName: nodeName, colorScheme: colorScheme, isInserted: isInserted = true, isActive: isActive = false, diffType: diffType })=>{
    if ($272524b39064824e$var$UNSTYLED_NODES.includes(nodeName)) return undefined;
    if ($272524b39064824e$var$CELL_NODES.includes(nodeName)) // When the gate is off, cells get no styling — as with UNSTYLED_NODES above.
    return (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? $272524b39064824e$var$cellPositionStyle : undefined;
    const colors = (0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme ?? $272524b39064824e$var$DEFAULT_COLOR_SCHEME];
    // Deleted nodes only differ under the extended experience; otherwise all are insertions.
    if (!isInserted && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return (0, $e28b33baecacf396$export$be2d45f1d38443ad)(colors, $272524b39064824e$var$getDeletedBlockNodeCategory(nodeName), isActive);
    return (0, $e28b33baecacf396$export$da6c5a56c4c92f0d)(colors, $272524b39064824e$var$getInsertedBlockNodeShape(nodeName), isActive);
};
/**
 * Dispatches to the registry-driven implementation, or to the verbatim pre-refactor one for the
 * OFF cohort of `platform_editor_show_diff_color_scheme_refactor`. Both are built to emit the
 * same style strings for both shipped schemes; see EDITOR-8281.
 */ const $272524b39064824e$var$getBlockNodeStyle = (props)=>{
    return (0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $272524b39064824e$var$getBlockNodeStyleNext(props) : (0, $fa0a813c4bfb9385$export$2f7042c1d2371481)({
        ...props,
        colorScheme: (0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(props.colorScheme)
    });
};
/**
 * A table cell is "empty" only when it has no content at all — no text AND no
 * non-text leaf/inline nodes (media, emoji, mention, inlineCard, status, date…).
 * `textContent` alone misses those non-text nodes, so we also reject any leaf or
 * inline descendant. An empty ADF cell (`tableCell > empty paragraph`) returns
 * true; a cell containing only media/emoji returns false.
 */ const $272524b39064824e$var$isCellEmpty = (cellNode)=>{
    if (cellNode.textContent.length > 0) return false;
    let hasNonTextContent = false;
    cellNode.descendants((node)=>{
        if (hasNonTextContent) return false;
        // A non-text leaf or inline node (media, emoji, mention, etc.) = real content.
        if (!node.isText && (node.isLeaf || node.isInline)) {
            hasNonTextContent = true;
            return false;
        }
        return true;
    });
    return !hasNonTextContent;
};
const $272524b39064824e$export$8df64513a6dc1f2a = ({ attributionKey: attributionKey, change: change, colorScheme: colorScheme, isInserted: isInserted = true, isActive: isActive = false, shouldHideDeleted: shouldHideDeleted = false, showContributorTags: showContributorTags = false, showIndicators: showIndicators = false, doc: doc, diffType: diffType, tagMountContext: tagMountContext })=>{
    const decorations = [];
    // Derived from the node range so it survives a recalculation, as in
    // `createInlineChangedDecoration`. Changes are disjoint, so no two of them decorate one node.
    const diffId = showContributorTags ? `block-${change.from}-${change.to}` : crypto.randomUUID();
    const shouldTagBlock = showContributorTags && $272524b39064824e$var$canTagBlock({
        diffType: diffType,
        doc: doc,
        from: change.from,
        name: change.name
    });
    // Named so this block's own tag can position against it; see `createContributorTagWidget`.
    const tagAnchorName = shouldTagBlock && (0, $6dde019bf889ed99$export$91669580aae6a96e)() ? (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).tag
    }) : undefined;
    if (shouldHideDeleted) return [
        (0, $8nvEM.Decoration).node(change.from, change.to, {
            style: $272524b39064824e$var$displayNoneStyle
        }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            colorScheme: colorScheme,
            decorationType: 'block',
            diffId: diffId,
            isActive: isActive,
            isInserted: isInserted,
            nodeName: change.name,
            diffType: diffType
        }))
    ];
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && $272524b39064824e$var$CELL_NODES.includes(change.name)) {
        const cellOverlay = document.createElement('div');
        const colors = (0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme ?? $272524b39064824e$var$DEFAULT_COLOR_SCHEME];
        const isRoundedTable = (0, $4o0zT.isExperimentEnabled)('platform_editor_table_diff_rounded_corners');
        // On an inverted diff, an empty cell being filled is an addition, so give it the
        // added (purple) overlay instead of the deleted (grey) one (EDITOR-8442).
        const cellNode = doc?.nodeAt(change.from);
        const isEmptyCellBeingFilled = !isInserted && !!cellNode && $272524b39064824e$var$isCellEmpty(cellNode);
        const useAddedStyle = isInserted || isEmptyCellBeingFilled;
        const cellOverlayStyle = (0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? useAddedStyle ? isRoundedTable ? (0, $e28b33baecacf396$export$ad8079eeea0b3320)(colors) : (0, $e28b33baecacf396$export$59d4030fb8ee6502)(colors) : isRoundedTable ? (0, $e28b33baecacf396$export$4e3e05920801547c)(colors) : (0, $e28b33baecacf396$export$79e32cdc2c1a623c)(colors) : (0, $fa0a813c4bfb9385$export$586f80a88d2bf3e5)({
            colorScheme: (0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme),
            isRoundedTable: isRoundedTable,
            useAddedStyle: useAddedStyle
        });
        cellOverlay.setAttribute('style', cellOverlayStyle);
        decorations.push(// change.to - 1 to position the overlay inside the end of the cell
        // this key doesn't use the spec / key builder since this is just for
        // decorating the cells, this is part of a bigger table diff
        (0, $8nvEM.Decoration).widget(change.to - 1, cellOverlay, {
            key: 'cell-overlay-decoration'
        }));
    }
    // isInserted is only read under the extended experience, so pass it unconditionally.
    const nodeStyle = $272524b39064824e$var$getBlockNodeStyle({
        nodeName: change.name,
        colorScheme: colorScheme,
        isInserted: isInserted,
        isActive: isActive,
        diffType: diffType
    });
    const style = tagAnchorName ? [
        nodeStyle,
        (0, $8Dx7s.convertToInlineCss)({
            anchorName: `--${tagAnchorName}`
        }),
        (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? (0, $c8506ce9a0d29c95$export$830d4c4bf8b7876b) : undefined
    ].filter(Boolean).join(' ') : nodeStyle;
    const className = $272524b39064824e$var$getNodeClass(change.name);
    if (style || className) decorations.push((0, $8nvEM.Decoration).node(change.from, change.to, {
        style: style,
        'data-testid': 'show-diff-changed-decoration-node',
        class: className,
        // Lets the contributor tag find the block it captions on hover.
        ...shouldTagBlock && {
            'data-diff-id': diffId
        }
    }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
        attributionKey: shouldTagBlock ? attributionKey : undefined,
        colorScheme: colorScheme,
        decorationType: 'block',
        diffId: diffId,
        isActive: isActive,
        isInserted: isInserted,
        nodeName: change.name,
        diffType: diffType
    })));
    if (decorations.length === 0) return decorations;
    if (showIndicators && doc && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) decorations.push(...(0, $b6432cc061a6f6cb$export$34d0779dfc2e9aea)({
        doc: doc,
        from: change.from,
        to: change.to,
        diffId: diffId
    }));
    // `change.from` is just before the node, so the host sits outside it and the tag renders on the
    // block's own top-left corner. Resolving inline content instead would put the host inside a
    // container block's content DOM (panel, expand, blockquote).
    if (shouldTagBlock && doc) {
        const tagWidget = (0, $6dde019bf889ed99$export$3281cc96f6ed36d3)({
            anchorAtRangeStart: true,
            anchorName: tagAnchorName,
            doc: doc,
            from: change.from,
            to: change.to,
            diffId: diffId,
            mountContext: tagMountContext
        });
        if (tagWidget) decorations.push(tagWidget);
    }
    return decorations;
};
















const $4170afb8d5f70d14$export$67d419665654ec06 = (slice)=>slice?.content.childCount === 1 && slice.content.firstChild?.type.name === 'paragraph' && slice.content.firstChild.content.size === 0;






/**
 * Pre-refactor `createInlineChangedDecoration` styling code, preserved verbatim for the OFF cohort
 * of `platform_editor_show_diff_color_scheme_refactor`.
 *
 * This module exists so the OFF cohort keeps running the code that shipped before the
 * `colorSchemeRegistry` + `factory.ts` migration. Standard deleted styles are resolved at runtime
 * only so the ADF-safety gate can select the equivalent longhand; with that gate off, their CSS
 * remains unchanged. Delete the whole file at experiment cleanup (EDITOR-8281).
 */ 


const $698b0abf2ed199c3$export$b22b01ecbc4960a2 = ({ colorScheme: colorScheme, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline, isActive: isActive, isInserted: isInserted })=>{
    let style;
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (isInserted) {
            if (colorScheme === 'traditional') style = isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
            else style = isActive ? hideAddedDiffsUnderline ? (0, $b4335631fdf63f73$export$1f17ddddf9c73b1f) : (0, $b4335631fdf63f73$export$6edd58aab948260b) : hideAddedDiffsUnderline ? (0, $b4335631fdf63f73$export$91e319dbe79d8dba) : (0, $b4335631fdf63f73$export$6cbccbf53a6b2a8);
        } else if (colorScheme === 'traditional') style = (0, $e7971598d3f97abe$export$f37b168a762b249f)(false);
        else style = (isActive ? (0, $b4335631fdf63f73$export$fbd0e685b6d20e1a)() : (0, $b4335631fdf63f73$export$377dbc0d0546178d)()) + (0, $b4335631fdf63f73$export$19cf8e2cf40a1110);
    } else if (colorScheme === 'traditional') style = isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
    else style = isActive ? (0, $b4335631fdf63f73$export$97e4289fb0e21ca7) : (0, $b4335631fdf63f73$export$8382eabaf43593de);
    return style;
};
const $698b0abf2ed199c3$export$8e6a26a5f4a3e261 = (inlineNodeName, colorScheme)=>{
    const classNames = [
        'show-diff-atomic-inline-changed'
    ];
    if (inlineNodeName) classNames.push(`show-diff-atomic-inline-changed-${inlineNodeName}`);
    if (colorScheme === 'traditional') classNames.push('show-diff-atomic-inline-changed-traditional');
    return classNames.join(' ');
};












const $a6f71fd197aec590$export$cee91f6cebab58c = 'data-show-diff-reveal';
const $a6f71fd197aec590$export$e058ad86e11ec259 = '--show-diff-reveal-bg';
const $a6f71fd197aec590$export$66395af787a97039 = '--show-diff-reveal-border';
/** Only schemes with background highlights can be revealed; 'traditional' uses underline only. */ const $a6f71fd197aec590$var$schemeSupportsReveal = (colorScheme)=>colorScheme !== 'traditional';
const $a6f71fd197aec590$export$9f2e698630a68448 = (color)=>(0, $8Dx7s.convertToInlineCss)({
        backgroundColor: 'transparent',
        backgroundImage: `linear-gradient(${color}, ${color})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '0% 100%',
        backgroundPosition: '0 0',
        // Each line fragment of a wrapped highlight gets its own background box, so they wipe
        // together rather than the gradient stretching across the whole wrapped run.
        WebkitBoxDecorationBreak: 'clone',
        boxDecorationBreak: 'clone'
    });
/** Base padding and transparent underline placeholder (no layout shift on reveal). */ const $a6f71fd197aec590$var$revealBaseStyle = (0, $8Dx7s.convertToInlineCss)({
    padding: `1px 0 2px`,
    borderBottom: `2px solid transparent`
});
const $a6f71fd197aec590$var$buildRevealVariables = ({ background: background, border: border })=>(0, $8Dx7s.convertToInlineCss)({
        [$a6f71fd197aec590$export$e058ad86e11ec259]: background,
        [$a6f71fd197aec590$export$66395af787a97039]: border
    });
/** Reveal colours from the refactored scheme registry (attribution palette ready). */ const $a6f71fd197aec590$var$revealColorsRefactored = (colors, { hideAddedDiffsUnderline: hideAddedDiffsUnderline, isActive: isActive, isInserted: isInserted })=>isInserted ? (0, $e28b33baecacf396$export$f892bb9756d31514)(colors, isActive, hideAddedDiffsUnderline) : (0, $e28b33baecacf396$export$19b310b9417bfd22)(colors);
/**
 * Legacy cohort reveal colours. Values MUST match `revealColorsRefactored()` output for
 * `standard` scheme (test: `revealStyles.ts` in test package).
 */ const $a6f71fd197aec590$var$revealColorsLegacy = ({ hideAddedDiffsUnderline: hideAddedDiffsUnderline, isActive: isActive, isInserted: isInserted })=>isInserted ? {
        // Mirrors `editingStyleExtended` / `editingStyleActiveExtended` and their
        // `*NoUnderline` variants in `colorSchemes/standard.ts`.
        background: isActive ? "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)" : "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        border: hideAddedDiffsUnderline ? 'transparent' : "var(--ds-border-accent-purple, #AF59E1)"
    } : {
        // Mirrors `deletedInlineContentStyleExtended` in `colorSchemes/standard.ts`.
        background: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        border: "var(--ds-border-accent-gray, #7D818A)"
    };
const $a6f71fd197aec590$var$resolveRevealColors = (colors, variant)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $a6f71fd197aec590$var$revealColorsRefactored(colors, variant) : $a6f71fd197aec590$var$revealColorsLegacy(variant);
const $a6f71fd197aec590$var$getColorScheme = (colorScheme)=>(0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme ?? 'standard'];
/** Deleted text appearance (grey and strikethrough) without the highlight. */ const $a6f71fd197aec590$var$deletedTextOnlyStyle = (colors, isActive)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? (0, $e28b33baecacf396$export$9a4d6f34023ac088)(colors, isActive ? 'active' : 'default') : isActive ? (0, $b4335631fdf63f73$export$fbd0e685b6d20e1a)() : (0, $b4335631fdf63f73$export$377dbc0d0546178d)();
const $a6f71fd197aec590$export$1a9616afdd8ebb95 = ({ colorScheme: colorScheme, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false, includeDeletedTextStyle: includeDeletedTextStyle = true, isActive: isActive, isInserted: isInserted, reveal: reveal })=>{
    if (reveal?.mode !== 'phased' || !$a6f71fd197aec590$var$schemeSupportsReveal(colorScheme)) return undefined;
    const colors = $a6f71fd197aec590$var$getColorScheme(colorScheme);
    const { background: background, border: border } = $a6f71fd197aec590$var$resolveRevealColors(colors, {
        hideAddedDiffsUnderline: hideAddedDiffsUnderline,
        isActive: isActive,
        isInserted: isInserted
    });
    return {
        role: isInserted ? 'added' : 'deleted',
        style: (isInserted || !includeDeletedTextStyle ? '' : $a6f71fd197aec590$var$deletedTextOnlyStyle(colors, isActive)) + $a6f71fd197aec590$var$revealBaseStyle + $a6f71fd197aec590$export$9f2e698630a68448(background) + $a6f71fd197aec590$var$buildRevealVariables({
            background: background,
            border: border
        })
    };
};
const $a6f71fd197aec590$export$88545ce374f4083 = ({ colorScheme: colorScheme, element: element, hideAddedDiffsUnderline: hideAddedDiffsUnderline, isActive: isActive, isInserted: isInserted, reveal: reveal })=>{
    const resolved = $a6f71fd197aec590$export$1a9616afdd8ebb95({
        colorScheme: colorScheme,
        hideAddedDiffsUnderline: hideAddedDiffsUnderline,
        isActive: isActive,
        isInserted: isInserted,
        reveal: reveal,
        // The widget supplies the deleted text's own grey/strikethrough styling already.
        includeDeletedTextStyle: false
    });
    if (!resolved) return '';
    element.setAttribute($a6f71fd197aec590$export$cee91f6cebab58c, resolved.role);
    return resolved.style;
};


const $446fe50ec2aaceae$var$displayNoneStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'none'
});
/**
 * Stacks the change's highlight below its contributor tag, so no highlight can slice through a tag:
 * a tag overlays the line *above* its own change, and a highlight already on that line — the tail of
 * this change, or another change entirely — would otherwise paint straight over it.
 *
 * The tag still reads as attached to the change rather than laid on top of it, because it cannot
 * paint over this highlight at all: its bottom edge is pinned to the highlight's top edge and
 * clipped there. See `CONTRIBUTOR_TAG_Z_INDEX`.
 *
 * prosemirror-view places the tag's host widget as a *sibling* of this decoration's span, so
 * painting order is decided by stacking level — and the host is absolutely positioned at
 * `CONTRIBUTOR_TAG_Z_INDEX`. `position: relative` is what makes `z-index` apply to an otherwise
 * static inline box; it adds no offset.
 */ const $446fe50ec2aaceae$var$stackBelowContributorTagStyle = (0, $8Dx7s.convertToInlineCss)({
    position: 'relative',
    zIndex: (0, $73303cab152d5784$export$7b5a98f29fec636e) - 1
});
const $446fe50ec2aaceae$var$getColorScheme = (colorScheme)=>(0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme ?? 'standard'];
/**
 * Class names for an atomic inline node decoration (date, emoji, mention, status). Scheme-agnostic
 * — `buildAtomicInlineChangedCSSVariables()` supplies the colour inline on the same element.
 */ const $446fe50ec2aaceae$var$getAtomicInlineNodeClassName = (inlineNodeName)=>{
    const classNames = [
        'show-diff-atomic-inline-changed'
    ];
    if (inlineNodeName) classNames.push(`show-diff-atomic-inline-changed-${inlineNodeName}`);
    return classNames.join(' ');
};
/** Inline style for inserted content under the extended diff experience. */ const $446fe50ec2aaceae$var$getExtendedInsertStyle = (colors, isActive, hideAddedDiffsUnderline)=>{
    if (colors.insertedInlineTreatment === 'underline') // hideAddedDiffsUnderline only targets the 'borderBottom' rule, so it does not apply here.
    return isActive ? (0, $e28b33baecacf396$export$bfc49da2006f92f0)(colors) : (0, $e28b33baecacf396$export$82262e1f5a4bc0d4)(colors);
    if (isActive) return hideAddedDiffsUnderline ? (0, $e28b33baecacf396$export$6560b65b269507f7)(colors) : (0, $e28b33baecacf396$export$a33e264c283926)(colors);
    return hideAddedDiffsUnderline ? (0, $e28b33baecacf396$export$ff53ea63d183e034)(colors) : (0, $e28b33baecacf396$export$5fab5218b7eea3ef)(colors);
};
/** Inline style for deleted content under the extended diff experience. */ const $446fe50ec2aaceae$var$getExtendedDeletedStyle = (colors, isActive)=>{
    if (colors.deletedInlineTreatment === 'strikethrough') // Identical in both states — the block decoration carries the active emphasis.
    return (0, $e28b33baecacf396$export$a253cd53c2e78280)(colors, false);
    return (0, $e28b33baecacf396$export$9a4d6f34023ac088)(colors, isActive ? 'active' : 'default') + (0, $e28b33baecacf396$export$cf33a4212f50e620)(colors, isActive);
};
/** Registry-driven inline `style` for a changed-content decoration. */ const $446fe50ec2aaceae$var$resolveInlineChangedStyleRefactored = ({ colors: colors, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline, isActive: isActive, isInserted: isInserted })=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return isInserted ? $446fe50ec2aaceae$var$getExtendedInsertStyle(colors, isActive, hideAddedDiffsUnderline) : $446fe50ec2aaceae$var$getExtendedDeletedStyle(colors, isActive);
    return isActive ? (0, $e28b33baecacf396$export$bfc49da2006f92f0)(colors) : (0, $e28b33baecacf396$export$82262e1f5a4bc0d4)(colors);
};
/**
 * Single gate for the inline `style` string: registry + factory when the refactor is on, the
 * verbatim pre-refactor per-scheme constants when it is off.
 */ const $446fe50ec2aaceae$var$resolveInlineChangedStyle = (args)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $446fe50ec2aaceae$var$resolveInlineChangedStyleRefactored(args) : (0, $698b0abf2ed199c3$export$b22b01ecbc4960a2)({
        ...args,
        colorScheme: (0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(args.colorScheme)
    });
/**
 * Single gate for the atomic-inline-node decoration attributes. The two cohorts differ in the DOM:
 * on, the colour rides on an inline CSS variable and the class list is scheme-agnostic; off, the
 * colour comes from a `-traditional` class and no variable is emitted. Returned together so the
 * class list and style suffix can never be mixed across cohorts.
 */ const $446fe50ec2aaceae$var$resolveAtomicInlineAttrs = (inlineNodeName, colorScheme, colors)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? {
        className: $446fe50ec2aaceae$var$getAtomicInlineNodeClassName(inlineNodeName),
        styleSuffix: (0, $e28b33baecacf396$export$d0c526b03c2e5381)(colors)
    } : {
        className: (0, $698b0abf2ed199c3$export$8e6a26a5f4a3e261)(inlineNodeName, (0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme)),
        styleSuffix: ''
    };
const $446fe50ec2aaceae$export$4d88fb3a58252f14 = (inlineNodeName, colorScheme)=>$446fe50ec2aaceae$var$resolveAtomicInlineAttrs(inlineNodeName, colorScheme, $446fe50ec2aaceae$var$getColorScheme(colorScheme));
const $446fe50ec2aaceae$export$69543ba6b110e31c = ({ attributionKey: attributionKey, change: change, colorScheme: colorScheme, isActive: isActive = false, isInserted: isInserted = true, isAtomicInlineNode: isAtomicInlineNode = false, shouldHideDeleted: shouldHideDeleted = false, showContributorTags: showContributorTags = false, showIndicators: showIndicators = false, doc: doc, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false, inlineNodeName: inlineNodeName, hasDeletedWidget: hasDeletedWidget = false, isDeletedWidgetBelow: isDeletedWidgetBelow = false, reveal: reveal, tagMountContext: tagMountContext })=>{
    // Derived from the range so it survives a recalculation: stepping to the next/previous change
    // rebuilds decorations without touching the doc, and a fresh id would change the React key and the
    // tag host's key, remounting every tag mid-step. Random ids are kept when tags are off.
    const diffId = showContributorTags ? `inline-${change.fromB}-${change.toB}` : crypto.randomUUID();
    // Match the rendered shape: whitespace text is eligible, while an empty paragraph is structural
    // content with no tag host.
    const canTagChange = showContributorTags && !!doc && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && (0, $6dde019bf889ed99$export$91669580aae6a96e)() && !(0, $4170afb8d5f70d14$export$67d419665654ec06)(doc.slice(change.fromB, change.toB));
    if (shouldHideDeleted) return [
        (0, $8nvEM.Decoration).inline(change.fromB, change.toB, {
            style: $446fe50ec2aaceae$var$displayNoneStyle
        }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            colorScheme: // No attribution: this decoration paints nothing and emits no tag host, so a tag
            // resolved from it would have nowhere to render.
            colorScheme,
            decorationType: 'inline',
            diffId: diffId,
            isActive: isActive,
            isInserted: isInserted
        }))
    ];
    const colors = $446fe50ec2aaceae$var$getColorScheme(colorScheme);
    // The reveal withholds the static highlight so the wipe has something to reveal, so it supplies
    // the whole style rather than adding to the usual one. Extended pipeline only — the AI review
    // surface is the only consumer, and the non-extended styles have no background to wipe.
    const revealed = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? (0, $a6f71fd197aec590$export$1a9616afdd8ebb95)({
        colorScheme: colorScheme,
        hideAddedDiffsUnderline: hideAddedDiffsUnderline,
        isActive: isActive,
        isInserted: isInserted,
        reveal: reveal
    }) : undefined;
    const style = revealed?.style ?? $446fe50ec2aaceae$var$resolveInlineChangedStyle({
        colors: colors,
        colorScheme: colorScheme,
        diffType: diffType,
        hideAddedDiffsUnderline: hideAddedDiffsUnderline,
        isActive: isActive,
        isInserted: isInserted
    });
    const isAtomicInlineInsertion = isAtomicInlineNode && isInserted;
    const atomicInlineAttrs = isAtomicInlineInsertion ? $446fe50ec2aaceae$var$resolveAtomicInlineAttrs(inlineNodeName, colorScheme, colors) : undefined;
    // Built from the raw change range, not the indicator anchors resolved below: a tag lines up with
    // the changed text, while the bar's anchors are held on a block boundary when a deleted widget
    // renders beside them.
    //
    // Built up here, ahead of where it is pushed, so the highlight's stacking below keys off whether a
    // tag exists rather than re-deriving the condition and risking disagreement.
    const tagWidget = canTagChange && doc ? (0, $6dde019bf889ed99$export$3281cc96f6ed36d3)({
        doc: doc,
        from: change.fromB,
        to: change.toB,
        diffId: diffId,
        mountContext: tagMountContext
    }) : undefined;
    const inlineStyle = [
        style,
        atomicInlineAttrs?.styleSuffix,
        tagWidget ? $446fe50ec2aaceae$var$stackBelowContributorTagStyle : undefined,
        (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? (0, $c8506ce9a0d29c95$export$830d4c4bf8b7876b) : undefined
    ].filter(Boolean).join('');
    const decorations = [
        (0, $8nvEM.Decoration).inline(change.fromB, change.toB, {
            style: inlineStyle,
            ...atomicInlineAttrs && {
                class: atomicInlineAttrs.className
            },
            ...revealed && {
                [(0, $a6f71fd197aec590$export$cee91f6cebab58c)]: revealed.role
            },
            'data-testid': 'show-diff-changed-decoration',
            // Lets the contributor tag find its highlight on hover.
            ...showContributorTags && {
                'data-diff-id': diffId
            }
        }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            attributionKey: canTagChange ? attributionKey : undefined,
            colorScheme: colorScheme,
            decorationType: 'inline',
            diffId: diffId,
            isActive: isActive,
            isInserted: isInserted
        }))
    ];
    if (showIndicators && doc && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        // For paragraphs, fromB/toB land on the outer block
        // boundary. Adjust anchor widgets into inline content so the indicator
        // bar doesn't extend into the preceding block's margin.
        // Skip when the deleted-content widget is rendered — the anchor must
        // stay at the boundary to keep the indicator continuous.
        //
        // The widget only pins the end of the range it is anchored to. It sits at `change.fromB`
        // by default, but `deletedDiffPlacement: 'bottom'` / `inlineDeletedDiffPlacement: 'after'`
        // move it to `change.toB` so the deleted content reads after the added content. In that
        // case the `from` anchor has no widget beside it any more and must be adjusted inward
        // again, otherwise the over-long indicator bar that CCI-18224 fixed comes back.
        let anchorFrom = change.fromB;
        let anchorTo = change.toB;
        if (!hasDeletedWidget || isDeletedWidgetBelow) {
            const $from = doc.resolve(anchorFrom);
            if (!$from.parent.inlineContent && $from.nodeAfter?.isTextblock) anchorFrom = anchorFrom + 1;
        }
        if (!hasDeletedWidget) {
            const $to = doc.resolve(anchorTo);
            if (!$to.parent.inlineContent && $to.nodeBefore?.isTextblock) anchorTo = anchorTo - 1;
        }
        decorations.push(...(0, $b6432cc061a6f6cb$export$dc213f6c0d801266)({
            doc: doc,
            from: anchorFrom,
            to: anchorTo,
            diffId: diffId
        }));
    }
    // Pushed after the indicator anchors so the decoration order is unchanged — see `tagWidget` above
    // for why it is built before them.
    if (tagWidget) decorations.push(tagWidget);
    return decorations;
};





















var $8Z43Z = parcelRequire("8Z43Z");














/**
 * Pre-refactor code preserved for the OFF cohort of
 * `platform_editor_show_diff_color_scheme_refactor`.
 *
 * These resolvers reproduce the per-scheme style decisions that `createChangedRowDOM` made before
 * the `colorSchemeRegistry` + `factory.ts` migration. Standard deleted styles are resolved at
 * runtime only so the ADF-safety gate can select the equivalent longhand; with that gate off,
 * their CSS remains unchanged.
 *
 * Do not modify. Delete this file at experiment cleanup (EDITOR-8281).
 */ 

const $b5d58d81c6fea5dc$export$e5ebd95d67546d95 = (colorScheme)=>{
    return colorScheme === 'traditional' ? (0, $e7971598d3f97abe$export$62207903895cae1) : (0, $b4335631fdf63f73$export$3b88c73646ebc317)();
};
const $b5d58d81c6fea5dc$export$586f80a88d2bf3e5 = ({ colorScheme: colorScheme, isInserted: isInserted, isRoundedTable: isRoundedTable })=>{
    const isTraditional = colorScheme === 'traditional';
    const deletedCellStyle = isTraditional ? isRoundedTable ? (0, $e7971598d3f97abe$export$ff7c70906e6c1d66) : (0, $e7971598d3f97abe$export$ea323b9930a7947d) : isRoundedTable ? (0, $b4335631fdf63f73$export$19ee1020da83364c) : (0, $b4335631fdf63f73$export$7000268b4d4c5e1);
    const addedCellStyle = isTraditional ? isRoundedTable ? (0, $e7971598d3f97abe$export$7ff4479842f2d7ec) : (0, $e7971598d3f97abe$export$d2957495f69575c) : isRoundedTable ? (0, $b4335631fdf63f73$export$9bb29312b2a8bd50) : (0, $b4335631fdf63f73$export$d311b2309a26b4fb);
    return isInserted ? addedCellStyle : deletedCellStyle;
};







function $0635766b84aa3009$export$c531c54bff461ffa(doc, pos, slice) {
    if (pos > doc.content.size) return doc.content.size;
    let $pos = doc.resolve(pos);
    while(!(0, $bjg0G.canInsert)($pos, slice.content) && slice.content.firstChild?.type.name !== 'paragraph'){
        if ($pos.pos + 1 > doc.content.size) break;
        $pos = doc.resolve($pos.pos + 1);
    }
    return $pos.pos;
}





const $2fd2341d66b1df5b$export$acaafec060277427 = (tableMap)=>{
    const edgeAttrsByOffset = new Map();
    const addLogicalRow = (offsets, edge)=>{
        offsets.forEach((offset, columnIndex)=>{
            var _edgeAttrs, _edgeAttrs1, _edgeAttrs2, _edgeAttrs3;
            const edgeAttrs = edgeAttrsByOffset.get(offset) ?? {
                reachesBottom: false,
                reachesLeft: false,
                reachesRight: false,
                reachesTop: false
            };
            (_edgeAttrs = edgeAttrs).reachesBottom || (_edgeAttrs.reachesBottom = edge === 'bottom');
            (_edgeAttrs1 = edgeAttrs).reachesLeft || (_edgeAttrs1.reachesLeft = columnIndex === 0);
            (_edgeAttrs2 = edgeAttrs).reachesRight || (_edgeAttrs2.reachesRight = columnIndex === tableMap.width - 1);
            (_edgeAttrs3 = edgeAttrs).reachesTop || (_edgeAttrs3.reachesTop = edge === 'top');
            edgeAttrsByOffset.set(offset, edgeAttrs);
        });
    };
    const topRow = tableMap.mapByRow[0];
    const bottomRow = tableMap.mapByRow[tableMap.height - 1];
    if (topRow) addLogicalRow(topRow, 'top');
    if (bottomRow) addLogicalRow(bottomRow, 'bottom');
    return edgeAttrsByOffset;
};
const $2fd2341d66b1df5b$export$1e50358f00090e62 = ({ edgeAttrsByOffset: edgeAttrsByOffset, rowNode: rowNode, rowStart: rowStart })=>{
    const cellEdgeAttrs = [];
    rowNode.content.forEach((cellNode, cellOffset)=>{
        if (cellNode.type.name !== 'tableCell' && cellNode.type.name !== 'tableHeader') return;
        cellEdgeAttrs.push(edgeAttrsByOffset.get(rowStart + 1 + cellOffset));
    });
    return cellEdgeAttrs;
};
const $2fd2341d66b1df5b$export$1bfd578646051821 = (cell, edgeAttrs)=>{
    if (!edgeAttrs) return;
    if (edgeAttrs.reachesTop) cell.setAttribute('data-reaches-top', 'true');
    if (edgeAttrs.reachesBottom) cell.setAttribute('data-reaches-bottom', 'true');
    if (edgeAttrs.reachesLeft) cell.setAttribute('data-reaches-left', 'true');
    if (edgeAttrs.reachesRight) cell.setAttribute('data-reaches-right', 'true');
};
const $2fd2341d66b1df5b$export$563df69c6396f5c = ({ element: element, tableNode: tableNode })=>{
    try {
        const table = element instanceof HTMLTableElement ? element : element.querySelector('table');
        if (!(table instanceof HTMLTableElement)) return;
        const tableMap = (0, $8Z43Z.TableMap).get(tableNode);
        const cells = Array.from(table.rows).flatMap((row)=>Array.from(row.cells));
        const cellsByOffset = new Map();
        let cellIndex = 0;
        tableNode.content.forEach((rowNode, rowStart)=>{
            rowNode.content.forEach((cellNode, cellOffset)=>{
                if (cellNode.type.name === 'tableCell' || cellNode.type.name === 'tableHeader') {
                    const cell = cells[cellIndex];
                    cellIndex++;
                    if (cell) cellsByOffset.set(rowStart + 1 + cellOffset, cell);
                }
            });
        });
        $2fd2341d66b1df5b$export$acaafec060277427(tableMap).forEach((edgeAttrs, offset)=>{
            const cell = cellsByOffset.get(offset);
            if (cell) $2fd2341d66b1df5b$export$1bfd578646051821(cell, edgeAttrs);
        });
    } catch  {
    // Table structure can be transient while widget DOM is being assembled.
    }
};


/**
 * Extracts information about deleted table rows from a change
 */ const $a3529214184876b7$var$extractChangedRows = ({ change: change, originalDoc: originalDoc, newDoc: newDoc, diffType: diffType })=>{
    const changedRows = [];
    // Find the table in the original document
    const $fromPos = originalDoc.resolve(change.fromA);
    const tableOld = (0, $bjg0G.findParentNodeClosestToPos)($fromPos, (node)=>node.type.name === 'table');
    if (!tableOld) return changedRows;
    const oldTableMap = (0, $8Z43Z.TableMap).get(tableOld.node);
    // Find the table in the new document at the insertion point
    const $newPos = newDoc.resolve(change.fromB);
    const tableNew = (0, $bjg0G.findParentNodeClosestToPos)($newPos, (node)=>node.type.name === 'table');
    if (!tableNew) return changedRows;
    const newTableMap = (0, $8Z43Z.TableMap).get(tableNew.node);
    // A row DELETION makes the table shorter. An in-place whole-row REPLACEMENT (`replaceNode` on a
    // `tableRow`, which AI suggested edits emits) leaves the row count untouched — and this helper
    // was written for deletions only, so it used to discard every replacement and the changed row's
    // content was never rendered anywhere. The reviewer was left with just the removed side.
    const isRowDeletion = oldTableMap.height > newTableMap.height;
    const handleRowReplacement = oldTableMap.height === newTableMap.height && (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1');
    // If no rows were changed, return empty
    if (!(isRowDeletion || handleRowReplacement) || // For now ignore if there are column deletions as well
    oldTableMap.width !== newTableMap.width) return changedRows;
    // Find which rows were changed by analyzing the change range
    const changeStartInTable = change.fromA - tableOld.pos - 1;
    const changeEndInTable = change.toA - tableOld.pos - 1;
    const edgeAttrsByOffset = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $4o0zT.isExperimentEnabled)('platform_editor_table_diff_rounded_corners') ? (0, $2fd2341d66b1df5b$export$acaafec060277427)(oldTableMap) : undefined;
    let currentOffset = 0;
    let rowIndex = 0;
    tableOld.node.content.forEach((rowNode)=>{
        const rowStart = currentOffset;
        const rowEnd = currentOffset + rowNode.nodeSize;
        // Check if this row overlaps with the deletion range
        const rowOverlapsChange = rowStart >= changeStartInTable && rowStart < changeEndInTable || rowEnd > changeStartInTable && rowEnd <= changeEndInTable || rowStart < changeStartInTable && rowEnd > changeEndInTable;
        if (rowOverlapsChange && rowNode.type.name === 'tableRow' && ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) || !$a3529214184876b7$var$isEmptyRow(rowNode))) {
            const cellEdgeAttrs = edgeAttrsByOffset ? (0, $2fd2341d66b1df5b$export$1e50358f00090e62)({
                edgeAttrsByOffset: edgeAttrsByOffset,
                rowNode: rowNode,
                rowStart: rowStart
            }) : undefined;
            const startOfRow = newTableMap.mapByRow.slice().reverse().find((row)=>row[0] + tableNew.pos < change.fromB && change.fromB < row[row.length - 1] + tableNew.pos);
            changedRows.push({
                rowIndex: rowIndex,
                rowNode: rowNode,
                cellEdgeAttrs: cellEdgeAttrs,
                fromA: tableOld.pos + 1 + rowStart,
                toA: tableOld.pos + 1 + rowEnd,
                fromB: startOfRow ? startOfRow[0] + tableNew.start : change.fromB
            });
        }
        currentOffset += rowNode.nodeSize;
        if (rowNode.type.name === 'tableRow') rowIndex++;
    });
    // Filter changes that never truly got deleted. Compare the number of equivalent rows rather
    // than only checking whether one still exists: deleting two of three identical empty rows should
    // retain two changed rows even though the third remains in the new table.
    const equivalentRowDeletionCounts = [];
    return changedRows.filter((changedRow)=>{
        // A replacement leaves every sibling row in place, so asking "does this row still exist
        // ANYWHERE in the new table?" can drop a genuinely rewritten row that happens to match a
        // sibling. Compare it against the row at the same index instead.
        if (handleRowReplacement) {
            const counterpart = tableNew.node.maybeChild(changedRow.rowIndex);
            return !counterpart || !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(counterpart, changedRow.rowNode);
        }
        let deletionCount = equivalentRowDeletionCounts.find(({ rowNode: rowNode })=>(0, $6SJ6d.areNodesEqualIgnoreAttrs)(rowNode, changedRow.rowNode));
        if (!deletionCount) {
            const oldRowCount = tableOld.node.children.filter((oldRow)=>(0, $6SJ6d.areNodesEqualIgnoreAttrs)(oldRow, changedRow.rowNode)).length;
            const newRowCount = tableNew.node.children.filter((newRow)=>(0, $6SJ6d.areNodesEqualIgnoreAttrs)(newRow, changedRow.rowNode)).length;
            deletionCount = {
                remaining: Math.max(0, oldRowCount - newRowCount),
                rowNode: changedRow.rowNode
            };
            equivalentRowDeletionCounts.push(deletionCount);
        }
        if (deletionCount.remaining === 0) return false;
        deletionCount.remaining--;
        return true;
    });
};
/**
 * Checks if a table row is empty (contains no meaningful content)
 */ const $a3529214184876b7$var$isEmptyRow = (rowNode)=>{
    let isEmpty = true;
    rowNode.descendants((node)=>{
        if (!isEmpty) return false;
        // If we find any inline content with size > 0, the row is not empty
        if (node.isInline && node.nodeSize > 0) {
            isEmpty = false;
            return false;
        }
        // If we find text content, the row is not empty
        if (node.isText && node.text && node.text.trim() !== '') {
            isEmpty = false;
            return false;
        }
        return true;
    });
    return isEmpty;
};
/**
 * Creates a DOM representation of a deleted table row
 */ const $a3529214184876b7$var$createChangedRowDOM = (rowNode, cellEdgeAttrs, nodeViewSerializer, colorScheme, isInserted, diffType)=>{
    const tr = document.createElement('tr');
    const colors = (0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme ?? 'standard'];
    // Inserted rows keep their natural styling; the row strikethrough is deletions only.
    if (!(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) || !isInserted) tr.setAttribute('style', (0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? (0, $e28b33baecacf396$export$f7d79f6b121d95c8)(colors) : (0, $b5d58d81c6fea5dc$export$e5ebd95d67546d95)((0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme)));
    // Mirrors the strikethrough condition above: under the extended experience an `isInserted` row
    // is ADDED content, so it must not claim the "deleted" testid — page models match that as
    // removed content (same reasoning as `createTableCellContentWidgets`).
    tr.setAttribute('data-testid', (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted && (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? 'show-diff-changed-row' : 'show-diff-deleted-row');
    if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) tr.style.setProperty('scroll-margin-top', (0, $c8506ce9a0d29c95$export$92a3db689480415b));
    // Serialize each cell in the row
    let cellIndex = 0;
    rowNode.content.forEach((cellNode)=>{
        if (cellNode.type.name === 'tableCell' || cellNode.type.name === 'tableHeader') {
            const nodeView = nodeViewSerializer.tryCreateNodeView(cellNode);
            if (nodeView) {
                if (nodeView instanceof HTMLElement) {
                    (0, $2fd2341d66b1df5b$export$1bfd578646051821)(nodeView, cellEdgeAttrs?.[cellIndex]);
                    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
                        const overlay = document.createElement('span');
                        const isRoundedTable = (0, $4o0zT.isExperimentEnabled)('platform_editor_table_diff_rounded_corners');
                        const overlayStyle = (0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? isInserted ? isRoundedTable ? (0, $e28b33baecacf396$export$ad8079eeea0b3320)(colors) : (0, $e28b33baecacf396$export$59d4030fb8ee6502)(colors) : isRoundedTable ? (0, $e28b33baecacf396$export$4e3e05920801547c)(colors) : (0, $e28b33baecacf396$export$79e32cdc2c1a623c)(colors) : (0, $b5d58d81c6fea5dc$export$586f80a88d2bf3e5)({
                            colorScheme: (0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme),
                            isInserted: isInserted,
                            isRoundedTable: isRoundedTable
                        });
                        overlay.setAttribute('style', overlayStyle);
                        nodeView.appendChild(overlay);
                    }
                }
                tr.appendChild(nodeView);
            } else {
                // Fallback to fragment serialization
                const serializedContent = nodeViewSerializer.serializeFragment(cellNode.content);
                if (serializedContent) tr.appendChild(serializedContent);
            }
            cellIndex++;
        }
    });
    return tr;
};
/**
 * Expands a diff to include whole changed rows when table rows are affected
 */ const $a3529214184876b7$var$expandDiffForChangedRows = ({ changes: changes, originalDoc: originalDoc, newDoc: newDoc, diffType: diffType })=>{
    const rowInfo = [];
    for (const change of changes){
        // Check if this change affects table content
        const changedRows = $a3529214184876b7$var$extractChangedRows({
            change: change,
            originalDoc: originalDoc,
            newDoc: newDoc,
            diffType: diffType
        });
        if (changedRows.length > 0) rowInfo.push(...changedRows);
    }
    return rowInfo;
};
const $a3529214184876b7$export$f3a7e2ee274f388a = ({ attributionKey: attributionKey, changes: changes, originalDoc: originalDoc, newDoc: newDoc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted = false, diffType: diffType, showIndicators: showIndicators = false, showContributorTags: showContributorTags = false, tagMountContext: tagMountContext })=>{
    // First, expand the changes to include complete deleted rows
    const changedRows = $a3529214184876b7$var$expandDiffForChangedRows({
        changes: changes.filter((change)=>change.deleted.length > 0),
        originalDoc: originalDoc,
        newDoc: newDoc,
        diffType: diffType
    });
    return changedRows.flatMap((changedRow)=>{
        const rowDOM = $a3529214184876b7$var$createChangedRowDOM(changedRow.rowNode, changedRow.cellEdgeAttrs, nodeViewSerializer, colorScheme, isInserted, diffType);
        // Find safe insertion position for the deleted row
        const safeInsertPos = (0, $0635766b84aa3009$export$c531c54bff461ffa)(newDoc, changedRow.fromB - 1, originalDoc.slice(changedRow.fromA, changedRow.toA));
        // Stable while contributor tags are enabled so a decoration recalculation preserves the tag's
        // identity and controller state.
        const diffId = showContributorTags ? `widget-row-${changedRow.fromA}-${changedRow.toA}` : crypto.randomUUID();
        const decorations = [];
        const rowAnchorNames = [];
        // `IndicatorBarContentComponent` renders a bar for every widget descriptor and anchors its
        // top and bottom to `anchor-<diffId>`. Without an element carrying that anchor name the bar
        // is still created but can never resolve a position, so it silently does not render and the
        // bar covers only the row being changed. `createNodeChangedDecorationWidget` sets the same
        // property on its own widget DOM for non-table content; this path returns before reaching it.
        if (showIndicators && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) {
            rowAnchorNames.push((0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                diffId: diffId
            }));
            // A table's content can extend past the doc margin, so the bar also needs a left anchor
            // measured against the table itself or it is clipped once the table is resized.
            const leftAnchor = (0, $b6432cc061a6f6cb$export$bb60b01773a85c0d)({
                doc: newDoc,
                from: safeInsertPos,
                diffId: diffId
            });
            if (leftAnchor) decorations.push(leftAnchor);
        }
        const tagAnchorName = showContributorTags && (0, $6dde019bf889ed99$export$91669580aae6a96e)() ? (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
            diffId: diffId,
            anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).tag
        }) : undefined;
        const tagWidget = tagAnchorName ? (0, $6dde019bf889ed99$export$3281cc96f6ed36d3)({
            anchorAtRangeStart: true,
            anchorName: tagAnchorName,
            diffId: diffId,
            doc: newDoc,
            from: safeInsertPos,
            mountContext: tagMountContext,
            to: safeInsertPos
        }) : undefined;
        if (tagAnchorName) // The tag host is a separate, table-safe widget. CSS anchor positioning aligns it to this
        // synthetic row without placing non-cell DOM inside the `<tr>` or inheriting its deletion
        // opacity and strikethrough.
        rowAnchorNames.push(tagAnchorName);
        if (rowAnchorNames.length > 0) rowDOM.style.setProperty('anchor-name', rowAnchorNames.map((anchorName)=>`--${anchorName}`).join(', '));
        if (tagWidget) // Lets the contributor tag reveal when any part of the deleted row is hovered.
        rowDOM.setAttribute('data-diff-id', diffId);
        const rowWidget = (0, $8nvEM.Decoration).widget(safeInsertPos, rowDOM, {
            ...(0, $c8506ce9a0d29c95$export$b63856cff30de075)({
                attributionKey: tagWidget ? attributionKey : undefined,
                colorScheme: colorScheme,
                decorationType: 'widget',
                diffId: diffId,
                isActive: isActive,
                isInserted: isInserted,
                diffType: diffType
            })
        });
        decorations.push(rowWidget);
        if (tagWidget) decorations.push(tagWidget);
        return decorations;
    });
};




/**
 * An empty, invisible element whose only job is to occupy a position in the DOM.
 *
 * At the top of the document `firstBlockNodeStyles` zeroes the top margin of whatever element
 * follows a leading `.ProseMirror-widget`, and it does so with `!important` — which no inline style
 * can outrank. This takes that hit so the shaped spacer after it, one position further along, keeps
 * the margin it is there to supply.
 *
 * It contributes no height (no content, border or padding) and margins collapse through it, so it
 * cannot affect layout beyond the selector it absorbs.
 */ const $e9b9dd6fbe76f57e$export$b5fce31ee9537050 = ({ testId: testId })=>{
    // Block-level: an empty inline element takes the match just as well, but collapses to a
    // zero-height line box, and the following margin then lands in the wrong place.
    const absorber = document.createElement('div');
    absorber.dataset.testid = testId;
    absorber.setAttribute('aria-hidden', 'true');
    absorber.contentEditable = 'false';
    return absorber;
};
const $e9b9dd6fbe76f57e$export$3160c4f8540bb072 = ({ testId: testId })=>{
    const absorber = document.createElement('div');
    absorber.dataset.testid = testId;
    absorber.setAttribute('aria-hidden', 'true');
    absorber.contentEditable = 'false';
    absorber.style.display = 'contents';
    return absorber;
};


const $3bc862eb4768c702$export$e40586911b64030a = ({ dom: dom, testId: testId })=>{
    dom.prepend((0, $e9b9dd6fbe76f57e$export$3160c4f8540bb072)({
        testId: testId
    }));
};



/**
 * Node types that can safely be reduced to an empty shell.
 *
 * A shell only replicates a margin if it collapses to nothing itself, which needs zero height and
 * no vertical border or padding. Textblocks and lists qualify; nodes with intrinsic sizing (tables
 * are `display: table`, media has a measured height) or a painted box (a zero-height panel is a
 * visible stripe of background) do not, and are left alone.
 */ const $7636efb3e01a37a2$var$isShapeableNode = (node)=>node.isTextblock || [
        'bulletList',
        'orderedList'
    ].includes(node.type.name);
const $7636efb3e01a37a2$export$bc2935b2acc5ca59 = ({ node: node, serializer: serializer, testId: testId })=>{
    if (!$7636efb3e01a37a2$var$isShapeableNode(node)) return null;
    // An empty node of the same type serializes to the same shell without walking real content.
    const shellNode = node.type.createAndFill(node.attrs) ?? node;
    const serialized = serializer.serializeNode(shellNode);
    if (!(serialized instanceof HTMLElement)) return null;
    // Keep the tag, classes and attributes the margin rules select on; drop anything that could
    // occupy a line box.
    serialized.replaceChildren();
    serialized.dataset.testid = testId;
    serialized.setAttribute('aria-hidden', 'true');
    serialized.contentEditable = 'false';
    // Zero height with no vertical border or padding keeps the spacer self-collapsing: its margins
    // stay adjoining, so they collapse with the neighbours into a single margin equal to the largest
    // rather than adding to them. That is what makes this safe in containers that never reset the
    // first child — the spacer cannot double the gap there. Deliberately no `overflow: hidden`, which
    // would open a block formatting context and stop that collapsing.
    serialized.style.height = '0';
    serialized.style.minHeight = '0';
    serialized.style.paddingTop = '0';
    serialized.style.paddingBottom = '0';
    serialized.style.borderTopWidth = '0';
    serialized.style.borderBottomWidth = '0';
    // Only the top margin is being replicated. Left as-is, a larger bottom margin would win the
    // self-collapse and overshoot the gap.
    serialized.style.marginBottom = '0';
    return serialized;
};



const $8ab7883bcc3719ae$export$15047155ec45c255 = (doc, pos)=>{
    try {
        return doc.resolve(pos);
    } catch  {
        return null;
    }
};






var $iInrd = parcelRequire("iInrd");


var $57Rmq = parcelRequire("57Rmq");


















var $3AVOh = parcelRequire("3AVOh");


var $1A89X = parcelRequire("1A89X");











var $hbVVb = parcelRequire("hbVVb");

const $5a5219f6ff8efa86$var$filterUndefined = (x)=>!!x;
// Attr lists sourced from the shared `diffableAttrs` map (shared with the encoder).
const $5a5219f6ff8efa86$var$mediaAttrs = (0, $hbVVb.getRequiredIncludedDiffableAttrs)('media');
const $5a5219f6ff8efa86$var$dateAttrs = (0, $hbVVb.getRequiredIncludedDiffableAttrs)('date');
const $5a5219f6ff8efa86$var$taskItemAttrs = (0, $hbVVb.getRequiredIncludedDiffableAttrs)('taskItem');
const $5a5219f6ff8efa86$var$panelAttrs = (0, $hbVVb.getRequiredIncludedDiffableAttrs)('panel');
const $5a5219f6ff8efa86$var$emojiAttrs = (0, $hbVVb.getRequiredIncludedDiffableAttrs)('emoji');
const $5a5219f6ff8efa86$var$mentionAttrs = (0, $hbVVb.getRequiredIncludedDiffableAttrs)('mention');
const $5a5219f6ff8efa86$var$statusAttrs = (0, $hbVVb.getRequiredIncludedDiffableAttrs)('status');
// Map of node type name → the attrs that represent a meaningful content change for that node
const $5a5219f6ff8efa86$var$inlineNodeAttrMap = {
    date: $5a5219f6ff8efa86$var$dateAttrs,
    emoji: $5a5219f6ff8efa86$var$emojiAttrs,
    mention: $5a5219f6ff8efa86$var$mentionAttrs,
    status: $5a5219f6ff8efa86$var$statusAttrs
};
const $5a5219f6ff8efa86$export$64700d50d24c2908 = (nodeName)=>nodeName in $5a5219f6ff8efa86$var$inlineNodeAttrMap;
// Extension node type names. Their "any attr except localId" exclude rule lives
// in the shared `diffableAttrs` map and is applied via `isDiffableAttr` below.
const $5a5219f6ff8efa86$var$extensionNodeNames = [
    'extension',
    'inlineExtension',
    'bodiedExtension'
];
const $5a5219f6ff8efa86$var$transientExtensionAttrPaths = [
    'localId',
    'parameters.macroParams._parentId'
];
/**
 * Removes extension metadata that can change between document versions without changing the
 * extension's user-visible configuration.
 */ const $5a5219f6ff8efa86$var$getComparableExtensionAttrs = (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(node.attrs, $5a5219f6ff8efa86$var$transientExtensionAttrPaths);
const $5a5219f6ff8efa86$var$haveSameRelevantExtensionAttrs = (beforeNode, afterNode)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))($5a5219f6ff8efa86$var$getComparableExtensionAttrs(beforeNode), $5a5219f6ff8efa86$var$getComparableExtensionAttrs(afterNode));
const $5a5219f6ff8efa86$var$getStepAttrs = (step)=>{
    if (step instanceof (0, $eOaGc.AttrStep)) return [
        step.attr
    ];
    if (step.attrs) return Object.keys(step.attrs);
    return [];
};
const $5a5219f6ff8efa86$export$34445edbbb29aecb = (doc, attrStepContexts, originalDoc)=>{
    return attrStepContexts.map((attrStepContext)=>{
        const { afterNode: afterNode, attributionKey: attributionKey, beforeNode: beforeNode, finalPos: finalPos, originalPos: originalPos, step: step } = attrStepContext;
        if (!(step instanceof (0, $eOaGc.AttrStep)) && !(step instanceof (0, $1A89X.SetAttrsStep))) return undefined;
        const stepAttrs = $5a5219f6ff8efa86$var$getStepAttrs(step);
        // SetAttrsStep contains the complete replacement attrs, not only the attrs that changed.
        // Keep the legacy payload-based checks until the rollout gate is enabled, and fall back
        // to them if either step-time node is unavailable.
        const attrsToCheck = (0, $iDrrr.fg)('platform_editor_reduce_diff_attr_sensitivity') && beforeNode && afterNode ? stepAttrs.filter((attrName)=>!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(beforeNode.attrs[attrName], afterNode.attrs[attrName])) : stepAttrs;
        const $pos = doc.resolve(finalPos);
        const nodeAtPos = doc.nodeAt(finalPos);
        const originalNodeAtPos = originalPos === undefined ? null : originalDoc.nodeAt(originalPos);
        // The changeset path (createDecorationsForChange) handles the deletion widget via
        // prosemirror-changeset; we only need to add the inline insertion highlight here.
        if (nodeAtPos) {
            const nodeName = nodeAtPos.type.name;
            if ($5a5219f6ff8efa86$export$64700d50d24c2908(nodeName)) {
                const watchedAttrs = $5a5219f6ff8efa86$var$inlineNodeAttrMap[nodeName];
                if (attrsToCheck.some((v)=>watchedAttrs.includes(v))) return {
                    ...attributionKey ? {
                        attributionKey: attributionKey
                    } : {},
                    fromB: finalPos,
                    toB: finalPos + nodeAtPos.nodeSize,
                    isInline: true,
                    inlineNodeName: nodeName,
                    ...originalPos !== undefined && originalNodeAtPos && {
                        fromA: originalPos,
                        toA: originalPos + originalNodeAtPos.nodeSize
                    }
                };
            }
        }
        // taskItem node: state attribute change — highlight the taskItem node
        if (attrsToCheck.some((v)=>$5a5219f6ff8efa86$var$taskItemAttrs.includes(v)) && nodeAtPos?.type.name === 'taskItem') return {
            ...attributionKey ? {
                attributionKey: attributionKey
            } : {},
            fromB: finalPos,
            toB: finalPos + nodeAtPos.nodeSize
        };
        // panel node (incl. variants like panel_c1): type/colour/icon attribute change
        // (e.g. note -> warning) — highlight the new panel and, when the original node
        // is resolvable, expose its range (fromA/toA) so the caller can render the old
        // panel as a "deleted" widget for a before/after comparison.
        if (attrsToCheck.some((v)=>$5a5219f6ff8efa86$var$panelAttrs.includes(v)) && nodeAtPos && (0, $57Rmq.getBaseNodeTypeName)(nodeAtPos.type) === 'panel') return {
            ...attributionKey ? {
                attributionKey: attributionKey
            } : {},
            fromB: finalPos,
            toB: finalPos + nodeAtPos.nodeSize,
            ...originalPos !== undefined && originalNodeAtPos && {
                fromA: originalPos,
                toA: originalPos + originalNodeAtPos.nodeSize
            }
        };
        // Extension nodes: highlight changes to user-visible configuration. When enabled,
        // transient extension metadata is ignored by the comparison below.
        if (nodeAtPos && $5a5219f6ff8efa86$var$extensionNodeNames.includes(nodeAtPos.type.name) && attrsToCheck.some((v)=>(0, $hbVVb.isDiffableAttr)(nodeAtPos.type.name, v))) {
            if ((0, $iDrrr.fg)('platform_editor_reduce_diff_attr_sensitivity') && beforeNode && afterNode && beforeNode.type === afterNode.type && $5a5219f6ff8efa86$var$haveSameRelevantExtensionAttrs(beforeNode, afterNode)) return undefined;
            const isInline = nodeAtPos.type.name === 'inlineExtension';
            return {
                ...attributionKey ? {
                    attributionKey: attributionKey
                } : {},
                fromB: finalPos,
                toB: finalPos + nodeAtPos.nodeSize,
                isInline: isInline
            };
        }
        // media node: id/collection/url attribute change — highlight the mediaSingle parent
        if (attrsToCheck.some((v)=>$5a5219f6ff8efa86$var$mediaAttrs.includes(v)) && $pos.parent.type === doc.type.schema.nodes.mediaSingle) {
            const startPos = $pos.pos + $pos.parentOffset;
            return {
                ...attributionKey ? {
                    attributionKey: attributionKey
                } : {},
                fromB: startPos,
                toB: startPos + $pos.parent.nodeSize - 1
            };
        }
        return undefined;
    }).filter($5a5219f6ff8efa86$var$filterUndefined)// Deduplicate by node position: multiple AttrSteps on the same node
    // (e.g. setNodeAttribute(pos, 'text', ...) + setNodeAttribute(pos, 'color', ...))
    // should produce only one decoration, not one per step.
    .filter((range, i, arr)=>arr.findIndex((r)=>r.fromB === range.fromB) === i);
};
const $5a5219f6ff8efa86$export$78b37f7430a7646c = (step, beforeDoc, afterDoc)=>{
    try {
        if (step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $1A89X.SetAttrsStep)) {
            const attrStepAfter = afterDoc.nodeAt(step.pos);
            const attrStepBefore = beforeDoc.nodeAt(step.pos);
            // The change affected the document
            if (attrStepAfter && attrStepBefore && !attrStepAfter.eq(attrStepBefore)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};


/**
 * Style resolution for the `wrapBlockNodeView` nodeview decorations.
 *
 * Every exported resolver is a single gate: the `colorSchemeRegistry` + `factory.ts`
 * implementation when `platform_editor_show_diff_color_scheme_refactor` is on, and the verbatim
 * pre-refactor per-scheme constants from `./wrapBlockNodeViewStyles.legacy` when it is off. The two
 * paths are built to emit identical style strings for both shipped schemes, so this is a kill
 * switch for a refactor rather than a behaviour experiment.
 *
 * On cleanup (EDITOR-8281): drop the `isExperimentEnabled` dispatch and the `*Legacy` imports,
 * keeping the `*Next` bodies.
 */ 











/**
 * Pre-refactor code preserved for the OFF cohort of
 * `platform_editor_show_diff_color_scheme_refactor`.
 *
 * These resolvers hold the per-scheme style decisions that `wrapBlockNodeView.ts` made before the
 * `colorSchemeRegistry` + `factory.ts` migration. Standard deleted styles are resolved at runtime
 * only so the ADF-safety gate can select the equivalent longhand; with that gate off, their CSS
 * remains unchanged. Delete this file at experiment cleanup, together with
 * `colorSchemes/standard.ts`, `colorSchemes/traditional.ts` (EDITOR-8281).
 */ 











const $a54eeb0465b000c0$var$lozengeStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $a54eeb0465b000c0$var$lozengeStyleActiveStandard = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $a54eeb0465b000c0$var$lozengeStyleActiveTraditional = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
/**
 * Frozen copies of the two node-name predicates `getChangedNodeStyle` branched on pre-refactor.
 * The live copies are exported from `./wrapBlockNodeViewStyles`; these exist so this module stays
 * self-contained (and so the OFF cohort keeps the exact pre-refactor classification) and go away
 * with the rest of the file at cleanup.
 */ const $a54eeb0465b000c0$var$isMultiContainerBlockNode = (nodeName)=>{
    return [
        'decisionList',
        'layoutSection'
    ].includes(nodeName);
};
const $a54eeb0465b000c0$var$isTextLikeBlockNode = (nodeName)=>{
    return [
        'heading',
        'bulletList',
        'orderedList',
        'listItem',
        'taskList',
        'blockquote'
    ].includes(nodeName);
};
const $a54eeb0465b000c0$export$f82524ceaad6e433 = (colorScheme, isActive = false, isInserted = false, diffType, hideAddedDiffsUnderline = false)=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted) {
        if (colorScheme === 'traditional') return isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
        return isActive ? hideAddedDiffsUnderline ? (0, $b4335631fdf63f73$export$1f17ddddf9c73b1f) : (0, $b4335631fdf63f73$export$6edd58aab948260b) : hideAddedDiffsUnderline ? (0, $b4335631fdf63f73$export$91e319dbe79d8dba) : (0, $b4335631fdf63f73$export$6cbccbf53a6b2a8);
    }
    if (colorScheme === 'traditional') return (0, $e7971598d3f97abe$export$f37b168a762b249f)(isActive);
    if (isActive) return (0, $b4335631fdf63f73$export$fbd0e685b6d20e1a)();
    return (0, $ieeJu.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? (0, $b4335631fdf63f73$export$4d3c1a132d48c86d)() : (0, $b4335631fdf63f73$export$377dbc0d0546178d)();
};
const $a54eeb0465b000c0$export$72a98a0aaa3e67fa = (nodeName, colorScheme, isInserted = false, isActive = false, diffType, hideAddedDiffsUnderline = false)=>{
    const isTraditional = colorScheme === 'traditional';
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted) {
        if ($a54eeb0465b000c0$var$isMultiContainerBlockNode(nodeName)) return hideAddedDiffsUnderline || (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? (0, $b4335631fdf63f73$export$4f4aedbfd2e6dac3) : (0, $b4335631fdf63f73$export$21401c524509064e);
        if ($a54eeb0465b000c0$var$isTextLikeBlockNode(nodeName)) return undefined;
        if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094);
        return 0, $b4335631fdf63f73$export$6ba987e1eae93022;
    }
    switch(nodeName){
        case 'blockquote':
            if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$cd5411bbe62ac5f5) : (0, $e7971598d3f97abe$export$781ad9e3e3929b91);
            return isActive ? (0, $b4335631fdf63f73$export$b1c2428901df334f) : (0, $b4335631fdf63f73$export$a26de8170ba89016);
        case 'expand':
        case 'decisionList':
            if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$bb158c719faea3c7) : (0, $e7971598d3f97abe$export$94cf9011b730dea);
            return isActive ? (0, $b4335631fdf63f73$export$f2cea9f09f40fb64) : (0, $b4335631fdf63f73$export$2b892754935ecdf0);
        case 'panel':
        case 'codeBlock':
            if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$9c9f71734a3c1e70) : (0, $e7971598d3f97abe$export$bd7e21e639c80e8d);
            return isActive ? (0, $b4335631fdf63f73$export$1e0b247f41c702d9) : (0, $b4335631fdf63f73$export$95d973a7458c1194);
        default:
            return undefined;
    }
};
const $a54eeb0465b000c0$export$ee5d421dba841b6e = (colorScheme, isActive = false)=>{
    if (colorScheme === 'traditional' && isActive) return 0, $e7971598d3f97abe$export$e384205f8cc82cfe;
    return colorScheme === 'traditional' ? (0, $e7971598d3f97abe$export$d7c13cc5c70ee199) : (0, $b4335631fdf63f73$export$f9aac5ed53f3d424);
};
const $a54eeb0465b000c0$export$664f8760749ab949 = (colorScheme, isActive = false, hideAddedDiffsUnderline = false)=>{
    if (colorScheme === 'traditional') return isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
    if (isActive) return hideAddedDiffsUnderline ? (0, $b4335631fdf63f73$export$1f17ddddf9c73b1f) : (0, $b4335631fdf63f73$export$6edd58aab948260b);
    return hideAddedDiffsUnderline ? (0, $b4335631fdf63f73$export$91e319dbe79d8dba) : (0, $b4335631fdf63f73$export$6cbccbf53a6b2a8);
};
const $a54eeb0465b000c0$export$684224ed6774160c = (colorScheme, isActive = false, diffType, // The reveal animation paints the highlight itself so it can wipe it in; a static one here would
// cover the whole span and leave nothing to reveal. Mirrors the same option on the Next variant.
omitHighlight = false)=>{
    if (colorScheme === 'traditional') return (0, $e7971598d3f97abe$export$f37b168a762b249f)(isActive);
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && !omitHighlight) return (isActive ? (0, $b4335631fdf63f73$export$fbd0e685b6d20e1a)() : (0, $b4335631fdf63f73$export$4d3c1a132d48c86d)()) + (0, $b4335631fdf63f73$export$19cf8e2cf40a1110);
    return isActive ? (0, $b4335631fdf63f73$export$fbd0e685b6d20e1a)() : (0, $b4335631fdf63f73$export$4d3c1a132d48c86d)();
};
const $a54eeb0465b000c0$export$586f80a88d2bf3e5 = ({ colorScheme: colorScheme, isInserted: isInserted, isRoundedTable: isRoundedTable })=>{
    const isTraditional = colorScheme === 'traditional';
    const deletedCellStyle = isTraditional ? isRoundedTable ? (0, $e7971598d3f97abe$export$ff7c70906e6c1d66) : (0, $e7971598d3f97abe$export$ea323b9930a7947d) : isRoundedTable ? (0, $b4335631fdf63f73$export$19ee1020da83364c) : (0, $b4335631fdf63f73$export$7000268b4d4c5e1);
    const addedCellStyle = isTraditional ? isRoundedTable ? (0, $e7971598d3f97abe$export$7ff4479842f2d7ec) : (0, $e7971598d3f97abe$export$4447a7c482f80938) : isRoundedTable ? (0, $b4335631fdf63f73$export$9bb29312b2a8bd50) : (0, $b4335631fdf63f73$export$d311b2309a26b4fb);
    return isInserted ? addedCellStyle : deletedCellStyle;
};
const $a54eeb0465b000c0$export$6aa1796df5b5775b = (colorScheme, isActive)=>isActive && colorScheme === 'traditional' ? $a54eeb0465b000c0$var$lozengeStyleActiveTraditional : isActive ? $a54eeb0465b000c0$var$lozengeStyleActiveStandard : $a54eeb0465b000c0$var$lozengeStyle;
const $a54eeb0465b000c0$export$175cd3faf9e9e7fe = ()=>(0, $b4335631fdf63f73$export$6ba987e1eae93022);
const $a54eeb0465b000c0$export$ee4d63f1f127a5a4 = (colorScheme)=>colorScheme === 'traditional';


const $4b41b4fe449f7205$var$getColorScheme = (colorScheme)=>(0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme ?? 'standard'];
/**
 * Preserve the historical purple nested outlines when the layout/decision diff patch is off.
 */ const $4b41b4fe449f7205$var$nestedContentScheme = (0, $2b1f4eac4487ddd9$export$656b90dc764786c5);
const $4b41b4fe449f7205$export$b2938eddc0463dd8 = (nodeName)=>{
    return [
        'decisionList',
        'layoutSection'
    ].includes(nodeName);
};
const $4b41b4fe449f7205$export$7709140fe7557937 = (nodeName)=>{
    return [
        'heading',
        'bulletList',
        'orderedList',
        'listItem',
        'taskList',
        'blockquote'
    ].includes(nodeName);
};
const $4b41b4fe449f7205$var$getChangedContentStyleNext = (colorScheme, isActive = false, isInserted = false, diffType, hideAddedDiffsUnderline = false)=>{
    const colors = $4b41b4fe449f7205$var$getColorScheme(colorScheme);
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted) return (0, $e28b33baecacf396$export$638cdf51a14ce957)(colors, isActive, hideAddedDiffsUnderline);
    if (isActive) return (0, $e28b33baecacf396$export$86cc6705ce45ea54)(colors, 'active');
    return (0, $e28b33baecacf396$export$86cc6705ce45ea54)(colors, (0, $ieeJu.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? 'new' : 'default');
};
const $4b41b4fe449f7205$var$getChangedNodeStyleNext = (nodeName, colorScheme, isInserted = false, isActive = false, diffType, hideAddedDiffsUnderline = false)=>{
    const colors = $4b41b4fe449f7205$var$getColorScheme(colorScheme);
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted) {
        if ($4b41b4fe449f7205$export$b2938eddc0463dd8(nodeName)) return hideAddedDiffsUnderline || (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? (0, $e28b33baecacf396$export$4a10e3f9ee1f1332)($4b41b4fe449f7205$var$nestedContentScheme) : (0, $e28b33baecacf396$export$bb378cc1b1ef4fa2)($4b41b4fe449f7205$var$nestedContentScheme);
        if ($4b41b4fe449f7205$export$7709140fe7557937(nodeName)) return undefined;
        return (0, $e28b33baecacf396$export$da6c5a56c4c92f0d)(colors, 'node', isActive);
    }
    switch(nodeName){
        case 'blockquote':
            return (0, $e28b33baecacf396$export$630ee3b3f22241a2)(colors, isActive);
        case 'expand':
        case 'decisionList':
            return (0, $e28b33baecacf396$export$a081ec2056a7f2bf)(colors, {
                isActive: isActive,
                isRounded: false
            });
        case 'panel':
        case 'codeBlock':
            return (0, $e28b33baecacf396$export$a081ec2056a7f2bf)(colors, {
                isActive: isActive,
                isRounded: true
            });
        default:
            return undefined;
    }
};
const $4b41b4fe449f7205$var$getDeletedContentStyleUnboundedNext = (colorScheme, isActive = false)=>(0, $e28b33baecacf396$export$66146d9b3a76038c)($4b41b4fe449f7205$var$getColorScheme(colorScheme), isActive);
const $4b41b4fe449f7205$var$getInsertedContentStyleNext = (colorScheme, isActive = false, hideAddedDiffsUnderline = false)=>(0, $e28b33baecacf396$export$638cdf51a14ce957)($4b41b4fe449f7205$var$getColorScheme(colorScheme), isActive, hideAddedDiffsUnderline);
const $4b41b4fe449f7205$var$getDeletedContentStyleNext = (colorScheme, isActive = false, diffType, omitHighlight = false)=>{
    const colors = $4b41b4fe449f7205$var$getColorScheme(colorScheme);
    const base = (0, $e28b33baecacf396$export$86cc6705ce45ea54)(colors, isActive ? 'active' : 'new');
    // glyphTint adds a background highlight and border-bottom over the tint; strikethrough does not.
    const needsExtendedHighlight = colors.deletedInlineTreatment === 'glyphTint' && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && !omitHighlight;
    return needsExtendedHighlight ? base + (0, $e28b33baecacf396$export$cf33a4212f50e620)(colors, isActive) : base;
};
const $4b41b4fe449f7205$var$resolveCellOverlayStyleNext = ({ colorScheme: colorScheme, isInserted: isInserted, isRoundedTable: isRoundedTable })=>{
    const colors = $4b41b4fe449f7205$var$getColorScheme(colorScheme);
    // Square added-cell overlays follow insertedNodeEmphasis: pressed background vs accent border.
    const addedCellStyle = isRoundedTable ? (0, $e28b33baecacf396$export$ad8079eeea0b3320)(colors) : colors.insertedNodeEmphasis === 'stateful' ? (0, $e28b33baecacf396$export$c6c02df0b7af04e7)(colors) : (0, $e28b33baecacf396$export$59d4030fb8ee6502)(colors);
    const deletedCellStyle = isRoundedTable ? (0, $e28b33baecacf396$export$4e3e05920801547c)(colors) : (0, $e28b33baecacf396$export$79e32cdc2c1a623c)(colors);
    return isInserted ? addedCellStyle : deletedCellStyle;
};
const $4b41b4fe449f7205$var$resolveRemovedLozengeStyleNext = (colorScheme, isActive)=>{
    const colors = $4b41b4fe449f7205$var$getColorScheme(colorScheme);
    return isActive ? (0, $e28b33baecacf396$export$6674adb58bd99cd8)(colors) : (0, $e28b33baecacf396$export$488e769d08c6469)(colors);
};
const $4b41b4fe449f7205$var$resolveNestedInsertedNodeStyleNext = (colorScheme)=>(0, $e28b33baecacf396$export$7c9daea341f0c892)((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? $4b41b4fe449f7205$var$getColorScheme(colorScheme) : $4b41b4fe449f7205$var$nestedContentScheme);
// Only 'stateful' schemes have a resting ring.
const $4b41b4fe449f7205$var$hasRestingDeletedRingNext = (colorScheme)=>$4b41b4fe449f7205$var$getColorScheme(colorScheme).deletedNodeEmphasis === 'stateful';
const $4b41b4fe449f7205$export$196ce5d96f32bce = (colorScheme, isActive = false, isInserted = false, diffType, hideAddedDiffsUnderline = false)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$getChangedContentStyleNext(colorScheme, isActive, isInserted, diffType, hideAddedDiffsUnderline) : (0, $a54eeb0465b000c0$export$f82524ceaad6e433)((0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme), isActive, isInserted, diffType, hideAddedDiffsUnderline);
const $4b41b4fe449f7205$export$a2ebbfed109683c2 = (nodeName, colorScheme, isInserted = false, isActive = false, diffType, hideAddedDiffsUnderline = false)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$getChangedNodeStyleNext(nodeName, colorScheme, isInserted, isActive, diffType, hideAddedDiffsUnderline) : (0, $a54eeb0465b000c0$export$72a98a0aaa3e67fa)(nodeName, (0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme), isInserted, isActive, diffType, hideAddedDiffsUnderline);
const $4b41b4fe449f7205$export$8482edbd6aeab6ec = (colorScheme, isActive = false)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$getDeletedContentStyleUnboundedNext(colorScheme, isActive) : (0, $a54eeb0465b000c0$export$ee5d421dba841b6e)((0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme), isActive);
const $4b41b4fe449f7205$export$7db62c93d6a6b5d5 = (colorScheme, isActive = false, hideAddedDiffsUnderline = false)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$getInsertedContentStyleNext(colorScheme, isActive, hideAddedDiffsUnderline) : (0, $a54eeb0465b000c0$export$664f8760749ab949)((0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme), isActive, hideAddedDiffsUnderline);
const $4b41b4fe449f7205$export$e981ebd97f4ac3fc = (colorScheme, isActive = false, diffType, // Set while the reveal animation is running: it paints the highlight itself so it can wipe it in
// left-to-right, and a static background here would leave nothing to reveal.
omitHighlight = false)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$getDeletedContentStyleNext(colorScheme, isActive, diffType, omitHighlight) : (0, $a54eeb0465b000c0$export$684224ed6774160c)((0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme), isActive, diffType, omitHighlight);
const $4b41b4fe449f7205$export$30beebe481f7d821 = (args)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$resolveCellOverlayStyleNext(args) : (0, $a54eeb0465b000c0$export$586f80a88d2bf3e5)({
        ...args,
        colorScheme: (0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(args.colorScheme)
    });
const $4b41b4fe449f7205$export$550b7a978d94dae7 = (colorScheme, isActive)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$resolveRemovedLozengeStyleNext(colorScheme, isActive) : (0, $a54eeb0465b000c0$export$6aa1796df5b5775b)((0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme), isActive);
const $4b41b4fe449f7205$export$a0a318520830ccf9 = (colorScheme)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$resolveNestedInsertedNodeStyleNext(colorScheme) : (0, $a54eeb0465b000c0$export$175cd3faf9e9e7fe)();
const $4b41b4fe449f7205$export$e1b905a50691c388 = (colorScheme)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $4b41b4fe449f7205$var$hasRestingDeletedRingNext(colorScheme) : (0, $a54eeb0465b000c0$export$ee4d63f1f127a5a4)((0, $2b1f4eac4487ddd9$export$fd28930f0c124891)(colorScheme));
const $4b41b4fe449f7205$export$ad856c08e943ba96 = (colorScheme)=>(0, $e28b33baecacf396$export$e85c271228836846)($4b41b4fe449f7205$var$getColorScheme(colorScheme));


const $be39abb9710747ce$var$shouldShowRemovedLozenge = (nodeName)=>{
    switch(nodeName){
        case 'expand':
        case 'codeBlock':
        case 'mediaSingle':
        case 'panel':
        case 'decisionList':
        case 'embedCard':
        case 'blockquote':
            return true;
        default:
            return false;
    }
};
const $be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass = (nodeName)=>{
    switch(nodeName){
        case 'mediaSingle':
        case 'embedCard':
        case 'blockquote':
            return true;
        default:
            return false;
    }
};
/** Scroll-nav “new” ring (4px red subtlest) for media/embed; styled in editor-core smartCardStyles. */ const $be39abb9710747ce$var$maybeAddDeletedOutlineNewClass = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive = false })=>{
    const name = targetNode.type.name;
    if (name !== 'mediaSingle' && name !== 'embedCard') return;
    // Only schemes with a resting ring get the class.
    if ((0, $4b41b4fe449f7205$export$e1b905a50691c388)(colorScheme) && !isActive) nodeView.classList.add('show-diff-deleted-outline-new');
};
/**
 * Pre-refactor markup for a deleted media/embed/blockquote nodeview: one class per scheme, and no
 * custom properties — the colours come from the matching per-scheme selectors in editor-core.
 *
 * Delete this together with those selectors at experiment cleanup (EDITOR-8281).
 */ const $be39abb9710747ce$var$applyDeletedNodeMarkupLegacy = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive = false })=>{
    nodeView.classList.add(colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node');
    if (isActive) nodeView.classList.add('show-diff-deleted-active');
    $be39abb9710747ce$var$maybeAddDeletedOutlineNewClass({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive
    });
};
/**
 * Registry-driven markup: one scheme-agnostic class, plus the scheme's colours as custom properties,
 * so editor-core needs one selector per visual role instead of one per scheme.
 *
 * `show-diff-deleted-node-vars` *replaces* the legacy classes rather than joining them. Both sets of
 * selectors live in editor-core for the life of the experiment, and they have equal specificity, so
 * a shared base class would leave the winner up to source order.
 *
 * The `-vars` suffix names what the class means — this node carries its scheme colours as
 * `--diff-delete-*` custom properties — rather than when it arrived, so it still reads correctly
 * once the legacy classes are gone.
 */ const $be39abb9710747ce$var$applyDeletedNodeMarkupNext = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive = false })=>{
    nodeView.classList.add('show-diff-deleted-node-vars');
    if (isActive) nodeView.classList.add('show-diff-deleted-active');
    $be39abb9710747ce$var$maybeAddDeletedOutlineNewClass({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive
    });
    const currentStyle = nodeView.getAttribute('style') || '';
    const separator = currentStyle && !currentStyle.trimEnd().endsWith(';') ? ';' : '';
    nodeView.setAttribute('style', `${currentStyle}${separator}${(0, $4b41b4fe449f7205$export$ad856c08e943ba96)(colorScheme)}`);
};
/** Single gate for the deleted-node classes and custom properties. */ const $be39abb9710747ce$var$applyDeletedNodeMarkup = (args)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor') ? $be39abb9710747ce$var$applyDeletedNodeMarkupNext(args) : $be39abb9710747ce$var$applyDeletedNodeMarkupLegacy(args);
/**
 * Checks if a node should apply deleted styles directly without wrapper
 * to preserve natural block-level margins
 */ const $be39abb9710747ce$var$shouldApplyStylesDirectly = (nodeName)=>{
    return nodeName === 'heading';
};
const $be39abb9710747ce$var$applyCellOverlayStyles = ({ element: element, colorScheme: colorScheme, isInserted: isInserted })=>{
    const isRoundedTable = (0, $4o0zT.isExperimentEnabled)('platform_editor_table_diff_rounded_corners');
    const overlayStyle = (0, $4b41b4fe449f7205$export$30beebe481f7d821)({
        colorScheme: colorScheme,
        isInserted: isInserted,
        isRoundedTable: isRoundedTable
    });
    element.querySelectorAll('td, th').forEach((cell)=>{
        const overlay = document.createElement('span');
        overlay.setAttribute('style', overlayStyle);
        cell.appendChild(overlay);
    });
};
/**
 * Creates a "Removed" lozenge to be displayed at the top right corner of deleted block nodes
 */ const $be39abb9710747ce$var$createRemovedLozenge = (intl, isActive = false, colorScheme)=>{
    const container = document.createElement('span');
    const containerStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: "var(--ds-space-075, 6px)",
        right: "var(--ds-space-075, 6px)",
        zIndex: 2,
        pointerEvents: 'none',
        display: 'flex'
    });
    container.setAttribute('style', containerStyle);
    container.setAttribute('data-testid', 'show-diff-removed-lozenge');
    // Create vanilla HTML lozenge element with Atlaskit Lozenge styling (visual refresh)
    const lozengeElement = document.createElement('span');
    const lozengeInnerStyle = (0, $4b41b4fe449f7205$export$550b7a978d94dae7)(colorScheme, isActive);
    lozengeElement.setAttribute('style', lozengeInnerStyle);
    lozengeElement.textContent = intl.formatMessage((0, $iInrd.trackChangesMessages).removed).toUpperCase();
    container.appendChild(lozengeElement);
    return container;
};
/**
 * Wraps a block node in a container with relative positioning to support absolute positioned lozenge
 */ const $be39abb9710747ce$var$createBlockNodeWrapper = ()=>{
    const wrapper = document.createElement('div');
    const baseStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'relative',
        display: 'block',
        opacity: 1
    });
    wrapper.setAttribute('style', baseStyle);
    return wrapper;
};
/**
 * Applies styles directly to an HTML element by merging with existing styles
 */ const $be39abb9710747ce$var$applyStylesToElement = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false })=>{
    const currentStyle = element.getAttribute('style') || '';
    const contentStyle = (0, $4b41b4fe449f7205$export$196ce5d96f32bce)(colorScheme, isActive, isInserted, diffType, hideAddedDiffsUnderline);
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeSpecificStyle = (0, $4b41b4fe449f7205$export$a2ebbfed109683c2)(targetNodeName, colorScheme, isInserted, isActive, diffType, hideAddedDiffsUnderline) || '';
    element.setAttribute('style', `${currentStyle}${contentStyle}${nodeSpecificStyle}`);
};
const $be39abb9710747ce$var$applyMultiContainerLikeStyles = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false })=>{
    const currentStyle = element.getAttribute('style') || '';
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeSpecificStyle = (0, $4b41b4fe449f7205$export$a2ebbfed109683c2)(targetNodeName, colorScheme, isInserted, isActive, diffType, hideAddedDiffsUnderline) || '';
    if (targetNode.type.name === 'decisionList') {
        const nestedInsertedNodeStyle = (0, $4b41b4fe449f7205$export$a0a318520830ccf9)(colorScheme);
        element.querySelectorAll('li').forEach((listItem)=>{
            const currentListItemStyle = listItem.getAttribute('style') || '';
            listItem.setAttribute('style', (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? $be39abb9710747ce$var$combineStyles(currentListItemStyle, nestedInsertedNodeStyle) : `${currentListItemStyle}${nestedInsertedNodeStyle}`);
        });
    } else if (targetNode.type.name === 'layoutSection') {
        const nestedInsertedNodeStyle = (0, $4b41b4fe449f7205$export$a0a318520830ccf9)(colorScheme);
        element.querySelectorAll('[data-layout-column="true"]').forEach((section)=>{
            const currentSectionStyle = section.getAttribute('style') || '';
            section.setAttribute('style', (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? $be39abb9710747ce$var$combineStyles(currentSectionStyle, nestedInsertedNodeStyle) : `${currentSectionStyle}${nestedInsertedNodeStyle}`);
        });
    } else if (targetNode.type.name === 'taskList') {
        const nestedInsertedNodeStyle = (0, $4b41b4fe449f7205$export$a0a318520830ccf9)(colorScheme);
        element.querySelectorAll('li').forEach((listItem)=>{
            const currentListItemStyle = listItem.getAttribute('style') || '';
            listItem.setAttribute('style', `${currentListItemStyle}${nestedInsertedNodeStyle}`);
        });
    }
    element.setAttribute('style', (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? $be39abb9710747ce$var$combineStyles(currentStyle, nodeSpecificStyle) : `${currentStyle};${nodeSpecificStyle}`);
};
const $be39abb9710747ce$var$combineStyles = (currentStyle, appendedStyle)=>{
    const separator = currentStyle && appendedStyle && !currentStyle.trimEnd().endsWith(';') ? '; ' : '';
    return `${currentStyle}${separator}${appendedStyle}`;
};
const $be39abb9710747ce$var$appendStyleToElement = (element, style)=>{
    const currentStyle = element.getAttribute('style') || '';
    element.setAttribute('style', $be39abb9710747ce$var$combineStyles(currentStyle, style));
};
const $be39abb9710747ce$var$wrapAtomicInlineNode = ({ element: element, className: className, style: style })=>{
    const wrapper = document.createElement('span');
    wrapper.className = className;
    wrapper.setAttribute('style', style);
    element.replaceWith(wrapper);
    wrapper.append(element);
};
const $be39abb9710747ce$var$applyInlineLeafNodeStyles = ({ element: element, targetNode: targetNode, contentStyle: contentStyle, colorScheme: colorScheme })=>{
    // NodeViewSerializer appends one DOM node per direct ProseMirror child, preserving order.
    const childDomNodes = [
        ...element.childNodes
    ];
    targetNode.content.forEach((childNode, _offset, index)=>{
        if (childNode.isText || !childNode.isLeaf) return;
        const childElement = childDomNodes[index];
        if (!(childElement instanceof HTMLElement)) return;
        if (!(0, $5a5219f6ff8efa86$export$64700d50d24c2908)(childNode.type.name)) {
            $be39abb9710747ce$var$appendStyleToElement(childElement, contentStyle);
            return;
        }
        const { className: className, styleSuffix: styleSuffix } = (0, $446fe50ec2aaceae$export$4d88fb3a58252f14)(childNode.type.name, colorScheme);
        // Inline decorations use an outer span so node-specific descendant selectors match.
        $be39abb9710747ce$var$wrapAtomicInlineNode({
            element: childElement,
            className: className,
            style: $be39abb9710747ce$var$combineStyles(contentStyle, styleSuffix)
        });
    });
};
/**
 * Editor CSS makes `blockquote` `inline-block` for its block formatting context. Inside a widget
 * that collapses the indicator bar: the container is an inline `span`, so its anchor rect comes from
 * font metrics, not from an inline-level child. `flow-root` keeps the formatting context but is
 * block-level — unlike `block`, which lets the child paragraph's top margin collapse out.
 */ const $be39abb9710747ce$var$quoteBlockLevelStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'flow-root'
});
const $be39abb9710747ce$var$applyTextLikeBlockNodeStyles = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false, highlightInlineLeafNodes: highlightInlineLeafNodes = false })=>{
    const currentStyle = element.getAttribute('style') || '';
    const nodeSpecificStyle = (0, $4b41b4fe449f7205$export$a2ebbfed109683c2)(targetNode.type.name, colorScheme, isInserted, isActive, diffType, hideAddedDiffsUnderline) || '';
    if (nodeSpecificStyle) element.setAttribute('style', `${currentStyle}${nodeSpecificStyle}`);
    const contentStyle = (0, $4b41b4fe449f7205$export$196ce5d96f32bce)(colorScheme, isActive, isInserted, diffType, hideAddedDiffsUnderline);
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodesToWrap = [];
    let currentNode = walker.nextNode();
    while(currentNode){
        if (currentNode instanceof Text && currentNode.textContent !== '' && currentNode.parentElement) textNodesToWrap.push(currentNode);
        currentNode = walker.nextNode();
    }
    textNodesToWrap.forEach((textNode)=>{
        const contentWrapper = document.createElement('span');
        contentWrapper.setAttribute('style', contentStyle);
        textNode.replaceWith(contentWrapper);
        contentWrapper.append(textNode);
    });
    if (highlightInlineLeafNodes && targetNode.type.inlineContent) $be39abb9710747ce$var$applyInlineLeafNodeStyles({
        element: element,
        targetNode: targetNode,
        contentStyle: contentStyle,
        colorScheme: colorScheme
    });
};
/**
 * Creates a content wrapper with deleted styles for a block node
 */ const $be39abb9710747ce$var$createBlockNodeContentWrapper = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false })=>{
    const contentWrapper = document.createElement('div');
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeStyle = (0, $4b41b4fe449f7205$export$a2ebbfed109683c2)(targetNodeName, colorScheme, isInserted, isActive, diffType, hideAddedDiffsUnderline);
    // When the extended experiment is enabled and the content is inserted,
    // block widget nodes that already have dedicated node-level styling (e.g. boxShadow outline)
    // should not also get the inline content style (borderBottom underline) on their container.
    const shouldSkipContentStyle = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted && nodeStyle !== undefined;
    const contentStyle = shouldSkipContentStyle ? '' : (0, $4b41b4fe449f7205$export$196ce5d96f32bce)(colorScheme, isActive, isInserted, diffType, hideAddedDiffsUnderline);
    contentWrapper.setAttribute('style', `${contentStyle}${nodeStyle || ''}`);
    contentWrapper.append(nodeView);
    return contentWrapper;
};
/**
 * Handles embedCard node rendering with lozenge attached to the rich-media-item container.
 * Since embedCard content loads asynchronously, we use a MutationObserver
 * to wait for the rich-media-item to appear before attaching the lozenge.
 * @returns true if embedCard was handled
 */ const $be39abb9710747ce$var$handleEmbedCardWithLozenge = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, lozenge: lozenge, colorScheme: colorScheme, isActive: isActive = false })=>{
    if (targetNode.type.name !== 'embedCard' || !(nodeView instanceof HTMLElement)) return false;
    const richMediaItem = nodeView.querySelector('.rich-media-item');
    if (richMediaItem instanceof HTMLElement) richMediaItem.appendChild(lozenge);
    else {
        const observer = new MutationObserver((_, obs)=>{
            const loadedRichMedia = nodeView.querySelector('.rich-media-item');
            if (loadedRichMedia instanceof HTMLElement) {
                loadedRichMedia.appendChild(lozenge);
                obs.disconnect();
            }
        });
        observer.observe(nodeView, {
            childList: true,
            subtree: true
        });
    }
    if ($be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) $be39abb9710747ce$var$applyDeletedNodeMarkup({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive
    });
    dom.append(nodeView);
    return true;
};
/**
 * Handles special mediaSingle node rendering with lozenge on child media element
 * @returns true if mediaSingle was handled, false otherwise
 */ const $be39abb9710747ce$var$handleMediaSingleWithLozenge = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, lozenge: lozenge, colorScheme: colorScheme, isActive: isActive = false })=>{
    if (targetNode.type.name !== 'mediaSingle' || !(nodeView instanceof HTMLElement)) return false;
    const mediaNode = nodeView.querySelector('[data-prosemirror-node-name="media"]');
    if (!mediaNode || !(mediaNode instanceof HTMLElement)) return false;
    // Add relative positioning to media node to anchor lozenge
    const currentStyle = mediaNode.getAttribute('style') || '';
    const relativePositionStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'relative'
    });
    mediaNode.setAttribute('style', `${currentStyle}${relativePositionStyle}`);
    mediaNode.append(lozenge);
    // Add deleted node class if needed
    if ($be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) $be39abb9710747ce$var$applyDeletedNodeMarkup({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive
    });
    dom.append(nodeView);
    return true;
};
/**
 * Appends a block node with wrapper, lozenge, and appropriate styling
 */ const $be39abb9710747ce$var$wrapBlockNode = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, intl: intl, isActive: isActive = false, isInserted: isInserted = false, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false })=>{
    const blockWrapper = $be39abb9710747ce$var$createBlockNodeWrapper();
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    if ($be39abb9710747ce$var$shouldShowRemovedLozenge(targetNodeName) && (!(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) || !isInserted)) {
        const lozenge = $be39abb9710747ce$var$createRemovedLozenge(intl, isActive, colorScheme);
        if ($be39abb9710747ce$var$handleEmbedCardWithLozenge({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            lozenge: lozenge,
            colorScheme: colorScheme,
            isActive: isActive
        })) return;
        if ($be39abb9710747ce$var$handleMediaSingleWithLozenge({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            lozenge: lozenge,
            colorScheme: colorScheme,
            isActive: isActive
        })) return;
        blockWrapper.append(lozenge);
    }
    const contentWrapper = $be39abb9710747ce$var$createBlockNodeContentWrapper({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive,
        isInserted: isInserted,
        diffType: diffType,
        hideAddedDiffsUnderline: hideAddedDiffsUnderline
    });
    blockWrapper.append(contentWrapper);
    if (nodeView instanceof HTMLElement && $be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) $be39abb9710747ce$var$applyDeletedNodeMarkup({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive
    });
    dom.append(blockWrapper);
};
const $be39abb9710747ce$export$decea4d8614a74b3 = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, intl: intl, isActive: isActive = false, isInserted: isInserted = false, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false, highlightInlineLeafNodes: highlightInlineLeafNodes = false })=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (nodeView instanceof HTMLElement) {
            if (isInserted && (0, $4b41b4fe449f7205$export$b2938eddc0463dd8)(targetNode.type.name)) {
                $be39abb9710747ce$var$applyMultiContainerLikeStyles({
                    element: nodeView,
                    targetNode: targetNode,
                    colorScheme: colorScheme,
                    isActive: isActive,
                    isInserted: isInserted,
                    diffType: diffType,
                    hideAddedDiffsUnderline: hideAddedDiffsUnderline
                });
                dom.append(nodeView);
                return;
            }
            if ((0, $4b41b4fe449f7205$export$7709140fe7557937)(targetNode.type.name)) {
                $be39abb9710747ce$var$applyTextLikeBlockNodeStyles({
                    element: nodeView,
                    targetNode: targetNode,
                    colorScheme: colorScheme,
                    isActive: isActive,
                    isInserted: isInserted,
                    diffType: diffType,
                    hideAddedDiffsUnderline: hideAddedDiffsUnderline,
                    highlightInlineLeafNodes: highlightInlineLeafNodes
                });
                if (targetNode.type.name === 'blockquote' && (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) $be39abb9710747ce$var$appendStyleToElement(nodeView, $be39abb9710747ce$var$quoteBlockLevelStyle);
                dom.append(nodeView);
                return;
            }
            if (targetNode.type.name === 'table') {
                if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $4o0zT.isExperimentEnabled)('platform_editor_table_diff_rounded_corners')) (0, $2fd2341d66b1df5b$export$563df69c6396f5c)({
                    element: nodeView,
                    tableNode: targetNode
                });
                $be39abb9710747ce$var$applyCellOverlayStyles({
                    element: nodeView,
                    colorScheme: colorScheme,
                    isInserted: isInserted
                });
                dom.append(nodeView);
                return;
            }
        }
        $be39abb9710747ce$var$wrapBlockNode({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            intl: intl,
            isActive: isActive,
            isInserted: isInserted,
            diffType: diffType,
            hideAddedDiffsUnderline: hideAddedDiffsUnderline
        });
        return;
    } else if ($be39abb9710747ce$var$shouldApplyStylesDirectly(targetNode.type.name) && nodeView instanceof HTMLElement) {
        // Apply deleted styles directly to preserve natural block-level margins
        $be39abb9710747ce$var$applyStylesToElement({
            element: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive,
            isInserted: isInserted,
            diffType: diffType
        });
        dom.append(nodeView);
    } else $be39abb9710747ce$var$wrapBlockNode({
        dom: dom,
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        intl: intl,
        isActive: isActive,
        isInserted: isInserted,
        diffType: diffType
    });
};
const $be39abb9710747ce$export$d67ad4e75a7e5029 = ({ node: node, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType, reveal: reveal })=>{
    const wrapper = document.createElement('span');
    const revealStyle = (0, $a6f71fd197aec590$export$88545ce374f4083)({
        colorScheme: colorScheme,
        element: wrapper,
        isActive: isActive ?? false,
        isInserted: isInserted ?? false,
        reveal: reveal
    });
    wrapper.setAttribute('style', (isInserted ? (0, $4b41b4fe449f7205$export$7db62c93d6a6b5d5)(colorScheme, isActive) : (0, $4b41b4fe449f7205$export$e981ebd97f4ac3fc)(colorScheme, isActive, diffType, Boolean(revealStyle))) + revealStyle);
    [
        ...node.childNodes
    ].forEach((child)=>{
        const removedChild = node.removeChild(child);
        wrapper.append(removedChild);
    });
    node.appendChild(wrapper);
    return node;
};
const $be39abb9710747ce$export$9fa8827364ac0e9d = (colorScheme, isActive = false, isInserted = false, diffType, reveal)=>{
    const wrapper = document.createElement('span');
    const baseStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'relative',
        width: 'fit-content'
    });
    // Empty unless the reveal is running, in which case the static highlight below is withheld so
    // the animation can wipe it in instead.
    const revealStyle = (0, $a6f71fd197aec590$export$88545ce374f4083)({
        colorScheme: colorScheme,
        element: wrapper,
        isActive: isActive,
        isInserted: isInserted,
        reveal: reveal
    });
    const deletedStyle = (0, $4b41b4fe449f7205$export$e981ebd97f4ac3fc)(colorScheme, isActive, diffType, Boolean(revealStyle));
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (isInserted) wrapper.setAttribute('style', `${baseStyle}${(0, $4b41b4fe449f7205$export$7db62c93d6a6b5d5)(colorScheme, isActive)}${revealStyle}`);
        else {
            wrapper.setAttribute('style', `${baseStyle}${deletedStyle}${revealStyle}`);
            const strikethrough = document.createElement('span');
            strikethrough.setAttribute('style', (0, $4b41b4fe449f7205$export$8482edbd6aeab6ec)(colorScheme, isActive));
            wrapper.append(strikethrough);
        }
    } else {
        wrapper.setAttribute('style', `${baseStyle}${deletedStyle}${revealStyle}`);
        const strikethrough = document.createElement('span');
        strikethrough.setAttribute('style', (0, $4b41b4fe449f7205$export$8482edbd6aeab6ec)(colorScheme, isActive));
        wrapper.append(strikethrough);
    }
    return wrapper;
};


const $6760b5578652a45a$var$isHeadingLevel = (level)=>typeof level === 'number' && level >= 1 && level <= 6;
/**
 * Render one content widget per table cell, positioned inside the matching cell in
 * `newDoc`, so a whole-cell replacement shows its added content in-place instead of
 * being dropped (EDITOR-8442).
 */ const $6760b5578652a45a$var$createTableCellContentWidgets = ({ slice: slice, newDoc: newDoc, change: change, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, isInserted: isInserted, diffType: diffType })=>{
    // Collect the inner content position of each cell in the new document within
    // the change range. Whole-cell replacement preserves cell count/order, so the
    // nth new-doc cell corresponds to the nth cell in the slice.
    const newCellInnerPositions = [];
    newDoc.nodesBetween(change.fromB, change.toB, (node, pos)=>{
        if (node.type.name === 'tableHeader' || node.type.name === 'tableCell') {
            // Skip malformed cells with no block child: `pos + 2` would be out of bounds.
            if (node.childCount === 0) return false;
            // +1 into the cell, +1 into its first child (the paragraph) = inner content.
            newCellInnerPositions.push(pos + 2);
            return false;
        }
        return true;
    });
    const decorations = [];
    slice.content.forEach((cellNode, _offset, index)=>{
        const targetPos = newCellInnerPositions[index];
        if (targetPos === undefined || cellNode.content.size === 0) return;
        const dom = document.createElement('span');
        // A cell contains block content (paragraphs); serialize the cell's content
        // so every block inside the cell is rendered.
        cellNode.content.forEach((blockNode)=>{
            const nodeView = nodeViewSerializer.tryCreateNodeView(blockNode);
            const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, false, isInserted, diffType);
            if (nodeView) wrapper.append(nodeView);
            else {
                const serialized = blockNode.type.inlineContent ? nodeViewSerializer.serializeFragment(blockNode.content) : nodeViewSerializer.serializeNode(blockNode);
                if (serialized) wrapper.append(serialized);
            }
            dom.append(wrapper);
        });
        if (dom.childNodes.length === 0) return;
        // This helper only runs for added content, so use the "changed" testid — not
        // "deleted", which page models match as removed content.
        dom.setAttribute('data-testid', 'show-diff-changed-decoration');
        if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) dom.style.setProperty('scroll-margin-top', (0, $c8506ce9a0d29c95$export$92a3db689480415b));
        // Skip findSafeInsertPos: it walks forward to a schema-valid cell-insert point
        // and pushes the widget into the next cell. `targetPos` is the correct spot.
        decorations.push((0, $8nvEM.Decoration).widget(targetPos, dom, {
            ...(0, $c8506ce9a0d29c95$export$b63856cff30de075)({
                colorScheme: colorScheme,
                decorationType: 'widget',
                diffId: crypto.randomUUID(),
                isInserted: isInserted,
                diffType: diffType,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    side: -1
                }
            })
        }));
    });
    return decorations;
};
const $6760b5578652a45a$export$33298e826c81587e = ({ attributionKey: attributionKey, change: change, doc: doc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, newDoc: newDoc, intl: intl, activeIndexPos: activeIndexPos, isInserted: // This is false by default as this is generally used to show deleted content
isInserted = false, showContributorTags: showContributorTags = false, showIndicators: showIndicators = false, placeBelow: // When true, render the deleted content *after* (below) the new content instead of
// before it. Used for `smart` node-level changes so the deleted node appears beneath
// its replacement (gray + strikethrough).
placeBelow = false, diffType: diffType, hideAddedDiffsUnderline: hideAddedDiffsUnderline = false, reveal: reveal, tagMountContext: tagMountContext })=>{
    const slice = doc.slice(change.fromA, change.toA);
    const shouldSkipDeletedEmptyParagraphDecoration = !isInserted && (0, $4170afb8d5f70d14$export$67d419665654ec06)(slice);
    // Widget decoration used for deletions as the content is not in the document
    // and we want to display the deleted content with a style.
    // For `placeBelow`, anchor at the END of the new content (change.toB) so the deleted
    // node renders beneath its replacement; otherwise anchor at the start (change.fromB).
    const anchorPos = placeBelow ? change.toB : change.fromB;
    const safeInsertPos = (0, $0635766b84aa3009$export$c531c54bff461ffa)(newDoc, anchorPos, slice);
    const isActive = activeIndexPos && ((0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') ? safeInsertPos >= activeIndexPos.from && safeInsertPos <= activeIndexPos.to : safeInsertPos === activeIndexPos.from && safeInsertPos === activeIndexPos.to);
    if (slice.content.content.length === 0 || shouldSkipDeletedEmptyParagraphDecoration) return [];
    const isTableCellContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableHeader',
                'tableCell'
            ].includes(siblingNode.type.name)));
    const isTableRowContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableRow'
            ].includes(siblingNode.type.name)));
    // Added whole cells (e.g. "Add table headers"): render per-cell content widgets.
    // Deleted whole cells (delete row/col) fall through — they don't exist in `newDoc`,
    // so there's nowhere to anchor content and we keep the original "render nothing".
    if (isTableCellContent && isInserted) return $6760b5578652a45a$var$createTableCellContentWidgets({
        slice: slice,
        newDoc: newDoc,
        change: change,
        nodeViewSerializer: nodeViewSerializer,
        colorScheme: colorScheme,
        isInserted: isInserted,
        diffType: diffType
    });
    if (isTableCellContent) // Deleted whole cells: nothing to render (see note above).
    return [];
    if (isTableRowContent) return (0, $a3529214184876b7$export$f3a7e2ee274f388a)({
        attributionKey: attributionKey,
        changes: [
            change
        ],
        originalDoc: doc,
        newDoc: newDoc,
        nodeViewSerializer: nodeViewSerializer,
        colorScheme: colorScheme,
        isActive: isActive,
        isInserted: isInserted,
        diffType: diffType,
        showIndicators: // Needed for the row's own indicator anchor; this path returns before the
        // `anchor-name` assignment further down.
        showIndicators,
        showContributorTags: showContributorTags,
        tagMountContext: tagMountContext
    });
    const serializer = nodeViewSerializer;
    // For non-table content, use the existing span wrapper approach
    const dom = document.createElement('span');
    const $safeInsertPos = newDoc.resolve(safeInsertPos);
    // Whether the widget renders above the very start of its parent's content — the document, a
    // layout column, a table cell, a panel.
    //
    // `parentOffset === 0` is the whole test on the position side: prosemirror-view paints every
    // widget at a position before the node starting there, so a leading widget at the parent's start
    // always renders above its content.
    const isVisuallyFirstInParent = !placeBelow && $safeInsertPos.parentOffset === 0;
    const isTopLevelInsert = $safeInsertPos.depth === 0;
    const hasPreviousBlock = $safeInsertPos.nodeBefore?.isBlock === true;
    const isFirstDocHeadingReplacement = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && !placeBelow && change.fromB === 0 && slice.content.firstChild?.type.name === 'heading' && newDoc.firstChild?.type.name === 'heading';
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isTopLevelInsert && hasPreviousBlock && !isFirstDocHeadingReplacement) // Editor CSS removes the top margin from a block when it is its parent's first child.
    // Keep the serialized block as a subsequent child so each block type retains its own margin.
    dom.append(dom.ownerDocument.createElement('div'));
    if (isFirstDocHeadingReplacement) {
        // The replacement widget is the visual first block, while the real first document node has
        // its top margin reset. Add a compact gap after the widget so the two diff blocks do not overlap.
        dom.style.display = 'block';
        dom.style.marginBottom = "var(--ds-space-200, 16px)";
    }
    // When mediaSingle nodes are rendered inside a widget decoration (e.g. as part of
    // a replaced panel), the centering CSS (margin-left: 50%; transform: translateX(-50%))
    // incorrectly applies because isNestedNode resolves to false (getPos returns 0).
    // Observe DOM mutations and override the transform on .rich-media-item elements
    // after React mounts to prevent the image from shifting outside its parent container.
    let constrainMediaObserver;
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        constrainMediaObserver = new MutationObserver(()=>{
            const richMediaItems = dom.querySelectorAll('.rich-media-item');
            richMediaItems.forEach((el)=>{
                if (el instanceof HTMLElement) {
                    el.style.transform = 'none';
                    el.style.marginLeft = '0';
                    el.style.maxWidth = '100%';
                }
            });
            if (richMediaItems.length > 0) constrainMediaObserver?.disconnect();
        });
        constrainMediaObserver.observe(dom, {
            childList: true,
            subtree: true
        });
    }
    // Derived from the deleted range so it survives a recalculation — see the same reasoning in
    // `createInlineChangedDecoration`.
    const diffId = showContributorTags ? `widget-${change.fromA}-${change.toA}` : crypto.randomUUID();
    // Match the rendering predicate above: an empty paragraph has no widget to tag, while whitespace
    // text in a rendered widget remains eligible.
    const canTagWidget = showContributorTags && !shouldSkipDeletedEmptyParagraphDecoration;
    const decorations = [];
    const replacementNode = newDoc.nodeAt(change.fromB);
    const firstReplacedNode = slice.content.firstChild;
    const lastReplacedNode = slice.content.lastChild;
    const showDiffPatch1 = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1');
    // Whether the slice's outermost textblocks still hold all of their original content.
    //
    // `openStart`/`openEnd` say whether the cut landed inside a block, but not whether it took
    // any text with it — a deletion stopping exactly at a block's content boundary is still
    // reported as open. Resolving the change's own ends separates the two, so a block whose text
    // survived intact can render as a block even though its boundary was open.
    //
    // Both resolves sit behind the gate that consumes them, so this adds no position arithmetic to
    // the ungated path, and an unresolvable position degrades to the `openStart`/`openEnd` test on
    // its own — the block is then treated as partial, which is what it rendered as before the gate.
    const $changeFromA = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') ? (0, $8ab7883bcc3719ae$export$15047155ec45c255)(doc, change.fromA) : null;
    const $changeToA = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') ? (0, $8ab7883bcc3719ae$export$15047155ec45c255)(doc, change.toA) : null;
    const isFirstNodeContentComplete = slice.openStart === 0 || $changeFromA?.parentOffset === 0;
    const isLastNodeContentComplete = slice.openEnd === 0 || $changeToA !== null && $changeToA.parentOffset === $changeToA.parent.content.size;
    const isCompleteSameTypeReplacement = slice.content.childCount === 1 && firstReplacedNode !== null && replacementNode !== null && firstReplacedNode.type === replacementNode.type && replacementNode.nodeSize === change.toB - change.fromB;
    /*
   * The thinking is we separate out the fragment we got from doc.slice
   * and if it's the first or last content, we go in however many the sliced Open
   * or sliced End depth is and match only the entire node.
   */ slice.content.forEach((node)=>{
        const isFirst = firstReplacedNode === node;
        const isLast = lastReplacedNode === node;
        const isOpenAtSliceBoundary = isFirst && slice.openStart > 0 || isLast && slice.openEnd > 0;
        const shouldPreserveCompleteMultiInlineBlock = showDiffPatch1 && node.isBlock && node.type.inlineContent && node.content.childCount > 1 && !isOpenAtSliceBoundary && isCompleteSameTypeReplacement;
        // A textblock is otherwise serialized as its inline content only, with no `<p>`/`<h2>` wrapper.
        // That is right when the diff cuts into an existing block — the deleted text belongs on the same
        // line as the text that replaced it — but when the whole block went away it drops the very
        // element that carries the block's margin, so the deleted block renders flush against its
        // neighbours. Only the first and last children can be partial; middle ones are always complete.
        const shouldRenderAsBlockNode = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') && node.isTextblock && (!isFirst || isFirstNodeContentComplete) && (!isLast || isLastNodeContentComplete);
        // Helper function to handle multiple child nodes
        const handleMultipleChildNodes = (node)=>{
            if (!shouldPreserveCompleteMultiInlineBlock && !shouldRenderAsBlockNode && node.content.childCount > 1 && node.type.inlineContent) {
                node.content.forEach((childNode)=>{
                    const childNodeView = serializer.tryCreateNodeView(childNode);
                    if (childNodeView) {
                        const lineBreak = document.createElement('br');
                        dom.append(lineBreak);
                        const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType);
                        wrapper.append(childNodeView);
                        dom.append(wrapper);
                    } else {
                        // Fallback to serializing the individual child node
                        const serializedChild = serializer.serializeNode(childNode);
                        if (serializedChild) {
                            const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType);
                            wrapper.append(serializedChild);
                            dom.append(wrapper);
                        }
                    }
                });
                return true; // Indicates we handled multiple children
            }
            return false; // Indicates single child, continue with normal logic
        };
        // Determine which node to use and how to serialize
        const hasInlineContent = node.content.childCount > 0 && node.type.inlineContent === true;
        let fallbackSerialization;
        if (handleMultipleChildNodes(node)) return;
        if (shouldPreserveCompleteMultiInlineBlock || shouldRenderAsBlockNode) fallbackSerialization = ()=>serializer.serializeNode(node);
        else if ((isFirst || isLast && slice.content.childCount > 2) && hasInlineContent) fallbackSerialization = ()=>serializer.serializeFragment(node.content);
        else if (isLast && slice.content.childCount === 2) fallbackSerialization = ()=>{
            if (node.type.name === 'text') return document.createTextNode(node.text || '');
            if (node.type.name === 'paragraph') {
                const lineBreak = document.createElement('br');
                dom.append(lineBreak);
                return serializer.serializeFragment(node.content);
            }
            return serializer.serializeFragment(node.content);
        };
        else fallbackSerialization = ()=>serializer.serializeNode(node);
        // Try to create node view, fallback to serialization
        const nodeView = serializer.tryCreateNodeView(node);
        if (nodeView) {
            if (node.isInline) {
                const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType, reveal);
                wrapper.append(nodeView);
                dom.append(wrapper);
            } else // Handle all block nodes with unified function
            (0, $be39abb9710747ce$export$decea4d8614a74b3)({
                dom: dom,
                nodeView: nodeView,
                targetNode: node,
                colorScheme: colorScheme,
                intl: intl,
                isActive: isActive,
                isInserted: isInserted,
                diffType: diffType,
                hideAddedDiffsUnderline: hideAddedDiffsUnderline,
                highlightInlineLeafNodes: shouldPreserveCompleteMultiInlineBlock
            });
        } else if (nodeViewSerializer.getFilteredNodeViewBlocklist([
            'paragraph',
            'tableRow'
        ]).has(node.type.name)) // Skip the case where the node is a paragraph or table row that way it can still be rendered and delete the entire table
        return;
        else {
            const fallbackNode = fallbackSerialization();
            if (fallbackNode) {
                if (fallbackNode instanceof HTMLElement) {
                    const injectedNode = (0, $be39abb9710747ce$export$d67ad4e75a7e5029)({
                        node: fallbackNode,
                        colorScheme: colorScheme,
                        isActive: isActive,
                        isInserted: isInserted,
                        diffType: diffType,
                        reveal: reveal
                    });
                    dom.append(injectedNode);
                } else {
                    const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType, reveal);
                    wrapper.append(fallbackNode);
                    dom.append(wrapper);
                }
            }
        }
    });
    dom.setAttribute('data-testid', 'show-diff-deleted-decoration');
    if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) dom.style.setProperty('scroll-margin-top', (0, $c8506ce9a0d29c95$export$92a3db689480415b));
    // A block node serialized into the widget is the widget's first child, and the editor's
    // first-child reset is written against the parent element rather than the document position — so
    // it zeroes the margin the block wrapper was kept for in the first place.
    //
    // Only away from the parent's start. There the reset is the correct outcome: the widget is the
    // first thing in the document, column, cell or panel, and a leading gap above it would be wrong.
    // The margin that matters at that position belongs to the node *below* the widget, which the
    // shaped spacer pair supplies instead.
    if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') && !isVisuallyFirstInParent) (0, $3bc862eb4768c702$export$e40586911b64030a)({
        dom: dom,
        testId: 'show-diff-widget-margin-absorber'
    });
    // Needed even when the indicator bar is off, because a contributor tag also anchors against the
    // widget.
    if ((showIndicators || showContributorTags) && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) dom.style.setProperty('anchor-name', `--${(0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId
    })}`);
    // Taken down in the widget's `destroy` below: `dom` is rebuilt on every recalculation, so the tag
    // mounted into it must not outlive the copy ProseMirror is drawing.
    let tagMount;
    if (canTagWidget) {
        // Lets the contributor tag find the deleted content on hover.
        dom.setAttribute('data-diff-id', diffId);
        // Hosted at the start of the deleted run rather than on `dom` itself: `dom` is inline, so once
        // the deleted content wraps its box is the union of its line fragments.
        const tagHost = (0, $6dde019bf889ed99$export$ab9117595eb8066d)(diffId, tagMountContext);
        if (tagHost) {
            dom.prepend(tagHost.host);
            tagMount = tagHost.mount;
        }
    }
    if (showIndicators && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        const leftAnchor = (0, $b6432cc061a6f6cb$export$bb60b01773a85c0d)({
            doc: newDoc,
            from: safeInsertPos,
            diffId: diffId
        });
        if (leftAnchor) decorations.push(leftAnchor);
    }
    decorations.push((0, $8nvEM.Decoration).widget(safeInsertPos, dom, {
        ...(0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            attributionKey: canTagWidget ? attributionKey : undefined,
            colorScheme: colorScheme,
            decorationType: 'widget',
            diffId: diffId,
            isActive: isActive,
            isInserted: isInserted,
            diffType: diffType,
            ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                // placeBelow anchors at the end of the new content, so render on the
                // trailing side (1); otherwise render before the new content (-1).
                side: placeBelow ? 1 : -1
            }
        }),
        // Without an explicit mark set, prosemirror-view wraps the widget in the marks of the
        // adjacent text in the NEW document. `dom` already carries the original marks, so a
        // formatting change would render the deleted side wrapped in the very mark the edit
        // introduced — unbolded text shown struck through but still bold.
        ...(0, $iDrrr.fg)('platform_editor_diff_inline_mark_changes') && {
            marks: []
        },
        destroy: ()=>{
            constrainMediaObserver?.disconnect();
            (0, $6dde019bf889ed99$export$ee8ab98941ac5744)(tagMount);
            tagMount = undefined;
        }
    }));
    // The first document node keeps its margin-top reset even when an inverted diff renders a visible
    // block before it. Add an empty widget matching the following heading so the editor's own heading
    // styles supply the appropriate spacing. For other node types, retain the existing generic spacer.
    const isPureDeletion = change.fromB === change.toB;
    const isSingleBlock = slice.content.childCount === 1 && slice.content.firstChild?.isBlock;
    const isDiffWidgetAtStartOfDoc = $safeInsertPos.depth === 0 && $safeInsertPos.index(0) === 0;
    // A node at the start of its parent has its top margin reset, so a diff widget rendered above
    // it sits flush against it. This applies wherever that parent is — the document, a layout
    // column, a table cell — so it is decided from the anchor rather than from the document root
    // (see `isVisuallyFirstInParent` above).
    //
    // Away from the parent's start the node below keeps its own margin, and it is the block *inside*
    // the widget that loses one — handled by `absorbFirstChildMarginReset` above, not here.
    const nodeAfterWidget = $safeInsertPos.nodeAfter;
    if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isVisuallyFirstInParent && nodeAfterWidget) {
        const shapedSpacer = (0, $7636efb3e01a37a2$export$bc2935b2acc5ca59)({
            node: nodeAfterWidget,
            serializer: serializer,
            testId: 'show-diff-shaped-margin-spacer'
        });
        if (shapedSpacer) {
            // Two elements, because the two families of reset have to be handled differently. The
            // absorber takes the document-level adjacent-sibling reset for a leading widget, whose
            // `!important` would otherwise zero the shaped spacer's margin; the shaped spacer, now one
            // position further along, is out of that rule's reach and keeps the margin it supplies.
            // Inside containers the counting selectors skip both, so only the shaped one has an effect.
            //
            // Sides order the widgets against each other only — both still paint before the real node.
            decorations.push((0, $8nvEM.Decoration).widget(safeInsertPos, (0, $e9b9dd6fbe76f57e$export$b5fce31ee9537050)({
                testId: 'show-diff-margin-absorber'
            }), {
                side: 0
            }));
            decorations.push((0, $8nvEM.Decoration).widget(safeInsertPos, shapedSpacer, {
                side: 1
            }));
        }
    }
    if (!(0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') && isDiffWidgetAtStartOfDoc && isSingleBlock && isPureDeletion && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        const followingNode = $safeInsertPos.nodeAfter;
        const headingLevel = followingNode?.type.name === 'heading' ? followingNode.attrs.level : undefined;
        if ($6760b5578652a45a$var$isHeadingLevel(headingLevel)) {
            const nodeLikeSpacer = dom.ownerDocument.createElement(`h${headingLevel}`);
            nodeLikeSpacer.dataset.testid = 'show-diff-node-like-margin-spacer';
            nodeLikeSpacer.setAttribute('aria-hidden', 'true');
            nodeLikeSpacer.contentEditable = 'false';
            decorations.push((0, $8nvEM.Decoration).widget(safeInsertPos, nodeLikeSpacer, {
                side: 0
            }));
        } else if (followingNode) {
            const defaultSpacer = dom.ownerDocument.createElement('span');
            defaultSpacer.dataset.testid = 'show-diff-default-margin-spacer';
            defaultSpacer.style.display = 'block';
            defaultSpacer.style.marginTop = "var(--ds-space-100, 8px)";
            if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) defaultSpacer.style.setProperty('scroll-margin-top', (0, $c8506ce9a0d29c95$export$92a3db689480415b));
            decorations.push((0, $8nvEM.Decoration).widget(safeInsertPos, defaultSpacer, {
                ...(0, $c8506ce9a0d29c95$export$b63856cff30de075)({
                    colorScheme: colorScheme,
                    decorationType: 'widget',
                    diffId: crypto.randomUUID(),
                    isInserted: isInserted,
                    diffType: diffType
                })
            }));
        }
    }
    return decorations;
};










/**
 * Diff kinds that expose an anchor a tag can be pinned to: `inline` is added/changed content,
 * `widget` is deleted content, `block` a whole changed block node.
 */ const $6893b7f154d19dab$var$TAGGABLE_DECORATION_TYPES = new Set([
    'block',
    'inline',
    'widget'
]);
/** The connection is an internal key, so it is dropped on the way to the tag. */ const $6893b7f154d19dab$var$toTagContributor = ({ connectedToKey: _connectedToKey, ...tagContributor })=>tagContributor;
/**
 * Whether a deleted-content widget belongs to the same change as an inline decoration. A replacement
 * renders both — the inserted text inline, the deleted text as a widget anchored to one end of that
 * inline range — and the two must not each claim a tag.
 */ const $6893b7f154d19dab$var$isSameChange = (widget, inline)=>widget.spec.attributionKey === inline.spec.attributionKey && widget.from >= inline.from && widget.from <= inline.to;
/**
 * Whether a deleted-content widget is the left-most half of the replacement it belongs to, in which
 * case it keeps the tag so the tag marks where the change begins (EDITOR-8855). `side: -1` paints
 * the deleted content in front of the inserted text; `1` is `deletedDiffPlacement: 'bottom'` /
 * `inlineDeletedDiffPlacement: 'after'`, where the inline half leads instead.
 */ const $6893b7f154d19dab$var$leadsReplacement = (widget)=>(0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') && widget.spec.side === -1;
/**
 * Whether `inner` captions the same change as the block decoration `block`, in which case only the
 * block keeps the tag — one tag per block. Containment counts in either direction: a leaf block's
 * highlight spans the wrapper the block sits in. Merely adjacent ranges keep a tag each.
 */ const $6893b7f154d19dab$var$isSameBlockChange = (inner, block)=>inner.spec.attributionKey === block.spec.attributionKey && (block.from <= inner.from && inner.to <= block.to || inner.from <= block.from && block.to <= inner.to);
/**
 * Which of two changes in the same range leads, and so is the one a tag captions. Position first,
 * then `side`, since deleted content shares its `from` with the content that replaced it and paints
 * above; then the narrower range, so a change nested in another captions itself.
 */ const $6893b7f154d19dab$var$byLeadingPosition = (a, b)=>a.decoration.from - b.decoration.from || (a.decoration.spec.side ?? 0) - (b.decoration.spec.side ?? 0) || a.decoration.to - a.decoration.from - (b.decoration.to - b.decoration.from);
/** The targets a navigation range wholly covers, leader first. */ const $6893b7f154d19dab$var$containedBy = (targets, { from: from, to: to })=>targets.filter(({ decoration: decoration })=>from <= decoration.from && decoration.to <= to).sort($6893b7f154d19dab$var$byLeadingPosition);
/**
 * The one tag a navigation step reveals. `spec.isActive` is no use here: it covers everything the
 * group's union range touches, so several tags revealed over each other (EDITOR-8971). Hence
 * containment, and the leading change of what it covers.
 */ const $6893b7f154d19dab$var$resolveActiveTarget = (surviving, activeIndexPos)=>$6893b7f154d19dab$var$containedBy(surviving, activeIndexPos)[0];
const $6893b7f154d19dab$export$a6180b5af1af0836 = (decorations, contributors, activeIndexPos, stops)=>{
    if (!contributors) return [];
    const targets = [];
    for (const decoration of decorations.find(undefined, undefined, (0, $c8506ce9a0d29c95$export$f24673b80d65051c))){
        if (!(0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration)) continue;
        const { spec: spec } = decoration;
        if (!spec.attributionKey || !$6893b7f154d19dab$var$TAGGABLE_DECORATION_TYPES.has(spec.decorationType)) continue;
        const contributor = contributors[spec.attributionKey];
        if (!contributor) continue;
        targets.push({
            contributor: contributor,
            decoration: decoration
        });
    }
    // Candidate hosts, in the order they outrank each other: block, then leading widget, then inline.
    const inlineTargets = targets.filter(({ decoration: decoration })=>decoration.spec.decorationType === 'inline');
    const blockTargets = targets.filter(({ decoration: decoration })=>decoration.spec.decorationType === 'block');
    const widgetTargets = targets.filter(({ decoration: decoration })=>decoration.spec.decorationType === 'widget');
    const linkedDiffIds = new Map();
    const folded = new Set();
    const fold = (host, target)=>{
        folded.add(target);
        const hostDiffId = host.decoration.spec.diffId;
        const targetDiffId = target.decoration.spec.diffId;
        // A target that already hosts folded tags hands them up, so no hover target is orphaned when
        // one host folds into another.
        const inherited = linkedDiffIds.get(targetDiffId) ?? [];
        linkedDiffIds.delete(targetDiffId);
        linkedDiffIds.set(hostDiffId, [
            ...linkedDiffIds.get(hostDiffId) ?? [],
            targetDiffId,
            ...inherited
        ]);
    };
    for (const target of targets){
        const { decorationType: decorationType } = target.decoration.spec;
        if (decorationType === 'block') continue;
        // A block outranks both other kinds, so it is tried first.
        const block = blockTargets.find(({ decoration: decoration })=>$6893b7f154d19dab$var$isSameBlockChange(target.decoration, decoration));
        if (block) {
            fold(block, target);
            continue;
        }
        if (decorationType === 'inline') {
            // The deleted half renders in front of this one, so that half captions the change.
            const leadingWidget = widgetTargets.find(({ decoration: decoration })=>$6893b7f154d19dab$var$leadsReplacement(decoration) && $6893b7f154d19dab$var$isSameChange(decoration, target.decoration));
            if (leadingWidget) fold(leadingWidget, target);
            continue;
        }
        // A leading widget keeps its own tag; it was folded into above.
        if ($6893b7f154d19dab$var$leadsReplacement(target.decoration)) continue;
        const host = inlineTargets.find(({ decoration: decoration })=>$6893b7f154d19dab$var$isSameChange(target.decoration, decoration));
        if (host) fold(host, target);
    }
    // One tag per contributor per navigation stop. The folds above only catch a replacement's two
    // halves and a block's own highlights; two of one contributor's changes that merely touch are a
    // single stop (`groupTouchingDecorations`) yet kept a tag each, so the stop's trailing tag was
    // drawn but could never be stepped to (EDITOR-8971). It folds into the leading tag of its
    // contributor, staying a hover target. Contributors are kept apart: a stop spanning two of them
    // still captions each, rather than crediting one for the other's change.
    for (const stop of stops ?? []){
        const byContributor = new Map();
        for (const target of $6893b7f154d19dab$var$containedBy(targets.filter((target)=>!folded.has(target)), stop)){
            const key = target.decoration.spec.attributionKey ?? '';
            byContributor.set(key, [
                ...byContributor.get(key) ?? [],
                target
            ]);
        }
        for (const [leader, ...trailing] of byContributor.values())trailing.forEach((target)=>fold(leader, target));
    }
    const surviving = targets.filter((target)=>!folded.has(target));
    const activeTarget = activeIndexPos === undefined ? undefined : $6893b7f154d19dab$var$resolveActiveTarget(surviving, activeIndexPos);
    return surviving.map((target)=>{
        const { contributor: contributor, decoration: { spec: spec } } = target;
        const connected = contributor.connectedToKey ? contributors[contributor.connectedToKey] : undefined;
        const connectedContributor = connected ? $6893b7f154d19dab$var$toTagContributor(connected) : undefined;
        const linked = linkedDiffIds.get(spec.diffId);
        // Only the navigated tag reveals; with no active range, the decoration's own state stands.
        const isActive = activeIndexPos === undefined ? spec.isActive : target === activeTarget;
        return {
            contributor: $6893b7f154d19dab$var$toTagContributor(contributor),
            diffId: spec.diffId,
            ...connectedContributor ? {
                connectedContributor: connectedContributor
            } : {},
            ...spec.colorScheme ? {
                colorScheme: spec.colorScheme
            } : {},
            ...isActive !== undefined ? {
                isActive: isActive
            } : {},
            ...spec.isInserted !== undefined ? {
                isInserted: spec.isInserted
            } : {},
            ...linked ? {
                linkedDiffIds: linked
            } : {}
        };
    });
};












// ProseMirror's assoc value chooses which side of an insertion a mapped boundary stays on.
const $fdebce299079402d$var$FROM_ASSOC = -1;
const $fdebce299079402d$var$TO_ASSOC = 1;
const $fdebce299079402d$export$59794bc331f1092 = (from, to, stepIndex, stepMaps)=>{
    if (!stepMaps) return {
        fromB: from,
        toB: to
    };
    // The range is already in the document immediately after this step, so skip its own map and
    // apply only the maps from subsequent steps.
    const firstSubsequentStepIndex = stepIndex + 1;
    const finalRange = new (0, $eOaGc.Mapping)(stepMaps.slice(firstSubsequentStepIndex));
    const fromB = finalRange.mapResult(from, $fdebce299079402d$var$FROM_ASSOC);
    const toB = finalRange.mapResult(to, $fdebce299079402d$var$TO_ASSOC);
    if (fromB.deleted && toB.deleted) return undefined;
    return {
        fromB: fromB.pos,
        toB: toB.pos
    };
};


const $112c13fed0acd0fd$var$extractMarkStep = (step)=>{
    if (step instanceof (0, $eOaGc.AddMarkStep)) return {
        type: 'add',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    if (step instanceof (0, $eOaGc.RemoveMarkStep)) return {
        type: 'remove',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    return undefined;
};
const $112c13fed0acd0fd$export$cb37e032b0f65b99 = (steps, stepAttributions = [], stepMaps = [])=>{
    const resultRanges = [];
    let lastOp;
    for (const [stepIndex, step] of steps.entries()){
        const op = $112c13fed0acd0fd$var$extractMarkStep(step);
        if (!op) continue;
        // Check if previous operation cancels this one
        if (lastOp && lastOp.from === op.from && lastOp.to === op.to && lastOp.markName === op.markName && lastOp.type !== op.type) resultRanges.pop();
        else {
            const finalRange = (0, $fdebce299079402d$export$59794bc331f1092)(op.from, op.to, stepIndex, stepMaps);
            if (!finalRange) {
                lastOp = op;
                continue;
            }
            resultRanges.push({
                attributionKey: (0, $8Rpmh.getAttributionKey)(stepAttributions[stepIndex]),
                fromB: finalRange.fromB,
                toB: finalRange.toB
            });
        }
        lastOp = op;
    }
    return resultRanges;
};










/**
 * True if `fragment` contains at least one inline node (text, hardBreak, emoji, mention, etc.).
 * Block-only subtrees (e.g. empty paragraphs, block cards with no inline children) return false.
 */ function $8dbcf03441d7dc2f$var$fragmentContainsInlineContent(fragment) {
    for(let i = 0; i < fragment.childCount; i++){
        const node = fragment.child(i);
        if (node.isInline) return true;
        if (node.content.size > 0 && $8dbcf03441d7dc2f$var$fragmentContainsInlineContent(node.content)) return true;
    }
    return false;
}
function $8dbcf03441d7dc2f$export$1176e62203433107(doc, from, to) {
    try {
        const slice = doc.slice(from, to);
        return $8dbcf03441d7dc2f$var$fragmentContainsInlineContent(slice.content);
    } catch  {
        return false;
    }
}
function $8dbcf03441d7dc2f$var$isRangeFullyInside(range1Start, range1End, range2Start, range2End) {
    return range2Start <= range1Start && range1End <= range2End;
}
function $8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, keyPrefix) {
    return Boolean(spec && typeof spec === 'object' && 'key' in spec && typeof spec.key === 'string' && spec.key.startsWith(keyPrefix));
}
/**
 * Where a decoration paints relative to others at the same position: negative before the node at
 * that position, positive after it. Only deleted-content widgets carry one — everything else is
 * ranged, and so paints where its range starts.
 */ function $8dbcf03441d7dc2f$var$decorationSide(decoration) {
    return (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.side || 0;
}
/**
 * Collapses decorations that represent one continuous customer-facing edit.
 *
 * Decorations are kept separate in the DecorationSet so each one can retain its own visual
 * styling. This list is only used for change counting and navigation, where an insertion and a
 * deletion at the same location should be treated as one replacement. Zero-width decorations
 * (normally deleted-content widgets) can join a group, but cannot extend its range and therefore
 * cannot bridge two otherwise separate edits.
 */ function $8dbcf03441d7dc2f$var$groupTouchingDecorations(decorations, isInlineDecoration) {
    if (decorations.length < 2) return decorations;
    const groups = [];
    let currentGroup = [];
    let currentGroupFrom = 0;
    let currentGroupTo = 0;
    const sortedDecorations = [
        ...decorations
    ].sort((a, b)=>a.from === b.from ? a.to - b.to : a.from - b.from);
    sortedDecorations.forEach((decoration)=>{
        if (currentGroup.length === 0 || decoration.from > currentGroupTo) {
            currentGroup = [
                decoration
            ];
            currentGroupFrom = decoration.from;
            currentGroupTo = decoration.to;
            groups.push({
                decorations: currentGroup,
                from: currentGroupFrom,
                to: currentGroupTo
            });
            return;
        }
        currentGroup.push(decoration);
        // A zero-width decoration must not extend the group and bridge a gap.
        currentGroupTo = Math.max(currentGroupTo, decoration.to);
        groups[groups.length - 1].to = currentGroupTo;
    });
    return groups.map(({ decorations: group, from: from, to: to })=>{
        const representative = group.find(isInlineDecoration) ?? group.find((decoration)=>decoration.from !== decoration.to) ?? group[0];
        if (!representative) return representative;
        // Deleted content is a widget at the start of the added content that replaced it, on a more
        // negative side so it paints above. That makes it the visual start of the edit, reachable
        // only through its own DOM — resolving the group's start position lands on the added content
        // painted after it. The group keeps its range, which navigation and the active-range
        // calculation both need, and reports the widget as what to scroll to.
        const scrollTarget = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') ? group.find((decoration)=>decoration.from === from && $8dbcf03441d7dc2f$var$decorationSide(decoration) < $8dbcf03441d7dc2f$var$decorationSide(representative)) : undefined;
        if (!scrollTarget && representative.from === from && representative.to === to) return representative;
        // This decoration is only used for navigation and active-range calculation. The actual
        // visual decorations remain in the DecorationSet with their original ranges and styles —
        // including their spec, hence a copy to add `scrollTarget` for `scrollToDiff` to read.
        const spec = {
            ...representative.spec,
            scrollTarget: scrollTarget
        };
        return isInlineDecoration(representative) ? (0, $8nvEM.Decoration).inline(from, to, {}, spec) : (0, $8nvEM.Decoration).node(from, to, {}, spec);
    });
}
const $8dbcf03441d7dc2f$export$c459ab16dd3c3d79 = (set, doc, diffType)=>{
    if (!set) return [];
    const isBlockDecoration = (decoration)=>(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.decorationType === 'block' : decoration.spec?.key?.startsWith((0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).block) ?? false;
    const isInlineDecoration = (decoration)=>(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.decorationType === 'inline' : decoration.spec?.key?.startsWith((0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).inline) ?? false;
    const isWidgetDecoration = (decoration)=>(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.decorationType === 'widget' : decoration.spec?.key?.startsWith((0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).widget) ?? false;
    const seenBlockKeys = new Set();
    const allDecorations = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? set.find(undefined, undefined, (0, $c8506ce9a0d29c95$export$f24673b80d65051c)) : set.find(undefined, undefined, (spec)=>$8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, (0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).inline) || $8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, (0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).widget) || $8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, (0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).block));
    // First pass: filter out listItem blocks and deduplicates blocks
    const filtered = allDecorations.filter((dec)=>{
        if (!isBlockDecoration(dec) && !isInlineDecoration(dec) && !isWidgetDecoration(dec)) return false;
        if (isBlockDecoration(dec)) {
            // Skip listItem blocks as they are not scrollable
            if (dec.spec?.nodeName === 'listItem') return false;
            const key = `${dec.from}-${dec.to}-${dec.spec.nodeName ?? ''}`;
            // Skip blocks that have already been seen
            if (seenBlockKeys.has(key)) return false;
            seenBlockKeys.add(key);
        }
        return true;
    });
    // Separate decorations by type for easier processing
    const blocks = filtered.filter(isBlockDecoration);
    const rawInlines = filtered.filter(isInlineDecoration);
    const inlines = doc !== undefined ? rawInlines.filter((d)=>$8dbcf03441d7dc2f$export$1176e62203433107(doc, d.from, d.to)) : rawInlines;
    const widgets = filtered.filter(isWidgetDecoration);
    let result;
    if ((0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history')) // Group overlapping or directly touching ranges into one customer-facing edit.
    result = $8dbcf03441d7dc2f$var$groupTouchingDecorations([
        ...blocks,
        ...inlines,
        ...widgets
    ], isInlineDecoration);
    else {
        // Legacy behavior: exclude blocks that contain or are contained by an inline decoration.
        const nonOverlappingBlocks = blocks.filter((block)=>!inlines.some((inline)=>$8dbcf03441d7dc2f$var$isRangeFullyInside(block.from, block.to, inline.from, inline.to) || $8dbcf03441d7dc2f$var$isRangeFullyInside(inline.from, inline.to, block.from, block.to)));
        result = [
            ...nonOverlappingBlocks,
            ...inlines,
            ...widgets
        ];
    }
    // Sort by from position, then by to position
    result.sort((a, b)=>a.from === b.from ? a.to - b.to : a.from - b.from);
    return result;
};




var $j1ahd = parcelRequire("j1ahd");


var $aa9kO = parcelRequire("aa9kO");

/** U+0000 cannot occur in ProseMirror text content, so this cannot collide with document text. */ const $44ffdf0f7017cf7f$var$NODE_MARKER = '\u0000';
/**
 * Node types and text only; marks and attrs excluded.
 *
 * Text is unprefixed so adjacent runs concatenate — a run only splits because its marks differ, so
 * `strong("hello")` and `strong("hel") + em("lo")` must match. Attrs are excluded because a
 * reconstructed agent edit regenerates `localId`s; `getAttrChangeRanges` reports attrs separately.
 */ const $44ffdf0f7017cf7f$var$markFreeSignature = (doc, from, to)=>{
    const parts = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isText) {
            const start = Math.max(pos, from) - pos;
            const end = Math.min(pos + node.nodeSize, to) - pos;
            parts.push((node.text ?? '').slice(start, end));
        } else parts.push(`${$44ffdf0f7017cf7f$var$NODE_MARKER}${node.type.name}`);
        return true;
    });
    return parts.join('');
};
const $44ffdf0f7017cf7f$export$26e81e2d68109c7e = ({ change: change, newDoc: newDoc, originalDoc: originalDoc })=>{
    const { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = change;
    const isPureInsertionOrDeletion = toA === fromA || toB === fromB;
    if (isPureInsertionOrDeletion || toA - fromA !== toB - fromB) return false;
    return $44ffdf0f7017cf7f$var$markFreeSignature(originalDoc, fromA, toA) === $44ffdf0f7017cf7f$var$markFreeSignature(newDoc, fromB, toB);
};


const $5f07a80437f8f98a$export$adb309d959e3ca0 = ({ change: change, originalDoc: originalDoc })=>{
    if (change.toA - change.fromA !== 1) return false;
    const slice = originalDoc.slice(change.fromA, change.toA);
    // `childCount === 1` already means `firstChild` is there; the optional chain is for the type,
    // which has it nullable.
    const node = slice.content.firstChild;
    return (slice.openStart > 0 || slice.openEnd > 0) && slice.content.childCount === 1 && node?.isBlock === true && node.content.size === 0;
};



var $85Bcz = parcelRequire("85Bcz");


var $bdYmy = parcelRequire("bdYmy");










const $362967b841a8051a$var$getAttributionIdentity = (change)=>{
    const identities = new Set();
    for (const span of [
        ...change.deleted,
        ...change.inserted
    ])identities.add((0, $8Rpmh.getAttributionKey)(span.data));
    if (identities.size > 1) return {
        key: undefined,
        mergeable: false
    };
    return {
        key: identities.values().next().value,
        mergeable: true
    };
};
const $362967b841a8051a$var$byNewDocRange = (left, right)=>left.fromB - right.fromB || left.toB - right.toB;
const $362967b841a8051a$export$443a91b25aa93b12 = (changes)=>{
    if (changes.length <= 1) return changes;
    // A zero-length new-document range paints no inline decoration, so it is kept aside rather than
    // folded into a neighbouring insertion.
    const emptyRanges = changes.filter((change)=>change.toB <= change.fromB);
    const collapsed = [];
    for (const change of changes.filter((change)=>change.toB > change.fromB).sort($362967b841a8051a$var$byNewDocRange)){
        const current = collapsed[collapsed.length - 1];
        if (current && change.fromB < current.toB) collapsed[collapsed.length - 1] = {
            fromA: Math.min(current.fromA, change.fromA),
            toA: Math.max(current.toA, change.toA),
            fromB: Math.min(current.fromB, change.fromB),
            toB: Math.max(current.toB, change.toB),
            deleted: [
                ...current.deleted,
                ...change.deleted
            ],
            inserted: [
                ...current.inserted,
                ...change.inserted
            ]
        };
        else collapsed.push({
            ...change
        });
    }
    return [
        ...collapsed,
        ...emptyRanges
    ].sort($362967b841a8051a$var$byNewDocRange);
};
const $362967b841a8051a$export$6f39a0ae26cc5c4a = (changes, doc)=>{
    const result = [];
    let run = [];
    let runIdentity;
    const flush = ()=>{
        if (run.length > 0) {
            // Some show-diff producers use structurally compatible Change objects rather than the
            // library class. `simplifyChanges` reads runtime `lenA`/`lenB` getters even though they
            // are intentionally omitted from its public declarations, so add equivalent getters
            // without calling the library's internal constructor.
            const normalizedRun = run.map((change)=>({
                    ...change,
                    get lenA () {
                        return change.toA - change.fromA;
                    },
                    get lenB () {
                        return change.toB - change.fromB;
                    }
                }));
            result.push(...(0, $85Bcz.optimizeChanges)((0, $dFI5z.simplifyChanges)(normalizedRun, doc)));
        }
        run = [];
        runIdentity = undefined;
    };
    for (const change of changes){
        const identity = $362967b841a8051a$var$getAttributionIdentity(change);
        const canJoinRun = runIdentity?.mergeable === true && identity.mergeable && runIdentity.key === identity.key;
        if (run.length > 0 && !canJoinRun) flush();
        run.push(change);
        runIdentity = identity;
        if (!identity.mergeable) flush();
    }
    flush();
    return result;
};



var $jggTf = parcelRequire("jggTf");


var $ddUGd = parcelRequire("ddUGd");


var $ekAyE = parcelRequire("ekAyE");

const $ccec9bbe1ed9722a$var$getChanges = ({ changeset: changeset, originalDoc: originalDoc, steppedDoc: steppedDoc, diffType: diffType, tr: tr, steps: steps, intl: intl, smartThresholds: smartThresholds })=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        // The `smart` diff type is gated behind `platform_editor_ai_smart_diff`. When the gate is
        // off, `smart` falls through to the default (`inline`) path below so behaviour degrades
        // gracefully (see docs/smart-diff-design.md §3).
        if (diffType === 'smart' && (0, $iDrrr.fg)('platform_editor_ai_smart_diff')) {
            const changes = (0, $dFI5z.simplifyChanges)(changeset.changes, tr.doc);
            return (0, $ddUGd.classifySmartChanges)({
                changes: changes,
                originalDoc: originalDoc,
                newDoc: tr.doc,
                locale: intl.locale,
                thresholds: smartThresholds
            });
        }
        if (diffType === 'step') return (0, $j1ahd.diffBySteps)(originalDoc, steps);
        if (diffType === 'block') return (0, $aa9kO.groupChangesByBlock)(changeset.changes, originalDoc, steppedDoc);
        const changes = (0, $dFI5z.simplifyChanges)(changeset.changes, tr.doc);
        return (0, $85Bcz.optimizeChanges)(changes);
    }
    const changes = (0, $dFI5z.simplifyChanges)(changeset.changes, tr.doc);
    return (0, $85Bcz.optimizeChanges)(changes);
};
const $ccec9bbe1ed9722a$var$getAttributedChanges = ({ attributedChanges: attributedChanges, changeset: changeset, originalDoc: originalDoc, steppedDoc: steppedDoc, diffType: diffType, tr: tr })=>{
    // `smart` is deliberately absent here, even though `getChanges` applies it: the classifier drops
    // the step attribution and promotes ranges to sentence/paragraph/node granularity, so a promoted
    // range covers several actors' steps and the latest-writer rule credits all of it to one of them.
    // The attributed changeset keeps step granularity instead.
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (diffType === 'step') return attributedChanges;
        if (diffType === 'block') return (0, $aa9kO.groupChangesByBlock)(changeset.changes, originalDoc, steppedDoc);
    }
    return (0, $362967b841a8051a$export$6f39a0ae26cc5c4a)(attributedChanges, tr.doc);
};
/**
 * Collect the inline-content ranges of every leaf text-bearing block (paragraph, heading, …)
 * whose content overlaps `[from, to)`. Used to clip a node-level `smart` insertion highlight to
 * the actual added text, so the inserted background/underline never spans structural gaps
 * (list markers, empty item slots, cell/column boundaries) which would render as phantom rows.
 */ const $ccec9bbe1ed9722a$var$leafTextblockRanges = (doc, from, to)=>{
    const ranges = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isTextblock && node.content.size > 0) {
            const contentFrom = Math.max(pos + 1, from);
            const contentTo = Math.min(pos + 1 + node.content.size, to);
            if (contentTo > contentFrom) ranges.push([
                contentFrom,
                contentTo
            ]);
            // Textblocks have no block children to descend into.
            return false;
        }
        return true;
    });
    return ranges;
};
// A large inserted table is treated with a coarse decoration path (see below)
// once it has more leaf textblocks (~cells) than this threshold. Small tables
// keep the precise per-cell path.
const $ccec9bbe1ed9722a$var$LARGE_TABLE_LEAF_THRESHOLD = 40;
/**
 * An active scrollable change may contain several underlying diff changes. Treat ranges that
 * overlap or touch the active range as part of the same active customer-facing edit.
 */ const $ccec9bbe1ed9722a$var$isRangeActive = (activeIndexPos, from, to)=>{
    if (activeIndexPos === undefined) return undefined;
    if (!(0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history')) return from === activeIndexPos.from && to === activeIndexPos.to;
    return from <= activeIndexPos.to && activeIndexPos.from <= to;
};
const $ccec9bbe1ed9722a$var$isLargeInsertedTableRange = (doc, from, to)=>{
    let containsTable = false;
    let leafCount = 0;
    doc.nodesBetween(from, to, (node)=>{
        if (node.type.name === 'table') containsTable = true;
        if (node.isTextblock) {
            leafCount += 1;
            return false;
        }
        return true;
    });
    return containsTable && leafCount > $ccec9bbe1ed9722a$var$LARGE_TABLE_LEAF_THRESHOLD;
};
// Collect the [from, to) ranges of every `table` node overlapping `[from, to)`. The coarse
// large-table path must only suppress decorations inside these ranges
const $ccec9bbe1ed9722a$var$tableRanges = (doc, from, to)=>{
    const ranges = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type.name === 'table') {
            ranges.push([
                pos,
                pos + node.nodeSize
            ]);
            return false;
        }
        return true;
    });
    return ranges;
};
const $ccec9bbe1ed9722a$var$isInsideTable = (tables, pos)=>tables.some(([tFrom, tTo])=>pos >= tFrom && pos < tTo);
const $ccec9bbe1ed9722a$var$calculateNodesForBlockDecoration = ({ attributionKey: attributionKey, doc: doc, from: from, to: to, colorScheme: colorScheme, isInserted: isInserted = true, activeIndexPos: activeIndexPos, shouldHideDeleted: shouldHideDeleted = false, showContributorTags: showContributorTags = false, showIndicators: showIndicators = false, diffType: diffType, coarseTableCellsOnly: coarseTableCellsOnly = false, tagMountContext: tagMountContext })=>{
    const decorations = [];
    // Coarse path: inside the large table, only cell/header overlays are kept — the
    // table/row/paragraph decorations there are redundant and cause expensive per-cell
    // re-render. Blocks outside the table keep their normal decorations.
    const coarseTables = coarseTableCellsOnly ? $ccec9bbe1ed9722a$var$tableRanges(doc, from, to) : [];
    // Iterate over the document nodes within the range
    doc.nodesBetween(from, to, (node, pos)=>{
        if (coarseTableCellsOnly && $ccec9bbe1ed9722a$var$isInsideTable(coarseTables, pos)) {
            const name = node.type.name;
            if (name !== 'tableCell' && name !== 'tableHeader') return;
        }
        if (node.isBlock && (!(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) || pos + node.nodeSize <= to)) {
            const nodeEnd = pos + node.nodeSize;
            const isActive = $ccec9bbe1ed9722a$var$isRangeActive(activeIndexPos, pos, nodeEnd);
            decorations.push(...(0, $272524b39064824e$export$8df64513a6dc1f2a)({
                attributionKey: attributionKey,
                change: {
                    from: pos,
                    to: nodeEnd,
                    name: node.type.name
                },
                colorScheme: colorScheme,
                isInserted: isInserted,
                isActive: isActive,
                shouldHideDeleted: shouldHideDeleted,
                showContributorTags: showContributorTags,
                showIndicators: showIndicators,
                doc: doc,
                diffType: diffType,
                tagMountContext: tagMountContext
            }));
        }
    });
    return decorations;
};
const $ccec9bbe1ed9722a$export$81a96632880f3735 = ({ change: change, deletedDiffPlacement: deletedDiffPlacement, inlineDeletedDiffPlacement: inlineDeletedDiffPlacement })=>{
    const level = (0, $ekAyE.smartChangeLevel)(change);
    if (level === 'node' || level === 'paragraph') return deletedDiffPlacement === 'bottom';
    // Inline-level (undefined) and sentence-level changes.
    return inlineDeletedDiffPlacement === 'after';
};
/**
 * Single place `platform_editor_diff_hide_pure_deletions` is read, shared by the widget-anchor
 * calculation and the decoration push below so the two cannot drift.
 *
 * The clean view ("new state") historically only suppressed a deleted side when the same change
 * also carried an insertion. A PURE deletion — text removed with nothing put in its place — fell
 * through and leaked struck-through text into a view that is supposed to show none. `smart` never
 * showed this because it pairs a rewrite into a single change that always carries an insertion;
 * `inline` emits delete-only changes, so it did.
 *
 * With the gate off this returns exactly what both callers computed before it existed.
 *
 * Umbrella experiment: within the AI streaming UX M1 population this behaviour is only enabled
 * for the treatment cohort. Non-AI callers (track-changes, etc.) are not enrolled and default
 * to `true`, preserving the pre-umbrella baseline.
 */ const $ccec9bbe1ed9722a$var$shouldHideDeletedSide = ({ change: change, diffType: diffType, hideDeletedDiffs: hideDeletedDiffs, isInverted: isInverted })=>(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && !isInverted && !!hideDeletedDiffs && (change.inserted.length > 0 || (0, $iDrrr.fg)('platform_editor_diff_hide_pure_deletions') && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_streaming_ux_experience_m1', 'isEnabled', false) === true);
const $ccec9bbe1ed9722a$var$calculateDiffDecorationsInner = ({ state: state, pluginState: pluginState, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos, api: api, isInverted: isInverted = false, diffType: diffType = (0, $e85d9b72d1bb97d7$export$abfb7344ac6f0d49)(), hideDeletedDiffs: hideDeletedDiffs = false, hideAddedDiffsUnderline: hideAddedDiffsUnderlineParam = false, showIndicators: showIndicators = false, smartThresholds: smartThresholds, deletedDiffPlacement: deletedDiffPlacement = 'top', inlineDeletedDiffPlacement: inlineDeletedDiffPlacement = 'before', reveal: reveal, tagMountContext: tagMountContext })=>{
    const { originalDoc: originalDoc, steps: steps, stepAttributions: stepAttributions, contributors: contributors, isDisplayingChanges: isDisplayingChanges } = pluginState;
    if (!originalDoc || !isDisplayingChanges) return {
        contributorTags: [],
        decorations: (0, $8nvEM.DecorationSet).empty,
        diffDescriptors: []
    };
    // Resolve the option against its gate once here, so every downstream inline/block builder
    // receives the same value. When the gate is off the option is a no-op.
    const hideAddedDiffsUnderline = hideAddedDiffsUnderlineParam && (0, $iDrrr.fg)('platform_editor_ai_smart_diff');
    const { tr: tr } = state;
    let steppedDoc = originalDoc;
    const attributionColoringEnabled = (0, $8Rpmh.isAttributionColoringEnabled)(stepAttributions);
    const showContributorTags = (0, $8Rpmh.isContributorTagsEnabled)(stepAttributions, contributors);
    // Tags need the attributed changeset even on diffs with too few actors to be worth colouring.
    const attributedChangesetEnabled = attributionColoringEnabled || showContributorTags;
    let simplifiedSteps;
    let simplifiedStepAttributions = [];
    if (attributedChangesetEnabled) {
        const simplifiedStepsWithAttribution = (0, $jggTf.simplifyStepsWithAttribution)(steps, stepAttributions ?? [], originalDoc);
        simplifiedSteps = simplifiedStepsWithAttribution.map(({ step: step })=>step);
        simplifiedStepAttributions = simplifiedStepsWithAttribution.map(({ stepAttribution: stepAttribution })=>stepAttribution);
    } else simplifiedSteps = (0, $jggTf.simplifySteps)(steps, originalDoc);
    const pendingAttrSteps = [];
    const stepMaps = [];
    for (const [stepIndex, step] of simplifiedSteps.entries()){
        const result = step.apply(steppedDoc);
        if (result.failed === null && result.doc) {
            if ((0, $5a5219f6ff8efa86$export$78b37f7430a7646c)(step, steppedDoc, result.doc)) pendingAttrSteps.push({
                attributionKey: (0, $8Rpmh.getAttributionKey)(simplifiedStepAttributions[stepIndex]),
                afterNode: result.doc.nodeAt(step.pos),
                beforeNode: steppedDoc.nodeAt(step.pos),
                mapIndex: stepMaps.length,
                step: step
            });
            stepMaps.push(step.getMap());
            steppedDoc = result.doc;
        }
    }
    // Gate the complete attribution fix: mapped positions and step-time nodes are used together.
    // The fallback deliberately preserves the legacy raw-position lookups for rollout safety.
    const attrStepContexts = (0, $iDrrr.fg)('platform_editor_reduce_diff_attr_sensitivity') ? pendingAttrSteps.flatMap(({ afterNode: afterNode, attributionKey: attributionKey, beforeNode: beforeNode, mapIndex: mapIndex, step: step })=>{
        const finalPosition = new (0, $eOaGc.Mapping)(stepMaps.slice(mapIndex + 1)).mapResult(step.pos);
        if (finalPosition.deleted) return [];
        const originalPosition = new (0, $eOaGc.Mapping)(stepMaps.slice(0, mapIndex)).invert().mapResult(step.pos);
        return [
            {
                attributionKey: attributionKey,
                afterNode: afterNode,
                beforeNode: beforeNode,
                finalPos: finalPosition.pos,
                ...originalPosition.deleted ? {} : {
                    originalPos: originalPosition.pos
                },
                step: step
            }
        ];
    }) : pendingAttrSteps.map(({ attributionKey: attributionKey, step: step })=>({
            attributionKey: attributionKey,
            afterNode: tr.doc.nodeAt(step.pos),
            beforeNode: originalDoc.nodeAt(step.pos),
            finalPos: step.pos,
            originalPos: step.pos,
            step: step
        }));
    // Rather than using .eq() we use a custom function that only checks for structural
    // changes and ignores differences in attributes which don't affect decoration positions
    if (!(0, $6SJ6d.areNodesEqualIgnoreAttrs)(steppedDoc, tr.doc)) {
        const recoveredViaContentEquality = (0, $gE3l8.areDocsEqualByBlockStructureAndText)(steppedDoc, tr.doc);
        api?.analytics?.actions.fireAnalyticsEvent({
            eventType: 'track',
            action: 'nodesNotEqual',
            actionSubject: 'showDiff',
            attributes: {
                docSizeEqual: steppedDoc.nodeSize === tr.doc.nodeSize,
                colorScheme: colorScheme,
                recoveredViaContentEquality: recoveredViaContentEquality
            }
        });
        if (!recoveredViaContentEquality) return {
            contributorTags: [],
            decorations: (0, $8nvEM.DecorationSet).empty,
            diffDescriptors: []
        };
    }
    // The attribute-aware encoder is only needed by the smart classifier and is gated with it.
    const { tokenEncoder: tokenEncoder, shouldHideMarkOnlyDeletions: shouldHideMarkOnlyDeletions } = (0, $bdYmy.selectTokenEncoder)(diffType === 'smart' && (0, $iDrrr.fg)('platform_editor_ai_smart_diff'));
    let changes;
    let attributedChanges = [];
    let attributionColors;
    if (attributedChangesetEnabled) {
        const changeset = (0, $dFI5z.ChangeSet).create(originalDoc, (left, right)=>(0, $8Rpmh.getAttributionKey)(left) === (0, $8Rpmh.getAttributionKey)(right) ? left.stepIndex > right.stepIndex ? left : right : // `prosemirror-changeset` uses null as its incompatible-data sentinel even
            // though its public combine callback is typed as returning Data.
            null, tokenEncoder).addSteps(steppedDoc, stepMaps, simplifiedStepAttributions.map((attribution, stepIndex)=>({
                ...attribution,
                stepIndex: stepIndex
            })));
        attributedChanges = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && diffType === 'step' ? (0, $j1ahd.diffBySteps)(originalDoc, simplifiedSteps, simplifiedStepAttributions) : [
            ...changeset.changes
        ];
        // The attributed pipeline gives no guarantee that its output ranges are disjoint — see
        // `collapseOverlappingChanges`.
        const uncollapsedChanges = $ccec9bbe1ed9722a$var$getAttributedChanges({
            changeset: changeset,
            originalDoc: originalDoc,
            steppedDoc: steppedDoc,
            diffType: diffType,
            tr: tr,
            attributedChanges: attributedChanges
        });
        changes = (0, $362967b841a8051a$export$443a91b25aa93b12)(uncollapsedChanges);
        // Still colours-only: a tags-only diff keeps the plain colour scheme.
        if (attributionColoringEnabled) attributionColors = (0, $8Rpmh.createAttributionColorMap)(simplifiedStepAttributions);
    } else {
        const changeset = (0, $dFI5z.ChangeSet).create(originalDoc, undefined, tokenEncoder).addSteps(steppedDoc, stepMaps, tr.doc);
        changes = $ccec9bbe1ed9722a$var$getChanges({
            changeset: changeset,
            originalDoc: originalDoc,
            steppedDoc: steppedDoc,
            diffType: diffType,
            tr: tr,
            steps: simplifiedSteps,
            intl: intl,
            smartThresholds: smartThresholds
        });
    }
    const decorations = [];
    /**
   * If showIndicators is on, we create an anchor widget here to mark the doc margin.
   */ if (showIndicators && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) decorations.push((0, $b6432cc061a6f6cb$export$e9accf2864a96b18)());
    // Our default operations are insertions, so it should match the opposite of isInverted.
    const isInserted = !isInverted;
    const createDecorationsForChange = (change)=>{
        const changeColorScheme = attributionColors ? (0, $8Rpmh.getColorSchemeForChange)(change, attributedChanges, attributionColors, colorScheme) : colorScheme;
        const attributionKey = showContributorTags ? (0, $8Rpmh.getAttributionKeyForChange)(change, attributedChanges) : undefined;
        const isActive = $ccec9bbe1ed9722a$var$isRangeActive(activeIndexPos, change.fromB, change.toB);
        // The deleted side of a mark-only change is a byte-identical copy of the new text, so it is
        // suppressed in the clean view. `hideDeletedDiffs` is load-bearing: when false the reviewer
        // asked to compare against the original, and the deleted side is the only place the
        // previous formatting is visible.
        const isMarkOnly = shouldHideMarkOnlyDeletions && hideDeletedDiffs && change.deleted.length > 0 && (0, $44ffdf0f7017cf7f$export$26e81e2d68109c7e)({
            change: change,
            originalDoc: originalDoc,
            newDoc: tr.doc
        });
        // The deleted side of a change over a node's open token is an attribute state rather than
        // content, so there is nothing for the deleted-content widget to draw. Decided here, with
        // the other deleted-side suppressions, so the widget is never asked for a slice it can only
        // render as an empty copy of the block (EDITOR-8912). Its inserted side is untouched, and
        // the node's content change is a change of its own.
        const hasNoDeletedContent = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') && change.deleted.length > 0 && (0, $5f07a80437f8f98a$export$adb309d959e3ca0)({
            change: change,
            originalDoc: originalDoc
        });
        // Hoisted because it decides BOTH where the deleted widget is anchored and — since the
        // widget pins whichever end of the range it sits at — how the indicator anchors below are
        // allowed to move.
        const isDeletedWidgetBelow = diffType === 'smart' && (0, $iDrrr.fg)('platform_editor_ai_smart_diff') && $ccec9bbe1ed9722a$export$81a96632880f3735({
            change: change,
            deletedDiffPlacement: deletedDiffPlacement,
            inlineDeletedDiffPlacement: inlineDeletedDiffPlacement
        });
        if (change.inserted.length > 0) {
            // On an inverted diff the inserted side is visually the deleted side.
            const shouldHideDeleted = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? isInverted && hideDeletedDiffs : false;
            // For `smart` NODE-level promotions the change range spans a whole container
            // (e.g. an entire list/table/layout, using outer node bounds). Applying a SINGLE
            // inline decoration across that whole range would paint the inserted style across
            // block boundaries and structural gaps (list markers, empty item slots), producing
            // phantom "empty" rows above the real content. But skipping the inline highlight
            // entirely leaves added text-bearing blocks (paragraphs/headings inside the added
            // container) without the inserted background+underline, because block decorations
            // return no style for paragraph/heading. So for node-level smart changes we instead
            // emit ONE inline decoration per leaf text-bearing block within the range — the text
            // gets highlighted, and structural gaps never do.
            const isSmartNodeLevel = diffType === 'smart' && (0, $iDrrr.fg)('platform_editor_ai_smart_diff') && (0, $ekAyE.smartChangeLevel)(change) === 'node';
            // For a large inserted table, skip the per-cell inline decorations that
            // freeze the browser on re-render. Only active when Review moment is
            // eligible (xstate + M1).
            const useCoarseTableDecoration = isSmartNodeLevel && (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_xstate_migration', 'isEnabled', true) && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_streaming_ux_experience_m1', 'isEnabled', false) === true && $ccec9bbe1ed9722a$var$isLargeInsertedTableRange(tr.doc, change.fromB, change.toB);
            // Whether the deleted-content widget will actually be rendered for this
            // change. Used to decide if indicator anchor positions should be adjusted
            // inward — when the widget is present the anchor must stay at the block
            // boundary to keep the indicator bar continuous with the deleted content.
            const willRenderDeletedWidget = change.deleted.length > 0 && !isMarkOnly && !$ccec9bbe1ed9722a$var$shouldHideDeletedSide({
                change: change,
                diffType: diffType,
                hideDeletedDiffs: hideDeletedDiffs,
                isInverted: isInverted
            });
            if (isSmartNodeLevel) {
                // For a large inserted table, skip the O(cells) inline decorations inside the
                // table (the cell overlays added below provide the highlight without the
                // expensive content re-render); leaf blocks outside the table still get theirs.
                const coarseTables = useCoarseTableDecoration ? $ccec9bbe1ed9722a$var$tableRanges(tr.doc, change.fromB, change.toB) : [];
                for (const [from, to] of $ccec9bbe1ed9722a$var$leafTextblockRanges(tr.doc, change.fromB, change.toB)){
                    if (useCoarseTableDecoration && $ccec9bbe1ed9722a$var$isInsideTable(coarseTables, from)) continue;
                    decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
                        attributionKey: attributionKey,
                        change: {
                            fromB: from,
                            toB: to
                        },
                        doc: tr.doc,
                        colorScheme: changeColorScheme,
                        isActive: isActive,
                        diffType: diffType,
                        ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                            isInserted: isInserted,
                            shouldHideDeleted: shouldHideDeleted,
                            showContributorTags: showContributorTags,
                            showIndicators: showIndicators,
                            hideAddedDiffsUnderline: hideAddedDiffsUnderline,
                            hasDeletedWidget: willRenderDeletedWidget,
                            isDeletedWidgetBelow: isDeletedWidgetBelow,
                            reveal: reveal,
                            tagMountContext: tagMountContext
                        }
                    }));
                }
            } else decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
                attributionKey: attributionKey,
                change: change,
                doc: tr.doc,
                colorScheme: changeColorScheme,
                isActive: isActive,
                diffType: diffType,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    isInserted: isInserted,
                    shouldHideDeleted: shouldHideDeleted,
                    showContributorTags: showContributorTags,
                    showIndicators: showIndicators,
                    hideAddedDiffsUnderline: hideAddedDiffsUnderline,
                    hasDeletedWidget: willRenderDeletedWidget,
                    isDeletedWidgetBelow: isDeletedWidgetBelow,
                    reveal: reveal,
                    tagMountContext: tagMountContext
                }
            }));
            decorations.push(...$ccec9bbe1ed9722a$var$calculateNodesForBlockDecoration({
                attributionKey: attributionKey,
                doc: tr.doc,
                from: change.fromB,
                to: change.toB,
                colorScheme: changeColorScheme,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    isInserted: isInserted,
                    shouldHideDeleted: shouldHideDeleted,
                    showContributorTags: showContributorTags,
                    showIndicators: showIndicators,
                    tagMountContext: tagMountContext
                },
                activeIndexPos: activeIndexPos,
                intl: intl,
                diffType: diffType,
                coarseTableCellsOnly: useCoarseTableDecoration
            }));
        }
        if (change.deleted.length > 0 && !isMarkOnly && !hasNoDeletedContent) {
            const shouldHideDeleted = $ccec9bbe1ed9722a$var$shouldHideDeletedSide({
                change: change,
                diffType: diffType,
                hideDeletedDiffs: hideDeletedDiffs,
                isInverted: isInverted
            });
            if (!shouldHideDeleted) decorations.push(...(0, $6760b5578652a45a$export$33298e826c81587e)({
                attributionKey: // The deleted side has no inline decoration, so the widget carries the actor.
                attributionKey,
                // Extended pipeline only, matching the inline path: the non-extended styles have no
                // background for the wipe to act on.
                reveal: (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? reveal : undefined,
                change: change,
                doc: originalDoc,
                nodeViewSerializer: nodeViewSerializer,
                colorScheme: changeColorScheme,
                newDoc: tr.doc,
                intl: intl,
                activeIndexPos: activeIndexPos,
                showContributorTags: showContributorTags,
                tagMountContext: tagMountContext,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    isInserted: !isInserted,
                    diffType: diffType,
                    hideAddedDiffsUnderline: hideAddedDiffsUnderline,
                    placeBelow: isDeletedWidgetBelow
                },
                showIndicators: showIndicators
            }));
        }
    };
    changes.forEach((change)=>{
        createDecorationsForChange(change);
    });
    // The attribute-aware token encoder already reports mark-only changes as regular changes in the
    // smart path. Only add the legacy step-range decoration when no equivalent changeset range was
    // produced; otherwise the same content receives two inline decorations (and two navigation
    // changes), usually one attribution colour and one default purple decoration.
    (0, $112c13fed0acd0fd$export$cb37e032b0f65b99)(simplifiedSteps, simplifiedStepAttributions, (0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') ? stepMaps : undefined).filter(({ fromB: fromB, toB: toB })=>!(0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') || !changes.some((change)=>change.fromB === fromB && change.toB === toB)).forEach((change)=>{
        const changeColorScheme = change.attributionKey ? attributionColors?.get(change.attributionKey) ?? colorScheme : colorScheme;
        const attributionKey = showContributorTags ? change.attributionKey : undefined;
        const isActive = $ccec9bbe1ed9722a$var$isRangeActive(activeIndexPos, change.fromB, change.toB);
        decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
            attributionKey: attributionKey,
            change: change,
            colorScheme: changeColorScheme,
            doc: tr.doc,
            diffType: diffType,
            isActive: isActive,
            isInserted: true,
            reveal: reveal,
            showContributorTags: showContributorTags,
            tagMountContext: tagMountContext
        }));
    });
    (0, $5a5219f6ff8efa86$export$34445edbbb29aecb)(tr.doc, attrStepContexts, originalDoc).filter(({ fromB: fromB, toB: toB })=>!(0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') || !changes.some((change)=>change.fromB === fromB && change.toB === toB)).forEach((change)=>{
        const changeColorScheme = change.attributionKey ? attributionColors?.get(change.attributionKey) ?? colorScheme : colorScheme;
        const attributionKey = showContributorTags ? change.attributionKey : undefined;
        if (change.isInline) {
            // Inline nodes (e.g. date, emoji, mention, status) need an inline decoration rather than a block decoration
            const isActive = $ccec9bbe1ed9722a$var$isRangeActive(activeIndexPos, change.fromB, change.toB);
            decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
                attributionKey: attributionKey,
                change: change,
                colorScheme: changeColorScheme,
                doc: tr.doc,
                isActive: isActive,
                isInserted: true,
                isAtomicInlineNode: true,
                inlineNodeName: change.inlineNodeName,
                showContributorTags: showContributorTags,
                tagMountContext: tagMountContext,
                // Suppress the border-bottom underline for atomic inline nodeviews —
                // it doesn't render on custom nodeview DOM elements and is unnecessary noise.
                hideAddedDiffsUnderline: true,
                diffType: diffType
            }));
            // If we have the original node position, also render the old node as a "deleted" widget
            // so the user can see what it looked like before the change.
            if (change.fromA !== undefined && change.toA !== undefined) decorations.push(...(0, $6760b5578652a45a$export$33298e826c81587e)({
                change: {
                    fromA: change.fromA,
                    toA: change.toA,
                    fromB: change.fromB,
                    toB: change.toB,
                    deleted: []
                },
                doc: originalDoc,
                attributionKey: attributionKey,
                nodeViewSerializer: nodeViewSerializer,
                colorScheme: changeColorScheme,
                newDoc: tr.doc,
                intl: intl,
                activeIndexPos: activeIndexPos,
                isInserted: false,
                showContributorTags: showContributorTags,
                tagMountContext: tagMountContext
            }));
        } else {
            decorations.push(...$ccec9bbe1ed9722a$var$calculateNodesForBlockDecoration({
                doc: tr.doc,
                from: change.fromB,
                to: change.toB,
                attributionKey: attributionKey,
                colorScheme: changeColorScheme,
                isInserted: true,
                activeIndexPos: activeIndexPos,
                intl: intl,
                showContributorTags: showContributorTags,
                showIndicators: showIndicators,
                tagMountContext: tagMountContext
            }));
            // If the original node position is known (e.g. a panel type change), also render
            // the old block node as a "deleted" widget so the reviewer sees the before/after.
            const isSmartNodeLevelAttrChange = diffType === 'smart' && (0, $iDrrr.fg)('platform_editor_ai_smart_diff') && (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_xstate_migration', 'isEnabled', true) && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_streaming_ux_experience_m1', 'isEnabled', false) === true;
            if (isSmartNodeLevelAttrChange && change.fromA !== undefined && change.toA !== undefined) {
                const placeBelow = deletedDiffPlacement === 'bottom';
                decorations.push(...(0, $6760b5578652a45a$export$33298e826c81587e)({
                    change: {
                        fromA: change.fromA,
                        toA: change.toA,
                        fromB: change.fromB,
                        toB: change.toB,
                        deleted: []
                    },
                    doc: originalDoc,
                    nodeViewSerializer: nodeViewSerializer,
                    attributionKey: attributionKey,
                    colorScheme: changeColorScheme,
                    newDoc: tr.doc,
                    intl: intl,
                    activeIndexPos: activeIndexPos,
                    isInserted: false,
                    ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                        diffType: diffType,
                        hideAddedDiffsUnderline: hideAddedDiffsUnderline,
                        placeBelow: placeBelow
                    },
                    showIndicators: showIndicators,
                    showContributorTags: showContributorTags,
                    tagMountContext: tagMountContext
                }));
            }
        }
    });
    const decorationSet = (0, $8nvEM.DecorationSet).empty.add(tr.doc, decorations);
    return {
        contributorTags: showContributorTags ? (0, $6893b7f154d19dab$export$a6180b5af1af0836)(decorationSet, contributors, activeIndexPos, // The stops the step buttons walk, so a stop cannot hold a second tag for one
        // contributor that navigation can never reach.
        (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(decorationSet, tr.doc, diffType)) : [],
        decorations: decorationSet,
        diffDescriptors: (0, $c8506ce9a0d29c95$export$f6b1e5edab6db0b1)(decorationSet)
    };
};
const $ccec9bbe1ed9722a$export$aa7cf3ccfb5d875f = (0, $dOBRD.default)($ccec9bbe1ed9722a$var$calculateDiffDecorationsInner, // Cache results unless relevant inputs change. `tagMountContext` is deliberately absent: it is
// built once per plugin instance, so it can never be the reason a diff needs recalculating.
([{ pluginState: pluginState, state: state, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos, isInverted: isInverted, diffType: diffType, hideDeletedDiffs: hideDeletedDiffs, hideAddedDiffsUnderline: hideAddedDiffsUnderline, showIndicators: showIndicators, smartThresholds: smartThresholds, deletedDiffPlacement: deletedDiffPlacement, inlineDeletedDiffPlacement: inlineDeletedDiffPlacement, reveal: reveal }], [{ pluginState: lastPluginState, state: lastState, colorScheme: lastColorScheme, intl: lastIntl, activeIndexPos: lastActiveIndexPos, isInverted: lastIsInverted, diffType: lastDiffType, hideDeletedDiffs: lastHideDeletedDiffs, hideAddedDiffsUnderline: lastHideAddedDiffsUnderline, showIndicators: lastShowIndicators, smartThresholds: lastSmartThresholds, deletedDiffPlacement: lastDeletedDiffPlacement, inlineDeletedDiffPlacement: lastInlineDeletedDiffPlacement, reveal: lastReveal }])=>{
    const originalDocIsSame = lastPluginState.originalDoc && pluginState.originalDoc && pluginState.originalDoc.eq(lastPluginState.originalDoc);
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return (colorScheme === lastColorScheme && intl.locale === lastIntl.locale && isInverted === lastIsInverted && diffType === lastDiffType && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(activeIndexPos, lastActiveIndexPos) && originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.steps, lastPluginState.steps) && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.stepAttributions, lastPluginState.stepAttributions) && // Contributors can arrive after the first calculation; without this, tags never appear.
    (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.contributors, lastPluginState.contributors) && state.doc.eq(lastState.doc) && hideDeletedDiffs === lastHideDeletedDiffs && hideAddedDiffsUnderline === lastHideAddedDiffsUnderline && showIndicators === lastShowIndicators && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(smartThresholds, lastSmartThresholds) && deletedDiffPlacement === lastDeletedDiffPlacement && inlineDeletedDiffPlacement === lastInlineDeletedDiffPlacement && // Turning the reveal on or off changes the emitted styles, so a cached result from the
    // other setting would leave the diff painted in the wrong resting state.
    (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(reveal, lastReveal)) ?? false;
    return (originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.steps, lastPluginState.steps) && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.stepAttributions, lastPluginState.stepAttributions) && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.contributors, lastPluginState.contributors) && state.doc.eq(lastState.doc) && colorScheme === lastColorScheme && intl.locale === lastIntl.locale && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(activeIndexPos, lastActiveIndexPos) && hideDeletedDiffs === lastHideDeletedDiffs) ?? false;
});



// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $aqgkf = parcelRequire("aqgkf");


var $aOSDg = parcelRequire("aOSDg");




const $c3b673b22464e106$export$b180cb547184e48c = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // @ts-expect-error ProseMirror step classes expose jsonID on prototype.
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // Re-register if needed; ignore if already registered.
                // @ts-expect-error Step.jsonID expects a step constructor.
                (0, $5aU9U.Step).jsonID(id, customStep);
            } catch  {
            // Step already registered.
            }
        }
    };
    // @ts-expect-error Step modules export non-step symbols too.
    tryToRegisterStep($aOSDg);
    // @ts-expect-error Step modules export non-step symbols too.
    tryToRegisterStep($aqgkf);
};








var $aPdNQ = parcelRequire("aPdNQ");

function $2dfa9b84b3c8f00b$export$42cf4389dbe8b0ff(view) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return view.nodeViews !== undefined;
}
class $2dfa9b84b3c8f00b$export$314a8d5cfa8a18e6 {
    /**
   * Initializes or reinitializes the NodeViewSerializer with a new EditorView.
   * This allows the same serializer instance to be reused across different editor states.
   */ init(params) {
        this.serializer = (0, $aPdNQ.DOMSerializer).fromSchema(params.editorView.state.schema);
        if ($2dfa9b84b3c8f00b$export$42cf4389dbe8b0ff(params.editorView)) this.editorView = params.editorView;
        const nodeViews = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params.editorView?.nodeViews || {};
        this.nodeViews = nodeViews ?? this.editorView?.nodeViews ?? {};
    }
    /**
   * Appends serialized child nodes to the given contentDOM element.
   */ appendChildNodes(children, contentDOM) {
        children.forEach((child)=>{
            const childNode = this.tryCreateNodeView(child) || this.serializeNode(child);
            if (childNode) contentDOM?.append(childNode);
        });
    }
    /**
   * Attempts to create a node view for the given node.
   *
   * Returns `null` when there is no `EditorView`, no constructor for the node type,
   * or the node type is blocklisted. Otherwise returns the constructed node view instance.
   */ tryCreateNodeView(targetNode) {
        if (!this.editorView) return null;
        const constructor = this.nodeViews?.[targetNode.type.name];
        const isBlocklisted = this.nodeViewBlocklist.has(targetNode.type.name);
        // Do not bail out a blocklisted container when it holds an atomic inline node
        // (e.g. date, status) whose schema toDOM is lossy. Text keeps bailing so the caller
        // renders it inline
        const hasAtomicInlineChild = (node)=>{
            let found = false;
            node.forEach((child)=>{
                if (child.isLeaf && !child.isText) found = true;
            });
            return found;
        };
        const serializeAtomicContainer = (0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_deleted_nodeview_content') && !targetNode.isInline && hasAtomicInlineChild(targetNode);
        if (isBlocklisted && !serializeAtomicContainer) return null;
        try {
            // No constructor, or (gated) the node's own view is blocklisted: render the toDOM
            // shell and recurse via appendChildNodes so nested atomic inline nodes render via
            // their node views instead of their lossy schema toDOM.
            if (!constructor || (0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_deleted_nodeview_content') && isBlocklisted) {
                if (targetNode.isInline) return null;
                const toDOMResult = targetNode.type.spec.toDOM?.(targetNode);
                if (!toDOMResult) return null;
                const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, toDOMResult);
                if (dom instanceof HTMLElement) {
                    // Legacy shortcut: a single-child paragraph serializes its inline content
                    // directly (no <p> wrapper). Applies only to a non-blocklisted paragraph with
                    // no node view
                    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_deleted_nodeview_content') && targetNode.type.name === 'paragraph' && targetNode.children.length === 1) return this.serializeFragment(targetNode.content);
                    this.appendChildNodes(targetNode.children, contentDOM);
                }
                return dom;
            }
            const { dom: dom, contentDOM: contentDOM } = constructor(targetNode, this.editorView, ()=>0, [], {});
            // Iteratively populate children
            this.appendChildNodes(targetNode.children, contentDOM);
            return dom;
        } catch  {
            return null;
        }
    }
    /**
   * Serializes a node to a DOM `Node` using the schema's `DOMSerializer`.
   */ serializeNode(node) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeNode(node);
        } catch  {
            return null;
        }
    }
    /**
   * Serializes a fragment to a `DocumentFragment` using the schema's `DOMSerializer`.
   */ serializeFragment(fragment) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeFragment(fragment);
        } catch  {
            return null;
        }
    }
    /**
   * Returns a copy of the current node view blocklist.
   */ getNodeViewBlocklist() {
        return new Set(this.nodeViewBlocklist);
    }
    /**
   * Returns a filtered copy of the node view blocklist, excluding specified node types.
   * @param excludeTypes - Array of node type names to exclude from the blocklist
   */ getFilteredNodeViewBlocklist(excludeTypes) {
        const filtered = new Set(this.nodeViewBlocklist);
        excludeTypes.forEach((type)=>filtered.delete(type));
        return filtered;
    }
    constructor(params){
        this.editorView = void 0;
        this.serializer = void 0;
        this.nodeViews = void 0;
        this.nodeViewBlocklist = void 0;
        if (params?.editorView) this.init({
            editorView: params.editorView
        });
        this.nodeViewBlocklist = new Set(params.blocklist ?? [
            'paragraph'
        ]);
    }
}



const $0b9c039f13e1bc64$export$3517b7b24c5b04fe = 950;
/**
 * The reflow settles slightly ahead of the highlights. Running it for the full duration makes the
 * movement read as sluggish next to the cross-fade, which is finished well before it.
 */ const $0b9c039f13e1bc64$var$REFLOW_DURATION_FRACTION = 0.8;
/** Share of the total spent cross-fading before the highlights come back. */ const $0b9c039f13e1bc64$var$PHASE_A_FRACTION = 0.6;
const $0b9c039f13e1bc64$var$EASING = 'ease-in-out';
/** Selector for agent highlights in the outgoing snapshot. */ const $0b9c039f13e1bc64$var$CHANGED_DECORATION_SELECTOR = '[data-testid="show-diff-changed-decoration"]';
/**
 * Every marker that identifies a block as changed, in either the outgoing or incoming render.
 * Deleted content is a widget in the incoming state only; reveal markers exist only while revealing.
 */ const $0b9c039f13e1bc64$var$CHANGED_BLOCK_SELECTOR = [
    '[data-testid="show-diff-changed-decoration"]',
    '[data-testid="show-diff-deleted-decoration"]',
    `[${(0, $a6f71fd197aec590$export$cee91f6cebab58c)}]`
].join(', ');
/** Elements that re-mount on clone; replace with placeholders to preserve layout. */ const $0b9c039f13e1bc64$var$REMOUNT_UNSAFE_SELECTOR = 'iframe, object, embed, video, audio, canvas';
/**
 * Marks animations this module owns, so a re-bind can tell them from anything else on the node.
 * Suffixed per purpose because one element can legitimately carry several — a changed block that
 * also grows takes both the cross-fade and the clip.
 */ const $0b9c039f13e1bc64$var$REVEAL_ID = {
    clock: 'show-diff-reveal-clock',
    fade: 'show-diff-reveal-fade',
    reflow: 'show-diff-reveal-reflow',
    wipe: 'show-diff-reveal-wipe'
};
const $0b9c039f13e1bc64$var$running = new WeakMap();
const $0b9c039f13e1bc64$export$80aac885ffed194c = (editorView)=>{
    const current = $0b9c039f13e1bc64$var$running.get(editorView);
    if (!current) return;
    $0b9c039f13e1bc64$var$running.delete(editorView);
    [
        ...current.outgoing,
        ...current.incoming
    ].forEach((animation)=>animation.cancel());
    current.overlay?.remove();
    current.restoreReflow?.();
    current.complete();
};
/**
 * Sanitise cloned subtree: remove IDs, contenteditable, re-mount-unsafe elements.
 * Measures embeds from LIVE element (clone is detached, would measure 0x0).
 */ const $0b9c039f13e1bc64$var$sanitiseClone = (live, clone)=>{
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((element)=>element.removeAttribute('id'));
    clone.removeAttribute('contenteditable');
    clone.querySelectorAll('[contenteditable]').forEach((element)=>{
        element.removeAttribute('contenteditable');
    });
    // Revealing decorations paint at zero width; snapshot must show full width so clear markers here.
    clone.querySelectorAll(`[${(0, $a6f71fd197aec590$export$cee91f6cebab58c)}]`).forEach((element)=>{
        element.removeAttribute((0, $a6f71fd197aec590$export$cee91f6cebab58c));
        element.style.removeProperty('background-size');
    });
    const liveEmbeds = live.querySelectorAll($0b9c039f13e1bc64$var$REMOUNT_UNSAFE_SELECTOR);
    clone.querySelectorAll($0b9c039f13e1bc64$var$REMOUNT_UNSAFE_SELECTOR).forEach((element, index)=>{
        const placeholder = document.createElement('div');
        const source = liveEmbeds[index];
        if (source) {
            const { width: width, height: height } = source.getBoundingClientRect();
            placeholder.style.width = `${width}px`;
            placeholder.style.height = `${height}px`;
        }
        element.replaceWith(placeholder);
    });
};
/**
 * Convert flat highlights (from non-revealing render) to wipeable gradients.
 * Reads colour from LIVE element (clone is detached, no computed style).
 */ const $0b9c039f13e1bc64$var$makeOutgoingHighlightsWipeable = (liveBlock, clonedBlock)=>{
    const live = liveBlock.querySelectorAll($0b9c039f13e1bc64$var$CHANGED_DECORATION_SELECTOR);
    const cloned = clonedBlock.querySelectorAll($0b9c039f13e1bc64$var$CHANGED_DECORATION_SELECTOR);
    const wipeable = [];
    cloned.forEach((clone, index)=>{
        const source = live[index];
        if (!source) return;
        // Read colour from custom property (revealing render) or computed style (flat render).
        const color = source.style.getPropertyValue((0, $a6f71fd197aec590$export$e058ad86e11ec259)).trim() || window.getComputedStyle(source).backgroundColor;
        if (!color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)') return;
        clone.setAttribute('style', `${clone.getAttribute('style') ?? ''}${(0, $a6f71fd197aec590$export$9f2e698630a68448)(color)}`);
        // Anchor right: shrinking retracts the highlight through the right edge.
        clone.style.backgroundSize = '100% 100%';
        clone.style.backgroundPosition = '100% 0';
        wipeable.push(clone);
    });
    return wipeable;
};
/**
 * The contiguous run of top-level blocks containing a change.
 *
 * Only these cross-fade. Fading the whole content area would also fade blocks that did not change
 * and have merely been pushed up or down by the reflow, which reads as the entire document
 * flickering.
 *
 * Exact rather than contiguous: an agent can touch two paragraphs either side of untouched ones,
 * and a first-to-last range would sweep up everything between them. The index travels with each
 * block so its outgoing height can be paired with its incoming height across the swap.
 */ const $0b9c039f13e1bc64$var$findChangedBlocks = (content)=>Array.from(content.children).filter((child)=>child instanceof HTMLElement).map((block, index)=>({
            block: block,
            index: index
        })).filter(({ block: block })=>block.matches($0b9c039f13e1bc64$var$CHANGED_BLOCK_SELECTOR) || block.querySelector($0b9c039f13e1bc64$var$CHANGED_BLOCK_SELECTOR));
/** Outgoing height of every changed block, keyed by its position among the content's children. */ const $0b9c039f13e1bc64$var$measureBlocks = (changed)=>new Map(changed.map(({ block: block, index: index })=>[
            index,
            block.getBoundingClientRect().height
        ]));
/**
 * Build and position a snapshot of the outgoing state over the changed blocks.
 *
 * The wrapper is a shallow clone of the ProseMirror element so the snapshot keeps the class-based
 * typography the real content has; a plain div would render the text differently. Inserted as a
 * sibling rather than a child so ProseMirror does not reconcile it away.
 */ const $0b9c039f13e1bc64$var$buildOverlay = (content, changed)=>{
    const host = content.parentElement;
    if (!host || !content.offsetParent || changed.length === 0) return undefined;
    const wrapper = content.cloneNode(false);
    if (!(wrapper instanceof HTMLElement)) return undefined;
    const contentRect = content.getBoundingClientRect();
    changed.forEach(({ block: block })=>{
        const clone = block.cloneNode(true);
        if (!(clone instanceof HTMLElement)) return;
        $0b9c039f13e1bc64$var$sanitiseClone(block, clone);
        $0b9c039f13e1bc64$var$makeOutgoingHighlightsWipeable(block, clone);
        // Each clone is placed at its own offset. Stacking them in flow would close the gaps left by
        // the unchanged blocks that were not copied, so a later block would sit too high.
        const rect = block.getBoundingClientRect();
        clone.style.position = 'absolute';
        clone.style.top = `${rect.top - contentRect.top}px`;
        clone.style.left = `${rect.left - contentRect.left}px`;
        clone.style.width = `${rect.width}px`;
        clone.style.margin = '0';
        wrapper.appendChild(clone);
    });
    wrapper.removeAttribute('id');
    wrapper.removeAttribute('contenteditable');
    // aria-hidden + inert removes overlay from focus, hit-testing and AT (aria-hidden-focus safe).
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.setAttribute('inert', '');
    wrapper.style.position = 'absolute';
    // Sits on the content box, with the clones positioned relative to it.
    wrapper.style.top = `${content.offsetTop}px`;
    wrapper.style.left = `${content.offsetLeft}px`;
    wrapper.style.width = `${content.offsetWidth}px`;
    // The wrapper inherits the editor's own padding and margin, which would offset the copied blocks
    // a second time on top of the position already measured from them.
    wrapper.style.margin = '0';
    wrapper.style.padding = '0';
    wrapper.style.boxSizing = 'border-box';
    wrapper.style.pointerEvents = 'none';
    wrapper.style.zIndex = '1';
    host.insertBefore(wrapper, content);
    return wrapper;
};
/**
 * Slide the content below the change from where it used to sit to where it now sits.
 *
 * The incoming blocks are already at their final height, so without this everything below them
 * jumps the instant the diff is applied. `margin-bottom` carries the following content; when the
 * change has grown, the last block is also clipped back to its old height and released, so the
 * content below is not overlapped while it catches up.
 */ const $0b9c039f13e1bc64$var$animateReflow = (changed, outgoingHeights, duration)=>{
    const specs = [];
    const restores = [];
    const deltas = new Map();
    changed.forEach(({ block: block, index: index })=>{
        const before = outgoingHeights.get(index);
        if (before === undefined) return;
        const delta = before - block.getBoundingClientRect().height;
        if (Math.abs(delta) < 1) return;
        deltas.set(index, delta);
        // Growth only: clip the block back to its old height and open it up. Without this the taller
        // new content would overlap the content below, which has not caught up yet.
        const growth = Math.max(0, -delta);
        if (growth === 0) return;
        const previousOverflow = block.style.overflow;
        block.style.overflow = 'hidden';
        restores.push(()=>{
            block.style.overflow = previousOverflow;
        });
        specs.push({
            index: index,
            keyframes: [
                {
                    clipPath: `inset(0 0 ${growth}px 0)`
                },
                {
                    clipPath: 'inset(0 0 0 0)'
                }
            ],
            property: 'clip'
        });
    });
    const parent = changed[0]?.block.parentElement;
    if (deltas.size === 0 || !parent) return {
        restore: ()=>restores.forEach((restore)=>restore()),
        specs: specs
    };
    // Everything below a change is carried with `transform`, never `margin`. Margin is a layout
    // property, so each frame would re-lay-out the content below at a fractional offset and
    // re-rasterise its text — that reads as shimmer even at a locked 60fps. Transforms run on the
    // compositor: the glyphs are rasterised once and moved.
    let carried = 0;
    Array.from(parent.children).forEach((child, index)=>{
        if (child instanceof HTMLElement && carried !== 0) specs.push({
            index: index,
            keyframes: [
                {
                    transform: `translateY(${carried}px)`
                },
                {
                    transform: 'translateY(0px)'
                }
            ],
            property: 'carry'
        });
        // Applied after the block itself: a change moves the content below it, not its own top edge.
        carried += deltas.get(index) ?? 0;
    });
    return {
        restore: ()=>restores.forEach((restore)=>restore()),
        specs: specs
    };
};
/** Animate incoming highlights; re-run if diff repaints mid-reveal. */ /**
 * Creates an animation unless the element already carries one of ours, and resumes it at `elapsed`.
 *
 * ProseMirror rebuilds inline decorations on any repaint, which destroys animations bound to them.
 * Widget DOM is reused and so survives, which is why deleted highlights used to animate while added
 * ones snapped in. Re-binding at the elapsed time keeps a re-rendered element in step rather than
 * restarting it from the beginning.
 */ const $0b9c039f13e1bc64$var$bind = (entry, element, id, keyframes, options, elapsed)=>{
    if (element.getAnimations().some((animation)=>animation.id === id)) return;
    const animation = element.animate(keyframes, options);
    animation.id = id;
    if (elapsed > 0) animation.currentTime = Math.min(elapsed, options.duration);
    entry.incoming.push(animation);
};
const $0b9c039f13e1bc64$var$highlightKeyframes = (element)=>{
    const border = element.style.getPropertyValue((0, $a6f71fd197aec590$export$66395af787a97039)).trim();
    return [
        {
            backgroundSize: '0% 100%',
            borderBottomColor: 'transparent',
            offset: 0
        },
        {
            backgroundSize: '0% 100%',
            borderBottomColor: 'transparent',
            easing: $0b9c039f13e1bc64$var$EASING,
            offset: $0b9c039f13e1bc64$var$PHASE_A_FRACTION
        },
        {
            backgroundSize: '100% 100%',
            borderBottomColor: border,
            offset: 1
        }
    ];
};
/** (Re)binds every animation that runs on live, ProseMirror-managed DOM. */ const $0b9c039f13e1bc64$var$applyIncoming = (entry, content, total, phaseA)=>{
    const elapsed = Math.max(0, performance.now() - entry.startedAt);
    const changedBlocks = $0b9c039f13e1bc64$var$findChangedBlocks(content);
    // Only the changed blocks cross-fade. Everything else is unchanged content that has merely
    // moved, and fading it would read as the whole document flickering.
    if (entry.overlay) {
        const fading = changedBlocks.length > 0 ? changedBlocks.map(({ block: block })=>block) : [
            content
        ];
        fading.forEach((block)=>{
            $0b9c039f13e1bc64$var$bind(entry, block, $0b9c039f13e1bc64$var$REVEAL_ID.fade, [
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: phaseA,
                easing: $0b9c039f13e1bc64$var$EASING,
                fill: 'forwards'
            }, elapsed);
        });
    }
    content.querySelectorAll(`[${(0, $a6f71fd197aec590$export$cee91f6cebab58c)}]`).forEach((element)=>{
        $0b9c039f13e1bc64$var$bind(entry, element, $0b9c039f13e1bc64$var$REVEAL_ID.wipe, $0b9c039f13e1bc64$var$highlightKeyframes(element), {
            duration: total,
            fill: 'forwards'
        }, elapsed);
    });
    entry.reflowSpecs.forEach(({ index: index, keyframes: keyframes, property: property })=>{
        const child = content.children[index];
        if (child instanceof HTMLElement) $0b9c039f13e1bc64$var$bind(entry, child, `${$0b9c039f13e1bc64$var$REVEAL_ID.reflow}-${property}`, keyframes, {
            duration: entry.reflowDuration,
            easing: $0b9c039f13e1bc64$var$EASING,
            fill: 'backwards'
        }, elapsed);
    });
};
const $0b9c039f13e1bc64$export$6f15c224adb80d84 = (editorView, content)=>{
    const entry = $0b9c039f13e1bc64$var$running.get(editorView);
    if (entry) $0b9c039f13e1bc64$var$applyIncoming(entry, content, entry.total, entry.phaseA);
};
const $0b9c039f13e1bc64$var$scheduleIncoming = (editorView, entry, content, total, phaseA)=>{
    requestAnimationFrame(()=>{
        if ($0b9c039f13e1bc64$var$running.get(editorView) !== entry) return;
        entry.startedAt = performance.now();
        const reflow = $0b9c039f13e1bc64$var$animateReflow($0b9c039f13e1bc64$var$findChangedBlocks(content), entry.outgoingHeights, entry.reflowDuration);
        entry.reflowSpecs = reflow.specs;
        entry.restoreReflow = reflow.restore;
        $0b9c039f13e1bc64$var$applyIncoming(entry, content, total, phaseA);
        // The clock runs on the content root, which ProseMirror never replaces. Hanging completion
        // off a decoration animation would strand the reveal whenever that decoration was rebuilt.
        const clock = content.animate([
            {
                opacity: 1
            },
            {
                opacity: 1
            }
        ], {
            duration: total
        });
        clock.id = $0b9c039f13e1bc64$var$REVEAL_ID.clock;
        clock.onfinish = ()=>{
            if ($0b9c039f13e1bc64$var$running.get(editorView) === entry) $0b9c039f13e1bc64$export$80aac885ffed194c(editorView);
        };
        entry.incoming.push(clock);
    });
};
const $0b9c039f13e1bc64$export$47d417ff82936669 = ({ editorView: editorView, onComplete: onComplete, reveal: reveal })=>{
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const content = editorView.dom;
    if (!(content instanceof HTMLElement)) return;
    const total = reveal.durationMs ?? $0b9c039f13e1bc64$export$3517b7b24c5b04fe;
    const phaseA = Math.round(total * $0b9c039f13e1bc64$var$PHASE_A_FRACTION);
    // Repaint mid-reveal: reuse snapshot (not retake), rebind incoming animations to fresh decorations.
    const existing = $0b9c039f13e1bc64$var$running.get(editorView);
    if (existing) {
        existing.incoming.forEach((animation)=>animation.cancel());
        existing.incoming = [];
        $0b9c039f13e1bc64$var$scheduleIncoming(editorView, existing, content, total, phaseA);
        return;
    }
    // Captured before dispatch: this is the last moment the outgoing layout can be measured.
    const outgoingBlocks = $0b9c039f13e1bc64$var$findChangedBlocks(content);
    const overlay = $0b9c039f13e1bc64$var$buildOverlay(content, outgoingBlocks);
    const outgoing = [];
    if (overlay) {
        // fill: 'forwards' is load-bearing: default fill: 'none' snaps snapshot to opaque (reads as swap).
        const fadeOut = overlay.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: phaseA,
            easing: $0b9c039f13e1bc64$var$EASING,
            fill: 'forwards'
        });
        fadeOut.onfinish = ()=>{
            overlay.remove();
        };
        outgoing.push(fadeOut);
        overlay.querySelectorAll($0b9c039f13e1bc64$var$CHANGED_DECORATION_SELECTOR).forEach((element)=>{
            if (!element.style.backgroundImage) return;
            outgoing.push(element.animate([
                {
                    backgroundSize: '100% 100%'
                },
                {
                    backgroundSize: '0% 100%'
                }
            ], {
                duration: phaseA,
                easing: $0b9c039f13e1bc64$var$EASING,
                fill: 'forwards'
            }));
        });
    }
    const entry = {
        complete: onComplete,
        incoming: [],
        outgoing: outgoing,
        outgoingHeights: $0b9c039f13e1bc64$var$measureBlocks(outgoingBlocks),
        phaseA: phaseA,
        reflowDuration: Math.round(total * $0b9c039f13e1bc64$var$REFLOW_DURATION_FRACTION),
        reflowSpecs: [],
        startedAt: performance.now(),
        total: total,
        overlay: overlay
    };
    $0b9c039f13e1bc64$var$running.set(editorView, entry);
    $0b9c039f13e1bc64$var$scheduleIncoming(editorView, entry, content, total, phaseA);
};



var $k8PFz = parcelRequire("k8PFz");


var $lLsh6 = parcelRequire("lLsh6");





/**
 * Extra space above the scrolled-to element so it does not sit flush under the
 * viewport edge (helps with sticky table headers, toolbars, etc.).
 *
 * Implemented with `scroll-margin-top` so we still use the browser’s native
 * `scrollIntoView`, which scrolls every relevant scrollport (nested containers
 * and the window). A single manual `scrollTop` on one ancestor often misses
 * outer scroll or mis-identifies the active scroll container.
 */ const $0a56d7ce3dd9c790$var$SCROLL_TOP_MARGIN_PX = 100;
function $0a56d7ce3dd9c790$var$updateScrollTargetMargin(view, targetPos, api) {
    const isLimitedModeEnabled = Boolean(api?.limitedMode?.sharedState.currentState()?.enabled);
    const tableHeaderHeight = isLimitedModeEnabled ? undefined : (0, $lLsh6.getStickyHeaderHeight)(view, targetPos);
    view.dom.style.setProperty((0, $c8506ce9a0d29c95$export$9a5be357131ea835), `${tableHeaderHeight ? tableHeaderHeight + (0, $k8PFz.tableMarginTop) : 0}px`);
}
/**
 * Returns the resolved HTMLElement for a given DOM node, walking up to the
 * parent element if the node itself is not an Element (e.g. a text node).
 */ function $0a56d7ce3dd9c790$var$scrollToSelection(node) {
    const element = node instanceof Element ? node : node?.parentElement instanceof Element ? node.parentElement : null;
    if (!(element instanceof HTMLElement)) return;
    if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        return;
    }
    // scroll-margin is included in scroll-into-view math; it does not change layout.
    const previousScrollMarginTop = element.style.scrollMarginTop;
    element.style.scrollMarginTop = `${$0a56d7ce3dd9c790$var$SCROLL_TOP_MARGIN_PX}px`;
    try {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    } finally{
        element.style.scrollMarginTop = previousScrollMarginTop;
    }
}
const $0a56d7ce3dd9c790$export$3d9616ccdd51e910 = (view, decorations, activeIndex = 0, api)=>{
    const decoration = decorations[activeIndex];
    if (!decoration) return ()=>{};
    // A grouped decoration spans a whole customer-facing edit, which can visually start with a
    // deleted-content widget rather than at the group's `from` position — see `scrollTarget` in
    // `getScrollableDecorations`. Only set under `platform_editor_ai_show_diff_patch_1`.
    const target = (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.scrollTarget || decoration;
    let rafId = requestAnimationFrame(()=>{
        rafId = null;
        if ((0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) $0a56d7ce3dd9c790$var$updateScrollTargetMargin(view, target.from, api);
        if ((0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(target) && target.spec.decorationType === 'widget') {
            // @ts-expect-error - decoration.type is not typed public API
            const widgetDom = target?.type?.toDOM;
            $0a56d7ce3dd9c790$var$scrollToSelection(widgetDom);
        } else {
            const targetNode = view.nodeDOM(target?.from);
            const node = targetNode instanceof Element ? targetNode : view.domAtPos(target?.from)?.node;
            $0a56d7ce3dd9c790$var$scrollToSelection(node);
        }
    });
    return ()=>{
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };
};


const $c205fa97f273a3e1$export$cc8ba64700247b36 = new (0, $kCECX.PluginKey)('showDiffPlugin');
/**
 * Tags whose diff decoration survived the transaction. A document change can map a decoration away
 * without any `showDiff`/`hideDiff` following it, and a tag left behind has no host to render into.
 * Returns the given array when every tag is still live.
 */ const $c205fa97f273a3e1$var$dropOrphanedContributorTags = (contributorTags, decorations)=>{
    if (!contributorTags?.length) return contributorTags;
    const liveDiffIds = new Set(decorations.find(undefined, undefined, (0, $c8506ce9a0d29c95$export$f24673b80d65051c)).filter((0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)).map(({ spec: spec })=>spec.diffId));
    const liveTags = contributorTags.filter(({ diffId: diffId })=>liveDiffIds.has(diffId));
    return liveTags.length === contributorTags.length ? contributorTags : liveTags;
};
const $c205fa97f273a3e1$export$ae829ec7b2625219 = (config, getIntl, api, onEditorView)=>{
    (0, $c3b673b22464e106$export$b180cb547184e48c)();
    const nodeViewSerializer = new (0, $2dfa9b84b3c8f00b$export$314a8d5cfa8a18e6)({});
    const setNodeViewSerializer = (editorView)=>{
        nodeViewSerializer.init({
            editorView: editorView
        });
    };
    /**
   * This editor's own content root. The contributor tags scope every DOM lookup to it, so they take
   * it from the view the plugin was mounted on rather than resolving `.ProseMirror` by class name
   * from a decoration — a class this package does not own, and one whose nearest match is the wrong
   * editor whenever editors are nested. A getter because the view arrives with the ProseMirror view
   * lifecycle, which decorations are calculated independently of.
   */ let currentEditorView;
    const tagMountContext = {
        api: api,
        getEditorRoot: ()=>currentEditorView?.dom ?? null,
        getIntl: getIntl
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $c205fa97f273a3e1$export$cc8ba64700247b36,
        state: {
            init (_, _state) {
                // We do initial setup after we setup the editor view
                const defaultDiffType = (0, $e85d9b72d1bb97d7$export$abfb7344ac6f0d49)();
                return {
                    steps: [],
                    stepAttributions: [],
                    originalDoc: undefined,
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    isDisplayingChanges: false,
                    ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(defaultDiffType) ? {
                        isInverted: false,
                        diffType: defaultDiffType,
                        hideDeletedDiffs: false,
                        hideAddedDiffsUnderline: false,
                        showIndicators: false,
                        diffDescriptors: []
                    } : {}
                };
            },
            apply: (tr, currentPluginState, oldState, newState)=>{
                const meta = tr.getMeta($c205fa97f273a3e1$export$cc8ba64700247b36);
                let newPluginState = currentPluginState;
                if (meta) {
                    if (meta?.action === 'SHOW_DIFF' || meta?.action === 'REVEAL_COMPLETE') {
                        // REVEAL_COMPLETE repaints with the reveal dropped, so the decorations render their
                        // ordinary resting style. Without it the reveal stays in state indefinitely and the
                        // next unrelated repaint re-emits the hidden, zero-width highlight with no animation
                        // left to bring it in — the highlight simply vanishes.
                        newPluginState = meta.action === 'REVEAL_COMPLETE' ? {
                            ...currentPluginState,
                            reveal: undefined
                        } : {
                            ...currentPluginState,
                            ...meta,
                            isDisplayingChanges: true,
                            activeIndex: undefined,
                            // Explicit rather than left to the spread: an absent key in `meta` would let
                            // the previous paint's choreography leak into this one, so closing the diff
                            // would animate too.
                            reveal: meta.reveal
                        };
                        // Calculate and store decorations in state
                        const { contributorTags: contributorTags, decorations: decorations, diffDescriptors: diffDescriptors } = (0, $ccec9bbe1ed9722a$export$aa7cf3ccfb5d875f)({
                            state: newState,
                            pluginState: newPluginState,
                            nodeViewSerializer: nodeViewSerializer,
                            colorScheme: newPluginState?.colorScheme ?? config?.colorScheme,
                            intl: getIntl(),
                            activeIndexPos: newPluginState.activeIndexPos,
                            api: api,
                            tagMountContext: tagMountContext,
                            ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState?.diffType) ? {
                                isInverted: newPluginState?.isInverted,
                                diffType: newPluginState?.diffType,
                                hideDeletedDiffs: newPluginState?.hideDeletedDiffs,
                                hideAddedDiffsUnderline: newPluginState?.hideAddedDiffsUnderline,
                                showIndicators: newPluginState?.showIndicators,
                                smartThresholds: newPluginState?.smartThresholds,
                                deletedDiffPlacement: newPluginState?.deletedDiffPlacement,
                                inlineDeletedDiffPlacement: newPluginState?.inlineDeletedDiffPlacement,
                                // SHOW_DIFF only. The scroll-to-next recalculation further down deliberately
                                // omits this so stepping through changes cannot replay the choreography.
                                reveal: newPluginState?.reveal
                            } : {}
                        });
                        // Update the decorations and their ids
                        newPluginState.decorations = decorations;
                        newPluginState.contributorTags = contributorTags;
                        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState?.diffType)) newPluginState.diffDescriptors = diffDescriptors;
                    } else if (meta?.action === 'HIDE_DIFF') newPluginState = {
                        ...currentPluginState,
                        ...meta,
                        decorations: (0, $8nvEM.DecorationSet).empty,
                        isDisplayingChanges: false,
                        activeIndex: undefined,
                        contributorTags: [],
                        reveal: undefined,
                        // Per-call override — do not let it leak into the next, unrelated `showDiff` call.
                        colorScheme: undefined,
                        /**
               * Reset isInverted & diffType state when hiding diffs
               * Otherwise this should persist for the diff-showing session
               */ ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(currentPluginState.diffType) ? {
                            isInverted: false,
                            diffType: (0, $e85d9b72d1bb97d7$export$abfb7344ac6f0d49)(),
                            hideDeletedDiffs: false,
                            hideAddedDiffsUnderline: false,
                            diffDescriptors: []
                        } : {}
                    };
                    else if (meta?.action === 'SCROLL_TO_NEXT' || meta?.action === 'SCROLL_TO_PREVIOUS') {
                        // Update the active index in plugin state and recalculate decorations
                        const decorations = (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(currentPluginState.decorations, newState.doc, newPluginState?.diffType);
                        if (decorations.length > 0) {
                            // Initialize to -1 if undefined so that the first "next" scroll takes us to index 0 (first change).
                            // This allows the UI to start with no selection and only highlight on first user interaction.
                            let nextIndex = currentPluginState.activeIndex ?? -1;
                            if (meta.action === 'SCROLL_TO_NEXT') nextIndex = (nextIndex + 1) % decorations.length;
                            else // Handle scrolling backwards from the uninitialized state.
                            // If at -1 (no selection), wrap to the last decoration.
                            if (nextIndex === -1) nextIndex = decorations.length - 1;
                            else nextIndex = (nextIndex - 1 + decorations.length) % decorations.length;
                            const activeDecoration = decorations[nextIndex];
                            newPluginState = {
                                ...currentPluginState,
                                activeIndex: nextIndex,
                                activeIndexPos: activeDecoration ? {
                                    from: activeDecoration.from,
                                    to: activeDecoration.to
                                } : undefined
                            };
                            // Recalculate decorations with the new active index
                            const { contributorTags: updatedContributorTags, decorations: updatedDecorations, diffDescriptors: updatedDiffDescriptors } = (0, $ccec9bbe1ed9722a$export$aa7cf3ccfb5d875f)({
                                state: newState,
                                pluginState: newPluginState,
                                nodeViewSerializer: nodeViewSerializer,
                                colorScheme: newPluginState?.colorScheme ?? config?.colorScheme,
                                intl: getIntl(),
                                activeIndexPos: newPluginState.activeIndexPos,
                                api: api,
                                tagMountContext: tagMountContext,
                                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState.diffType) ? {
                                    isInverted: newPluginState.isInverted,
                                    diffType: newPluginState.diffType,
                                    hideDeletedDiffs: newPluginState.hideDeletedDiffs,
                                    hideAddedDiffsUnderline: newPluginState.hideAddedDiffsUnderline,
                                    showIndicators: newPluginState.showIndicators,
                                    smartThresholds: newPluginState.smartThresholds,
                                    deletedDiffPlacement: newPluginState.deletedDiffPlacement,
                                    inlineDeletedDiffPlacement: newPluginState.inlineDeletedDiffPlacement
                                } : {}
                            });
                            newPluginState.decorations = updatedDecorations;
                            newPluginState.contributorTags = updatedContributorTags;
                            if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState.diffType)) newPluginState.diffDescriptors = updatedDiffDescriptors;
                        }
                    } else newPluginState = {
                        ...currentPluginState,
                        ...meta
                    };
                }
                const mappedDecorations = newPluginState.decorations.map(tr.mapping, tr.doc);
                const nextState = {
                    ...newPluginState,
                    decorations: mappedDecorations
                };
                if (tr.docChanged) nextState.contributorTags = $c205fa97f273a3e1$var$dropOrphanedContributorTags(newPluginState.contributorTags, mappedDecorations);
                return nextState;
            }
        },
        view (editorView) {
            setNodeViewSerializer(editorView);
            currentEditorView = editorView;
            onEditorView?.(editorView);
            let isFirst = true;
            let previousActiveIndex;
            let cancelPendingScrollToDecoration = null;
            return {
                update (view) {
                    // If we're using configuration to show diffs we initialise here once we setup the editor view
                    if (config?.originalDoc && config?.steps && config.steps.length > 0 && isFirst) {
                        isFirst = false;
                        view.dispatch(view.state.tr.setMeta($c205fa97f273a3e1$export$cc8ba64700247b36, {
                            action: 'SHOW_DIFF',
                            steps: config.steps.map((step)=>(0, $5aU9U.Step).fromJSON(view.state.schema, step)),
                            originalDoc: (0, $5Qi6J.processRawValue)(view.state.schema, config.originalDoc)
                        }));
                    }
                    const pluginState = $c205fa97f273a3e1$export$cc8ba64700247b36.getState(view.state);
                    // A repaint rebuilds inline decorations, destroying any animation bound to them, so
                    // an in-flight reveal has to be re-attached to the new nodes. No-op when idle.
                    (0, $0b9c039f13e1bc64$export$6f15c224adb80d84)(view, view.dom);
                    // Scroll to the first decoration when scrollIntoView was requested.
                    // Use the same filtered/position-sorted list as the active-index path
                    // so "first" reliably means the topmost scrollable diff in the document.
                    if (pluginState?.scrollIntoView && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(pluginState?.diffType)) {
                        cancelPendingScrollToDecoration?.();
                        cancelPendingScrollToDecoration = (0, $0a56d7ce3dd9c790$export$3d9616ccdd51e910)(view, (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(pluginState.decorations, view.state.doc, pluginState?.diffType), undefined, api);
                        // Reset the flag so we don't scroll again on subsequent updates
                        view.dispatch(view.state.tr.setMeta($c205fa97f273a3e1$export$cc8ba64700247b36, {
                            scrollIntoView: false
                        }));
                    }
                    // Check for any potential scroll side-effects
                    const activeIndexChanged = pluginState?.activeIndex !== undefined && pluginState.activeIndex !== previousActiveIndex;
                    previousActiveIndex = pluginState?.activeIndex;
                    if (pluginState?.activeIndex !== undefined && activeIndexChanged) {
                        cancelPendingScrollToDecoration?.();
                        const scrollableDecorations = (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(pluginState.decorations, view.state.doc, pluginState?.diffType);
                        const activeDecoration = scrollableDecorations[pluginState.activeIndex];
                        if (activeDecoration) // EDITOR-7926: use editor-common's command instead of the expand plugin API to
                        // avoid a circular dependency; expand picks up the meta if loaded (no-op if not).
                        api?.core.actions.execute((0, $8QOo3.toggleExpandRange)(activeDecoration.from, activeDecoration.to, true));
                        cancelPendingScrollToDecoration = (0, $0a56d7ce3dd9c790$export$3d9616ccdd51e910)(view, scrollableDecorations, pluginState.activeIndex, api);
                        // Stepping only scrolls — no focus moves and no content changes — so without this a
                        // screen-reader user gets silence. Announced through the live region rather than by
                        // focusing the change, since the "next change" control has to stay focused to be
                        // pressed again. After the scroll above, so the announcement never precedes it.
                        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(pluginState?.diffType)) {
                            const announcement = (0, $06c65279ee11c673$export$be37737225e29297)({
                                activeIndex: pluginState.activeIndex,
                                contributorTags: pluginState.contributorTags,
                                decorations: scrollableDecorations,
                                intl: getIntl()
                            });
                            if (announcement) api?.accessibilityUtils?.actions.ariaNotify(announcement);
                        }
                    }
                },
                destroy () {
                    cancelPendingScrollToDecoration?.();
                    cancelPendingScrollToDecoration = null;
                    currentEditorView = undefined;
                    onEditorView?.(undefined);
                }
            };
        },
        props: {
            decorations: (state)=>{
                const pluginState = $c205fa97f273a3e1$export$cc8ba64700247b36.getState(state);
                return pluginState?.decorations;
            }
        }
    });
};


// The element a deleted-content widget renders, or undefined if it renders via a factory.
const $edd6c61ae745aecc$var$getWidgetElement = (decoration)=>{
    const { toDOM: toDOM } = decoration.type ?? {};
    return toDOM instanceof HTMLElement ? toDOM : undefined;
};
const $edd6c61ae745aecc$export$4b2e83eb1fbe1891 = (editorState, range)=>{
    const decorations = (0, $c205fa97f273a3e1$export$cc8ba64700247b36).getState(editorState)?.decorations;
    if (!decorations) return [];
    return decorations.find(range?.from, range?.to, (spec)=>(0, $c8506ce9a0d29c95$export$f24673b80d65051c)(spec) && spec.decorationType === 'widget').reduce((widgets, decoration)=>{
        const element = $edd6c61ae745aecc$var$getWidgetElement(decoration);
        if (element) widgets.push({
            element: element,
            position: decoration.from
        });
        return widgets;
    }, []).sort((a, b)=>a.position - b.position);
};







/** A brand name, so a literal rather than a translated message. */ const $01564221a85d07f9$var$ROVO_AGENT_NAME = 'Rovo';
/** `agentType` values that render as "Rovo" rather than as a generic external agent. */ const $01564221a85d07f9$var$ROVO_AGENT_TYPES = new Set([
    'convo-ai',
    'rovo_chat'
]);
/** Known external agent types emitted by Confluence's agent identification service. */ const $01564221a85d07f9$var$EXTERNAL_AGENT_PRESENTATIONS = {
    claude: {
        agentKind: 'claude',
        name: 'Claude'
    },
    codex: {
        agentKind: 'external',
        name: 'Codex'
    },
    vscode: {
        agentKind: 'external',
        name: 'VS Code'
    },
    hermes: {
        agentKind: 'external',
        name: 'Hermes'
    },
    runlayer: {
        agentKind: 'external',
        name: 'Runlayer'
    },
    zed: {
        agentKind: 'external',
        name: 'Zed'
    },
    ampcode: {
        agentKind: 'external',
        name: 'Ampcode'
    },
    antigravity: {
        agentKind: 'external',
        name: 'Antigravity'
    },
    devin_cli: {
        agentKind: 'external',
        name: 'Devin CLI'
    },
    pi_agent: {
        agentKind: 'external',
        name: 'Pi Agent'
    }
};
const $01564221a85d07f9$var$hasAgentIdentity = (attribution)=>Boolean(attribution.agentId?.trim() || attribution.agentType?.trim());
const $01564221a85d07f9$var$toProfilesByAccountId = (profiles)=>{
    const profilesByAccountId = new Map();
    profiles?.forEach((profile)=>{
        // Trimmed to match how attribution ids are keyed, so the two sides compare like for like.
        const accountId = profile.accountId.trim();
        if (accountId && !profilesByAccountId.has(accountId)) profilesByAccountId.set(accountId, profile);
    });
    return profilesByAccountId;
};
const $01564221a85d07f9$var$resolveUser = (userId, profilesByAccountId)=>{
    const profile = profilesByAccountId.get(userId);
    return profile ? {
        avatarUrl: profile.avatarUrl,
        kind: 'user',
        name: profile.name
    } : undefined;
};
/** Resolve branding or a profile first, then a known type name or the external-agent fallback. */ const $01564221a85d07f9$var$resolveAgent = (attribution, profilesByAccountId)=>{
    const agentType = attribution.agentType?.trim().toLowerCase();
    const agentPresentation = agentType ? $01564221a85d07f9$var$EXTERNAL_AGENT_PRESENTATIONS[agentType] : undefined;
    if (agentPresentation && agentPresentation.agentKind !== 'external') return {
        ...agentPresentation,
        kind: 'agent'
    };
    const agentId = attribution.agentId?.trim();
    const agentProfile = agentId ? profilesByAccountId.get(agentId) : undefined;
    if (agentProfile) return {
        agentKind: 'identified',
        avatarUrl: agentProfile.avatarUrl,
        kind: 'agent',
        name: agentProfile.name
    };
    // Unknown types keep an empty name for the tag's localised "External agent" label.
    return agentType && $01564221a85d07f9$var$ROVO_AGENT_TYPES.has(agentType) ? {
        agentKind: 'rovo',
        kind: 'agent',
        name: $01564221a85d07f9$var$ROVO_AGENT_NAME
    } : agentPresentation ? {
        ...agentPresentation,
        kind: 'agent'
    } : {
        agentKind: 'external',
        kind: 'agent',
        name: ''
    };
};
const $01564221a85d07f9$export$e63dae0afea9836 = (stepsWithAttribution, profiles)=>{
    // Profiles opt callers into contributor tags; attribution alone still supplies diff colours.
    if (profiles === undefined) return undefined;
    const profilesByAccountId = $01564221a85d07f9$var$toProfilesByAccountId(profiles);
    const contributors = [];
    /** Keyed as the plugin keys changes, so no two entries can collapse onto one another. */ const creditedActors = new Set();
    for (const { stepAttribution: stepAttribution } of stepsWithAttribution){
        // An attribution naming nobody (e.g. one carrying only `wasOffline`) has nobody to credit.
        const actor = stepAttribution ? (0, $8Rpmh.getAttributionKey)(stepAttribution) : undefined;
        if (!stepAttribution || !actor || creditedActors.has(actor)) continue;
        const userId = stepAttribution.userId?.trim();
        if ($01564221a85d07f9$var$hasAgentIdentity(stepAttribution)) {
            const agent = $01564221a85d07f9$var$resolveAgent(stepAttribution, profilesByAccountId);
            if (!userId) {
                // Agent mode: the agent acted on its own, so it is credited on its own.
                contributors.push({
                    ...agent,
                    attribution: stepAttribution
                });
                creditedActors.add(actor);
                continue;
            }
            // User-invoked agent: credit both actors and link the agent back to the invoking user.
            const invokingUser = {
                userId: userId
            };
            const user = $01564221a85d07f9$var$resolveUser(userId, profilesByAccountId);
            // Skipped if the invoking user's own step already credited them.
            const invokingUserActor = (0, $8Rpmh.getAttributionKey)(invokingUser);
            if (user && invokingUserActor && !creditedActors.has(invokingUserActor)) {
                contributors.push({
                    ...user,
                    attribution: invokingUser
                });
                creditedActors.add(invokingUserActor);
            }
            // The agent is always nameable, so it is credited even when its invoker is not — but
            // without the connection, which would point at a contributor that was never created.
            contributors.push({
                ...agent,
                attribution: stepAttribution,
                ...user ? {
                    connectedTo: invokingUser
                } : {}
            });
            creditedActors.add(actor);
            continue;
        }
        const user = userId ? $01564221a85d07f9$var$resolveUser(userId, profilesByAccountId) : undefined;
        if (!user) continue;
        contributors.push({
            ...user,
            attribution: stepAttribution
        });
        creditedActors.add(actor);
    }
    return contributors.length > 0 ? contributors : undefined;
};



/* IndicatorBarContentComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


/* IndicatorBar.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");




const $a83541013b9d489a$var$barStyles = null;
const $a83541013b9d489a$var$getIndicatorColor = (colorScheme, isInserted)=>{
    if (colorScheme === undefined || colorScheme === 'standard' || colorScheme === 'traditional' || isInserted === undefined) return "var(--ds-border-information, #357DE8)";
    return (0, $e28b33baecacf396$export$c010c3eb7bcbc04e)((0, $2b1f4eac4487ddd9$export$ff5fc39b2e819c33)[colorScheme][isInserted ? 'insertColor' : 'deleteColor']);
};
function $a83541013b9d489a$export$9541970bb1a2b56c({ anchorTop: anchorTop, anchorBottom: anchorBottom, anchorLeft: anchorLeft, anchorLeftFallback: anchorLeftFallback, colorScheme: colorScheme, isInserted: isInserted }) {
    const leftAnchors = [
        anchorLeft,
        anchorLeftFallback,
        (0, $c8506ce9a0d29c95$export$bc2e1517d52e2060)
    ].filter(Boolean).map((anchor)=>`anchor(--${anchor} left)`).join(', ');
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": "diff-indicator-bar",
        style: {
            backgroundColor: $a83541013b9d489a$var$getIndicatorColor(colorScheme, isInserted),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            left: `min(${leftAnchors})`,
            top: `anchor(--${anchorTop} top)`,
            bottom: `anchor(--${anchorBottom} bottom)`
        },
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _1mT5xdWVPG _39xV024Y4b _1pp6NdYbGa _2XsHFMUgYP _2RljVsYpy6 _313842TUhv _1DCdHiTUhv"
        ])
    });
}


const $018a8bbdd67e90a0$var$renderIndicatorBar = (descriptor)=>{
    switch(descriptor.type){
        case 'inline':
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a83541013b9d489a$export$9541970bb1a2b56c), {
                colorScheme: descriptor.colorScheme,
                isInserted: descriptor.isInserted,
                anchorTop: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from
                }),
                anchorBottom: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).to
                }),
                anchorLeft: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
                })
            }, descriptor.id);
        case 'block':
            {
                // The block anchor is a single element (keyed by diffId with no
                // anchorType) sized to the full height of the block node, so top,
                // bottom and left all resolve against it.
                const blockAnchor = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                });
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a83541013b9d489a$export$9541970bb1a2b56c), {
                    colorScheme: descriptor.colorScheme,
                    isInserted: descriptor.isInserted,
                    anchorTop: blockAnchor,
                    anchorBottom: blockAnchor,
                    anchorLeft: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                        diffId: descriptor.id,
                        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
                    })
                }, descriptor.id);
            }
        case 'widget':
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a83541013b9d489a$export$9541970bb1a2b56c), {
                colorScheme: descriptor.colorScheme,
                isInserted: descriptor.isInserted,
                anchorTop: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                }),
                anchorBottom: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                }),
                anchorLeft: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
                }),
                anchorLeftFallback: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                })
            }, descriptor.id);
        default:
            return null;
    }
};
const $018a8bbdd67e90a0$export$6b19438129810c85 = ({ api: api })=>{
    const { showIndicators: showIndicators, isDisplayingChanges: isDisplayingChanges, diffDescriptors: diffDescriptors } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'showDiff'
    ], (state)=>{
        return {
            showIndicators: state.showDiffState?.showIndicators,
            isDisplayingChanges: state.showDiffState?.isDisplayingChanges,
            diffDescriptors: state.showDiffState?.diffDescriptors
        };
    });
    if (!showIndicators || !isDisplayingChanges || !diffDescriptors?.length) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: diffDescriptors.map($018a8bbdd67e90a0$var$renderIndicatorBar)
    });
};


const $7a6c101d54699cc6$var$normalizeShowDiffParams = (params)=>{
    if (!params || !('stepsWithAttribution' in params)) // Clear contributors to prevent leaking from attributed to unattributed diffs.
    return params ? {
        ...params,
        stepAttributions: [],
        contributors: undefined
    } : params;
    const { stepsWithAttribution: stepsWithAttribution, contributorProfiles: contributorProfiles, ...rest } = params;
    return {
        ...rest,
        // Resolve at boundary to keep contributor model and attribution format internal.
        contributors: (0, $8Rpmh.areAttributionColorGatesEnabled)() ? (0, $8Rpmh.resolveContributors)((0, $01564221a85d07f9$export$e63dae0afea9836)(stepsWithAttribution, contributorProfiles)) : undefined,
        steps: stepsWithAttribution.map(({ step: step })=>step),
        stepAttributions: stepsWithAttribution.map(({ stepAttribution: stepAttribution })=>stepAttribution)
    };
};
const $7a6c101d54699cc6$var$prefersReducedMotion = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/**
 * Resolve reveal preconditions once here so decorations and animation share one answer. If
 * decorations think a reveal is happening but animation doesn't, highlight paints hidden forever.
 * All preconditions resolved here (not just gate) ensures "unable to animate" means "do not reveal".
 *
 * Umbrella experiment: within the AI streaming UX M1 population this behaviour is only enabled
 * for the treatment cohort. Non-AI callers (track-changes, etc.) are not enrolled and default
 * to `true`, preserving the pre-umbrella baseline.
 */ const $7a6c101d54699cc6$var$resolveReveal = (reveal, editorView)=>// Gate first, so it is the primary switch and is always observable once a reveal is requested.
    reveal && (0, $iDrrr.fg)('platform_editor_diff_reveal_animation') && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_streaming_ux_experience_m1', 'isEnabled', false) === true && editorView && typeof window !== 'undefined' && !$7a6c101d54699cc6$var$prefersReducedMotion() ? reveal : undefined;
const $7a6c101d54699cc6$export$b025b000fc343096 = ({ api: api, config: config })=>{
    // Captured from view lifecycle so read-only actions access state without exposing plugin key.
    let editorView;
    const setEditorView = (view)=>{
        editorView = view;
    };
    return {
        name: 'showDiff',
        actions: {
            getDeletedWidgets: (range)=>editorView ? (0, $edd6c61ae745aecc$export$4b2e83eb1fbe1891)(editorView.state, range) : []
        },
        commands: {
            showDiff: (params)=>({ tr: tr })=>{
                    if ((0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) api?.userIntent?.commands.setCurrentUserIntent('viewingDiff')({
                        tr: tr
                    });
                    const reveal = $7a6c101d54699cc6$var$resolveReveal(params?.reveal, editorView);
                    // Capture snapshot BEFORE transaction dispatch (last moment outgoing DOM exists).
                    if (reveal && editorView) {
                        const view = editorView;
                        (0, $0b9c039f13e1bc64$export$47d417ff82936669)({
                            editorView: view,
                            reveal: reveal,
                            onComplete: ()=>{
                                // Repaint without the reveal so the decorations settle into their resting
                                // style. Kept out of history: this is presentation, not an edit.
                                view.dispatch(view.state.tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                                    action: 'REVEAL_COMPLETE'
                                }).setMeta('addToHistory', false));
                            }
                        });
                    }
                    return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                        ...$7a6c101d54699cc6$var$normalizeShowDiffParams(params),
                        reveal: reveal,
                        action: 'SHOW_DIFF'
                    });
                },
            hideDiff: ({ tr: tr })=>{
                if (editorView) (0, $0b9c039f13e1bc64$export$80aac885ffed194c)(editorView);
                if ((0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                    steps: [],
                    stepAttributions: [],
                    contributors: undefined,
                    action: 'HIDE_DIFF'
                });
            },
            scrollToNext: ({ tr: tr })=>{
                return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                    action: 'SCROLL_TO_NEXT'
                });
            },
            scrollToPrevious: ({ tr: tr })=>{
                return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                    action: 'SCROLL_TO_PREVIOUS'
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'showDiffPlugin',
                    // Contributor tags draw themselves into their own decoration widgets — plain DOM, so
                    // no portal provider is needed here.
                    plugin: ({ getIntl: getIntl })=>(0, $c205fa97f273a3e1$export$ae829ec7b2625219)(config, getIntl, api, setEditorView)
                }
            ];
        },
        contentComponent: ()=>{
            if (!(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) return null;
            // Rendered here sharing decoration anchor span DOM context (tags mount separately).
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $018a8bbdd67e90a0$export$6b19438129810c85), {
                    api: api
                })
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false,
                activeIndex: undefined,
                ...(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                    diffDescriptors: []
                } : {}
            };
            const pluginState = (0, $c205fa97f273a3e1$export$cc8ba64700247b36).getState(editorState);
            const decorationCount = (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(pluginState?.decorations, editorState.doc);
            return {
                isDisplayingChanges: decorationCount.length > 0,
                activeIndex: pluginState?.activeIndex,
                numberOfChanges: decorationCount.length,
                ...(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                    contributorTags: pluginState?.contributorTags,
                    diffDescriptors: pluginState?.diffDescriptors,
                    showIndicators: pluginState?.showIndicators
                } : {}
            };
        }
    };
};
module.exports["showDiffPlugin"] = $7a6c101d54699cc6$export$b025b000fc343096;

});

parcelRegister("gE3l8", function(module, exports) {

var $2lPWP = parcelRequire("2lPWP");


var $iDrrr = parcelRequire("iDrrr");


var $eOaGc = parcelRequire("eOaGc");

function $48f674c8b0e12ae0$export$2b9c81e9e2c68dae(node1, node2) {
    if ((0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history')) {
        node1 = $48f674c8b0e12ae0$var$normalizeDocument(node1);
        node2 = $48f674c8b0e12ae0$var$normalizeDocument(node2);
    }
    if (node1.textContent !== node2.textContent) return false;
    const stripped1 = $48f674c8b0e12ae0$var$stripMarks(node1);
    const stripped2 = $48f674c8b0e12ae0$var$stripMarks(node2);
    return stripped1.nodeSize === stripped2.nodeSize && $48f674c8b0e12ae0$var$isBlockStructureEqual(stripped1, stripped2);
}
const $48f674c8b0e12ae0$var$transformers = new WeakMap();
function $48f674c8b0e12ae0$var$normalizeDocument(node) {
    const schema = node.type.schema;
    let transformer = $48f674c8b0e12ae0$var$transformers.get(schema);
    if (!transformer) {
        transformer = new (0, $2lPWP.JSONTransformer)(schema);
        $48f674c8b0e12ae0$var$transformers.set(schema, transformer);
    }
    return transformer.parse(transformer.encode(node));
}
function $48f674c8b0e12ae0$var$stripMarks(doc) {
    const tr = new (0, $eOaGc.Transform)(doc);
    tr.removeMark(0, doc.content.size);
    return tr.doc;
}
function $48f674c8b0e12ae0$var$isBlockStructureEqual(node1, node2) {
    if (node1.type !== node2.type || node1.childCount !== node2.childCount) return false;
    for(let index = 0; index < node1.childCount; index++){
        if (!$48f674c8b0e12ae0$var$isBlockStructureEqual(node1.child(index), node2.child(index))) return false;
    }
    return true;
}
module.exports["areDocsEqualByBlockStructureAndText"] = $48f674c8b0e12ae0$export$2b9c81e9e2c68dae;

});

parcelRegister("lLsh6", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");

function $7cbf39a0acc3c960$export$d1fcec696543b27b(view, targetPos) {
    const closestTable = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(view.state.doc.resolve(targetPos), view.state.schema.nodes.table);
    if (!closestTable) return undefined;
    const outermostTable = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(view.state.doc.resolve(closestTable.pos), view.state.schema.nodes.table) ?? closestTable;
    const firstRow = outermostTable.node.firstChild;
    let isHeaderRow = Boolean(firstRow && firstRow.childCount > 0);
    firstRow?.forEach((cell)=>{
        isHeaderRow && (isHeaderRow = cell.type === view.state.schema.nodes.tableHeader);
    });
    if (!isHeaderRow) return undefined;
    const firstRowDom = view.nodeDOM(outermostTable.pos + 1);
    if (!(firstRowDom instanceof HTMLTableRowElement)) return undefined;
    const headerRow = firstRowDom;
    const height = headerRow.getBoundingClientRect().height;
    return height > 0 && height <= window.innerHeight / 2 ? height : undefined;
}
module.exports["getStickyHeaderHeight"] = $7cbf39a0acc3c960$export$d1fcec696543b27b;

});

parcelRegister("7pyfy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2nOF5 = parcelRequire("2nOF5");


var $1KOhB = parcelRequire("1KOhB");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $dvybL = parcelRequire("dvybL");


var $krYZG = parcelRequire("krYZG");


var $6SJ6d = parcelRequire("6SJ6d");







function $ba9e453592b72692$export$a76b6d56e2272140(symptom, detectionLayer) {
    // ─── Parser-detected symptoms ────────────────────────────────────────
    // The streaming-JSON parser (in ai-model-io / ADFStreamer) is the
    // detector here, but the *cause* in every case is upstream — the model
    // produced output that the parser had to reject or repair. Detection
    // point ≠ ownership: we attribute to the backend.
    // Parser detecting malformed final ADF → backend generated bad output.
    // High confidence because the parser does not modify content — if the
    // final ADF is invalid, it's invalid as emitted by the model.
    if (detectionLayer === 'parser' && symptom === 'final_adf_invalid') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Parser had to repair JSON → backend streamed invalid JSON. Medium
    // confidence because some JSON-repair recoveries are triggered by
    // transport-level glitches (truncation, re-ordering) rather than true
    // model-output errors.
    if (detectionLayer === 'parser' && symptom === 'final_json_repaired') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // ─── Orchestrator-detected symptoms ──────────────────────────────────
    // The orchestrator is responsible for translating streamed ADF into
    // ProseMirror transactions and managing session lifecycle. Symptoms it
    // detects can split between frontend bugs (apply logic, lifecycle) and
    // backend bugs (the model emitted ADF that doesn't conform to the
    // schema or references a node that doesn't exist).
    // Orchestrator session lifecycle error → frontend issue. The session
    // machine itself is FE-owned; lifecycle errors are almost always our
    // bugs.
    if (detectionLayer === 'orchestrator' && symptom === 'session_lifecycle_error') return {
        attribution: 'frontend_apply_logic',
        confidence: 'high'
    };
    // Apply step failed with ProseMirror transaction error → FE apply
    // logic. The transaction was constructed by our code; if PM rejects
    // it, our construction is wrong.
    if (detectionLayer === 'orchestrator' && symptom === 'apply_failed_pm_error') return {
        attribution: 'frontend_apply_logic',
        confidence: 'high'
    };
    // Apply step failed because incoming ADF node had schema errors →
    // backend. The orchestrator only attempts to apply what the model
    // emitted; if the schema check fails, the model is at fault.
    if (detectionLayer === 'orchestrator' && symptom === 'apply_failed_adf_schema_error') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Target node not found → LLM hallucinated a localId. The orchestrator
    // looks up the target by the model-supplied localId; if no such node
    // exists in the doc, the model invented an identifier.
    if (detectionLayer === 'orchestrator' && symptom === 'local_id_not_found') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Node disappeared that wasn't the explicit target → frontend apply
    // side effect. Medium confidence because a poorly-formed transaction
    // can collateral-damage a sibling, but it could also be backend asking
    // for a structural change that we translated correctly into a
    // destructive transaction.
    if (detectionLayer === 'orchestrator' && symptom === 'unexpected_node_removal') return {
        attribution: 'frontend_apply_logic',
        confidence: 'medium'
    };
    // Tool call applied successfully but produced no document change.
    // Highest-likelihood cause is the model emitting content identical to
    // what already exists in the document (redundant generation). Medium
    // confidence rather than high because frontend apply-layer normalisation
    // can also silently collapse a transaction to a no-op (e.g. ProseMirror
    // merging adjacent identical text runs). A future refinement comparing
    // pre/post node-content hashes could upgrade this to high confidence
    // when the replacement content is byte-identical to the existing content.
    if (detectionLayer === 'orchestrator' && symptom === 'no_document_change') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // User / UI explicitly aborted the session. Origin is opaque to
    // telemetry (could be intentional cancel, navigation away, etc.) so we
    // can't confidently attribute the cause — only the fact of the abort
    // itself.
    if (detectionLayer === 'orchestrator' && symptom === 'session_aborted') return {
        attribution: 'unknown',
        confidence: 'high'
    };
    // Stream stalled: no further commands arrived within the orchestrator's
    // queue timeout. The most common cause is the backend halting its
    // stream (network slowness, model latency, or upstream error) so we
    // attribute to backend generation quality with medium confidence —
    // frontend bugs can also stall the stream, so this is not high
    // confidence.
    if (detectionLayer === 'orchestrator' && symptom === 'session_timeout') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // Post-apply analyzer detected a top-level node removed that no tool
    // call had explicitly targeted. When the analyzer used the precise
    // backend-supplied selection set we can confidently attribute to the
    // model. The proxy-fallback path (no backend selection) is handled at
    // the call site, where it returns unknown/low instead.
    if (detectionLayer === 'post_apply' && symptom === 'unexpected_content_removal') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Post-apply analyzer detected text content of a top-level node changed
    // that no tool call had explicitly targeted. Heuristic-driven (uses
    // character-count inequality with a `±1` ProseMirror normalisation
    // tolerance) so low-confidence — the caller is expected to also flag
    // the event with `experimental: true`. Same-length rewrites are silent
    // false negatives by design (out of scope for v1).
    if (detectionLayer === 'post_apply' && symptom === 'unintended_text_modification') return {
        attribution: 'unknown',
        confidence: 'low'
    };
    // Mutating tool calls ran but the document is effectively unchanged.
    // Highest-likelihood cause is a model that emitted commands targeting
    // the wrong node or producing no-op transactions; medium confidence
    // because frontend bugs (e.g. apply-layer no-op merges) can also
    // produce this signal.
    if (detectionLayer === 'post_apply' && symptom === 'no_meaningful_effect') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // Inferred intent doesn't match structural delta (e.g. APPEND intent
    // but net node removal). Heuristic-driven and so low-confidence — the
    // caller is expected to also flag the event with `experimental: true`.
    if (detectionLayer === 'post_apply' && symptom === 'semantic_mismatch') return {
        attribution: 'unknown',
        confidence: 'low'
    };
    // Default: unknown.
    return {
        attribution: 'unknown',
        confidence: 'low'
    };
}



var $1w4hj = parcelRequire("1w4hj");

const $a04a7145bc1aceaa$export$d4371db4dc3f8b5f = [
    'replaceDoc',
    'replaceNode',
    'removeNode',
    'removeNodes',
    'moveNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'appendNodeToEnd',
    'setAttrs',
    'wrap',
    'wrapNode',
    'appendNode'
];
 // #endregion


function $a7955f6a2f01a095$export$6bf900bab6a4720d(api) {
    let doc;
    // Quick and dirty way to get the doc
    api?.core.actions.execute(({ tr: tr })=>{
        doc = tr.doc;
        return null;
    });
    return doc;
}


function $e357a3431509036d$export$f85aff2979b590a7(command) {
    return [
        'replaceDoc',
        'replaceNode',
        'insertNodeBefore',
        'insertNodeAfter',
        'appendNode',
        'appendNodeToEnd'
    ].includes(command.type);
}














function $fa9ee0382ce8619d$export$1bd732ee2c8aaeb(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (nodeResult) return false;
        if (node.attrs.localId === localId) nodeResult = {
            node: node,
            pos: pos,
            parent: parent
        };
        return !nodeResult;
    });
    return nodeResult;
}
function $fa9ee0382ce8619d$export$a3fa3f6695d8b421(doc) {
    const ids = new Set();
    if (!doc) return ids;
    doc.descendants((node)=>{
        const localId = node.attrs?.localId;
        if (typeof localId === 'string' && localId.length > 0) ids.add(localId);
        return true;
    });
    return ids;
}
function $fa9ee0382ce8619d$export$c1cb5b5eb3aab3e3(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (node.attrs.localId === localId) {
            nodeResult = {
                node: node,
                pos: pos,
                parent: parent
            };
            return false;
        }
        return true;
    });
    return nodeResult;
}
function $fa9ee0382ce8619d$export$b7b4fc0a0195a016(api, localId) {
    if (!localId) return undefined;
    let foundNode;
    api?.core.actions.execute(({ tr: tr })=>{
        foundNode = $fa9ee0382ce8619d$export$1bd732ee2c8aaeb(tr.doc, localId)?.node;
        return null;
    });
    return foundNode;
}
function $fa9ee0382ce8619d$export$aadcc3ba2430b(api, tr, localId, callback, reversed) {
    const result = (reversed ? $fa9ee0382ce8619d$export$c1cb5b5eb3aab3e3 : $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(tr.doc, localId);
    if (result) {
        api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
        callback(result);
    }
    if (!result) {
        const localIdState = api?.localId?.sharedState.currentState();
        let localIdStatus;
        if (!localIdState) localIdStatus = 'localIdPluginMissing';
        else if (!localIdState.localIdWatchmenEnabled) localIdStatus = 'localIdWatchmenDisabled';
        else localIdStatus = localIdState.localIdStatus?.get(localId) ?? 'notFound';
        let docSize;
        // Quick and dirty way to get the node size - do not copy this pattern, use `requestDocument`
        api?.core.actions.execute(({ tr: tr })=>{
            docSize = tr.doc.nodeSize;
            return null;
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).LOCAL_ID_NOT_FOUND,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                localIdLength: localId?.length,
                docSize: docSize,
                scrubbedLocalId: (0, $dvybL.scrubStr)(localId),
                localIdStatus: (0, $iDrrr.fg)('platform_editor_ai_aifc_localid_error_reporting') ? localIdStatus : 'unavailable',
                localIdStatusSize: localIdState?.localIdStatus?.size ?? 0
            }
        });
        return null;
    }
    return tr;
}



var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

function $f2384266701dbede$export$7b6c9d9d26e2f428(api, response) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!schema || !response) return {
        adfDoc: response
    };
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $eOaGc.Transform)(doc);
        const node = (0, $aPdNQ.Node).fromJSON(schema, response);
        const newDoc = transform.replaceWith(0, 2, node).doc;
        return {
            doc: newDoc,
            // The "doc" response can cause nesting issues (ie. by wrapping a taskItem in doc -> taskList -> taskItem)
            // We should use the response, but for now only use it for `replaceNode` since it causes some edge cases with other commands
            // that need to be resolved separately
            adfDoc: response
        };
    } catch  {
        return {
            adfDoc: response
        };
    }
}


function $c9ae6183f2e7bf15$export$450b2ad108e2e506(api, initialNode, finalNode) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!initialNode || !finalNode || !schema || !initialNode.attrs.localId) return false;
    const finalPMDoc = (0, $f2384266701dbede$export$7b6c9d9d26e2f428)(api, finalNode)?.doc;
    if (!finalPMDoc) return false;
    const finalPMNode = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(finalPMDoc, initialNode.attrs.localId)?.node;
    return (finalPMNode && !initialNode.eq(finalPMNode) && (0, $6SJ6d.areNodesEqualIgnoreAttrs)(initialNode, finalPMNode)) ?? false;
}


function $800cd9937abd732b$export$6dcba6b9d3966cf9({ api: api, isCreateAction: isCreateAction, traceId: traceId, promptVersion: promptVersion }) {
    return (event)=>{
        const commonAttributes = {
            traceId: traceId,
            ...promptVersion && (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? {
                promptVersion: promptVersion
            } : {},
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: isCreateAction
            }
        };
        if (event.type === 'error') api?.analytics?.actions.fireAnalyticsEvent({
            action: 'error',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                ...commonAttributes,
                errorMessage: event.message,
                errorData: event.data
            }
        });
        else api?.analytics?.actions.fireAnalyticsEvent({
            action: 'info',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                ...commonAttributes,
                message: event.message,
                data: event.data
            }
        });
    };
}
function $800cd9937abd732b$export$7535a054b27a27c4({ api: api, initialNode: initialNode, lastDoc: lastDoc }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'replaceNodeAction',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'orchestratorReplaceNode',
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            attributeOnlyChange: (0, $c9ae6183f2e7bf15$export$450b2ad108e2e506)(api, initialNode, lastDoc),
            nodeName: initialNode?.type.name
        }
    });
}
// Validates the command is valid ()
const $800cd9937abd732b$var$validateCommandType = (cmd)=>cmd?.type && (0, $a04a7145bc1aceaa$export$d4371db4dc3f8b5f).includes(cmd.type) ? cmd.type : 'invalid';
function $800cd9937abd732b$export$276ecd5322451ab4({ api: api, docBeforeStreaming: docBeforeStreaming, command: command, traceId: traceId }) {
    const docAfterStreaming = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(api);
    if (docBeforeStreaming && docAfterStreaming) {
        const isSameDoc = docBeforeStreaming.eq(docAfterStreaming);
        const isSameDocIgnoreAttrs = (0, $6SJ6d.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming);
        if (isSameDoc || isSameDocIgnoreAttrs) api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).NO_DOC_CHANGE_FOUND,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                command: $800cd9937abd732b$var$validateCommandType(command),
                isSameDoc: isSameDoc,
                isSameDocIgnoreAttrs: isSameDocIgnoreAttrs,
                traceId: traceId
            }
        });
        // Attribution-first `toolCallAnomaly { symptom: 'no_document_change' }` for
        // streamable commands. The call site (streamCommandQueue) defers this call until
        // after handleFinalize's commit transaction lands (via an isStreaming subscription),
        // so by the time this runs, getPmDoc() reflects the committed doc.
        // isSameDoc is therefore accurate: true only when the stream genuinely produced
        // no structural change.
        //
        // The legacy NO_DOC_CHANGE_FOUND event above keeps the broader isSameDoc ||
        // isSameDocIgnoreAttrs check for dashboard continuity.
        if (command !== undefined && (0, $e357a3431509036d$export$f85aff2979b590a7)(command) && (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            // CCI-16980: For the toolCallAnomaly path we use a narrower comparator that
            // ignores only `localId` attributes. `replaceNode` always produces replacement
            // nodes with fresh localIds (CCI-16968 pattern), so `isSameDoc` alone would
            // miss genuine no-ops. However, the old `isSameDocIgnoreAttrs` was too broad
            // — it ignored ALL attributes including meaningful ones like heading `level`,
            // `panelType`, `background` etc., causing false positives when a replaceNode
            // intentionally changed only those attributes.
            //
            // `areNodesEqualIgnoreAttrs(…, ['localId'])` strips only localId before
            // comparing, so attribute-only changes to level/panelType/background etc. are
            // still detected as real edits and will NOT fire no_document_change.
            //
            // Short-circuit on isSameDoc: if docs are byte-for-byte identical the
            // localId-only traversal is redundant (isSameDoc ⊆ isSameDocIgnoreLocalIdsOnly).
            const isSameDocIgnoreLocalIdsOnly = isSameDoc || (0, $6SJ6d.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming, [
                'localId'
            ]);
            if (isSameDocIgnoreLocalIdsOnly) $800cd9937abd732b$export$4d196ad3126dbf0c({
                api: api,
                traceId: traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'no_document_change'
            });
            else $800cd9937abd732b$export$4d196ad3126dbf0c({
                api: api,
                traceId: traceId,
                commandType: command.type,
                result: 'success'
            });
        }
    }
}
function $800cd9937abd732b$export$8b7d4483ec260574({ api: api, sessionStarted: sessionStarted, endSessionCallCount: endSessionCallCount, lastEndedSessionId: lastEndedSessionId, isDoubleCall: isDoubleCall }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreamingEndSession',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            sessionStarted: sessionStarted,
            endSessionCallCount: endSessionCallCount,
            lastEndedSessionId: lastEndedSessionId,
            isDoubleCall: isDoubleCall
        }
    });
}
function $800cd9937abd732b$export$121949ee4a6ce5f6({ api: api, backendEndToPacerCompleteMs: backendEndToPacerCompleteMs, backlogCharsAtBackendEnd: backlogCharsAtBackendEnd, charsPerTickAtComplete: charsPerTickAtComplete, terminalType: terminalType, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'completed',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'streamFlowPacerCompletion',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            backendEndToPacerCompleteMs: backendEndToPacerCompleteMs,
            backlogCharsAtBackendEnd: backlogCharsAtBackendEnd,
            charsPerTickAtComplete: charsPerTickAtComplete,
            terminalType: terminalType,
            traceId: traceId
        }
    });
}
function $800cd9937abd732b$export$4b84cbb6abceadd2({ api: api, sessionId: sessionId, traceId: traceId, promptVersion: promptVersion }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionStart',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'userFlow',
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            aiGroupId: sessionId,
            actionTaken: undefined,
            editCount: 0,
            aiSessionId: '',
            traceIds: traceId ? [
                traceId
            ] : undefined,
            ...promptVersion && (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? {
                promptVersion: promptVersion
            } : {}
        }
    });
}
function $800cd9937abd732b$export$2197bcc2a00f4a51({ api: api, command: command, actionId: actionId, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'captured',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'toolCall',
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            actionId: actionId,
            commandType: $800cd9937abd732b$var$validateCommandType(command),
            contentType: 'contentType' in command ? command.contentType : undefined,
            traceId: traceId
        }
    });
}
function $800cd9937abd732b$export$f31b302ceb439402({ api: api, traceId: traceId, outcomeClass: outcomeClass, detectionLayer: detectionLayer, symptom: symptom, finalJsonInvalid: finalJsonInvalid, finalJsonRepaired: finalJsonRepaired, finalAdfInvalid: finalAdfInvalid, finalAdfRepaired: finalAdfRepaired, unintendedRegionRemoved: unintendedRegionRemoved, unintendedRegionModified: unintendedRegionModified, noMeaningfulEffect: noMeaningfulEffect, intentEffectMismatch: intentEffectMismatch, removedNodeCount: removedNodeCount, totalNodeDelta: totalNodeDelta, textCharacterDelta: textCharacterDelta, commandTypeCounts: commandTypeCounts, selectionLocalIdsAvailable: selectionLocalIdsAvailable, heuristicInferred: heuristicInferred }) {
    // When no symptom is reported (e.g. clean_success) the routing table
    // returns `unknown`/`low`, which is the correct contract value for "no
    // detectable failure to attribute".
    const { attribution: attribution, confidence: confidence } = (0, $ba9e453592b72692$export$a76b6d56e2272140)(symptom ?? '', detectionLayer);
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionOutcome',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            traceId: traceId,
            outcomeClass: outcomeClass,
            attribution: attribution,
            confidence: confidence,
            detectionLayer: detectionLayer,
            symptom: symptom,
            finalJsonInvalid: finalJsonInvalid,
            finalJsonRepaired: finalJsonRepaired,
            finalAdfInvalid: finalAdfInvalid,
            finalAdfRepaired: finalAdfRepaired,
            ...unintendedRegionRemoved !== undefined ? {
                unintendedRegionRemoved: unintendedRegionRemoved
            } : {},
            ...unintendedRegionModified !== undefined ? {
                unintendedRegionModified: unintendedRegionModified
            } : {},
            ...noMeaningfulEffect !== undefined ? {
                noMeaningfulEffect: noMeaningfulEffect
            } : {},
            ...intentEffectMismatch !== undefined ? {
                intentEffectMismatch: intentEffectMismatch
            } : {},
            ...removedNodeCount !== undefined ? {
                removedNodeCount: removedNodeCount
            } : {},
            ...totalNodeDelta !== undefined ? {
                totalNodeDelta: totalNodeDelta
            } : {},
            ...textCharacterDelta !== undefined ? {
                textCharacterDelta: textCharacterDelta
            } : {},
            ...commandTypeCounts !== undefined ? {
                commandTypeCounts: commandTypeCounts
            } : {},
            ...selectionLocalIdsAvailable !== undefined ? {
                selectionLocalIdsAvailable: selectionLocalIdsAvailable
            } : {},
            ...heuristicInferred !== undefined ? {
                heuristicInferred: heuristicInferred
            } : {}
        }
    });
}
function $800cd9937abd732b$export$c20b86820b0850bf({ api: api, command: command, traceId: traceId, isCreateAction: isCreateAction, error: error }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: 'toolCallError',
            errorData: {
                commandType: command?.type,
                commandReason: command?.type === 'endStream' ? command?.reason : undefined,
                errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
            },
            traceId: traceId,
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: isCreateAction ?? false
            }
        }
    });
}
function $800cd9937abd732b$export$4d196ad3126dbf0c(args) {
    const { api: api, traceId: traceId, commandType: commandType, result: result } = args;
    const symptom = args.result === 'anomaly' ? args.symptom : undefined;
    const errorMessage = args.result === 'anomaly' ? args.errorMessage : undefined;
    const targetLocalId = args.result === 'anomaly' ? args.targetLocalId : undefined;
    const removedLocalIds = args.result === 'anomaly' ? args.removedLocalIds : undefined;
    const routed = result === 'anomaly' && symptom !== undefined && symptom !== 'no_document_change' ? (0, $ba9e453592b72692$export$a76b6d56e2272140)(symptom, 'orchestrator') : undefined;
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'toolCallResult',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            result: result,
            commandType: commandType,
            detectionLayer: 'orchestrator',
            traceId: traceId,
            ...symptom !== undefined && {
                symptom: symptom
            },
            ...routed !== undefined && {
                attribution: routed.attribution,
                confidence: routed.confidence
            },
            ...errorMessage !== undefined && {
                errorMessage: errorMessage
            },
            ...targetLocalId !== undefined && {
                scrubbedTargetLocalId: (0, $dvybL.scrubStr)(targetLocalId)
            },
            ...removedLocalIds !== undefined && {
                scrubbedRemovedLocalIds: removedLocalIds.map((id)=>(0, $dvybL.scrubStr)(id))
            }
        }
    });
}
function $800cd9937abd732b$export$50f05d3d56fe90a9({ api: api, commandType: commandType }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'anomaly',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'resumeAbortedToolCallFallback',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            commandType: commandType
        }
    });
}



var $cXtTj = parcelRequire("cXtTj");


var $9kYSx = parcelRequire("9kYSx");

function $69782acbd729286a$var$isNumber(value) {
    return typeof value === 'number';
}
function $69782acbd729286a$var$isRamp(value) {
    if (typeof value !== 'object' || value === null) return false;
    const v = value;
    return $69782acbd729286a$var$isNumber(v.initialDelaySec) && $69782acbd729286a$var$isNumber(v.stepDelaySec) && $69782acbd729286a$var$isNumber(v.flushDelaySec) && $69782acbd729286a$var$isNumber(v.growthFactor);
}
function $69782acbd729286a$var$getExperimentValue(key, defaultValue) {
    return (0, $cXtTj.default).getExperimentValue('platform-editor-ai-streaming-speed', key, defaultValue, {
        typeGuard: $69782acbd729286a$var$isNumber
    });
}
function $69782acbd729286a$export$9ea8217d5ec56f82(enabled) {
    if (enabled === false) return null;
    const backlogRampThreshold = $69782acbd729286a$var$getExperimentValue('backlogRampThreshold', 100);
    const initialCharsPerTick = $69782acbd729286a$var$getExperimentValue('initialCharsPerTick', 8);
    const maxCharsPerTick = $69782acbd729286a$var$getExperimentValue('maxCharsPerTick', 1000);
    const tickMs = $69782acbd729286a$var$getExperimentValue('tickMs', 41);
    const ramp = (0, $cXtTj.default).getExperimentValue('platform-editor-ai-streaming-speed', 'ramp', {
        initialDelaySec: 6,
        stepDelaySec: 3,
        flushDelaySec: 0.5,
        growthFactor: 1.5
    }, {
        typeGuard: $69782acbd729286a$var$isRamp
    });
    // These settings are copied from the ai plugins pacer -> platform/packages/editor/editor-plugin-ai/src/ui/utils/request/stream-flow-pacer.ts
    return new (0, $9kYSx.StreamFlowPacer)({
        backlogRampThreshold: backlogRampThreshold,
        initialCharsPerTick: initialCharsPerTick,
        maxCharsPerTick: maxCharsPerTick,
        ramp: ramp,
        tickMs: tickMs
    });
}





var $iLrhi = parcelRequire("iLrhi");








var $aAERY = parcelRequire("aAERY");





var $hEuOY = parcelRequire("hEuOY");


var $j2p1x = parcelRequire("j2p1x");




const $5a1197e1a8fb1986$var$reset = '\x1b[0m';
const $5a1197e1a8fb1986$var$red = '\x1b[31m';
const $5a1197e1a8fb1986$var$magenta = '\x1b[35m';
const $5a1197e1a8fb1986$var$green = '\x1b[32m';
const $5a1197e1a8fb1986$var$blue = '\x1b[34m';
class $5a1197e1a8fb1986$export$21e6cc849c1dc1ab {
    add(log) {
        if ((0, $iDrrr.fg)('platform_editor_editor_debugging_panel')) {
            try {
                if (window.top?.__aifcDebuggerEnabled__) {
                    const { type: type, message: message } = log;
                    // eslint-disable-next-line no-console
                    console.log(`${$5a1197e1a8fb1986$var$magenta}[AIFC]:EditorStreamQueue${$5a1197e1a8fb1986$var$reset} ${type === 'Public' ? $5a1197e1a8fb1986$var$green : type === 'Queue' ? $5a1197e1a8fb1986$var$blue : $5a1197e1a8fb1986$var$red}${type}${$5a1197e1a8fb1986$var$reset} ${message}`, log);
                }
            } catch  {
            // Ignore cross-origin errors
            }
            this.logs.push({
                type: log.type,
                message: log.message,
                timestamp: log.timestamp
            });
            if (this.logs.length > this.MAX_LENGTH) this.logs.shift(); // Remove the oldest log to maintain a max log
        }
    }
    logPublic(message, data) {
        this.add({
            type: 'Public',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logError(message, data) {
        this.add({
            type: 'Error',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logQueueState(message, data) {
        this.add({
            type: 'Queue',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    // Current ADF at the time of logging so we can recreate the scenario
    getAdf() {
        if (!this.api) return undefined;
        let doc;
        this.api.core.actions.execute(({ tr: tr })=>{
            doc = tr.doc.toJSON();
            return null;
        });
        return doc;
    }
    getDebugInformation() {
        return {
            logs: this.logs,
            adf: this.getAdf(),
            selection: this.api?.selection?.actions.getSelectionFragment() ?? undefined,
            localIds: this.api?.selection?.actions.getSelectionLocalIds() ?? undefined
        };
    }
    constructor(api){
        this.api = api;
        this.logs = [];
        this.MAX_LENGTH = 100;
        if ((0, $iDrrr.fg)('platform_editor_editor_debugging_panel')) {
            if (window.top) try {
                window.top.__aifcEditorDebugData__ = ()=>this.getDebugInformation();
            } catch  {
            // Ignore cross-origin errors
            }
        }
    }
}



/**
 * Walk the document once and collect everything the analyzer needs:
 * `byLocalId` (top-level node text-length lookup), `totalNodesTopLevel`,
 * `totalNodesRecursive` (used by `noMeaningfulEffect`), `totalTextLength`,
 * and `attrFingerprints` (multiset for `attrSignaturesEqual`).
 */ function $ea65a4b3d3a11c9b$var$snapshotDoc(doc) {
    const byLocalId = new Map();
    // Multiset (fingerprint → count) — catches compositional swaps with
    // matching unique fingerprints but different multiplicities.
    const attrFingerprints = new Map();
    // nested localId → top-level localId, built during the existing walk.
    const nestedToTopLevel = new Map();
    let totalNodesTopLevel = 0;
    let totalNodesRecursive = 0;
    let totalTextLength = 0;
    const content = doc.content;
    if (!Array.isArray(content)) return {
        byLocalId: byLocalId,
        totalNodesTopLevel: totalNodesTopLevel,
        totalNodesRecursive: totalNodesRecursive,
        totalTextLength: totalTextLength,
        attrFingerprints: attrFingerprints,
        nestedToTopLevel: nestedToTopLevel
    };
    for (const child of content){
        if (child === null || typeof child !== 'object') continue;
        totalNodesTopLevel += 1;
        const node = child;
        const localId = typeof node.attrs?.localId === 'string' ? node.attrs.localId : undefined;
        const { textLength: textLength, descendantCount: descendantCount } = $ea65a4b3d3a11c9b$var$collectSubtreeMetrics(node, attrFingerprints, localId, nestedToTopLevel);
        // `descendantCount` includes the root node itself.
        totalNodesRecursive += descendantCount;
        totalTextLength += textLength;
        if (localId !== undefined) byLocalId.set(localId, {
            localId: localId,
            textLength: textLength
        });
    }
    return {
        byLocalId: byLocalId,
        totalNodesTopLevel: totalNodesTopLevel,
        totalNodesRecursive: totalNodesRecursive,
        totalTextLength: totalTextLength,
        attrFingerprints: attrFingerprints,
        nestedToTopLevel: nestedToTopLevel
    };
}
/**
 * True when `doc` is an "empty" starting document — a single top-level
 * empty paragraph (no child content) and nothing else.
 *
 * The editor seeds a brand-new / fully-cleared page with one placeholder
 * paragraph. That placeholder carries no `localId`, so it counts as an
 * unlabelled top-level node. When `appendNodeToEnd` (or any additive
 * command) writes labelled content into such a page, the apply layer drops
 * the now-redundant placeholder paragraph — a benign, expected side effect,
 * NOT content loss.
 *
 * The unlabelled-node removal accounting in `analyzeOutcome` would otherwise
 * see `postUnlabelledCount (0) < preUnlabelledCount (1)` and raise a
 * false-positive `unintendedRegionRemoved` / `unexpected_content_removal`.
 * See CCI-17328.
 */ function $ea65a4b3d3a11c9b$var$isEmptyStartingDocument(doc) {
    const content = doc.content;
    if (!Array.isArray(content) || content.length !== 1) return false;
    const only = content[0];
    if (only === null || typeof only !== 'object') return false;
    const node = only;
    if (node.type !== 'paragraph') return false;
    // Empty paragraph: missing or empty `content` array.
    return !Array.isArray(node.content) || node.content.length === 0;
}
/**
 * Attrs excluded from the per-node fingerprint: `localId` (regenerated on
 * every streaming insert) and any `__`-prefixed key (editor-internal / UI-only
 * state, e.g. `__expanded`, `__autoSize`).
 */ function $ea65a4b3d3a11c9b$var$isIgnoredAttr(key) {
    return key === 'localId' || key.startsWith('__');
}
/**
 * Stable string fingerprint of a node's identity: `type` + sorted filtered
 * `attrs` + sorted marks. Used by `attrSignaturesEqual`.
 */ function $ea65a4b3d3a11c9b$var$buildNodeAttrFingerprint(node) {
    const type = typeof node.type === 'string' ? node.type : '?';
    const attrs = node.attrs;
    let attrsPart = '';
    if (attrs !== null && typeof attrs === 'object') {
        const keys = Object.keys(attrs).filter((k)=>!$ea65a4b3d3a11c9b$var$isIgnoredAttr(k)).sort();
        if (keys.length > 0) {
            const pairs = [];
            for (const key of keys){
                const value = attrs[key];
                pairs.push(`${key}=${JSON.stringify(value)}`);
            }
            attrsPart = `|${pairs.join(',')}`;
        }
    }
    // Fold marks into the fingerprint (each mark contributes type + attrs).
    const marks = node.marks;
    let marksPart = '';
    if (Array.isArray(marks) && marks.length > 0) {
        const markStrings = [];
        for (const mark of marks)if (mark !== null && typeof mark === 'object') markStrings.push($ea65a4b3d3a11c9b$var$buildNodeAttrFingerprint(mark));
        markStrings.sort();
        marksPart = `|marks=${markStrings.join(';')}`;
    }
    return `${type}${attrsPart}${marksPart}`;
}
/**
 * Estimated displayed-text contribution of atomic inline nodes that store
 * their user-visible text in attributes rather than child `text` nodes.
 *
 * Without this accounting the analyzer's `textCharacterDelta` would view
 * a legitimate user-requested conversion (e.g. "Notion" → status lozenge
 * labelled "Notion") as a large negative delta and incorrectly flag the
 * session with `unintendedTextModification`. See CCI-16817.
 *
 * The values returned are intentionally a coarse estimate — the analyzer
 * only consumes them as a `±1` tolerance proxy for "this region's text
 * length changed meaningfully". Sub-character precision is not required.
 *
 * Per-type rationale:
 * - `status`      — `attrs.text` is the lozenge label (e.g. "Notion").
 * - `date`        — rendered as a localised date badge; we have no access
 *                   to the formatter, so use a fixed `10` character estimate
 *                   (matches common short-date renderings like
 *                   "Jan 1, 2024").
 * - `mention`     — `attrs.text` (e.g. "@John Doe"); falls back to `0` if
 *                   absent (mention text is optional in the schema).
 * - `emoji`       — `attrs.text` (the rendered glyph) when present;
 *                   otherwise `attrs.shortName` (e.g. ":smile:").
 * - `inlineCard`  — renders as a link. URL-based cards expose
 *                   `attrs.url`; datasource-based cards (e.g. Jira
 *                   issue inline smart links) expose `attrs.data`
 *                   instead. We prefer `attrs.url` length when
 *                   present, otherwise fall back to
 *                   `JSON.stringify(attrs.data).length` so datasource
 *                   cards also contribute a non-zero text estimate
 *                   and don't re-trigger the
 *                   `unintendedTextModification` false-positive this
 *                   analyzer change is fixing. If neither attr is
 *                   present (malformed / unknown shape) we fall back
 *                   to a fixed `10` char estimate, mirroring `date`.
 * - `placeholder` — `attrs.text` is the placeholder string.
 */ function $ea65a4b3d3a11c9b$var$getAtomicInlineNodeTextLength(type, attrs) {
    // `date`'s estimate is independent of attrs content — it must return
    // the fixed value even when attrs is absent or non-object. Handled
    // before the `attrs === undefined` guard so a malformed-ADF `date`
    // node (missing attrs) does not silently fall through to `0` and
    // re-trigger the very false positive this analyzer change is
    // fixing. Short-date renderings are typically ~10 chars
    // ("Jan 1, 2024"); the exact value isn't important — the goal is
    // to absorb the text-delta of the conversion, not to match what
    // the renderer ultimately displays.
    if (type === 'date') return 10;
    if (attrs === undefined) return 0;
    switch(type){
        case 'status':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        case 'mention':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        case 'emoji':
            {
                const text = attrs.text;
                if (typeof text === 'string' && text.length > 0) return text.length;
                const shortName = attrs.shortName;
                return typeof shortName === 'string' ? shortName.length : 0;
            }
        case 'inlineCard':
            {
                const url = attrs.url;
                if (typeof url === 'string' && url.length > 0) return url.length;
                // Datasource-based inline cards (e.g. Jira-issue inline
                // smart links) carry no `url` attr — their content lives
                // in `attrs.data`. Serialise it to JSON to get a coarse
                // non-zero estimate so a text-to-datasource-inlineCard
                // conversion doesn't reintroduce the very false positive
                // CCI-16817 is fixing. The exact length is unimportant —
                // the analyzer only needs a ±1-tolerance proxy.
                const data = attrs.data;
                if (data !== undefined && data !== null) try {
                    return JSON.stringify(data).length;
                } catch  {
                // Circular refs or unserialisable values fall
                // through to the fixed estimate below.
                }
                // Last-resort fixed estimate — matches the rationale used
                // for `date` (locale-rendered content with no plain text
                // in the ADF). Avoids returning 0 for malformed/unknown
                // inlineCard shapes that would otherwise re-trigger the
                // false positive.
                return 10;
            }
        case 'placeholder':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        default:
            return 0;
    }
}
/**
 * Single recursive walk: returns `textLength` + `descendantCount`,
 * accumulates fingerprints into the passed-in multiset, and — as a free
 * byproduct of the traversal — records every descendant node's `localId`
 * into `nestedToTopLevel` mapped to `topLevelLocalId`. O(N) per snapshot.
 *
 * `textLength` counts characters from both regular `text` nodes AND from
 * atomic inline nodes that store their displayed text in attributes
 * (e.g. `status.text`, `mention.text`). See `getAtomicInlineNodeTextLength`
 * for the per-type contribution and CCI-16817 for the rationale.
 *
 * `topLevelLocalId` is `undefined` for the top-level node itself (which is
 * the ancestor, not a descendant) and for top-level nodes that lack a
 * `localId` (unlabelled nodes can't be looked up anyway). Only descendants
 * of a labelled top-level node are added to the map.
 */ function $ea65a4b3d3a11c9b$var$collectSubtreeMetrics(node, attrFingerprints, topLevelLocalId, nestedToTopLevel) {
    if (node === null || typeof node !== 'object') return {
        textLength: 0,
        descendantCount: 0
    };
    const n = node;
    let textLength = 0;
    let descendantCount = 1; // this node + its descendants below
    if (n.type === 'text' && typeof n.text === 'string') textLength += n.text.length;
    else if (typeof n.type === 'string') {
        const attrs = n.attrs !== null && typeof n.attrs === 'object' ? n.attrs : undefined;
        textLength += $ea65a4b3d3a11c9b$var$getAtomicInlineNodeTextLength(n.type, attrs);
    }
    const fingerprint = $ea65a4b3d3a11c9b$var$buildNodeAttrFingerprint(n);
    attrFingerprints.set(fingerprint, (attrFingerprints.get(fingerprint) ?? 0) + 1);
    if (Array.isArray(n.content)) for (const child of n.content){
        // Record the child's localId → top-level ancestor before recursing.
        // We do this here (at the child level, not the node level) so that
        // the top-level node itself is never added as its own descendant.
        if (topLevelLocalId !== undefined && child !== null && typeof child === 'object') {
            const childNode = child;
            const childLocalId = typeof childNode.attrs?.localId === 'string' ? childNode.attrs.localId : undefined;
            if (childLocalId !== undefined) nestedToTopLevel.set(childLocalId, topLevelLocalId);
        }
        const childMetrics = $ea65a4b3d3a11c9b$var$collectSubtreeMetrics(child, attrFingerprints, topLevelLocalId, nestedToTopLevel);
        textLength += childMetrics.textLength;
        descendantCount += childMetrics.descendantCount;
    }
    return {
        textLength: textLength,
        descendantCount: descendantCount
    };
}
function $ea65a4b3d3a11c9b$export$6cc6bb4851b62689(toolCalls) {
    const ids = new Set();
    for (const record of toolCalls){
        if (record.targetLocalId !== undefined) ids.add(record.targetLocalId);
        if (Array.isArray(record.targetLocalIds)) for (const id of record.targetLocalIds)ids.add(id);
    }
    return ids;
}
function $ea65a4b3d3a11c9b$export$61c69a2d86d8e0fe(doc) {
    return $ea65a4b3d3a11c9b$var$snapshotDoc(doc).nestedToTopLevel;
}
const $ea65a4b3d3a11c9b$var$APPEND_INTENT_COMMANDS = new Set([
    'append',
    'appendNode',
    'appendNodeToEnd',
    'insertNodeAfter',
    'insertNodeBefore'
]);
const $ea65a4b3d3a11c9b$var$REWRITE_INTENT_COMMANDS = new Set([
    'replaceNode',
    'setAttrs',
    'wrap',
    'wrapNode'
]);
const $ea65a4b3d3a11c9b$var$REMOVE_INTENT_COMMANDS = new Set([
    'removeNode',
    'removeNodes',
    'moveNode'
]);
const $ea65a4b3d3a11c9b$export$55aaf9e829063b88 = 0.7;
function $ea65a4b3d3a11c9b$var$inferSessionIntent(toolCalls) {
    let hasAppend = false;
    let hasRewrite = false;
    let hasRemove = false;
    for (const call of toolCalls){
        if ($ea65a4b3d3a11c9b$var$APPEND_INTENT_COMMANDS.has(call.commandType)) hasAppend = true;
        else if ($ea65a4b3d3a11c9b$var$REWRITE_INTENT_COMMANDS.has(call.commandType)) hasRewrite = true;
        else if ($ea65a4b3d3a11c9b$var$REMOVE_INTENT_COMMANDS.has(call.commandType)) hasRemove = true;
    }
    const categoryCount = (hasAppend ? 1 : 0) + (hasRewrite ? 1 : 0) + (hasRemove ? 1 : 0);
    if (categoryCount !== 1) // Either zero recognised categories (no signal) or two-or-more
    // (genuinely mixed — heuristic too noisy to apply).
    return 'mixed';
    if (hasAppend) return 'append';
    if (hasRewrite) return 'rewrite';
    return 'remove';
}
/**
 * Decide whether the top-level structural delta contradicts the inferred
 * intent. Uses the **top-level** node delta (not recursive) because the
 * heuristic targets root-shape contradictions and its `±1` tolerance was
 * tuned to the top-level scale.
 *
 * Threshold rationale:
 * - `'append'`  — any net removal (`topLevelNodeDelta < 0`) is a mismatch.
 *                  Net delta of `0` is allowed: a `replaceNode`-shaped
 *                  command can produce zero delta even with append intent
 *                  (this case is rare but not a contradiction).
 * - `'rewrite'` — `|topLevelNodeDelta| ≥ 2` is a mismatch. The `±1` window
 *                  absorbs single trailing whitespace / newline / paragraph
 *                  normalisation that can shift the top-level count by 1
 *                  without indicating a real structural change.
 * - `'remove'`  — `topLevelNodeDelta ≥ 0` is a mismatch (the apply layer
 *                  didn't actually remove anything despite remove intent).
 */ /**
 * Returns true when the session's inferred intent contradicts the observed
 * structural delta — a heuristic signal that something unexpected happened.
 *
 * @param intent - Inferred from the mix of tool-call types in the session.
 * @param topLevelNodeDelta - post minus pre top-level node count.
 * @param totalNodeDelta - post minus pre recursive node count (CCI-16969 P1).
 * @param anyAffectedLocalIdDisappearedPostApply - true when a targeted top-level
 *   node is absent from the post-doc (CCI-16969 P2): a replaceNode that expands
 *   one container into many top-level nodes produces a large topLevelNodeDelta
 *   that is intentional, not anomalous.
 */ function $ea65a4b3d3a11c9b$var$detectIntentEffectMismatch(intent, topLevelNodeDelta, totalNodeDelta, anyAffectedLocalIdDisappearedPostApply) {
    switch(intent){
        case 'append':
            return topLevelNodeDelta < 0;
        case 'rewrite':
            // CCI-16969 P2: when the targeted node itself disappeared from the
            // post-doc, the expansion is intentional (e.g. bulletList → headed
            // sections, expand → inline content). Skip the topLevelDelta check.
            if (anyAffectedLocalIdDisappearedPostApply) return false;
            return Math.abs(topLevelNodeDelta) >= 2;
        case 'remove':
            // CCI-16969 P1: removeNodes targeting nested nodes (e.g. tableRows
            // inside a table) leaves topLevelNodeDelta at 0 even though content
            // was legitimately removed. Use recursive totalNodeDelta instead,
            // which correctly captures nested removals.
            return totalNodeDelta >= 0;
        case 'mixed':
        default:
            return false;
    }
}
function $ea65a4b3d3a11c9b$export$9aa9db1056f785bc({ preSessionAdf: preSessionAdf, postSessionAdf: postSessionAdf, toolCalls: toolCalls, selectionLocalIds: selectionLocalIds }) {
    const pre = $ea65a4b3d3a11c9b$var$snapshotDoc(preSessionAdf);
    const post = $ea65a4b3d3a11c9b$var$snapshotDoc(postSessionAdf);
    const affectedLocalIds = $ea65a4b3d3a11c9b$export$6cc6bb4851b62689(toolCalls);
    if (Array.isArray(selectionLocalIds)) for (const id of selectionLocalIds)affectedLocalIds.add(id);
    // For any targeted localId that belongs to a nested node
    // (e.g. a paragraph inside a table cell), also add the top-level
    // ancestor's localId to `affectedLocalIds`. Without this, the
    // modification-detection loop below flags the top-level container
    // (table, panel, expand, etc.) as "unintentionally modified" even
    // though the change was entirely within the tool call's intended target.
    //
    // `pre.nestedToTopLevel` is built as a free byproduct of the
    // `snapshotDoc` walk above — no additional document traversal.
    // Snapshot the set before iterating so that newly added ancestor IDs are
    // not re-examined. Mutating a Set during for-of is valid JS (new entries
    // ARE visited), but snapshotting makes the intent explicit and removes the
    // dependency on that spec detail.
    for (const targetId of [
        ...affectedLocalIds
    ]){
        const topLevelAncestorId = pre.nestedToTopLevel.get(targetId);
        if (topLevelAncestorId !== undefined) affectedLocalIds.add(topLevelAncestorId);
    }
    /**
   * True when at least one targeted localId is absent from the post-doc.
   *
   * This happens when `replaceNode` (or similar) creates replacement nodes
   * with fresh localIds — the targeted node has been genuinely replaced, not
   * silently dropped. Using this guard prevents two classes of false positives:
   *
   * - CCI-16968: `noMeaningfulEffect` fires because `totalNodeDelta === 0`
   *   and `|textCharacterDelta| <= 1`, even though real content was rewritten
   *   (the targeted node's content is now under a different localId).
   *
   * - CCI-16969 (P2): `intentEffectMismatch` fires for 'rewrite' intent when
   *   `|topLevelNodeDelta| >= 2` because one container was replaced by many
   *   top-level nodes (e.g. a bulletList expanded into headed sections). The
   *   large top-level delta is intentional — the targeted node is gone and new
   *   nodes took its place.
   *
   * Known limitation: `pre.byLocalId` contains only top-level nodes, so this
   * check does not fire when a `replaceNode` targets a nested node (e.g. a
   * paragraph inside a table cell) and produces fresh localIds. In practice
   * the other `noMeaningfulEffect` conditions (`|textCharacterDelta| <= 1`)
   * rarely hold simultaneously for nested rewrites, so the gap is low-impact.
   */ const anyAffectedLocalIdDisappearedPostApply = [
        ...affectedLocalIds
    ].some((id)=>pre.byLocalId.has(id) && !post.byLocalId.has(id));
    // CCI-16970: replaceDoc replaces the entire document with HTML-streamed
    // content that goes through an HTML→ADF parser, which always assigns fresh
    // localIds to every node. As a result:
    //   • All pre-session localIds disappear from the post-doc, regardless of
    //     how much content the model actually preserved.
    //   • `affectedLocalIds` is always empty for replaceDoc (it has no
    //     `targetLocalId`).
    // Running the localId-based removal loop below would therefore flag every
    // pre-doc node as "unintendedly removed" on every replaceDoc session —
    // a guaranteed false positive even when the model faithfully rewrote the
    // entire document.
    //
    // Instead, for replaceDoc sessions we skip the localId loops entirely and
    // use a proportional text-loss check: the model genuinely truncated the
    // document only when the post-doc retains less than 70% of the pre-doc
    // text length.
    //
    // Threshold validation: tested against 11 production examples —
    //   7 false positives all had ≥96% text retention (well above 70%)
    //   4 true positives all had ≤52% text retention (well below 70%)
    // A 70% threshold cleanly separates the two populations.
    const hasReplaceDoc = toolCalls.some((tc)=>tc.commandType === 'replaceDoc');
    let removedNodeCount = 0;
    let unintendedRegionRemoved = false;
    if (hasReplaceDoc) // Proportional text-loss check for replaceDoc sessions.
    // Only meaningful when the pre-doc had text to begin with; empty
    // documents are silently skipped to avoid division-by-zero edge cases.
    {
        if (pre.totalTextLength > 0 && post.totalTextLength < pre.totalTextLength * $ea65a4b3d3a11c9b$export$55aaf9e829063b88) {
            unintendedRegionRemoved = true;
            // Use the pre-doc top-level count so dashboards can see how many
            // nodes were effectively dropped (the post-doc nodes are all new).
            removedNodeCount = pre.totalNodesTopLevel;
        }
    } else {
        for (const [localId] of pre.byLocalId)if (!post.byLocalId.has(localId)) {
            removedNodeCount += 1;
            if (!affectedLocalIds.has(localId)) unintendedRegionRemoved = true;
        }
        // Account for unlabelled top-level nodes (no `localId` attr).
        // These can't be targeted by any tool call (every command keys off
        // `localId`), so a net drop in unlabelled-node count is by definition
        // unintended collateral damage. Tracking it here keeps
        // `removedNodeCount` consistent with `totalNodeDelta` and surfaces
        // the most clearly-anomalous removals on the `unintendedRegionRemoved`
        // flag.
        //
        // Known limitation: an equal-count swap (one unlabelled node removed
        // AND one unlabelled node added in the same session) is invisible to
        // this counter. Detecting it would require position/content matching,
        // which the analyzer intentionally avoids for cost reasons. Net delta
        // is sufficient for current dashboard needs.
        // Unlabelled-node accounting uses the top-level count: only top-level
        // nodes are keyed in `byLocalId`, so the comparison must be against
        // `totalNodesTopLevel` to keep the subtraction meaningful.
        const preUnlabelledCount = pre.totalNodesTopLevel - pre.byLocalId.size;
        const postUnlabelledCount = post.totalNodesTopLevel - post.byLocalId.size;
        // CCI-17328: appending labelled content to an empty starting document
        // (a single unlabelled placeholder paragraph) drops that placeholder.
        // That is a benign, expected removal — not content loss — so do not
        // count it towards `removedNodeCount` / `unintendedRegionRemoved`.
        const benignEmptyDocPlaceholderRemoval = $ea65a4b3d3a11c9b$var$isEmptyStartingDocument(preSessionAdf);
        if (postUnlabelledCount < preUnlabelledCount && !benignEmptyDocPlaceholderRemoval) {
            const unlabelledRemoved = preUnlabelledCount - postUnlabelledCount;
            removedNodeCount += unlabelledRemoved;
            unintendedRegionRemoved = true;
        }
    }
    // Modification detection uses total text-length inequality as a cheap
    // proxy for "this node's text changed". A `±1` character tolerance is
    // applied per node to absorb ProseMirror normalisation artefacts
    // (single trailing whitespace, newline, punctuation injection/strip
    // on block close) — same rationale as the session-wide
    // `noMeaningfulEffect` derivation. Same-length rewrites are still a
    // silent false negative — see the JSDoc on
    // `OutcomeAnalysis.unintendedRegionModified` for the known limitation.
    let unintendedRegionModified = false;
    for (const [localId, preRecord] of pre.byLocalId){
        const postRecord = post.byLocalId.get(localId);
        if (postRecord === undefined) continue;
        if (Math.abs(preRecord.textLength - postRecord.textLength) > 1 && !affectedLocalIds.has(localId)) {
            unintendedRegionModified = true;
            break;
        }
    }
    // Recursive count for `noMeaningfulEffect` — catches depth-only changes
    // (blank column added, empty rows removed, nested reorders). See CCI-16816.
    const totalNodeDelta = post.totalNodesRecursive - pre.totalNodesRecursive;
    // Top-level count for `intentEffectMismatch` — the heuristic's ±1
    // tolerance was tuned to top-level scale; recursive would be too noisy.
    const topLevelNodeDelta = post.totalNodesTopLevel - pre.totalNodesTopLevel;
    const intent = $ea65a4b3d3a11c9b$var$inferSessionIntent(toolCalls);
    const intentEffectMismatch = $ea65a4b3d3a11c9b$var$detectIntentEffectMismatch(intent, topLevelNodeDelta, totalNodeDelta, anyAffectedLocalIdDisappearedPostApply);
    // Multiset equality on per-node fingerprints. Catches attribute-only
    // changes and compositional swaps that node count + text length miss.
    let attrSignaturesEqual = pre.attrFingerprints.size === post.attrFingerprints.size;
    if (attrSignaturesEqual) {
        for (const [fingerprint, preCount] of pre.attrFingerprints)if (post.attrFingerprints.get(fingerprint) !== preCount) {
            attrSignaturesEqual = false;
            break;
        }
    }
    return {
        totalNodeDelta: totalNodeDelta,
        removedNodeCount: removedNodeCount,
        textCharacterDelta: post.totalTextLength - pre.totalTextLength,
        affectedLocalIds: affectedLocalIds,
        unintendedRegionModified: unintendedRegionModified,
        unintendedRegionRemoved: unintendedRegionRemoved,
        protectedContentRemoved: false,
        intentEffectMismatch: intentEffectMismatch,
        attrSignaturesEqual: attrSignaturesEqual,
        anyAffectedLocalIdDisappearedPostApply: anyAffectedLocalIdDisappearedPostApply
    };
}



var $kCECX = parcelRequire("kCECX");

const $ff56e6956d0962e2$export$47c18b0b568dba43 = (api, resume)=>{
    const live = api.aiExperience.actions.getAbortedToolCallPosition?.(resume.toolCallId);
    // The aborted tool call is being resumed now; drop its stored position so it
    // is not remapped again by subsequent resumes' transactions.
    api.aiExperience.actions.clearAbortedToolCallPosition?.(resume.toolCallId);
    if (live) return {
        fromPos: live.startPos,
        toPos: live.aiContentEndPos
    };
    return undefined;
};
const $ff56e6956d0962e2$export$b49478c44446ab49 = (api)=>(from, to)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            const docSize = tr.doc.content.size;
            const safeFrom = Math.max(0, Math.min(from, docSize));
            const safeTo = Math.max(safeFrom, Math.min(to, docSize));
            const selection = (0, $kCECX.TextSelection).create(tr.doc, safeFrom, safeTo);
            return tr.setSelection(selection).scrollIntoView();
        });
    };


/**
 * Classifies an error caught by the orchestrator's apply pipeline into one of
 * three normalized symptom strings, used by `fireToolCallApplyFailed` to drive
 * the shared `attributeError` routing table.
 *
 * The classification is intentionally conservative: definitive ProseMirror
 * `ReplaceError` instances and message-pattern-matched ADF schema validation
 * errors are routed to specific symptoms; anything ambiguous falls back to the
 * generic `apply_failed`, which routes to `unknown`/`low` so dashboards do not
 * incorrectly attribute fault to either layer.
 *
 * Pure function — no side effects, no logging, no external dependencies.
 */ /**
 * Patterns thrown by `prosemirror-model`'s `Node.fromJSON` /
 * `Mark.fromJSON` / `Fragment.fromJSON` when the incoming ADF describes a
 * node-type, mark-type, content-type, or shape that the local schema cannot
 * accept. These are caused by the *incoming* model output, not by the
 * orchestrator's apply logic — so they route to backend-quality attribution.
 *
 * See prosemirror-model/dist/index.cjs throw-sites for the canonical list.
 */ /* eslint-disable require-unicode-regexp -- The orchestrator's tsconfig
   targets ES5, which does not support the `u` flag in regex literals
   (TS1501). None of these patterns use Unicode-specific features, so
   the flag is not needed at runtime. */ const $47926c3fe91d7830$var$ADF_SCHEMA_ERROR_PATTERNS = [
    /^Invalid content for node type/,
    /^There is no (?:node|mark) type/,
    /^Invalid mark data for /,
    /^Empty text nodes are not allowed/,
    /^Invalid input for (?:Mark|Node|Fragment|Slice)\.fromJSON/,
    /^Invalid collection of marks for node /,
    /^Invalid text node in JSON/
];
/**
 * `RangeError` messages emitted by `prosemirror-model` and
 * `prosemirror-transform` from transaction-mechanics throw sites
 * (positions, replace/wrap/lift/join validation, slice resolution).
 *
 * Anything matching this list is a frontend apply-logic concern.
 *
 * Anything that is a `RangeError` but does NOT match either this list
 * OR the ADF schema list above is treated as ambiguous — native JS
 * also throws `RangeError` for non-PM reasons (e.g. "Maximum call
 * stack size exceeded", "Invalid array length", `Intl` constructor
 * failures, third-party libraries) and we deliberately route those
 * to `apply_failed` (`unknown`/`low`) so dashboards do not
 * misattribute them to either layer.
 */ const $47926c3fe91d7830$var$PM_TRANSACTION_ERROR_PATTERNS = [
    /^Position [0-9]+ out of range/,
    /^Inserted content deeper than insertion position/,
    /^Cannot (?:insert|replace|delete|wrap|join|split|lift|unwrap)/i,
    /^Selected node can't be replaced by content/,
    /can't (?:join|wrap|fit|lift|split)/i,
    /^Removing non-flat range/,
    /^Cannot find a valid cursor position/,
    /^Wrap (?:depth|range) /,
    /^Lifted range/,
    /^Tried to (?:lift|wrap|join|step)/,
    /^Step result has /,
    /^Invalid (?:position|step|content) for /
];
function $47926c3fe91d7830$export$e36a42623b7e8456(error) {
    if (!(error instanceof Error)) return {
        symptom: 'apply_failed'
    };
    // `ReplaceError` is exported by prosemirror-model and extends `Error`.
    // We match by `.name === 'ReplaceError'` rather than `instanceof` to
    // avoid a runtime dependency on prosemirror-model and to remain robust
    // across multiple loaded copies of the module.
    if (error.name === 'ReplaceError') return {
        symptom: 'apply_failed_pm_error'
    };
    if (error instanceof RangeError) {
        for (const pattern of $47926c3fe91d7830$var$ADF_SCHEMA_ERROR_PATTERNS){
            if (pattern.test(error.message)) return {
                symptom: 'apply_failed_adf_schema_error'
            };
        }
        for (const pattern of $47926c3fe91d7830$var$PM_TRANSACTION_ERROR_PATTERNS){
            if (pattern.test(error.message)) return {
                symptom: 'apply_failed_pm_error'
            };
        }
    // Unmatched `RangeError` — could be a JS-engine error (e.g.
    // "Maximum call stack size exceeded"), an `Intl`/Date/Number
    // validation throw, or a third-party library throw. Route to
    // `apply_failed` so dashboards stay conservative and do not
    // misattribute non-PM faults to the apply layer.
    }
    return {
        symptom: 'apply_failed'
    };
}



/**
 * The set of command types whose targeted subtree is genuinely
 * removed from the doc. For these, descendant `localId`s of the
 * target are also expected to disappear from the post-apply snapshot
 * and must be added to the exclusion set so they don't fire
 * `unexpected_node_removal` spuriously.
 *
 * Commands like `moveNode`, `wrap`, and `wrapNode` are deliberately
 * NOT in this set: they relocate/nest the targeted subtree but the
 * descendants remain in the doc. If a descendant of a moved or
 * wrapped node disappears, that IS a genuine anomaly worth surfacing
 * — so we leave it to `unexpected_node_removal` to fire.
 */ const $6718584366a375eb$var$COMMAND_TYPES_THAT_REMOVE_SUBTREE = new Set([
    'removeNode',
    'removeNodes',
    'replaceNode'
]);
function $6718584366a375eb$export$30ebe6cd1aac119d(command, preApplyDoc) {
    const ids = new Set();
    switch(command.type){
        case 'removeNode':
        case 'moveNode':
        case 'replaceNode':
            ids.add(command.localId);
            break;
        case 'removeNodes':
            for (const id of command.localIds)ids.add(id);
            break;
        case 'wrap':
        case 'wrapNode':
            ids.add(command.localId);
            break;
        default:
            break;
    }
    // Expand each direct target to include its descendant `localId`s
    // from the pre-apply doc, but ONLY for commands whose intent is to
    // remove the targeted subtree entirely. For moveNode/wrap/wrapNode
    // the subtree is preserved (relocated or nested), so its
    // descendants must still appear in the post-apply snapshot — if
    // they don't, that is a genuine anomaly we want to surface.
    if (preApplyDoc !== undefined && ids.size > 0 && $6718584366a375eb$var$COMMAND_TYPES_THAT_REMOVE_SUBTREE.has(command.type)) {
        // Snapshot the direct targets up-front because we're about to
        // mutate `ids` while iterating.
        const directTargets = Array.from(ids);
        for (const targetId of directTargets){
            const result = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(preApplyDoc, targetId);
            if (!result) continue;
            result.node.descendants((descendant)=>{
                const descendantLocalId = descendant.attrs?.localId;
                if (typeof descendantLocalId === 'string' && descendantLocalId.length > 0) ids.add(descendantLocalId);
                return true;
            });
        }
    }
    return ids;
}






function $9e7aabb2e4516310$export$c48ec1bf46060d54(commandsToProcess) {
    const mergedCommands = [];
    for (const command of commandsToProcess){
        const lastCommand = mergedCommands[mergedCommands.length - 1];
        // Check if we can merge the current command with the last one
        if (command.type === 'streamCommand' && lastCommand && lastCommand.type === 'streamCommand' && command.actionId === lastCommand.actionId) lastCommand.chunk = command.chunk;
        else // Otherwise, just push the command to mergedCommands
        mergedCommands.push(command);
    }
    return mergedCommands;
}


function $452730881cb932a3$export$6c44330c7facd24b(promise, options) {
    const { timeout: timeout, onTimeout: onTimeout, onCleanup: onCleanup } = options;
    let timeoutHandle;
    let timeoutResolve;
    let isCompleted = false;
    // Function to start/restart the timeout
    const resetTimeout = ()=>{
        if (isCompleted) return;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(()=>{
            if (!isCompleted) {
                onTimeout();
                timeoutResolve?.();
            }
        }, timeout);
    };
    const timeoutPromise = new Promise((resolve)=>{
        timeoutResolve = resolve;
    });
    resetTimeout();
    // Race the original promise against the timeout
    const wrappedPromise = Promise.race([
        promise,
        timeoutPromise
    ]).finally(()=>{
        isCompleted = true;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        onCleanup?.();
    });
    return {
        resetTimeout: resetTimeout,
        promise: wrappedPromise
    };
}



var $jTt8P = parcelRequire("jTt8P");

function $286950ef0f6e1392$export$ab173b3d1046c711(adfResponse, type, schema) {
    if (!adfResponse || type !== 'insertNodeAfter') return {
        updatedResponse: adfResponse,
        localId: undefined
    };
    const indexMap = [];
    let newLocalId = crypto.randomUUID();
    const depthToCheckAgainst = 0;
    // First pass just to get the node to update
    (0, $jTt8P.traverse)(adfResponse, {
        any: (_n, _p, index, depth)=>{
            if (depth === depthToCheckAgainst) indexMap.push(index);
        }
    });
    // Update the localId of the last node
    let localIdUpdated = false;
    const newAdfResponse = (0, $jTt8P.traverse)({
        ...adfResponse
    }, {
        any: (node, _p, index, depth)=>{
            if (depth === depthToCheckAgainst && indexMap[indexMap.length - 1] === index && !!schema?.nodes[node.type]?.spec?.attrs?.localId) {
                localIdUpdated = true;
                if (!!node?.attrs?.localId) newLocalId = node?.attrs?.localId;
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        localId: newLocalId
                    }
                };
            }
        }
    });
    return {
        updatedResponse: newAdfResponse ? newAdfResponse : adfResponse,
        localId: localIdUpdated ? newLocalId : undefined
    };
}








const $43211781682ae73a$export$9e6d85a71b01d30 = (api)=>()=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let selection;
            if ((0, $iLrhi.isEmptyDocument)(tr.doc)) selection = (0, $kCECX.Selection).atEnd(tr.doc);
            else {
                const $pos = tr.doc.resolve(tr.doc.content.size);
                tr.insert($pos.pos, tr.doc.type.schema.nodes.paragraph.create());
                selection = (0, $kCECX.TextSelection).create(tr.doc, $pos.pos + 1);
            }
            if (!selection) throw new Error('Failed to create selection');
            api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
            tr.setSelection(selection).scrollIntoView();
            return tr;
        });
    };






var $8HW7o = parcelRequire("8HW7o");


var $8Z43Z = parcelRequire("8Z43Z");


var $bAYhP = parcelRequire("bAYhP");


const $e7ae99ec7aab8b89$var$nodeNamesToSkipInsertParagraph = [
    'listItem',
    'taskItem',
    'decisionItem'
];
const $e7ae99ec7aab8b89$export$d4ccce03e5361e34 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node, parent: parent })=>{
                if (node.type.name === 'tableRow' && parent) {
                    const tableMap = (0, $8Z43Z.TableMap).get(parent);
                    const $pos = tr.doc.resolve(pos);
                    const tableStart = $pos.start($pos.depth);
                    const rect = tableMap.findCell(pos - tableStart + 1);
                    const tableContext = {
                        map: tableMap,
                        table: parent,
                        tableStart: tableStart
                    };
                    (0, $bAYhP.addRow)(tr, tableContext, rect.bottom);
                    const $newPos = tr.doc.resolve(pos);
                    const table = $newPos.node($newPos.depth);
                    const newTableMap = (0, $8Z43Z.TableMap).get(table);
                    // Not considering merged cells
                    const cells = newTableMap.mapByRow[rect.bottom];
                    const selection = (0, $8HW7o.CellSelection).rowSelection(tr.doc.resolve(cells[0] + tableStart), tr.doc.resolve(cells[cells.length - 1] + tableStart));
                    tr.setSelection(selection).scrollIntoView();
                } else if ($e7ae99ec7aab8b89$var$nodeNamesToSkipInsertParagraph.includes(node.type.name) && parent) {
                    /**
						 * Not creating new paragraph node when inserting node after list item.
						 * Because when inserting new list item, it will add new list item in new list.
						 */ const selection = (0, $kCECX.TextSelection).create(tr.doc, pos + node.nodeSize);
                    tr.setSelection(selection).scrollIntoView();
                } else {
                    let insertPos = Math.min(pos + node.nodeSize, tr.doc.content.size);
                    while(insertPos < tr.doc.content.size){
                        const $pos = tr.doc.resolve(insertPos);
                        let nextNode = null;
                        // For top-level nodes (depth 0 = document), check document children directly
                        // For nested nodes, use nodeAfter which works at higher depths
                        if ($pos.depth === 0) {
                            // At document root level, find the next top-level child
                            const childIndex = $pos.indexAfter(0);
                            if (childIndex < tr.doc.childCount) nextNode = tr.doc.child(childIndex);
                        } else // For nested structures, nodeAfter works correctly
                        nextNode = $pos.nodeAfter;
                        // Skip nodes without localId (from previous AI insertions)
                        // This prevents sequential insertions from overriding each other
                        if (nextNode && !nextNode.attrs.localId) insertPos += nextNode.nodeSize;
                        else break;
                    }
                    if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') insertPos--;
                    if (insertPos + 1 <= tr.doc.content.size) tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                    const selection = (0, $kCECX.TextSelection).create(tr.doc, Math.min(insertPos + 1, tr.doc.content.size));
                    tr.setSelection(selection).scrollIntoView();
                }
            }, // Inserting after should always look for the last node with a matching localid. This will ensure that we
            // always insert AFTER.
            true);
        });
    };






const $e260d991e2f29ec5$export$1226208ece997066 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos })=>{
                const selection = new (0, $kCECX.TextSelection)(tr.doc.resolve(pos));
                tr.setSelection(selection).scrollIntoView();
            });
        });
    };















var $4o0zT = parcelRequire("4o0zT");


const $fdf8819bcf43bc0d$var$doesNodeContain = ({ start: start, nodeSize: nodeSize }, pos)=>pos > start && pos < start + nodeSize;
const $fdf8819bcf43bc0d$var$unsupportedTableStructureNodeTypes = new Set([
    'tableRow',
    'tableCell',
    'tableHeader'
]);
const $fdf8819bcf43bc0d$var$isUnsupportedTableStructureNode = (nodeTypeName)=>$fdf8819bcf43bc0d$var$unsupportedTableStructureNodeTypes.has(nodeTypeName);
const $fdf8819bcf43bc0d$var$isValidRelationship = (relationship)=>relationship === 'before' || relationship === 'after';
const $fdf8819bcf43bc0d$var$getFragmentTypes = (node)=>node.content.content.map((child)=>child.type.name);
const $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics = ({ api: api, reason: reason, sourceNodeType: sourceNodeType, anchorNodeType: anchorNodeType, sourceParentNodeType: sourceParentNodeType, destinationParentNodeType: destinationParentNodeType, parentNodeType: parentNodeType, fragments: fragments })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).INVALID_COMMAND_FOUND,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            success: false,
            repaired: false,
            errorMessage: 'moveNodeValidationFailed',
            validationReason: reason,
            sourceNodeType: sourceNodeType,
            anchorNodeType: anchorNodeType,
            sourceParentNodeType: sourceParentNodeType,
            destinationParentNodeType: destinationParentNodeType,
            parentNodeType: parentNodeType,
            fragments: fragments
        }
    });
};
const $fdf8819bcf43bc0d$export$731ead7592859425 = (api)=>(command)=>{
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_move_node')) return false;
        return api.core.actions.execute(({ tr: tr })=>{
            const reportMissingLocalId = (localId)=>{
                // `findNodeByLocalId` owns the existing LOCAL_ID_NOT_FOUND analytics payload,
                // so we intentionally re-run it on miss even though we already did a pure lookup.
                (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, localId, ()=>{});
            };
            const nodeToMove = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(tr.doc, command.localId);
            if (!nodeToMove) {
                reportMissingLocalId(command.localId);
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'sourceNotFound'
                });
                return null;
            }
            const anchorNode = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(tr.doc, command.anchorLocalId);
            if (!anchorNode) {
                reportMissingLocalId(command.anchorLocalId);
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'anchorNotFound',
                    sourceNodeType: nodeToMove.node.type.name
                });
                return null;
            }
            if (command.localId === command.anchorLocalId) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'sameNode',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if (!$fdf8819bcf43bc0d$var$isValidRelationship(command.relationship)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidRelationship',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if ($fdf8819bcf43bc0d$var$isUnsupportedTableStructureNode(nodeToMove.node.type.name) || $fdf8819bcf43bc0d$var$isUnsupportedTableStructureNode(anchorNode.node.type.name)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'unsupportedTableStructure',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if ($fdf8819bcf43bc0d$var$doesNodeContain({
                start: nodeToMove.pos,
                nodeSize: nodeToMove.node.nodeSize
            }, anchorNode.pos)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'anchorInsideSource',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            const $sourcePos = tr.doc.resolve(nodeToMove.pos);
            const sourceIndex = $sourcePos.index();
            if (!$sourcePos.parent.canReplace(sourceIndex, sourceIndex + 1, (0, $aPdNQ.Fragment).empty)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidSourceParent',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name,
                    sourceParentNodeType: $sourcePos.parent.type.name,
                    parentNodeType: $sourcePos.parent.type.name
                });
                return null;
            }
            const slice = tr.doc.slice(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize, false);
            const insertPos = command.relationship === 'before' ? anchorNode.pos : anchorNode.pos + anchorNode.node.nodeSize;
            const validationTransform = new (0, $eOaGc.Transform)(tr.doc);
            validationTransform.delete(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize);
            const mappedInsertPos = validationTransform.mapping.map(insertPos);
            const $mappedInsertPos = validationTransform.doc.resolve(mappedInsertPos);
            const insertIndex = $mappedInsertPos.index();
            if (!$mappedInsertPos.parent.canReplace(insertIndex, insertIndex, slice.content)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidDestination',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name,
                    destinationParentNodeType: $mappedInsertPos.parent.type.name,
                    parentNodeType: $mappedInsertPos.parent.type.name,
                    fragments: $fdf8819bcf43bc0d$var$getFragmentTypes(slice.content.firstChild ?? nodeToMove.node)
                });
                return null;
            }
            api.aiExperience?.actions.tagAsAIStreamingTransformation(tr, {
                isFinal: true
            });
            // [CCI-17297] Capture the moved node so we can record reviewable
            // segments. move is non-streamable: it mutates the doc directly here and
            // never reaches `buildCommitTransaction`. A move is modelled as a
            // "remove" at the source (zero-width after deletion) plus an "add" at the
            // destination. No-op when the New AIFC experience is OFF.
            const movedSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodeToMove.node), 0, 0);
            const sourceFrom = tr.mapping.map(nodeToMove.pos);
            tr.delete(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize);
            const appliedInsertPos = tr.mapping.map(insertPos);
            tr.replace(appliedInsertPos, appliedInsertPos, slice);
            const collapsedSource = tr.mapping.map(sourceFrom);
            api.aiExperience?.actions.recordAIContentSegments(tr, [
                {
                    startPos: collapsedSource,
                    endPos: collapsedSource,
                    originalUserContentSlice: movedSlice,
                    newSlice: (0, $aPdNQ.Slice).empty,
                    kind: 'remove'
                },
                {
                    startPos: appliedInsertPos,
                    endPos: appliedInsertPos + slice.size,
                    originalUserContentSlice: (0, $aPdNQ.Slice).empty,
                    newSlice: movedSlice,
                    kind: 'add'
                }
            ]);
            if ((0, $kCECX.NodeSelection).isSelectable(nodeToMove.node)) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, appliedInsertPos));
            else tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(appliedInsertPos)));
            tr.scrollIntoView();
            api.aiExperience?.actions.stampAgentEditChrome(tr);
            return tr;
        });
    };






const $1e600f514eaf34c7$export$9a6ccf2338830d60 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
                // Record a coarse "remove" segment so the Post Stream
                // Review modal can review / undo / redo this deletion. removeNode is
                // non-streamable: it mutates the doc directly here and never reaches
                // `buildCommitTransaction`, so we must record the segment ourselves.
                // The removed node becomes `originalUserContentSlice`; the segment
                // collapses to a zero-width range at the deletion point (`newSlice`
                // is empty). `recordAIContentSegments` is a no-op when the New AIFC
                // experience is OFF.
                const removedSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(node), 0, 0);
                tr.delete(pos, pos + node.nodeSize).scrollIntoView();
                // Map the original position through the delete step to get the
                // collapsed (zero-width) position at the deletion point.
                const collapsedPos = tr.mapping.map(pos);
                api.aiExperience.actions.recordAIContentSegments(tr, [
                    {
                        startPos: collapsedPos,
                        endPos: collapsedPos,
                        originalUserContentSlice: removedSlice,
                        newSlice: (0, $aPdNQ.Slice).empty,
                        kind: 'remove'
                    }
                ]);
                api.aiExperience.actions.stampAgentEditChrome(tr);
            });
        });
    };



const $c1ee154d5cff80f2$export$b932a8906dc70a6a = (api)=>(command)=>{
        const removeNode = (0, $1e600f514eaf34c7$export$9a6ccf2338830d60)(api);
        for (const localId of command.localIds)removeNode({
            type: 'removeNode',
            localId: localId
        });
        return true;
    };









const $e92a5a98bc795abf$export$8077407ea1dae01f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node })=>{
                // Record the exact located node so `buildMountTransaction` can rebuild
                // an accurate single-node `originalUserContentSlice`. Slicing the doc
                // range can return a different shape (e.g. listItem children of a
                // bulletList). The optional call on `recordOriginalNode` itself makes
                // this a no-op when the new AIFC experience gate is off or the action
                // is not present on the resolved AI experience API.
                api.aiExperience?.actions.recordOriginalNode?.(tr, node);
                let selection = null;
                if ((0, $kCECX.NodeSelection).isSelectable(node)) selection = (0, $kCECX.NodeSelection).create(tr.doc, pos);
                else {
                    const role = node.type.spec.tableRole;
                    if (role === 'cell' || role === 'header_cell') selection = (0, $8HW7o.CellSelection).create(tr.doc, pos);
                    else if (role === 'row') {
                        // There's always a cell after the row
                        const $cell = tr.doc.resolve(pos + 1);
                        selection = (0, $8HW7o.CellSelection).rowSelection($cell, $cell, true);
                    } else {
                        const $pos = tr.doc.resolve(pos);
                        const $end = tr.doc.resolve(pos + node.nodeSize);
                        selection = (0, $kCECX.TextSelection).between($pos, $end);
                    }
                }
                if (selection) tr.setSelection(selection).scrollIntoView();
            });
        });
    };








const $bb185a965101a71b$export$4e08a85ccc8f26d0 = (api)=>(_command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            if ((0, $iDrrr.fg)('platform_editor_ai_replace_doc_use_all_selection')) return tr.setSelection(new (0, $kCECX.AllSelection)(tr.doc)).scrollIntoView();
            const $start = tr.doc.resolve(0);
            const $end = tr.doc.resolve(tr.doc.content.size);
            return tr.setSelection((0, $kCECX.TextSelection).between($start, $end)).scrollIntoView();
        });
    };









const $88130d0c8e66d82d$var$getValidAttributes = (attrs, nodeSpec)=>{
    const validAttrs = {};
    for(const key in attrs)if (nodeSpec.attrs?.hasOwnProperty(key)) validAttrs[key] = attrs[key];
    return validAttrs;
};
const $88130d0c8e66d82d$export$3c4e918a3d6ca42f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let shouldExecute = false;
            (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                if (node) {
                    const attrs = command.attrs;
                    if (!attrs || typeof attrs !== 'object') return;
                    const validAttrs = $88130d0c8e66d82d$var$getValidAttributes(attrs, node.type.spec);
                    node.type.spec.attrs;
                    api.aiExperience?.actions.tagAsAIStreamingTransformation(tr, {
                        isFinal: true
                    });
                    // [CCI-17297] Capture the node BEFORE the attr change as the
                    // segment's original content; setAttrs is non-streamable so we
                    // record the reviewable "update" segment ourselves.
                    const originalSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(node), 0, 0);
                    const from = tr.mapping.map(pos);
                    tr.setNodeMarkup(pos, node.type, {
                        ...node.attrs,
                        ...validAttrs
                    });
                    tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(pos)));
                    // Capture the node AFTER the attr change as the new content and
                    // record a coarse "update" segment spanning it. No-op when the
                    // New AIFC experience is OFF.
                    const mappedFrom = tr.mapping.map(from);
                    const updatedNode = tr.doc.nodeAt(mappedFrom);
                    if (updatedNode) api.aiExperience?.actions.recordAIContentSegments(tr, [
                        {
                            startPos: mappedFrom,
                            endPos: mappedFrom + updatedNode.nodeSize,
                            originalUserContentSlice: originalSlice,
                            newSlice: new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(updatedNode), 0, 0),
                            kind: 'update'
                        }
                    ]);
                    shouldExecute = true;
                }
            });
            if (shouldExecute) api.aiExperience?.actions.stampAgentEditChrome(tr);
            return shouldExecute ? tr : null;
        });
    };



var $8hfTK = parcelRequire("8hfTK");


var $yQ01u = parcelRequire("yQ01u");





var $57Rmq = parcelRequire("57Rmq");














const $fa8ab6765ce29d9d$var$panelTypes = new (0, $8hfTK.default)((0, $yQ01u.panel).props.attrs.props.panelType.values);
function $fa8ab6765ce29d9d$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $fa8ab6765ce29d9d$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
function $fa8ab6765ce29d9d$var$getAncestorTypes($to) {
    const ancestors = [];
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        ancestors.push(ancestor.type.name);
    }
    return ancestors;
}
function $fa8ab6765ce29d9d$var$getChildTypes(fragment) {
    return fragment.content.map((node)=>node.type.name);
}
const $fa8ab6765ce29d9d$export$2c6212a0adabc271 = (api)=>(command)=>{
        let success = false;
        let error;
        let repaired = false;
        let ancestors = [];
        let fragments = [];
        api.core.actions.execute(({ tr: tr })=>{
            try {
                (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                    const $from = tr.doc.resolve(pos);
                    const $to = tr.doc.resolve(pos + node.nodeSize);
                    const range = $from.blockRange($to);
                    if (range) {
                        // [CCI-17297] Capture the pre-wrap content so we can record a
                        // reviewable "update" segment. wrap is non-streamable: it mutates
                        // the doc directly here and never reaches `buildCommitTransaction`.
                        const originalSlice = new (0, $aPdNQ.Slice)(tr.doc.slice(range.$from.pos, range.$to.pos).content, 0, 0);
                        const wrapFrom = tr.mapping.map(range.$from.pos);
                        const type = command.wrapperType === 'panel' && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.pickPanelTypeForInsertion)(range.$from) : tr.doc.type.schema.nodes[command.wrapperType];
                        const attrs = command.wrapperAttrs;
                        // TODO: EDITOR-1371 - Validate attributes for all nodes
                        if (command.wrapperType === 'panel' && attrs.panelType !== undefined) {
                            const panelType = command.wrapperAttrs.panelType;
                            const panelTypeResult = $fa8ab6765ce29d9d$var$panelTypes.search(panelType);
                            if (panelTypeResult.length) attrs.panelType = panelTypeResult[0].item;
                            else attrs.panelType = 'info';
                        }
                        try {
                            // NOTE: `wrapping` will be empty ([]) when it fits directly
                            const wrapping = (0, $eOaGc.findWrapping)(range, type, attrs);
                            if (wrapping !== null) {
                                tr.wrap(range, wrapping).scrollIntoView();
                                success = true;
                            } else {
                                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                                const fragment = slice.content;
                                let node = type.createAndFill(attrs, fragment);
                                if (!node) node = $fa8ab6765ce29d9d$var$wrapChild(fragment, type, attrs);
                                if (node) {
                                    const insertPos = $fa8ab6765ce29d9d$var$findPosForNode(node, $to);
                                    if (insertPos !== null) {
                                        tr.insert(insertPos, node).scrollIntoView();
                                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $aPdNQ.Slice).empty);
                                        success = true;
                                        repaired = true;
                                    }
                                }
                                ancestors = $fa8ab6765ce29d9d$var$getAncestorTypes($to);
                                fragments = $fa8ab6765ce29d9d$var$getChildTypes(fragment);
                            }
                        } catch (e) {
                            error = e;
                            // TODO: EDITOR-1370 - Log the error
                            // eslint-disable-next-line no-console
                            console.error(e);
                        }
                        // [CCI-17297] Record a reviewable "update" segment for the wrap.
                        // After a successful wrap the new wrapper node sits at `wrapFrom`;
                        // the segment's original content is the pre-wrap slice captured
                        // above. No-op when the New AIFC experience is OFF.
                        if (success) {
                            const mappedWrapFrom = tr.mapping.map(wrapFrom);
                            const wrappedNode = tr.doc.nodeAt(mappedWrapFrom);
                            if (wrappedNode) api.aiExperience.actions.recordAIContentSegments(tr, [
                                {
                                    startPos: mappedWrapFrom,
                                    endPos: mappedWrapFrom + wrappedNode.nodeSize,
                                    originalUserContentSlice: originalSlice,
                                    newSlice: new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(wrappedNode), 0, 0),
                                    kind: 'update'
                                }
                            ]);
                        }
                    }
                });
                api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
            } catch (e) {
                error = e;
                // TODO: EDITOR-1370 - Log the error
                // eslint-disable-next-line no-console
                console.error(e);
            }
            if (success) api.aiExperience?.actions.stampAgentEditChrome(tr);
            return tr;
        });
        if (!success || repaired) {
            // Log the error
            const errorMessage = (0, $1w4hj.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) errorStack = error.stack || '';
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).INVALID_COMMAND_FOUND,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    success: // Disable for now #hot-122604
                    // command,
                    success,
                    repaired: repaired,
                    ancestors: ancestors,
                    fragments: fragments,
                    errorMessage: errorMessage,
                    errorStack: errorStack
                }
            });
        }
        return success;
    };


function $33e0a97ce57d98ef$export$a0774277976bc21f(api) {
    return {
        replaceDoc: (0, $bb185a965101a71b$export$4e08a85ccc8f26d0)(api),
        replaceNode: (0, $e92a5a98bc795abf$export$8077407ea1dae01f)(api),
        insertNodeBefore: (0, $e260d991e2f29ec5$export$1226208ece997066)(api),
        insertNodeAfter: (0, $e7ae99ec7aab8b89$export$d4ccce03e5361e34)(api),
        removeNode: (0, $1e600f514eaf34c7$export$9a6ccf2338830d60)(api),
        removeNodes: (0, $c1ee154d5cff80f2$export$b932a8906dc70a6a)(api),
        moveNode: (0, $fdf8819bcf43bc0d$export$731ead7592859425)(api),
        appendNode: (0, $43211781682ae73a$export$9e6d85a71b01d30)(api),
        appendNodeToEnd: (0, $43211781682ae73a$export$9e6d85a71b01d30)(api),
        wrap: (0, $fa8ab6765ce29d9d$export$2c6212a0adabc271)(api),
        wrapNode: (0, $fa8ab6765ce29d9d$export$2c6212a0adabc271)(api),
        setAttrs: (0, $88130d0c8e66d82d$export$3c4e918a3d6ca42f)(api)
    };
}


/**
 * Returns the wire-name of the streaming command associated with a failed
 * apply attempt, suitable for the `commandType` attribute on
 * `tool_call_apply_failed` events.
 *
 * Prefers the active `StreamingCommand` (e.g. `'replaceNode'`,
 * `'appendNodeToEnd'`) when available, falling back to the queue-level
 * discriminant (`'streamCommand'`, `'endStream'`, `'initStream'`) and finally
 * to `'unknown'`.
 */ function $e3512170c06603fc$var$extractCommandType(queuedCommand, activeCommand) {
    if (queuedCommand?.type === 'initStream') return queuedCommand.command.type;
    if (activeCommand?.type) return activeCommand.type;
    return queuedCommand?.type ?? 'unknown';
}
/**
 * Returns the `localId` of the node targeted by a failed apply attempt, if
 * one can be derived from the active command. Returns `undefined` for
 * commands that operate without a target node (e.g. `appendNodeToEnd`,
 * `getPageContent`) or when no command is in flight.
 */ function $e3512170c06603fc$var$extractTargetLocalId(queuedCommand, activeCommand) {
    const command = queuedCommand?.type === 'initStream' ? queuedCommand.command : activeCommand;
    if (command && 'localId' in command && typeof command.localId === 'string') return command.localId;
    return undefined;
}
/**
 * Command types whose execution mutates the document. Used by the post-apply
 * outcome analyzer to decide whether `noMeaningfulEffect` should fire — a
 * session that ran nothing but read-only commands cannot be flagged for "no
 * meaningful effect" because no effect was ever requested.
 */ const $e3512170c06603fc$var$MUTATING_COMMAND_TYPES = new Set([
    'append',
    'appendNode',
    'appendNodeToEnd',
    'replaceNode',
    'removeNode',
    'removeNodes',
    'setAttrs',
    'wrap',
    'wrapNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'moveNode'
]);
function $e3512170c06603fc$var$resolveApplyMode(options) {
    return options?.applyMode ?? 'stream';
}
/**
 * Returns the `localId` field for a streaming command that targets a
 * single existing node, or `undefined` for commands without one
 * (`appendNode`, `appendNodeToEnd`) or whose target uses a different
 * shape (`removeNodes` uses `localIds[]` plural, not a single `localId`).
 *
 * Used by the pre-apply target-resolution check so we only fire
 * `local_id_not_found` when the command actually expected a node
 * by ID.
 */ function $e3512170c06603fc$var$getTargetLocalId(command) {
    if ('localId' in command && typeof command.localId === 'string') return command.localId;
    return undefined;
}
/**
 * Convert a `StreamingCommand` into the condensed `ToolCallRecord` shape
 * consumed by `analyzeOutcome`. Captures the command type and any localId
 * targets (single or list-shaped). Used to build the per-session tool-call
 * record so the analyzer can distinguish intentional removals/modifications
 * from collateral damage.
 */ function $e3512170c06603fc$var$toToolCallRecord(command) {
    const targetLocalId = $e3512170c06603fc$var$getTargetLocalId(command);
    const targetLocalIds = 'localIds' in command && Array.isArray(command.localIds) ? command.localIds.filter((id)=>typeof id === 'string') : undefined;
    return {
        commandType: command.type,
        ...targetLocalId !== undefined ? {
            targetLocalId: targetLocalId
        } : {},
        ...targetLocalIds !== undefined && targetLocalIds.length > 0 ? {
            targetLocalIds: targetLocalIds
        } : {}
    };
}
class $e3512170c06603fc$export$f3feb8728b17a0a9 {
    isActorReady() {
        try {
            const currentState = this.api.aiExperience.sharedState.currentState();
            if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
                // Check if actor exists and is in streaming state
                const actor = this.api.aiExperience.actions.getAiExperienceActor();
                return actor && currentState?.isStreaming === true;
            }
            return currentState?.isStreaming === true;
        } catch  {
            return false;
        }
    }
    commandToProcess(commandToProcess) {
        const { type: type, actionId: actionId, chunk: chunk } = commandToProcess;
        if (type === 'initStream') return this.initStreamPromise(commandToProcess.command, commandToProcess.options);
        else if (type === 'endStream') return this.endExperiencePromise(commandToProcess);
        else return this.processStreamCommandPromise(actionId, chunk);
    }
    async processQueue() {
        if (this.processingQueue) return;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.processingQueue = true;
        let commandsToProcess = [
            ...this.queue
        ].filter((cmd)=>cmd.actionId === this.currentAction?.id);
        this.inProcessing = [
            ...new Set(commandsToProcess.map((cmd)=>cmd.actionId))
        ];
        this.queue = this.queue.filter((cmd)=>!commandsToProcess.includes(cmd));
        let currentCommand = null;
        try {
            commandsToProcess = (0, $9e7aabb2e4516310$export$c48ec1bf46060d54)(commandsToProcess);
            for (const commandToProcess of commandsToProcess){
                currentCommand = commandToProcess;
                if (this.aborted.includes(commandToProcess.actionId)) {
                    // If we abort the last stream let's move onto the next stream
                    if (commandToProcess.type === 'endStream') this.resolvePendingQueue(true);
                    continue;
                }
                await this.wrapInTimeout(this.commandToProcess(commandToProcess), commandToProcess);
            }
        } catch (error) {
            (0, $800cd9937abd732b$export$c20b86820b0850bf)({
                api: this.api,
                traceId: this.traceId,
                command: currentCommand,
                isCreateAction: this.currentAction?.isCreateAction,
                error: error
            });
            // Fire the unified tool_call_anomaly event in parallel —
            // keeps the existing fireCommandError event flowing for
            // legacy dashboards while attribution-first dashboards
            // consume the new event.
            if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true) && this.telemetryEventsEnabled) {
                const { symptom: symptom } = (0, $47926c3fe91d7830$export$e36a42623b7e8456)(error);
                (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                    api: this.api,
                    traceId: this.traceId,
                    commandType: $e3512170c06603fc$var$extractCommandType(currentCommand, this.currentCommand),
                    targetLocalId: $e3512170c06603fc$var$extractTargetLocalId(currentCommand, this.currentCommand),
                    errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error),
                    result: 'anomaly',
                    symptom: symptom
                });
            }
        } finally{
            // Reset the processing queue flag
            this.processingQueue = false;
            const lastCommand = commandsToProcess.pop();
            this.inProcessing = [];
            if (lastCommand?.type === 'endStream') this.checkAndResolveEmptyQueue();
        }
        // If commands have been added to the queue during async operations, process them now
        if (this.queue.filter((cmd)=>cmd.actionId === this.currentAction?.id).length > 0) this.processQueue();
        else if (this.queue.length > 0) this.queueTimeout = setTimeout(()=>{
            this.logger.logError(`Current stream queue timed out while starting next`, {
                actionId: this.currentAction?.id ?? undefined
            });
            this.resolvePendingQueue(true);
            this.processQueue();
        }, this.CURRENT_QUEUE_TIMEOUT);
    }
    onEmptyQueue() {
        const promise = new Promise((resolve)=>{
            this.onEmptyQueueResolve = resolve;
        });
        this.checkAndResolveEmptyQueue();
        return promise;
    }
    async wrapInTimeout(promise, cmd) {
        const { promise: wrappedPromise, resetTimeout: resetTimeout } = (0, $452730881cb932a3$export$6c44330c7facd24b)(promise, {
            timeout: this.COMMAND_TIMEOUT,
            onTimeout: ()=>{
                this.logger.logError(`Stream command timed out ${cmd.type}`, {
                    actionId: cmd.actionId,
                    chunk: cmd.chunk
                });
            },
            onCleanup: ()=>{
                this.currentCommandTimeoutReset = null;
                if (cmd.type === 'endStream') this.checkAndResolveEmptyQueue();
                this.resolvePendingQueue();
            }
        });
        this.currentCommandTimeoutReset = resetTimeout;
        await wrappedPromise;
    }
    /**
   * End the AI experience
   */ endStreamCommand(actionId, options) {
        // duplicated endStreamCommand will kill accept reject screen prematurely
        if (this.endedActionIds.includes(actionId)) {
            this.logger.logPublic('End Stream Command Ignored', {
                actionId: actionId
            });
            return;
        }
        this.endedActionIds.push(actionId);
        if (this.endedActionIds.length > 10) this.endedActionIds.shift();
        this.logger.logPublic('End Stream Command', {
            actionId: actionId
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endCurrentStream',
            forceAbortedToolCallId: options?.forceAbortedToolCallId
        });
        this.processQueue();
    }
    endExperience() {
        // if it's isFinalStream
        // - when auto accept AI changes is on, editor-plugin-ai will end itself
        // - when auto accept AI changes is off, the accept reject screen will be shown
        // if it's not isFinalStream, the endAIExperience is used to kill a previous AI modal
        // - which can be the previous accept reject screen
        // - or the command palette screen (followed by rovo free-gen screen)
        if (!this.isFinalStream) {
            this.logger.logQueueState('End AI Experience');
            this.api.aiExperience.actions.endAIExperience();
        }
        this.isFinalStream = false;
        this.adfStreamer?.reset();
        this.streamFlowPacer?.reset();
        this.subscription?.();
    }
    resolvePendingQueue(timeout = false) {
        if (timeout || this.isPendingResolveQueue) {
            const currentAction = this.queue.find((cmd)=>cmd.type === 'initStream') ?? null;
            this.logger.logQueueState('Resolve Pending Queue', {
                actionId: currentAction?.actionId,
                reason: timeout ? 'timeout' : 'isPendingResolveQueue'
            });
            if (timeout && (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) // Queue-stall timeout fired (no further commands arrived).
            // Idempotent via `fireSessionOutcomeOnce`'s once-per-session guard.
            this.fireSessionOutcomeOnce({
                lifecycleSymptom: 'session_timeout'
            });
            this.currentAction = currentAction ? {
                id: currentAction.actionId,
                isCreateAction: (currentAction.command.type === 'appendNode' || currentAction.command.type === 'appendNodeToEnd') && currentAction.command.streamingType === 'create',
                initialNode: (0, $fa9ee0382ce8619d$export$b7b4fc0a0195a016)(this.api, // replaceDoc has no localId — only replaceNode needs one here.
                currentAction.command.type === 'replaceNode' && currentAction.command.localId),
                type: currentAction.command.type,
                applyMode: $e3512170c06603fc$var$resolveApplyMode(currentAction.options)
            } : null;
            this.isPendingResolveQueue = false;
        }
    }
    checkAndResolveEmptyQueue() {
        if (this.queue.length === 0 && this.inProcessing.length === 0) this.onEmptyQueueResolve?.();
    }
    endNonStreamble() {
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) this.api.aiExperience.actions.dispatchAIEvent({
            type: 'complete',
            adfResponse: undefined
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            send({
                type: 'complete',
                markdown: '',
                adfResponse: undefined,
                cacheKey: '',
                modelInput: {}
            });
        }
    }
    async endExperiencePromise(command) {
        const { actionId: actionId, reason: reason } = command;
        this.logger.logQueueState('End Experience', {
            actionId: actionId,
            reason: reason
        });
        // Carry the force-aborted tool call id onto the terminal `complete` event
        // (emitted by finalStream below) so `buildCommitTransaction` can persist its
        // final positions for resume.
        this.pendingForceAbortedToolCallId = command.forceAbortedToolCallId;
        this.isPendingResolveQueue = reason === 'endCurrentStream';
        // should not check empty queue if the end command is triggered by the initStreamCommand
        // which is used to close a previous AI modal
        // because there are more commands to process even if the queue is empty
        // and this.isPendingResolveQueue will be reset, so use a different flag here
        const shouldCheckEmptyQueue = reason === 'endCurrentStream';
        const isStreamingCommand = !(this.currentAction?.type && !(0, $e357a3431509036d$export$f85aff2979b590a7)({
            type: this.currentAction?.type
        }));
        const isCommit = this.currentAction?.applyMode === 'commit';
        // Subscribe before the terminal event is queued below. With concurrent React,
        // the pacer can drain that event while `processStreamCommandPromise` yields;
        // subscribing afterwards lets the next action start before this one has fully
        // committed to the editor.
        const waitForPacerCompletion = !isCommit && (0, $ieeJu.expValEquals)('platform_editor_fix_ai_streaming_race', 'isEnabled', true) && this.isStreaming && isStreamingCommand && this.streamFlowPacer?.isRunning() ? new Promise((resolve)=>this.streamFlowPacer?.onComplete(resolve)) : undefined;
        if (this.isStreaming && isStreamingCommand) {
            await this.processStreamCommandPromise(actionId, '', true);
            if (this.currentAction?.type === 'replaceNode') (0, $800cd9937abd732b$export$7535a054b27a27c4)({
                api: this.api,
                initialNode: this.currentAction.initialNode,
                lastDoc: this.adfStreamer?.getLastDoc()
            });
            this.scheduleDeferredNoDocChangeAnalytics();
        } else if (!isStreamingCommand) this.isFinalStream = true;
        // Commit apply does not mount typewriter decorations, so do not
        // wait on streaming state. Do not call `endAIExperience` per tool
        // call (loader race / FIFO stall); chrome lives startSession → endSession.
        if (isCommit) {
            this.adfStreamer?.reset();
            this.streamFlowPacer?.reset();
            this.subscription?.();
            this.isFinalStream = false;
            this.logger.logQueueState('End Experience Resolved', {
                actionId: actionId,
                reason: reason
            });
            this.resolvePendingQueue();
            if (shouldCheckEmptyQueue) this.checkAndResolveEmptyQueue();
            return;
        }
        return new Promise((resolve)=>{
            const endNow = ()=>{
                this.endExperience();
                // After we end the experience there are a number of React re-renders that occur immediately after
                // This causes the state to flick between streaming and not streaming, it's not pretty
                // but wrap this in a `requestAnimationFrame` to delay our check until this clears.
                // To fix this properly we probably need to decouple the state with React
                const checkStreaming = ()=>{
                    const resolveAndEndStream = ()=>{
                        resolve();
                        this.logger.logQueueState('End Experience Resolved', {
                            actionId: actionId,
                            reason: reason
                        });
                        this.resolvePendingQueue();
                        shouldCheckEmptyQueue && this.checkAndResolveEmptyQueue();
                    };
                    if (!isStreamingCommand) {
                        this.endNonStreamble();
                        resolveAndEndStream();
                        return;
                    }
                    if (!this.api.aiExperience?.sharedState.currentState()?.isStreaming) {
                        resolveAndEndStream();
                        return;
                    }
                    const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (!nextSharedState.isStreaming) {
                            unsubscribe();
                            resolveAndEndStream();
                        }
                    });
                };
                setTimeout(checkStreaming, 0);
            };
            if ((0, $ieeJu.expValEquals)('platform_editor_fix_ai_streaming_race', 'isEnabled', true)) {
                if (waitForPacerCompletion) waitForPacerCompletion.then(()=>{
                    // Need to be careful not to end the experience too soon. We need to give the xstate and react time to process
                    // the final stream events before we kill the experience. Otherwise you will see an unfinished stream in the doc.
                    setTimeout(endNow, 100);
                });
                else // If we're not running the pacer or its a non-streamable command, end immediately
                endNow();
            } else // If we're not running the pacer or its a non-streamable command, end immediately
            if (!this.streamFlowPacer?.isRunning() || this.currentAction?.type && !(0, $e357a3431509036d$export$f85aff2979b590a7)({
                type: this.currentAction?.type
            })) endNow();
            else this.streamFlowPacer.onComplete(()=>{
                // Need to be careful not to end the experience too soon. We need to give the xstate and react time to process
                // the final stream events before we kill the experience. Otherwise you will see an unfinished stream in the doc.
                setTimeout(endNow, 100);
            });
        });
    }
    /**
   * Streams the AI experience
   */ /**
   * Called by the orchestrator plugin when the chunk strategy detects that
   * ADF schema content was rejected (e.g. blockCard inside listItem).
   * Fires a toolCallResult anomaly and suppresses the deferred success event.
   */ notifySchemaContentRejection(actionId, errorMessage) {
        if (this.toolCallResultFiredForCurrentCommand) return;
        const command = this.currentCommand;
        const traceId = this.traceId;
        if (!command || !traceId) return;
        this.toolCallResultFiredForCurrentCommand = true;
        (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
            api: this.api,
            traceId: traceId,
            commandType: command.type,
            result: 'anomaly',
            symptom: 'apply_failed_adf_schema_error',
            errorMessage: errorMessage
        });
    }
    queueStreamCommand(actionId, chunk) {
        this.logger.logPublic('Stream Command', {
            actionId: actionId,
            chunk: chunk
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'streamCommand',
            actionId: actionId,
            chunk: chunk
        });
        // Commit apply never flips typewriter `isStreaming`, so `isActorReady`
        // stays false. Still drain — finish/endSession wait on an empty queue.
        if (this.isActorReady() || this.currentAction?.applyMode === 'commit') this.processQueue();
        else {
            // if there are multiple sequential queueStreamCommand calls
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api?.aiExperience.sharedState.onChange(()=>{
                if (this.isActorReady()) {
                    unsubscribe?.();
                    this.processQueue();
                }
            });
        }
    }
    hasChangedDocument(latestDoc) {
        if (!this.previousValidDoc && latestDoc) return true;
        const nodesAreNotEqual = !this.previousValidDoc?.doc || !latestDoc?.doc || !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(this.previousValidDoc?.doc, latestDoc.doc);
        if (this.streamFlowPacer === null) {
            // replaceDoc is allowed to produce an empty document (e.g. "delete entire page"),
            // so we skip the isEmptyDocument guard for that action type.
            const isReplaceDoc = this.currentAction?.type === 'replaceDoc';
            if (isReplaceDoc) // For replaceDoc, latestDoc.doc may be undefined when the streamed content is
            // empty HTML (the adfStreamer returns undefined for empty input). We treat
            // "undefined → previous doc exists" as a change so the empty-page intent
            // is honoured — the final stream path will supply the empty-paragraph fallback.
            return Boolean(nodesAreNotEqual);
            return Boolean(nodesAreNotEqual && latestDoc.doc && !(0, $iLrhi.isEmptyDocument)(latestDoc.doc));
        }
        const latestCount = this.streamFlowPacer?.adfTextLen(latestDoc?.adfDoc);
        return Boolean(nodesAreNotEqual && latestDoc.adfDoc && this.previousValidDoc?.adfDoc && latestCount.chars > 0 && // Ensure we only stream changes if the stream flow pacer detects semantic changes
        !this.streamFlowPacer?.adfTextLen(this.previousValidDoc?.adfDoc).gte(latestCount));
    }
    createCallback(usePush) {
        if (usePush) return (evt)=>{
            const fullEvent = (0, $hEuOY.normaliseAIExperienceEvent)(evt);
            this?.streamFlowPacer?.push(fullEvent);
        };
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return (evt)=>{
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        };
        // Legacy path: send to actor with padded defaults
        const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
        return (evt)=>{
            const payload = (0, $hEuOY.normaliseAIExperienceEvent)(evt);
            send(payload);
        };
    }
    processStreamCommand(actionId, chunk, finalStream = false) {
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) this.streamFlowPacer?.setEmit((evt)=>{
            // While the stream flow pacer is doing work reset the timeout
            this.currentCommandTimeoutReset?.();
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            this.streamFlowPacer?.setEmit((evt)=>{
                // While the stream flow pacer is doing work reset the timeout
                this.currentCommandTimeoutReset?.();
                send(evt);
            });
        }
        const isCommit = this.currentAction?.applyMode === 'commit';
        const callback = this.createCallback(!!this.streamFlowPacer?.push && !isCommit);
        // Initialize streamer if needed
        if (!this.adfStreamer) {
            const schema = this.api.core.sharedState.currentState()?.schema;
            this.adfStreamer = schema ? new (0, $aAERY.ADFStreamer)(schema, (0, $800cd9937abd732b$export$6dcba6b9d3966cf9)({
                api: this.api,
                isCreateAction: this.currentAction?.isCreateAction ?? false,
                traceId: this.traceId,
                promptVersion: this.promptVersion
            })) : undefined;
        }
        if (finalStream) {
            const lastDocResult = (0, $f2384266701dbede$export$7b6c9d9d26e2f428)(this.api, this.adfStreamer?.getLastDoc());
            let adfResponseBefore = lastDocResult.adfDoc;
            // replaceDoc with an empty value (e.g. "delete entire page") produces either no
            // ADF or a bare { type:"doc" } with no content from the streamer. Substitute a
            // minimal empty document so the downstream insertion path actually clears the
            // editor content rather than silently no-oping.
            const isFinalEffectivelyEmptyDoc = !adfResponseBefore || !adfResponseBefore.content || adfResponseBefore.content.length === 0;
            if (isFinalEffectivelyEmptyDoc && this.currentAction?.type === 'replaceDoc') adfResponseBefore = {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            };
            const schema = this.api.core.sharedState.currentState()?.schema;
            const { updatedResponse: updatedResponse, localId: localId } = (0, $286950ef0f6e1392$export$ab173b3d1046c711)(adfResponseBefore, this.currentAction?.type, schema);
            const adfResponse = updatedResponse;
            this.insertAfterQueueLocalId = localId;
            const repairSignals = this.adfStreamer?.endStreamingSession({
                hasProcessedFinalResponse: true
            });
            if (repairSignals && (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) // A session may contain multiple streaming actions. Aggregate
            // repair signals across them so the final `sessionOutcome` event
            // correctly reflects the worst per-action outcome:
            // - `*Invalid`: OR — any invalid action means the session saw
            //   that layer fail at least once.
            // - `unrepaired*Count`: count actions whose invalid layer was
            //   NOT recovered. The session is only considered "fully
            //   repaired" if this count is zero. A naive OR over the
            //   per-action `*Repaired` flags would incorrectly mask a
            //   later irrecoverable failure when an earlier action had
            //   recovered.
            this.sessionRepairSignals = {
                anyJsonInvalid: this.sessionRepairSignals.anyJsonInvalid || repairSignals.finalJsonInvalid,
                anyAdfInvalid: this.sessionRepairSignals.anyAdfInvalid || repairSignals.finalAdfInvalid,
                unrepairedJsonCount: this.sessionRepairSignals.unrepairedJsonCount + (repairSignals.finalJsonInvalid && !repairSignals.finalJsonRepaired ? 1 : 0),
                unrepairedAdfCount: this.sessionRepairSignals.unrepairedAdfCount + (repairSignals.finalAdfInvalid && !repairSignals.finalAdfRepaired ? 1 : 0)
            };
            this.logger.logQueueState('Final Stream', {
                actionId: actionId,
                adf: adfResponse,
                finalStream: true
            });
            const forceAbortedToolCallId = this.pendingForceAbortedToolCallId;
            this.pendingForceAbortedToolCallId = undefined;
            callback({
                type: 'complete',
                adfResponse: adfResponse,
                ...forceAbortedToolCallId ? {
                    forceAbortedToolCallId: forceAbortedToolCallId
                } : {}
            });
            return true;
        }
        // Resetting because we are going to get full ADF as chunk
        this.adfStreamer?.reset();
        this.adfStreamer?.processChunk(chunk);
        const latestDoc = (0, $f2384266701dbede$export$7b6c9d9d26e2f428)(this.api, isCommit ? this.adfStreamer?.getLastDoc() : this.adfStreamer?.getLastDocWithoutLastLeafNode());
        const changed = this.hasChangedDocument(latestDoc);
        this.previousValidDoc = latestDoc;
        // We compare the before/after docs because if nothing has changed then it will not trigger a react update (because the adfResponse needs to be different)
        // which means the chunkNumber will never update and the processStreamCommandPromise Promise will never resolve.
        // This cause the wrapInTimeout 1sec delay to occur before the next chunk is processed. This means we can end up in a situation
        // where we're recieving a lot of chunks, but nothing in the view is changed and everything starts taking a lot of time
        // because of the sequential 1sec failovers.
        if (changed) {
            // For replaceDoc with an empty value (e.g. "delete entire page"), the adfStreamer
            // returns either undefined or a bare { type:"doc" } with no content — fall back to
            // a minimal empty document so the editor content is actually cleared.
            const isEffectivelyEmptyDoc = !latestDoc.adfDoc || !latestDoc.adfDoc.content || latestDoc.adfDoc.content.length === 0;
            const streamAdfResponse = isEffectivelyEmptyDoc && this.currentAction?.type === 'replaceDoc' ? {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            } : latestDoc.adfDoc;
            callback({
                type: 'stream',
                adfResponse: streamAdfResponse
            });
            return true;
        }
        return false;
    }
    processStreamCommandPromise(actionId, chunk, finalStream = false) {
        this.logger.logQueueState('Streaming Command', {
            actionId: actionId,
            chunk: chunk,
            finalStream: finalStream
        });
        this.isStreaming = !finalStream;
        this.isFinalStream = finalStream;
        return new Promise((resolve)=>{
            // do not wrap the code in setTimeout, it will pause the streaming when the tab is in background
            const chunkBefore = this.api.aiExperience?.sharedState.currentState()?.chunkNumber;
            const processed = this.processStreamCommand(actionId, chunk, finalStream);
            // Commit writes without typewriter, so `chunkNumber` may never change.
            if (!processed || this.currentAction?.applyMode === 'commit') {
                // If nothing was processed then we should be able to end immediately since we will never get a chuckNumber update
                // this means the next chunk can be processed straight away.
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            if (chunkBefore !== this.api.aiExperience?.sharedState.currentState()?.chunkNumber) {
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            // if there are multiple sequential queueStreamCommand calls and one of them timeout
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (nextSharedState?.chunkNumber !== prevSharedState?.chunkNumber) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState('Streaming Command Resolved', {
                        actionId: actionId,
                        chunk: chunk,
                        finalStream: finalStream
                    });
                }
            });
        });
    }
    /**
   * Streams the AI experience
   */ initStreamCommand(actionId, command, options) {
        this.logger.logPublic('Init Command', {
            actionId: actionId,
            command: command
        });
        this.isAborted = false;
        // Track tool call captured for analytics
        if ((0, $iDrrr.fg)('platform_editor_ai_tool_call_received_analytics')) (0, $800cd9937abd732b$export$2197bcc2a00f4a51)({
            api: this.api,
            command: command,
            actionId: actionId,
            traceId: this.traceId
        });
        if (!this.currentAction) this.currentAction = {
            id: actionId,
            isCreateAction: (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create',
            initialNode: (0, $fa9ee0382ce8619d$export$b7b4fc0a0195a016)(this.api, // replaceDoc has no localId — only pass localId for replaceNode.
            command.type === 'replaceNode' && command.localId),
            type: command.type,
            applyMode: $e3512170c06603fc$var$resolveApplyMode(options)
        };
        if ($e3512170c06603fc$var$resolveApplyMode(options) === 'commit') this.hasCommitApplyInSession = true;
        // If we're already running end the stream and restart.
        // Commit chrome stays up until endSession — do not insert a
        // teardown between FIFO tool calls.
        if (this.currentAction?.applyMode !== 'commit' && this.api.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.isRunning) this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endPreviousStream'
        });
        this.queue.push({
            type: 'initStream',
            actionId: actionId,
            chunk: undefined,
            command: command,
            options: options
        });
        this.processQueue();
    }
    applyCommand(command) {
        const insertAfterQueue = this.currentCommand?.type === 'insertNodeAfter' && command.type === 'insertNodeAfter' && command.localId === this.currentCommand?.localId;
        this.currentCommand = command;
        this.toolCallResultFiredForCurrentCommand = false;
        this.docBeforeStreaming = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        let isSuccessful = true;
        // Apply-anomaly diagnostics: see runPre/PostApplyDiagnostics for
        // the symptoms detected. Gated to keep the snapshot/diff cost
        // (and any associated bookkeeping) out of the hot path entirely
        // when the experiment is off.
        const normalizedTelemetryEnabled = (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true);
        // Record this tool call so end-of-session `analyzeOutcome` can
        // distinguish intentional removals/modifications from collateral
        // damage. Only collected when the experiment is on.
        if (normalizedTelemetryEnabled) this.sessionToolCalls.push($e3512170c06603fc$var$toToolCallRecord(command));
        // The localId the apply path will actually attempt to act on.
        // `insertAfterQueue` commands rewrite the localId at apply time
        // so that consecutive `insertNodeAfter` calls chain correctly
        // (see the apply branch below). Diagnostics must use the same
        // effective localId so target-resolution checks match the apply
        // path's actual behaviour — otherwise we get false positives
        // (command.localId missing but insertAfterQueueLocalId valid) and
        // false negatives (the inverse).
        const effectiveTargetLocalId = normalizedTelemetryEnabled ? insertAfterQueue && this.insertAfterQueueLocalId ? this.insertAfterQueueLocalId : $e3512170c06603fc$var$getTargetLocalId(command) : undefined;
        const preApplyResult = normalizedTelemetryEnabled ? this.runPreApplyDiagnostics(command, effectiveTargetLocalId) : undefined;
        // If we have subsequent "insertAfter" commands with the same localId, instead point to the end of the
        // previous insertion. This is because the AI will "insertAfter" in a logical order, but that puts the content
        // into the document backwards.
        if (insertAfterQueue && this.insertAfterQueueLocalId) // If for some reason the localId doesn't exist in the document fallback to the original stream command
        try {
            isSuccessful = this.streamingCommands[command.type]({
                ...command,
                localId: this.insertAfterQueueLocalId
            });
        } catch  {
            isSuccessful = this.streamingCommands[command.type](command);
        }
        else isSuccessful = this.streamingCommands[command.type](command);
        const postApplyAnomalyDetected = normalizedTelemetryEnabled && preApplyResult !== undefined && !preApplyResult.anomalyDetected ? this.runPostApplyDiagnostics(command, preApplyResult.preApplyLocalIds, effectiveTargetLocalId) : false;
        // Fire success only if no anomaly detected and not a streamable
        // command. Streamable commands defer success/anomaly to
        // checkAndFireNoDocumentChangeAnalytics once streaming completes, since
        // the doc change arrives via chunks after applyCommand returns.
        if (normalizedTelemetryEnabled && this.telemetryEventsEnabled) {
            const preApplyAnomalyDetected = preApplyResult?.anomalyDetected ?? false;
            if (!preApplyAnomalyDetected && !postApplyAnomalyDetected && !(0, $e357a3431509036d$export$f85aff2979b590a7)(command)) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'success'
            });
        }
        return isSuccessful;
    }
    /**
   * Apply-anomaly diagnostics: pre-apply phase. Snapshots full-depth
   * localIds and fires `local_id_not_found` if the command targets
   * a localId that doesn't exist. Returns the snapshot for reuse by the
   * post-apply phase.
   *
   * Caller is responsible for the experiment gate check, and for
   * computing `effectiveTargetLocalId` so it reflects what the apply
   * path will actually act on (e.g. the substituted
   * `insertAfterQueueLocalId` for chained `insertNodeAfter` calls).
   */ runPreApplyDiagnostics(command, effectiveTargetLocalId) {
        const preApplyLocalIds = (0, $fa9ee0382ce8619d$export$a3fa3f6695d8b421)(this.docBeforeStreaming ?? undefined);
        // Use the live PM doc lookup (same walk every command uses) so
        // detection is ground-truth equivalent to the apply layer.
        if (effectiveTargetLocalId !== undefined && (0, $fa9ee0382ce8619d$export$b7b4fc0a0195a016)(this.api, effectiveTargetLocalId) === undefined) {
            if (this.telemetryEventsEnabled) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'local_id_not_found',
                targetLocalId: effectiveTargetLocalId
            });
            return {
                anomalyDetected: true,
                preApplyLocalIds: preApplyLocalIds
            };
        }
        return {
            anomalyDetected: false,
            preApplyLocalIds: preApplyLocalIds
        };
    }
    /**
   * Apply-anomaly diagnostics: post-apply phase. Diffs the post-apply
   * full-depth localId snapshot against the pre-apply snapshot (both
   * built via `collectAllLocalIds`, so every depth is included) and
   * fires:
   * - `unexpected_node_removal` when nodes disappeared that the command
   *   wasn't supposed to remove/relocate. Reports
   *   `effectiveTargetLocalId` so the dashboard reader sees the localId
   *   the apply path actually acted on.
   * - `no_document_change` when a mutating command produced no document
   *   change at all.
   * Caches the post-apply snapshot for reuse by the next applyCommand.
   *
   * Caller is responsible for the experiment gate check, and for
   * computing `effectiveTargetLocalId` so it reflects what the apply
   * path actually acted on (see `runPreApplyDiagnostics`).
   */ runPostApplyDiagnostics(command, preApplyLocalIds, effectiveTargetLocalId) {
        const postApplyDoc = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        if (postApplyDoc === undefined) // Editor view unavailable post-apply (teardown race). Skip
        // the diff — can't distinguish "everything removed" from
        // "couldn't observe post-apply state".
        return false;
        // Full-depth snapshot so the diff catches collateral removals
        // nested inside layouts, expand blocks, panels, table cells, etc.
        const postApplyLocalIds = (0, $fa9ee0382ce8619d$export$a3fa3f6695d8b421)(postApplyDoc);
        // Pass `docBeforeStreaming` so the helper can expand each direct
        // target to include its descendant `localId`s. Required since
        // the diff above (`collectAllLocalIds`) is full-depth — removing
        // a container would otherwise spuriously fire
        // `unexpected_node_removal` for every nested descendant.
        const explicitTargets = (0, $6718584366a375eb$export$30ebe6cd1aac119d)(command, this.docBeforeStreaming ?? undefined);
        const removedLocalIds = [];
        preApplyLocalIds.forEach((id)=>{
            if (!postApplyLocalIds.has(id) && !explicitTargets.has(id)) removedLocalIds.push(id);
        });
        if (removedLocalIds.length > 0) {
            if (this.telemetryEventsEnabled) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'unexpected_node_removal',
                targetLocalId: effectiveTargetLocalId,
                removedLocalIds: removedLocalIds
            });
            return true;
        }
        // Streamable commands (`replaceNode`, `replaceDoc`,
        // `insertNodeBefore`, `insertNodeAfter`, `appendNode`,
        // `appendNodeToEnd`) are two-phase: the apply call only sets a
        // selection (and sometimes inserts a placeholder paragraph), and
        // the actual content change arrives later via streaming chunks.
        // At apply time the document has legitimately not changed yet, so
        // firing `no_document_change` here would produce false positives
        // for every streamable command. The deferred check fires from
        // `checkAndFireNoDocumentChangeAnalytics` in `endExperiencePromise`
        // once all stream chunks have been applied.
        if (!(0, $e357a3431509036d$export$f85aff2979b590a7)(command) && this.docBeforeStreaming && postApplyDoc.eq(this.docBeforeStreaming)) {
            if (this.telemetryEventsEnabled) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'no_document_change'
            });
            return true;
        }
        return false;
    }
    /**
   * Resume-mode counterpart of {@link applyCommand}.
   *
   * Unlike `applyCommand`, it does NOT invoke a tool-call action (which would set
   * the selection to end-of-doc and re-insert a placeholder, landing content in
   * the wrong place). Instead it sets the selection to the stored, mapped
   * positions via `reapply`, so the subsequent `openAIModal` (which reads its
   * range from `state.selection` when `isExternal` is set) fills the original
   * range.
   *
   * Kept as a dedicated method (rather than simply skipping `applyCommand`) so we
   * have a single home for resume/reapply telemetry.
   */ reapplyCommand(command, resume) {
        this.currentCommand = command;
        this.docBeforeStreaming = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        // Intentionally no tool-call action and no apply-anomaly diagnostics here:
        // resume re-applies into an explicit, already-resolved range. We set the
        // selection to the stored, transaction-mapped positions so that the
        // subsequent `openAIModal` (which reads its range from `state.selection`
        // when `isExternal` is set) re-applies the content where the aborted call
        // left off.
        //
        // The position is resolved at apply time from the toolCallId by reading the
        // LATEST (transaction-remapped) stored position; see `resolveResumePositions`
        // for the full rationale (multiple aborted tool calls resumed in sequence
        // must each anchor to their own remapped range).
        const resolved = (0, $ff56e6956d0962e2$export$47c18b0b568dba43)(this.api, resume);
        if (!resolved) // No stored position (shouldn't happen): re-run the command so content is
        // not lost. resumeAction already fires the fallback anomaly event.
        return this.applyCommand(command);
        return this.reapply(resolved.fromPos, resolved.toPos);
    }
    initStream(command, options) {
        const resume = options?.resume;
        // Resume mode: skip the tool-call action (which would re-resolve to end-of-doc)
        // and re-apply at the stored, mapped positions instead.
        const applied = resume ? this.reapplyCommand(command, resume) : this.applyCommand(command);
        // If we couldn't apply the command (ie. broken localId) add it to the abort cache so we don't apply anymore commands
        if (!applied) {
            // Never start the stream and resolve immediately
            if (this.currentAction?.id) this.updateAbortedCache([
                this.currentAction?.id
            ]);
            return true;
        }
        this.streamFlowPacer?.reset();
        this.adfStreamer?.reset();
        const isCommit = $e3512170c06603fc$var$resolveApplyMode(options) === 'commit';
        // Commit apply never pushes into the pacer. Starting it here would leave
        // `endExperiencePromise` waiting on `onComplete` that never fires.
        if (!isCommit) {
            // We have to set an empty callback before starting otherwise the flow pacer wont start. We need to cleanup the flow pacer
            // and make it more generic.
            this.streamFlowPacer?.setEmit(()=>{});
            this.streamFlowPacer?.start();
            // Fire a simple operational event measuring the gap between the backend
            // finishing its stream and the pacer finishing draining it (HTML+ lag).
            this.streamFlowPacer?.onPacerCompletionGap((info)=>{
                (0, $800cd9937abd732b$export$121949ee4a6ce5f6)({
                    api: this.api,
                    backendEndToPacerCompleteMs: info.backendEndToPacerCompleteMs,
                    backlogCharsAtBackendEnd: info.backlogCharsAtBackendEnd,
                    charsPerTickAtComplete: info.charsPerTickAtComplete,
                    terminalType: info.terminalType,
                    traceId: this.traceId
                });
            });
        }
        const isCreate = (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create';
        this.logger.logQueueState('Open AI Modal', {
            command: command
        });
        this.api.aiExperience.actions.openAIModal({
            invokedFrom: 'streamingApi',
            configItem: (0, $j2p1x.UNSTABLE_configItems).freeGenerateAifcConfigItem,
            // Typewriter still paints the active write. Commit apply skips it so
            // unified chrome can own the post-apply treatment. Resume is
            // selection-based: it must keep the remapped range.
            withStreamingHighlight: !isCreate && !isCommit && !resume,
            skipSelectionHighlight: !resume && (isCommit || isCreate),
            // don't show accept reject screen for staging first-time creation streaming
            withAcceptReject: !isCreate,
            hideLoadingScreen: ((0, $iDrrr.fg)('platform_editor_tmp_hide_loader') && options?.hideLoadingScreen) ?? false,
            traceId: this.traceId,
            singleInstrumentationId: this.singleInstrumentationId,
            isCreate: isCreate,
            promptVersion: this.promptVersion
        });
        if (!(0, $e357a3431509036d$export$f85aff2979b590a7)(command)) (0, $800cd9937abd732b$export$276ecd5322451ab4)({
            api: this.api,
            command: this.currentCommand,
            docBeforeStreaming: this.docBeforeStreaming,
            traceId: this.traceId
        });
        return false;
    }
    async initStreamPromise(command, options) {
        await new Promise((resolve)=>{
            this.logger.logQueueState(`Init Command ${command.type}`, {
                command: command
            });
            if (this.initStream(command, options)) {
                resolve();
                this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                    command: command
                });
                return;
            }
            // Commit apply never mounts typewriter decorations, so `isRunning`
            // may never flip. Waiting here stalls the queue and drops later
            // tool calls / resume writes.
            if ($e3512170c06603fc$var$resolveApplyMode(options) === 'commit') {
                resolve();
                this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                    command: command
                });
                return;
            }
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState.aiDecorationExperiencePluginState.isRunning) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                        command: command
                    });
                }
            });
        });
    }
    startSession(sessionId, traceId, singleInstrumentationId, promptVersion) {
        this.traceId = traceId;
        (0, $800cd9937abd732b$export$4b84cbb6abceadd2)({
            api: this.api,
            sessionId: sessionId,
            traceId: traceId,
            promptVersion: promptVersion
        });
        this.singleInstrumentationId = singleInstrumentationId;
        this.promptVersion = (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? promptVersion : undefined;
        this.hasCommitApplyInSession = false;
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            this.resetSessionOutcomeState();
            // Capture the doc as it was before any streaming command runs.
            // `analyzeOutcome` will diff this against the post-session doc
            // at end-of-session to compute structural-delta fields.
            this.preSessionDoc = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        }
        this.logger.logPublic('Start Session', {
            sessionId: sessionId,
            singleInstrumentationId: singleInstrumentationId
        });
    }
    queueEndSession(sessionId) {
        this.logger.logPublic('Queue End Session', {
            sessionId: sessionId
        });
    }
    endSession(sessionId) {
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            this.runPostApplyOutcomeAnalysis();
            this.fireSessionOutcomeOnce();
        }
        if (this.hasCommitApplyInSession) {
            // Legacy ExperienceApplication (xstate off): keep the modal up so
            // accept/reject can mount (`accept-reject.spec.ts`).
            // SessionUI (xstate on): `endAIExperience()` lets Loading cleanup
            // end the experience instead of showing review (`session-ui.spec.ts`).
            if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) this.isFinalStream = true;
            this.endExperience();
            this.hasCommitApplyInSession = false;
        }
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
        this.promptVersion = undefined;
        this.currentCommand = undefined;
        this.logger.logPublic('End Session', {
            sessionId: sessionId
        });
    }
    /**
   * Fire the authoritative `sessionOutcome` analytics event for the current
   * session. Idempotent — calling this multiple times within the same session
   * results in at most a single event being fired.
   *
   * If `lifecycleSymptom` is supplied, it overrides any repair-derived
   * symptom and forces `outcome_class: 'failure'` — a session that never
   * reached end-of-stream cannot be a success.
   */ fireSessionOutcomeOnce(options = {}) {
        if (this.sessionOutcomeFired) return;
        this.sessionOutcomeFired = true;
        const { lifecycleSymptom: lifecycleSymptom } = options;
        const { anyJsonInvalid: anyJsonInvalid, anyAdfInvalid: anyAdfInvalid, unrepairedJsonCount: unrepairedJsonCount, unrepairedAdfCount: unrepairedAdfCount } = this.sessionRepairSignals;
        // Derive the session-level repair-signal contract reported on the
        // outcome event:
        // - `finalJsonInvalid` / `finalAdfInvalid`: did any action see that
        //   layer become invalid at all?
        // - `finalJsonRepaired` / `finalAdfRepaired`: was every invalid
        //   occurrence in the session recovered? (i.e. AND over the per-action
        //   `repaired` flags for actions where invalid=true). False when the
        //   layer was never invalid, matching the per-action semantic.
        const finalJsonInvalid = anyJsonInvalid;
        const finalAdfInvalid = anyAdfInvalid;
        const finalJsonRepaired = anyJsonInvalid && unrepairedJsonCount === 0;
        const finalAdfRepaired = anyAdfInvalid && unrepairedAdfCount === 0;
        // Post-apply analysis flags. Read from the analyzer result computed
        // in `runPostApplyOutcomeAnalysis`. Each flag drives one suspicious-
        // signal event AND (if the session would otherwise have succeeded)
        // upgrades the outcome class to `success_but_suspicious`.
        //
        // `noMeaningfulEffect` only counts when the session actually ran a
        // mutating tool call — a read-only session that happens to leave
        // the doc unchanged is not suspicious, it's expected.
        const analysis = this.lastOutcomeAnalysis;
        const hadMutatingToolCall = this.sessionToolCalls.some((tc)=>$e3512170c06603fc$var$MUTATING_COMMAND_TYPES.has(tc.commandType));
        const unintendedRegionRemoved = analysis !== undefined && analysis.unintendedRegionRemoved;
        const unintendedRegionModified = analysis !== undefined && analysis.unintendedRegionModified;
        // `textCharacterDelta` tolerance: we treat ±1 character as
        // negligible because the apply layer can legitimately inject or
        // strip a single trailing whitespace / newline / punctuation
        // character during ProseMirror normalisation (e.g. closing a block
        // node, collapsing adjacent whitespace, trimming a trailing space
        // the model emitted). Strict equality to 0 would generate
        // false-positive `noMeaningfulEffect` events for sessions whose
        // only effect was a one-character normalisation artefact. A wider
        // tolerance would risk hiding real (but tiny) edits.
        //
        // `attrSignaturesEqual` catches attribute-only edits (e.g. cell
        // background, panel type, heading level) that node count + text
        // length miss. See CCI-16816.
        // CCI-16968: when a replaceNode creates replacement nodes with fresh
        // localIds, the targeted node disappears from the post-doc top-level
        // snapshot. In that case the totalNodeDelta and textCharacterDelta
        // metrics are coincidentally 0/±1 even though real content was
        // rewritten — the content just moved to a new localId. Suppress
        // noMeaningfulEffect when any targeted top-level node is absent from
        // the post-doc (the replacement genuinely happened).
        const noMeaningfulEffect = analysis !== undefined && hadMutatingToolCall && analysis.totalNodeDelta === 0 && Math.abs(analysis.textCharacterDelta) <= 1 && analysis.attrSignaturesEqual && !analysis.anyAffectedLocalIdDisappearedPostApply;
        const intentEffectMismatch = analysis !== undefined && analysis.intentEffectMismatch;
        // Outcome class derivation per the design doc (Phase 1 + 3):
        // - failure                : any layer (ADF or JSON) was invalid and
        //                            could not be repaired, OR the session
        //                            ended via a lifecycle event (abort /
        //                            timeout)
        // - success_with_repairs   : a layer was invalid but every invalid
        //                            occurrence was recovered
        // - clean_success          : no repair signals fired at all
        // - success_but_suspicious : the session would otherwise have been
        //                            clean_success or success_with_repairs
        //                            but the post-apply analyzer flagged
        //                            one or more suspicious signals
        // `failure` is never overridden by a suspicious signal — an
        // unrecovered apply error is more important than "looks fishy".
        const adfFailed = finalAdfInvalid && !finalAdfRepaired;
        const jsonFailed = finalJsonInvalid && !finalJsonRepaired;
        const anySuspiciousSignal = unintendedRegionRemoved || unintendedRegionModified || noMeaningfulEffect || intentEffectMismatch;
        let outcomeClass;
        if (lifecycleSymptom !== undefined || adfFailed || jsonFailed) outcomeClass = 'failure';
        else if (anySuspiciousSignal) outcomeClass = 'success_but_suspicious';
        else if (finalAdfRepaired || finalJsonRepaired) outcomeClass = 'success_with_repairs';
        else outcomeClass = 'clean_success';
        // Compute a small histogram of command types to help debug
        // no-effect sessions ("what was being attempted?"). Keys are
        // orchestrator command-type constants (not user content). Scoped
        // deliberately to `noMeaningfulEffect` sessions — avoids inflating
        // every sessionOutcome payload with histogram data that is only
        // useful when the session produced no meaningful change.
        let commandTypeCounts;
        if (noMeaningfulEffect) {
            commandTypeCounts = {};
            for (const tc of this.sessionToolCalls)commandTypeCounts[tc.commandType] = (commandTypeCounts[tc.commandType] ?? 0) + 1;
        }
        // True when any of the suspicious signals that fired came from a
        // heuristic rather than a backend-supplied label. Currently always
        // true for `unintendedRegionModified` (text-length proxy) and
        // `intentEffectMismatch` (intent inferred from tool-call mix).
        // Lets dashboards filter the noisier inferred signals out of
        // headline KPIs.
        const heuristicInferred = unintendedRegionModified || intentEffectMismatch ? true : undefined;
        // Pick the worst (symptom, detectionLayer) we observed: lifecycle >
        // unrecovered failure > successful repair > clean. `detectionLayer`
        // names where the symptom was *first surfaced* (parser for repair
        // signals, orchestrator for apply / lifecycle), not where this
        // event is fired. Unmapped pairs fall back to `unknown`/`low`.
        let detectionLayer = 'orchestrator';
        let symptom;
        if (lifecycleSymptom !== undefined) {
            // Lifecycle symptoms are orchestrator-owned (abort / timeout).
            detectionLayer = 'orchestrator';
            symptom = lifecycleSymptom;
        } else if (adfFailed) {
            // The orchestrator surfaced an unrecovered ADF schema failure
            // when it tried to apply the streamed ADF.
            detectionLayer = 'orchestrator';
            symptom = 'apply_failed_adf_schema_error';
        } else if (jsonFailed) {
            // Parser-layer detection. There is no dedicated routing-table
            // entry for an unrecovered JSON failure today; we still attach
            // the symptom so dashboards can see it, and it routes to
            // `unknown`/`low` until the routing table grows an entry
            // covering this case.
            detectionLayer = 'parser';
            symptom = 'final_json_invalid';
        } else if (finalAdfRepaired) {
            // ADF repair is the higher-severity success signal — checked
            // before JSON repair so a session that observed both still
            // surfaces the more impactful symptom (ADF/high) rather than
            // the weaker JSON/medium one. Preserves the "worst observed
            // signal wins" invariant.
            detectionLayer = 'parser';
            symptom = 'final_adf_invalid';
        } else if (finalJsonRepaired) {
            detectionLayer = 'parser';
            symptom = 'final_json_repaired';
        } else if (anySuspiciousSignal) {
            // Pick the highest-severity suspicious signal observed — worst
            // signal wins, matching the same invariant used for repair/failure
            // signals above. The four signals are checked in severity order:
            // unintendedRegionRemoved (content disappeared) > unintendedRegionModified
            // (content changed unexpectedly) > noMeaningfulEffect (no net change) >
            // intentEffectMismatch (structural delta contradicts inferred intent).
            detectionLayer = 'post_apply';
            if (unintendedRegionRemoved) symptom = 'unexpected_content_removal';
            else if (unintendedRegionModified) symptom = 'unintended_text_modification';
            else if (noMeaningfulEffect) symptom = 'no_meaningful_effect';
            else // intentEffectMismatch
            symptom = 'semantic_mismatch';
        }
        if (!this.telemetryEventsEnabled) return;
        (0, $800cd9937abd732b$export$f31b302ceb439402)({
            api: this.api,
            traceId: this.traceId,
            outcomeClass: outcomeClass,
            detectionLayer: detectionLayer,
            symptom: symptom,
            finalJsonInvalid: finalJsonInvalid,
            finalJsonRepaired: finalJsonRepaired,
            finalAdfInvalid: finalAdfInvalid,
            finalAdfRepaired: finalAdfRepaired,
            // Forward the post-apply analyzer flags so dashboards can see
            // "what happened" and "why it was suspicious" on a single
            // event. Each is `undefined` when the analyzer didn't run
            // (e.g. session aborted before any apply).
            ...analysis !== undefined ? {
                unintendedRegionRemoved: unintendedRegionRemoved,
                unintendedRegionModified: unintendedRegionModified,
                noMeaningfulEffect: noMeaningfulEffect,
                intentEffectMismatch: intentEffectMismatch,
                // Raw deltas — only attached when the corresponding
                // suspicious flag is true, to avoid forwarding
                // meaningless zeros on clean sessions.
                ...unintendedRegionRemoved ? {
                    removedNodeCount: analysis.removedNodeCount,
                    totalNodeDelta: analysis.totalNodeDelta,
                    // Indicates whether unintendedRegionRemoved used
                    // backend-supplied selectionLocalIds (precise) or
                    // the proxy fallback. Backend plumbing arrives with
                    // CCI-15978; until then always false.
                    selectionLocalIdsAvailable: false
                } : {},
                ...unintendedRegionModified ? {
                    textCharacterDelta: analysis.textCharacterDelta
                } : {}
            } : {},
            ...commandTypeCounts !== undefined ? {
                commandTypeCounts: commandTypeCounts
            } : {},
            ...heuristicInferred !== undefined ? {
                heuristicInferred: heuristicInferred
            } : {}
        });
    }
    /**
   * Schedules the `no_document_change` toolCallAnomaly check for streamable commands.
   *
   * The check must not run immediately after `processStreamCommandPromise` resolves
   * because `handleFinalize` (which commits the final content via two `view.dispatch`
   * calls) runs in a later `view.update()` cycle triggered by `endAIExperience`.
   * Firing immediately gives a stale pre-finalize doc — a guaranteed false positive.
   *
   * Instead we subscribe to `aiExperience.sharedState` and fire only after
   * `isStreaming` transitions to `false`, which happens after `handleFinalize`'s
   * commit transaction has landed and `getPmDoc()` is accurate.
   *
   * No-op when:
   * - The normalized telemetry experiment is disabled.
   * - `aiExperience` plugin is absent (streaming state machine unavailable).
   */ scheduleDeferredNoDocChangeAnalytics() {
        if (!(0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true) || !this.telemetryEventsEnabled || !this.api.aiExperience || this.toolCallResultFiredForCurrentCommand) return;
        const capturedCommand = this.currentCommand;
        const capturedDocBeforeStreaming = this.docBeforeStreaming;
        const capturedTraceId = this.traceId;
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = this.api.aiExperience.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState != null && !nextSharedState.isStreaming) {
                this.pendingNoDocChangeUnsubscribe?.();
                this.pendingNoDocChangeUnsubscribe = undefined;
                if (!this.toolCallResultFiredForCurrentCommand) (0, $800cd9937abd732b$export$276ecd5322451ab4)({
                    api: this.api,
                    command: capturedCommand,
                    docBeforeStreaming: capturedDocBeforeStreaming,
                    traceId: capturedTraceId
                });
            }
        });
    }
    /**
   * Reset session-outcome bookkeeping so the next session starts from a clean
   * slate. Called from `startSession`, `destroy`, and `abort`.
   */ resetSessionOutcomeState() {
        this.sessionRepairSignals = {
            anyJsonInvalid: false,
            anyAdfInvalid: false,
            unrepairedJsonCount: 0,
            unrepairedAdfCount: 0
        };
        this.sessionOutcomeFired = false;
        // Post-apply outcome analyzer state. Cleared so the next session
        // starts with an empty tool-call record and no stale analysis.
        this.sessionToolCalls = [];
        this.lastOutcomeAnalysis = undefined;
        this.preSessionDoc = undefined;
    }
    /**
   * Compute the structural-delta analysis for the just-completed session
   * and stash it on `lastOutcomeAnalysis`. Called from `endSession`
   * (gated). `fireSessionOutcomeOnce` reads `lastOutcomeAnalysis` to
   * derive the `success_but_suspicious` outcome class and to fire the
   * three suspicious-signal session-scope events.
   *
   * Skips silently if either the pre-session or post-session doc is
   * unavailable (e.g. editor view torn down mid-stream) — partial-data
   * analysis would produce misleading deltas.
   */ runPostApplyOutcomeAnalysis() {
        const postDoc = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        if (this.preSessionDoc === undefined || postDoc === undefined) return;
        this.lastOutcomeAnalysis = (0, $ea65a4b3d3a11c9b$export$9aa9db1056f785bc)({
            preSessionAdf: this.preSessionDoc.toJSON(),
            postSessionAdf: postDoc.toJSON(),
            toolCalls: this.sessionToolCalls
        });
    }
    destroy() {
        this.queue = [];
        this.adfStreamer = undefined;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
        this.promptVersion = undefined;
        this.hasCommitApplyInSession = false;
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = undefined;
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) this.resetSessionOutcomeState();
    }
    /**
   * Abort the current streaming and end the experience
   * This is a hard abort and will clear the queue
   * This will only restart the experience when initStreamCommand is called again
   */ abort() {
        this.logger.logPublic('Abort');
        // Fire BEFORE any state teardown so `traceId` and
        // `singleInstrumentationId` are still set and the event can be
        // correlated in dashboards (matches the timeout / clean-drain paths).
        // We deliberately do NOT reset `sessionOutcomeFired` here — the
        // guard must persist through any follow-up `endSession` / timeout
        // for this same session; the next `startSession()` resets it.
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) this.fireSessionOutcomeOnce({
            lifecycleSymptom: 'session_aborted'
        });
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = undefined;
        const currentQueue = this.queue.map((cmd)=>cmd.actionId);
        this.queue = [];
        // Add new aborted action IDs to end of array
        this.updateAbortedCache([
            ...new Set(currentQueue),
            ...this.inProcessing
        ]);
        this.isAborted = true;
        this.hasCommitApplyInSession = false;
        this.endExperience();
        this.isPendingResolveQueue = false;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.currentAction = null;
        this.isFinalStream = false;
        this.currentCommand = undefined;
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
    }
    updateAbortedCache(actionIds) {
        this.aborted = [
            ...new Set([
                ...this.aborted,
                ...actionIds
            ])
        ];
        const maxAbortedCacheLength = 5;
        if (this.aborted.length > maxAbortedCacheLength) this.aborted = this.aborted.slice(-maxAbortedCacheLength);
    }
    constructor(api, streamFlowPacer = null, telemetryEventsEnabled = false){
        this.api = api;
        this.streamFlowPacer = streamFlowPacer;
        this.telemetryEventsEnabled = telemetryEventsEnabled;
        this.queue = [];
        this.adfStreamer = void 0;
        this.streamingCommands = void 0;
        // Resume-mode selection setter used by reapplyCommand().
        this.reapply = void 0;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.isStreaming = false;
        this.isFinalStream = false;
        /**
     * Commit apply keeps chrome up until `endSession`. Set on the first
     * commit init so session-end can tear down after `currentAction` is cleared.
     */ this.hasCommitApplyInSession = false;
        this.aborted = [];
        this.subscription = null;
        this.previousValidDoc = null;
        this.logger = void 0;
        this.endedActionIds = [];
        this.currentAction = null;
        this.insertAfterQueueLocalId = undefined;
        /**
     * The traceId received in response header from AI api call
     * This is used to trace the AI experience through the backend to frontend.
     */ this.traceId = undefined;
        /**
     * The singleInstrumentationId for tracking the AI experience
     * This is used to correlate events across multiple stream processing passes
     */ this.singleInstrumentationId = undefined;
        /**
     * The promptVersion from action metadata
     * This is used to track which version of the prompt was used for analytics
     */ this.promptVersion = undefined;
        /**
     * Aggregated repair signals across every streaming action in the current
     * session, used to fire the authoritative `sessionOutcome` event exactly
     * once per session.
     *
     * `*Invalid` aggregates with OR (any action that observed an invalid layer
     * marks the session as having seen an invalid layer).
     *
     * `*UnrepairedCount` counts how many actions had an invalid layer that was
     * NOT recovered. From these we derive a correct session-level "repaired"
     * value as: `*Invalid && *UnrepairedCount === 0` — i.e. every invalid
     * occurrence in the session was recovered.
     *
     * This avoids a misleading `success_with_repairs` classification when an
     * earlier action repaired successfully but a later action failed to repair:
     * a naive OR over `*Repaired` would incorrectly flatten the irrecoverable
     * failure into a success.
     */ this.sessionRepairSignals = {
            anyJsonInvalid: false,
            anyAdfInvalid: false,
            unrepairedJsonCount: 0,
            unrepairedAdfCount: 0
        };
        /**
     * Tracks whether the `sessionOutcome` analytics event has already been fired
     * for the active session. Ensures the event fires at most once per session.
     */ this.sessionOutcomeFired = false;
        /** Cleanup handle for the deferred no_document_change analytics subscription. Cleared in abort/destroy. */ this.pendingNoDocChangeUnsubscribe = undefined;
        /**
     * Set to true when a toolCallResult event has already been fired for the current
     * command (e.g. apply_failed_adf_schema_error from repair signals). Prevents
     * scheduleDeferredNoDocChangeAnalytics from firing a second toolCallResult for
     * the same command.
     */ this.toolCallResultFiredForCurrentCommand = false;
        /**
     * Per-session record of every tool call processed by `applyCommand`.
     * Consumed at end-of-session by `analyzeOutcome` to compute
     * `affectedLocalIds`. Reset at all session boundaries. Only populated
     * when the `platform_editor_ai_normalized_telemetry` experiment is on.
     */ this.sessionToolCalls = [];
        /**
     * The most recent `analyzeOutcome` result, computed at end-of-session.
     * Read by `fireSessionOutcomeOnce` (added by CCI-15893) to enrich the
     * `sessionOutcome` event with structural-delta fields. Undefined until
     * the first end-of-session analysis runs in the active lifetime, and
     * reset at all session boundaries.
     */ this.lastOutcomeAnalysis = undefined;
        /**
     * Snapshot of the editor document at session start, captured by
     * `startSession`. Consumed at end-of-session by `analyzeOutcome` as
     * `preSessionAdf`. Distinct from `docBeforeStreaming`, which is
     * reassigned per command for the per-command repair-signal pipeline.
     * Reset at all session boundaries. Only populated when the
     * `platform_editor_ai_normalized_telemetry` experiment is on.
     */ this.preSessionDoc = undefined;
        this.processingQueue = false;
        this.inProcessing = [];
        // Id of a timeout-force-finished tool call being processed; read once when
        // emitting the terminal `complete` event so it rides to `buildCommitTransaction`.
        this.pendingForceAbortedToolCallId = undefined;
        this.queueTimeout = null;
        // This is only used *if* we have started receiving values with a different
        // action id (new stream) and we have nothing left in the current stream (ie. it hasn't finished)
        // Really this shouldn't be hit since this would only happen on the edge when we're wrapping up the old stream
        // and starting the next early
        this.CURRENT_QUEUE_TIMEOUT = 5000;
        this.currentCommandTimeoutReset = null;
        this.onEmptyQueueResolve = null;
        // 2 seconds - this is the maximum time to process a command before we abort it and continue
        // This can be longer if for example if a lot of commands have been processed, but the stream flow
        // pacer has a backlog (particularly for elements with lots of attributes / marks etc) and hasn't had
        // a chance to emit yet
        this.COMMAND_TIMEOUT = 2000;
        this.isPendingResolveQueue = false;
        this.isAborted = false;
        this.logger = new (0, $5a1197e1a8fb1986$export$21e6cc849c1dc1ab)(api);
        this.streamingCommands = (0, $33e0a97ce57d98ef$export$a0774277976bc21f)(api);
        this.reapply = (0, $ff56e6956d0962e2$export$b49478c44446ab49)(api);
    }
}


const $1ce24a8ae51aaef4$export$4010adcbb216eb38 = ({ api: api, config: config })=>{
    if (!api) throw new Error('api is not defined');
    let streamQueue;
    // Only allow one session to be active at a time
    let sessionId = null;
    // Tracking variables for debugging session lifecycle issues
    let hasSessionBeenStarted = false;
    let isEndingSession = false;
    let lastEndedSessionId = null;
    let endSessionCallCount = 0;
    let sessionAborted = false;
    // Replaced per session: an aborted queue's request keeps running and pushing into
    // its pacer, which would otherwise emit into the next session.
    let streamFlowPacer = (0, $69782acbd729286a$export$9ea8217d5ec56f82)(config?.streamFlowPacerEnabled);
    const telemetryEventsEnabled = config?.telemetryEventsEnabled === true;
    const commitQueuedToolCall = (command, value, options)=>{
        if (sessionId === null) throw new Error('commitToolCall requires a session to be started first!');
        const actionId = crypto.randomUUID();
        streamQueue?.initStreamCommand(actionId, command, {
            applyMode: 'commit',
            hideLoadingScreen: options?.hideLoadingScreen,
            resume: options?.resume
        });
        streamQueue?.queueStreamCommand(actionId, value);
        streamQueue?.endStreamCommand(actionId, {
            forceAbortedToolCallId: options?.abortedToolCallId
        });
        return actionId;
    };
    return {
        name: 'aiStreamingOrchestrator',
        actions: {
            startSession: (traceId, params)=>{
                sessionId = crypto.randomUUID() ?? (0, $2nOF5.uuid).generate();
                hasSessionBeenStarted = true;
                sessionAborted = false;
                if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true)) {
                    streamFlowPacer?.destroy();
                    streamFlowPacer = (0, $69782acbd729286a$export$9ea8217d5ec56f82)(config?.streamFlowPacerEnabled);
                }
                streamQueue = new (0, $e3512170c06603fc$export$f3feb8728b17a0a9)(api, streamFlowPacer, telemetryEventsEnabled);
                streamQueue.startSession(sessionId, traceId, params?.singleInstrumentationId, (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? params?.promptVersion : undefined);
                // agentInfo is already gated by the platform_editor_agent_mentions experiment
                // in update-command-processor — it will be undefined when the experiment is off,
                // so no additional gate is needed here.
                api.aiExperience.actions.startSession(sessionId, traceId, (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? params?.promptVersion : undefined, params?.agentInfo, params?.isCreateSession, params?.isInlineEditSession, params?.agentAttribution, params?.isChatEditSession);
                return sessionId;
            },
            endSession: async (error)=>{
                // In the session abort we end the session and no longer need to run this
                // On a new session we reset the state so this is safe to ignore
                if (sessionAborted) return;
                if (sessionId === null) {
                    (0, $800cd9937abd732b$export$8b7d4483ec260574)({
                        api: api,
                        sessionStarted: hasSessionBeenStarted,
                        endSessionCallCount: endSessionCallCount,
                        lastEndedSessionId: lastEndedSessionId,
                        isDoubleCall: isEndingSession
                    });
                    throw new Error(`endSession requires a session to be started first!`);
                }
                endSessionCallCount++;
                isEndingSession = true;
                const currentSessionId = sessionId;
                try {
                    streamQueue?.queueEndSession(currentSessionId);
                    if (error) {
                        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api.aiExperience.actions.dispatchAIEvent({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                        else {
                            const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                            send({
                                type: 'error',
                                errorInfo: {
                                    failureReason: error.failureReason,
                                    statusCode: error.statusCode
                                }
                            });
                        }
                    }
                    // Since `endSession` is going to be called after all the actions are invoked
                    // so we can basically wait for the queue to be empty
                    await streamQueue?.onEmptyQueue();
                    streamQueue?.endSession(currentSessionId);
                    // https://atlassian.slack.com/archives/C0962DYFLRL/p1759397599541949?thread_ts=1759366160.706849&cid=C0962DYFLRL
                    // streamQueue?.destroy();
                    api.aiExperience.actions.endSession(currentSessionId, {
                        type: error ? 'error' : 'finished'
                    });
                    hasSessionBeenStarted = false;
                    lastEndedSessionId = currentSessionId;
                    sessionId = null;
                } finally{
                    isEndingSession = false;
                }
            },
            abortSession: ()=>{
                // abortSession can be called multiple times from multiple command handlers
                if (!sessionId) return;
                const sessionToEnd = sessionId;
                lastEndedSessionId = sessionToEnd;
                sessionId = null;
                streamQueue?.abort();
                if (sessionToEnd) {
                    api.aiExperience.actions.endSession(sessionToEnd, {
                        type: 'abort'
                    });
                    sessionAborted = true;
                }
            },
            initAction: (command, options)=>{
                if (sessionId === null) throw new Error('initAction requires a session to be started first!');
                const actionId = crypto.randomUUID();
                streamQueue?.initStreamCommand(actionId, command, options);
                return actionId;
            },
            // One-shot write: apply (or resume at a stored range), emit the value,
            // and finish. Commit mode skips the typewriter pacer.
            commitToolCall: commitQueuedToolCall,
            // Resume a tool call aborted by the queue timeout, re-applying its content
            // at the stored (mapped) position. Same commit write as a finished tool call.
            resumeAction: (toolCallId, command, fullValue)=>{
                if (sessionId === null) throw new Error('resumeAction requires a session to be started first!');
                const stored = api.aiExperience.actions.getAbortedToolCallPosition?.(toolCallId);
                if (!stored) // Should not happen in practice (content is already written before a
                // timeout abort). Fire an anomaly so this degradation is observable in
                // production. The queue's resume path will itself fall back to
                // re-running the real command when no stored position is found.
                (0, $800cd9937abd732b$export$50f05d3d56fe90a9)({
                    api: api,
                    commandType: command.type
                });
                // Resume mode is keyed solely by `toolCallId`: the queue resolves the
                // LATEST (transaction-remapped) stored position at apply time. This
                // matters when multiple aborted tool calls are resumed in sequence —
                // each earlier resume mutates the document and shifts the not-yet-resumed
                // positions, so reading the up-to-date value at apply time keeps every
                // resume anchored to its own content instead of collapsing onto a stale,
                // shared range.
                commitQueuedToolCall(command, fullValue, {
                    resume: {
                        toolCallId: toolCallId
                    }
                });
            },
            // We are sending the full document as a chunk for create actions
            streamValue: (actionId, chunk)=>{
                // Use the queue manager to handle streaming
                // This will either process immediately if actor is ready, or queue for later
                streamQueue?.queueStreamCommand(actionId, chunk);
            },
            // HTML+ v2 incremental tool-call streaming contract:
            // Each chunk is a full snapshot of the value, not a delta.
            //
            // IMPORTANT — REPLACE-NOT-APPEND INVARIANT:
            // At the queue layer this is currently equivalent to `streamValue`
            // because `streamCommandQueue.ts#processStreamCommand` resets the
            // internal ADFStreamer accumulator on every processed chunk before
            // parsing. **Two distinct public actions (`streamValue` and
            // `replaceValue`) depend on this single internal behaviour.** If
            // `streamValue` is ever migrated to append semantics for the v1
            // path, this `replaceValue` body MUST be rewired to a dedicated
            // `queueReplaceCommand` (or equivalent) on `StreamCommandQueue`
            // that preserves the replace-on-snapshot guarantee, otherwise v2
            // callers (`ToolCallProcessorV2`) will silently break — each
            // snapshot would be appended to the previous one instead of
            // replacing it, producing duplicated / concatenated ADF.
            //
            // See `streamCommandQueue.ts#processStreamCommand` for the
            // implementation detail this invariant relies on.
            replaceValue: (actionId, fullValue)=>{
                streamQueue?.queueStreamCommand(actionId, fullValue);
            },
            notifySchemaContentRejection: (actionId, errorMessage)=>{
                streamQueue?.notifySchemaContentRejection(actionId, errorMessage);
            },
            finishAction: (actionId, error, options)=>{
                if (error) {
                    if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
                        if (error.errorKey !== 'user_abort' || !(0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true)) api.aiExperience.actions.dispatchAIEvent({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                    } else if (error.errorKey !== 'user_abort' || !(0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true)) {
                        const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                        send({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                    }
                }
                // On a timeout force-finish, pass the aborted tool call id through
                // endStreamCommand. It rides the terminal `complete` event so
                // `buildCommitTransaction` (the last write of the tool call's content)
                // persists its final positions for resume.
                streamQueue?.endStreamCommand(actionId, {
                    forceAbortedToolCallId: options?.abortedToolCallId
                });
            }
        },
        usePluginHook: ()=>{
            const prevStreamPausedRef = (0, $cozmU.useRef)(undefined);
            (0, $1KOhB.usePluginStateEffect)(api, [
                'aiExperience'
            ], ({ aiExperienceState: aiExperienceState })=>{
                const streamPaused = aiExperienceState?.aiSessionPluginState?.streamPaused;
                if (streamPaused !== prevStreamPausedRef.current) {
                    if (streamPaused) streamFlowPacer?.pause();
                    else streamFlowPacer?.resume();
                    prevStreamPausedRef.current = streamPaused;
                }
            }, {
                disabled: !(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)
            });
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    streamQueue?.destroy();
                    streamFlowPacer?.destroy();
                };
            }, []);
        }
    };
};
module.exports["aiStreamingOrchestratorPlugin"] = $1ce24a8ae51aaef4$export$4010adcbb216eb38;

});


//# sourceMappingURL=FullPageEditorComponent.b76ba1c0.js.map
